function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

!function (e, t) {
  "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) && "object" == (typeof module === "undefined" ? "undefined" : _typeof(module)) ? module.exports = t() : "function" == typeof define && define.amd ? define([], t) : "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) ? exports["@asgerb/apparatus"] = t() : e["@asgerb/apparatus"] = t();
}(window, function () {
  return function (e) {
    var t = {};

    function n(r) {
      if (t[r]) return t[r].exports;
      var i = t[r] = {
        i: r,
        l: !1,
        exports: {}
      };
      return e[r].call(i.exports, i, i.exports, n), i.l = !0, i.exports;
    }

    return n.m = e, n.c = t, n.d = function (e, t, r) {
      n.o(e, t) || Object.defineProperty(e, t, {
        enumerable: !0,
        get: r
      });
    }, n.r = function (e) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }, n.t = function (e, t) {
      if (1 & t && (e = n(e)), 8 & t) return e;
      if (4 & t && "object" == _typeof(e) && e && e.__esModule) return e;
      var r = Object.create(null);
      if (n.r(r), Object.defineProperty(r, "default", {
        enumerable: !0,
        value: e
      }), 2 & t && "string" != typeof e) for (var i in e) {
        n.d(r, i, function (t) {
          return e[t];
        }.bind(null, i));
      }
      return r;
    }, n.n = function (e) {
      var t = e && e.__esModule ? function () {
        return e["default"];
      } : function () {
        return e;
      };
      return n.d(t, "a", t), t;
    }, n.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, n.p = "", n(n.s = 57);
  }([function (e, t, n) {
    "use strict";

    n.d(t, "a", function () {
      return I;
    }), n.d(t, "b", function () {
      return R;
    });

    var r = function () {
      function e(e, t) {
        this.eventTarget = e, this.eventName = t, this.unorderedBindings = new Set();
      }

      return e.prototype.connect = function () {
        this.eventTarget.addEventListener(this.eventName, this, !1);
      }, e.prototype.disconnect = function () {
        this.eventTarget.removeEventListener(this.eventName, this, !1);
      }, e.prototype.bindingConnected = function (e) {
        this.unorderedBindings.add(e);
      }, e.prototype.bindingDisconnected = function (e) {
        this.unorderedBindings["delete"](e);
      }, e.prototype.handleEvent = function (e) {
        for (var t = function (e) {
          if (("immediatePropagationStopped" in e)) return e;
          var t = e.stopImmediatePropagation;
          return Object.assign(e, {
            immediatePropagationStopped: !1,
            stopImmediatePropagation: function stopImmediatePropagation() {
              this.immediatePropagationStopped = !0, t.call(this);
            }
          });
        }(e), n = 0, r = this.bindings; n < r.length; n++) {
          var i = r[n];
          if (t.immediatePropagationStopped) break;
          i.handleEvent(t);
        }
      }, Object.defineProperty(e.prototype, "bindings", {
        get: function get() {
          return Array.from(this.unorderedBindings).sort(function (e, t) {
            var n = e.index,
                r = t.index;
            return n < r ? -1 : n > r ? 1 : 0;
          });
        },
        enumerable: !0,
        configurable: !0
      }), e;
    }();

    var i = function () {
      function e(e) {
        this.application = e, this.eventListenerMaps = new Map(), this.started = !1;
      }

      return e.prototype.start = function () {
        this.started || (this.started = !0, this.eventListeners.forEach(function (e) {
          return e.connect();
        }));
      }, e.prototype.stop = function () {
        this.started && (this.started = !1, this.eventListeners.forEach(function (e) {
          return e.disconnect();
        }));
      }, Object.defineProperty(e.prototype, "eventListeners", {
        get: function get() {
          return Array.from(this.eventListenerMaps.values()).reduce(function (e, t) {
            return e.concat(Array.from(t.values()));
          }, []);
        },
        enumerable: !0,
        configurable: !0
      }), e.prototype.bindingConnected = function (e) {
        this.fetchEventListenerForBinding(e).bindingConnected(e);
      }, e.prototype.bindingDisconnected = function (e) {
        this.fetchEventListenerForBinding(e).bindingDisconnected(e);
      }, e.prototype.handleError = function (e, t, n) {
        void 0 === n && (n = {}), this.application.handleError(e, "Error " + t, n);
      }, e.prototype.fetchEventListenerForBinding = function (e) {
        var t = e.eventTarget,
            n = e.eventName;
        return this.fetchEventListener(t, n);
      }, e.prototype.fetchEventListener = function (e, t) {
        var n = this.fetchEventListenerMapForEventTarget(e),
            r = n.get(t);
        return r || (r = this.createEventListener(e, t), n.set(t, r)), r;
      }, e.prototype.createEventListener = function (e, t) {
        var n = new r(e, t);
        return this.started && n.connect(), n;
      }, e.prototype.fetchEventListenerMapForEventTarget = function (e) {
        var t = this.eventListenerMaps.get(e);
        return t || (t = new Map(), this.eventListenerMaps.set(e, t)), t;
      }, e;
    }(),
        o = /^((.+?)(@(window|document))?->)?(.+?)(#(.+))?$/;

    var a = function () {
      function e(e, t, n) {
        this.element = e, this.index = t, this.eventTarget = n.eventTarget || e, this.eventName = n.eventName || function (e) {
          var t = e.tagName.toLowerCase();
          if (t in s) return s[t](e);
        }(e) || u("missing event name"), this.identifier = n.identifier || u("missing identifier"), this.methodName = n.methodName || u("missing method name");
      }

      return e.forToken = function (e) {
        return new this(e.element, e.index, (n = e.content, r = n.trim().match(o) || [], {
          eventTarget: (t = r[4], "window" == t ? window : "document" == t ? document : void 0),
          eventName: r[2],
          identifier: r[5],
          methodName: r[7]
        }));
        var t, n, r;
      }, e.prototype.toString = function () {
        var e = this.eventTargetName ? "@" + this.eventTargetName : "";
        return "" + this.eventName + e + "->" + this.identifier + "#" + this.methodName;
      }, Object.defineProperty(e.prototype, "eventTargetName", {
        get: function get() {
          return (e = this.eventTarget) == window ? "window" : e == document ? "document" : void 0;
          var e;
        },
        enumerable: !0,
        configurable: !0
      }), e;
    }(),
        s = {
      a: function a(e) {
        return "click";
      },
      button: function button(e) {
        return "click";
      },
      form: function form(e) {
        return "submit";
      },
      input: function input(e) {
        return "submit" == e.getAttribute("type") ? "click" : "change";
      },
      select: function select(e) {
        return "change";
      },
      textarea: function textarea(e) {
        return "change";
      }
    };

    function u(e) {
      throw new Error(e);
    }

    var c = function () {
      function e(e, t) {
        this.context = e, this.action = t;
      }

      return Object.defineProperty(e.prototype, "index", {
        get: function get() {
          return this.action.index;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "eventTarget", {
        get: function get() {
          return this.action.eventTarget;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "identifier", {
        get: function get() {
          return this.context.identifier;
        },
        enumerable: !0,
        configurable: !0
      }), e.prototype.handleEvent = function (e) {
        this.willBeInvokedByEvent(e) && this.invokeWithEvent(e);
      }, Object.defineProperty(e.prototype, "eventName", {
        get: function get() {
          return this.action.eventName;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "method", {
        get: function get() {
          var e = this.controller[this.methodName];
          if ("function" == typeof e) return e;
          throw new Error('Action "' + this.action + '" references undefined method "' + this.methodName + '"');
        },
        enumerable: !0,
        configurable: !0
      }), e.prototype.invokeWithEvent = function (e) {
        try {
          this.method.call(this.controller, e);
        } catch (n) {
          var t = {
            identifier: this.identifier,
            controller: this.controller,
            element: this.element,
            index: this.index,
            event: e
          };
          this.context.handleError(n, 'invoking action "' + this.action + '"', t);
        }
      }, e.prototype.willBeInvokedByEvent = function (e) {
        var t = e.target;
        return this.element === t || !(t instanceof Element && this.element.contains(t)) || this.scope.containsElement(t);
      }, Object.defineProperty(e.prototype, "controller", {
        get: function get() {
          return this.context.controller;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "methodName", {
        get: function get() {
          return this.action.methodName;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "element", {
        get: function get() {
          return this.scope.element;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "scope", {
        get: function get() {
          return this.context.scope;
        },
        enumerable: !0,
        configurable: !0
      }), e;
    }(),
        l = function () {
      function e(e, t) {
        var n = this;
        this.element = e, this.started = !1, this.delegate = t, this.elements = new Set(), this.mutationObserver = new MutationObserver(function (e) {
          return n.processMutations(e);
        });
      }

      return e.prototype.start = function () {
        this.started || (this.started = !0, this.mutationObserver.observe(this.element, {
          attributes: !0,
          childList: !0,
          subtree: !0
        }), this.refresh());
      }, e.prototype.stop = function () {
        this.started && (this.mutationObserver.takeRecords(), this.mutationObserver.disconnect(), this.started = !1);
      }, e.prototype.refresh = function () {
        if (this.started) {
          for (var e = new Set(this.matchElementsInTree()), t = 0, n = Array.from(this.elements); t < n.length; t++) {
            var r = n[t];
            e.has(r) || this.removeElement(r);
          }

          for (var i = 0, o = Array.from(e); i < o.length; i++) {
            r = o[i];
            this.addElement(r);
          }
        }
      }, e.prototype.processMutations = function (e) {
        if (this.started) for (var t = 0, n = e; t < n.length; t++) {
          var r = n[t];
          this.processMutation(r);
        }
      }, e.prototype.processMutation = function (e) {
        "attributes" == e.type ? this.processAttributeChange(e.target, e.attributeName) : "childList" == e.type && (this.processRemovedNodes(e.removedNodes), this.processAddedNodes(e.addedNodes));
      }, e.prototype.processAttributeChange = function (e, t) {
        var n = e;
        this.elements.has(n) ? this.delegate.elementAttributeChanged && this.matchElement(n) ? this.delegate.elementAttributeChanged(n, t) : this.removeElement(n) : this.matchElement(n) && this.addElement(n);
      }, e.prototype.processRemovedNodes = function (e) {
        for (var t = 0, n = Array.from(e); t < n.length; t++) {
          var r = n[t],
              i = this.elementFromNode(r);
          i && this.processTree(i, this.removeElement);
        }
      }, e.prototype.processAddedNodes = function (e) {
        for (var t = 0, n = Array.from(e); t < n.length; t++) {
          var r = n[t],
              i = this.elementFromNode(r);
          i && this.elementIsActive(i) && this.processTree(i, this.addElement);
        }
      }, e.prototype.matchElement = function (e) {
        return this.delegate.matchElement(e);
      }, e.prototype.matchElementsInTree = function (e) {
        return void 0 === e && (e = this.element), this.delegate.matchElementsInTree(e);
      }, e.prototype.processTree = function (e, t) {
        for (var n = 0, r = this.matchElementsInTree(e); n < r.length; n++) {
          var i = r[n];
          t.call(this, i);
        }
      }, e.prototype.elementFromNode = function (e) {
        if (e.nodeType == Node.ELEMENT_NODE) return e;
      }, e.prototype.elementIsActive = function (e) {
        return e.isConnected == this.element.isConnected && this.element.contains(e);
      }, e.prototype.addElement = function (e) {
        this.elements.has(e) || this.elementIsActive(e) && (this.elements.add(e), this.delegate.elementMatched && this.delegate.elementMatched(e));
      }, e.prototype.removeElement = function (e) {
        this.elements.has(e) && (this.elements["delete"](e), this.delegate.elementUnmatched && this.delegate.elementUnmatched(e));
      }, e;
    }(),
        f = function () {
      function e(e, t, n) {
        this.attributeName = t, this.delegate = n, this.elementObserver = new l(e, this);
      }

      return Object.defineProperty(e.prototype, "element", {
        get: function get() {
          return this.elementObserver.element;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "selector", {
        get: function get() {
          return "[" + this.attributeName + "]";
        },
        enumerable: !0,
        configurable: !0
      }), e.prototype.start = function () {
        this.elementObserver.start();
      }, e.prototype.stop = function () {
        this.elementObserver.stop();
      }, e.prototype.refresh = function () {
        this.elementObserver.refresh();
      }, Object.defineProperty(e.prototype, "started", {
        get: function get() {
          return this.elementObserver.started;
        },
        enumerable: !0,
        configurable: !0
      }), e.prototype.matchElement = function (e) {
        return e.hasAttribute(this.attributeName);
      }, e.prototype.matchElementsInTree = function (e) {
        var t = this.matchElement(e) ? [e] : [],
            n = Array.from(e.querySelectorAll(this.selector));
        return t.concat(n);
      }, e.prototype.elementMatched = function (e) {
        this.delegate.elementMatchedAttribute && this.delegate.elementMatchedAttribute(e, this.attributeName);
      }, e.prototype.elementUnmatched = function (e) {
        this.delegate.elementUnmatchedAttribute && this.delegate.elementUnmatchedAttribute(e, this.attributeName);
      }, e.prototype.elementAttributeChanged = function (e, t) {
        this.delegate.elementAttributeValueChanged && this.attributeName == t && this.delegate.elementAttributeValueChanged(e, t);
      }, e;
    }();

    function d(e, t, n) {
      h(e, t).add(n);
    }

    function p(e, t, n) {
      h(e, t)["delete"](n), function (e, t) {
        var n = e.get(t);
        null != n && 0 == n.size && e["delete"](t);
      }(e, t);
    }

    function h(e, t) {
      var n = e.get(t);
      return n || (n = new Set(), e.set(t, n)), n;
    }

    var v,
        g = function () {
      function e() {
        this.valuesByKey = new Map();
      }

      return Object.defineProperty(e.prototype, "values", {
        get: function get() {
          return Array.from(this.valuesByKey.values()).reduce(function (e, t) {
            return e.concat(Array.from(t));
          }, []);
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "size", {
        get: function get() {
          return Array.from(this.valuesByKey.values()).reduce(function (e, t) {
            return e + t.size;
          }, 0);
        },
        enumerable: !0,
        configurable: !0
      }), e.prototype.add = function (e, t) {
        d(this.valuesByKey, e, t);
      }, e.prototype["delete"] = function (e, t) {
        p(this.valuesByKey, e, t);
      }, e.prototype.has = function (e, t) {
        var n = this.valuesByKey.get(e);
        return null != n && n.has(t);
      }, e.prototype.hasKey = function (e) {
        return this.valuesByKey.has(e);
      }, e.prototype.hasValue = function (e) {
        return Array.from(this.valuesByKey.values()).some(function (t) {
          return t.has(e);
        });
      }, e.prototype.getValuesForKey = function (e) {
        var t = this.valuesByKey.get(e);
        return t ? Array.from(t) : [];
      }, e.prototype.getKeysForValue = function (e) {
        return Array.from(this.valuesByKey).filter(function (t) {
          t[0];
          return t[1].has(e);
        }).map(function (e) {
          var t = e[0];
          e[1];
          return t;
        });
      }, e;
    }(),
        m = (v = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (e, t) {
      e.__proto__ = t;
    } || function (e, t) {
      for (var n in t) {
        t.hasOwnProperty(n) && (e[n] = t[n]);
      }
    }, function (e, t) {
      function n() {
        this.constructor = e;
      }

      v(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
    }),
        y = (function (e) {
      function t() {
        var t = e.call(this) || this;
        return t.keysByValue = new Map(), t;
      }

      m(t, e), Object.defineProperty(t.prototype, "values", {
        get: function get() {
          return Array.from(this.keysByValue.keys());
        },
        enumerable: !0,
        configurable: !0
      }), t.prototype.add = function (t, n) {
        e.prototype.add.call(this, t, n), d(this.keysByValue, n, t);
      }, t.prototype["delete"] = function (t, n) {
        e.prototype["delete"].call(this, t, n), p(this.keysByValue, n, t);
      }, t.prototype.hasValue = function (e) {
        return this.keysByValue.has(e);
      }, t.prototype.getKeysForValue = function (e) {
        var t = this.keysByValue.get(e);
        return t ? Array.from(t) : [];
      };
    }(g), function () {
      function e(e, t, n) {
        this.attributeObserver = new f(e, t, this), this.delegate = n, this.tokensByElement = new g();
      }

      return Object.defineProperty(e.prototype, "started", {
        get: function get() {
          return this.attributeObserver.started;
        },
        enumerable: !0,
        configurable: !0
      }), e.prototype.start = function () {
        this.attributeObserver.start();
      }, e.prototype.stop = function () {
        this.attributeObserver.stop();
      }, e.prototype.refresh = function () {
        this.attributeObserver.refresh();
      }, Object.defineProperty(e.prototype, "element", {
        get: function get() {
          return this.attributeObserver.element;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "attributeName", {
        get: function get() {
          return this.attributeObserver.attributeName;
        },
        enumerable: !0,
        configurable: !0
      }), e.prototype.elementMatchedAttribute = function (e) {
        this.tokensMatched(this.readTokensForElement(e));
      }, e.prototype.elementAttributeValueChanged = function (e) {
        var t = this.refreshTokensForElement(e),
            n = t[0],
            r = t[1];
        this.tokensUnmatched(n), this.tokensMatched(r);
      }, e.prototype.elementUnmatchedAttribute = function (e) {
        this.tokensUnmatched(this.tokensByElement.getValuesForKey(e));
      }, e.prototype.tokensMatched = function (e) {
        var t = this;
        e.forEach(function (e) {
          return t.tokenMatched(e);
        });
      }, e.prototype.tokensUnmatched = function (e) {
        var t = this;
        e.forEach(function (e) {
          return t.tokenUnmatched(e);
        });
      }, e.prototype.tokenMatched = function (e) {
        this.delegate.tokenMatched(e), this.tokensByElement.add(e.element, e);
      }, e.prototype.tokenUnmatched = function (e) {
        this.delegate.tokenUnmatched(e), this.tokensByElement["delete"](e.element, e);
      }, e.prototype.refreshTokensForElement = function (e) {
        var t,
            n,
            r,
            i = this.tokensByElement.getValuesForKey(e),
            o = this.readTokensForElement(e),
            a = (t = i, n = o, r = Math.max(t.length, n.length), Array.from({
          length: r
        }, function (e, r) {
          return [t[r], n[r]];
        })).findIndex(function (e) {
          return !function (e, t) {
            return e && t && e.index == t.index && e.content == t.content;
          }(e[0], e[1]);
        });
        return -1 == a ? [[], []] : [i.slice(a), o.slice(a)];
      }, e.prototype.readTokensForElement = function (e) {
        var t = this.attributeName;
        return function (e, t, n) {
          return e.trim().split(/\s+/).filter(function (e) {
            return e.length;
          }).map(function (e, r) {
            return {
              element: t,
              attributeName: n,
              content: e,
              index: r
            };
          });
        }(e.getAttribute(t) || "", e, t);
      }, e;
    }());

    var b = function () {
      function e(e, t, n) {
        this.tokenListObserver = new y(e, t, this), this.delegate = n, this.parseResultsByToken = new WeakMap(), this.valuesByTokenByElement = new WeakMap();
      }

      return Object.defineProperty(e.prototype, "started", {
        get: function get() {
          return this.tokenListObserver.started;
        },
        enumerable: !0,
        configurable: !0
      }), e.prototype.start = function () {
        this.tokenListObserver.start();
      }, e.prototype.stop = function () {
        this.tokenListObserver.stop();
      }, e.prototype.refresh = function () {
        this.tokenListObserver.refresh();
      }, Object.defineProperty(e.prototype, "element", {
        get: function get() {
          return this.tokenListObserver.element;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "attributeName", {
        get: function get() {
          return this.tokenListObserver.attributeName;
        },
        enumerable: !0,
        configurable: !0
      }), e.prototype.tokenMatched = function (e) {
        var t = e.element,
            n = this.fetchParseResultForToken(e).value;
        n && (this.fetchValuesByTokenForElement(t).set(e, n), this.delegate.elementMatchedValue(t, n));
      }, e.prototype.tokenUnmatched = function (e) {
        var t = e.element,
            n = this.fetchParseResultForToken(e).value;
        n && (this.fetchValuesByTokenForElement(t)["delete"](e), this.delegate.elementUnmatchedValue(t, n));
      }, e.prototype.fetchParseResultForToken = function (e) {
        var t = this.parseResultsByToken.get(e);
        return t || (t = this.parseToken(e), this.parseResultsByToken.set(e, t)), t;
      }, e.prototype.fetchValuesByTokenForElement = function (e) {
        var t = this.valuesByTokenByElement.get(e);
        return t || (t = new Map(), this.valuesByTokenByElement.set(e, t)), t;
      }, e.prototype.parseToken = function (e) {
        try {
          return {
            value: this.delegate.parseValueForToken(e)
          };
        } catch (e) {
          return {
            error: e
          };
        }
      }, e;
    }(),
        w = function () {
      function e(e, t) {
        this.context = e, this.delegate = t, this.bindingsByAction = new Map();
      }

      return e.prototype.start = function () {
        this.valueListObserver || (this.valueListObserver = new b(this.element, this.actionAttribute, this), this.valueListObserver.start());
      }, e.prototype.stop = function () {
        this.valueListObserver && (this.valueListObserver.stop(), delete this.valueListObserver, this.disconnectAllActions());
      }, Object.defineProperty(e.prototype, "element", {
        get: function get() {
          return this.context.element;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "identifier", {
        get: function get() {
          return this.context.identifier;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "actionAttribute", {
        get: function get() {
          return this.schema.actionAttribute;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "schema", {
        get: function get() {
          return this.context.schema;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "bindings", {
        get: function get() {
          return Array.from(this.bindingsByAction.values());
        },
        enumerable: !0,
        configurable: !0
      }), e.prototype.connectAction = function (e) {
        var t = new c(this.context, e);
        this.bindingsByAction.set(e, t), this.delegate.bindingConnected(t);
      }, e.prototype.disconnectAction = function (e) {
        var t = this.bindingsByAction.get(e);
        t && (this.bindingsByAction["delete"](e), this.delegate.bindingDisconnected(t));
      }, e.prototype.disconnectAllActions = function () {
        var e = this;
        this.bindings.forEach(function (t) {
          return e.delegate.bindingDisconnected(t);
        }), this.bindingsByAction.clear();
      }, e.prototype.parseValueForToken = function (e) {
        var t = a.forToken(e);
        if (t.identifier == this.identifier) return t;
      }, e.prototype.elementMatchedValue = function (e, t) {
        this.connectAction(t);
      }, e.prototype.elementUnmatchedValue = function (e, t) {
        this.disconnectAction(t);
      }, e;
    }(),
        _ = function () {
      function e(e, t) {
        this.module = e, this.scope = t, this.controller = new e.controllerConstructor(this), this.bindingObserver = new w(this, this.dispatcher);

        try {
          this.controller.initialize();
        } catch (e) {
          this.handleError(e, "initializing controller");
        }
      }

      return e.prototype.connect = function () {
        this.bindingObserver.start();

        try {
          this.controller.connect();
        } catch (e) {
          this.handleError(e, "connecting controller");
        }
      }, e.prototype.disconnect = function () {
        try {
          this.controller.disconnect();
        } catch (e) {
          this.handleError(e, "disconnecting controller");
        }

        this.bindingObserver.stop();
      }, Object.defineProperty(e.prototype, "application", {
        get: function get() {
          return this.module.application;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "identifier", {
        get: function get() {
          return this.module.identifier;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "schema", {
        get: function get() {
          return this.application.schema;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "dispatcher", {
        get: function get() {
          return this.application.dispatcher;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "element", {
        get: function get() {
          return this.scope.element;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "parentElement", {
        get: function get() {
          return this.element.parentElement;
        },
        enumerable: !0,
        configurable: !0
      }), e.prototype.handleError = function (e, t, n) {
        void 0 === n && (n = {});
        var r = this.identifier,
            i = this.controller,
            o = this.element;
        n = Object.assign({
          identifier: r,
          controller: i,
          element: o
        }, n), this.application.handleError(e, "Error " + t, n);
      }, e;
    }(),
        x = function () {
      var e = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var n in t) {
          t.hasOwnProperty(n) && (e[n] = t[n]);
        }
      };

      return function (t, n) {
        function r() {
          this.constructor = t;
        }

        e(t, n), t.prototype = null === n ? Object.create(n) : (r.prototype = n.prototype, new r());
      };
    }();

    function C(e) {
      var t = k(e);
      return t.bless(), t;
    }

    var k = function () {
      function e(e) {
        function t() {
          var n = this && this instanceof t ? this.constructor : void 0;
          return Reflect.construct(e, arguments, n);
        }

        return t.prototype = Object.create(e.prototype, {
          constructor: {
            value: t
          }
        }), Reflect.setPrototypeOf(t, e), t;
      }

      try {
        return (t = e(function () {
          this.a.call(this);
        })).prototype.a = function () {}, new t(), e;
      } catch (e) {
        return function (e) {
          return function (e) {
            function t() {
              return null !== e && e.apply(this, arguments) || this;
            }

            return x(t, e), t;
          }(e);
        };
      }

      var t;
    }(),
        T = function () {
      function e(e, t) {
        this.application = e, this.definition = function (e) {
          return {
            identifier: e.identifier,
            controllerConstructor: C(e.controllerConstructor)
          };
        }(t), this.contextsByScope = new WeakMap(), this.connectedContexts = new Set();
      }

      return Object.defineProperty(e.prototype, "identifier", {
        get: function get() {
          return this.definition.identifier;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "controllerConstructor", {
        get: function get() {
          return this.definition.controllerConstructor;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "contexts", {
        get: function get() {
          return Array.from(this.connectedContexts);
        },
        enumerable: !0,
        configurable: !0
      }), e.prototype.connectContextForScope = function (e) {
        var t = this.fetchContextForScope(e);
        this.connectedContexts.add(t), t.connect();
      }, e.prototype.disconnectContextForScope = function (e) {
        var t = this.contextsByScope.get(e);
        t && (this.connectedContexts["delete"](t), t.disconnect());
      }, e.prototype.fetchContextForScope = function (e) {
        var t = this.contextsByScope.get(e);
        return t || (t = new _(this, e), this.contextsByScope.set(e, t)), t;
      }, e;
    }(),
        S = function () {
      function e(e) {
        this.scope = e;
      }

      return Object.defineProperty(e.prototype, "element", {
        get: function get() {
          return this.scope.element;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "identifier", {
        get: function get() {
          return this.scope.identifier;
        },
        enumerable: !0,
        configurable: !0
      }), e.prototype.get = function (e) {
        return e = this.getFormattedKey(e), this.element.getAttribute(e);
      }, e.prototype.set = function (e, t) {
        return e = this.getFormattedKey(e), this.element.setAttribute(e, t), this.get(e);
      }, e.prototype.has = function (e) {
        return e = this.getFormattedKey(e), this.element.hasAttribute(e);
      }, e.prototype["delete"] = function (e) {
        return !!this.has(e) && (e = this.getFormattedKey(e), this.element.removeAttribute(e), !0);
      }, e.prototype.getFormattedKey = function (e) {
        return "data-" + this.identifier + "-" + e.replace(/([A-Z])/g, function (e, t) {
          return "-" + t.toLowerCase();
        });
      }, e;
    }();

    function A(e, t) {
      return "[" + e + '~="' + t + '"]';
    }

    var E = function () {
      function e(e) {
        this.scope = e;
      }

      return Object.defineProperty(e.prototype, "element", {
        get: function get() {
          return this.scope.element;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "identifier", {
        get: function get() {
          return this.scope.identifier;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "schema", {
        get: function get() {
          return this.scope.schema;
        },
        enumerable: !0,
        configurable: !0
      }), e.prototype.has = function (e) {
        return null != this.find(e);
      }, e.prototype.find = function () {
        for (var e = [], t = 0; t < arguments.length; t++) {
          e[t] = arguments[t];
        }

        var n = this.getSelectorForTargetNames(e);
        return this.scope.findElement(n);
      }, e.prototype.findAll = function () {
        for (var e = [], t = 0; t < arguments.length; t++) {
          e[t] = arguments[t];
        }

        var n = this.getSelectorForTargetNames(e);
        return this.scope.findAllElements(n);
      }, e.prototype.getSelectorForTargetNames = function (e) {
        var t = this;
        return e.map(function (e) {
          return t.getSelectorForTargetName(e);
        }).join(", ");
      }, e.prototype.getSelectorForTargetName = function (e) {
        var t = this.identifier + "." + e;
        return A(this.schema.targetAttribute, t);
      }, e;
    }(),
        O = function () {
      function e(e, t, n) {
        this.schema = e, this.identifier = t, this.element = n, this.targets = new E(this), this.data = new S(this);
      }

      return e.prototype.findElement = function (e) {
        return this.findAllElements(e)[0];
      }, e.prototype.findAllElements = function (e) {
        var t = this.element.matches(e) ? [this.element] : [],
            n = this.filterElements(Array.from(this.element.querySelectorAll(e)));
        return t.concat(n);
      }, e.prototype.filterElements = function (e) {
        var t = this;
        return e.filter(function (e) {
          return t.containsElement(e);
        });
      }, e.prototype.containsElement = function (e) {
        return e.closest(this.controllerSelector) === this.element;
      }, Object.defineProperty(e.prototype, "controllerSelector", {
        get: function get() {
          return A(this.schema.controllerAttribute, this.identifier);
        },
        enumerable: !0,
        configurable: !0
      }), e;
    }(),
        j = function () {
      function e(e, t, n) {
        this.element = e, this.schema = t, this.delegate = n, this.valueListObserver = new b(this.element, this.controllerAttribute, this), this.scopesByIdentifierByElement = new WeakMap(), this.scopeReferenceCounts = new WeakMap();
      }

      return e.prototype.start = function () {
        this.valueListObserver.start();
      }, e.prototype.stop = function () {
        this.valueListObserver.stop();
      }, Object.defineProperty(e.prototype, "controllerAttribute", {
        get: function get() {
          return this.schema.controllerAttribute;
        },
        enumerable: !0,
        configurable: !0
      }), e.prototype.parseValueForToken = function (e) {
        var t = e.element,
            n = e.content,
            r = this.fetchScopesByIdentifierForElement(t),
            i = r.get(n);
        return i || (i = new O(this.schema, n, t), r.set(n, i)), i;
      }, e.prototype.elementMatchedValue = function (e, t) {
        var n = (this.scopeReferenceCounts.get(t) || 0) + 1;
        this.scopeReferenceCounts.set(t, n), 1 == n && this.delegate.scopeConnected(t);
      }, e.prototype.elementUnmatchedValue = function (e, t) {
        var n = this.scopeReferenceCounts.get(t);
        n && (this.scopeReferenceCounts.set(t, n - 1), 1 == n && this.delegate.scopeDisconnected(t));
      }, e.prototype.fetchScopesByIdentifierForElement = function (e) {
        var t = this.scopesByIdentifierByElement.get(e);
        return t || (t = new Map(), this.scopesByIdentifierByElement.set(e, t)), t;
      }, e;
    }(),
        D = function () {
      function e(e) {
        this.application = e, this.scopeObserver = new j(this.element, this.schema, this), this.scopesByIdentifier = new g(), this.modulesByIdentifier = new Map();
      }

      return Object.defineProperty(e.prototype, "element", {
        get: function get() {
          return this.application.element;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "schema", {
        get: function get() {
          return this.application.schema;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "controllerAttribute", {
        get: function get() {
          return this.schema.controllerAttribute;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "modules", {
        get: function get() {
          return Array.from(this.modulesByIdentifier.values());
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "contexts", {
        get: function get() {
          return this.modules.reduce(function (e, t) {
            return e.concat(t.contexts);
          }, []);
        },
        enumerable: !0,
        configurable: !0
      }), e.prototype.start = function () {
        this.scopeObserver.start();
      }, e.prototype.stop = function () {
        this.scopeObserver.stop();
      }, e.prototype.loadDefinition = function (e) {
        this.unloadIdentifier(e.identifier);
        var t = new T(this.application, e);
        this.connectModule(t);
      }, e.prototype.unloadIdentifier = function (e) {
        var t = this.modulesByIdentifier.get(e);
        t && this.disconnectModule(t);
      }, e.prototype.getContextForElementAndIdentifier = function (e, t) {
        var n = this.modulesByIdentifier.get(t);
        if (n) return n.contexts.find(function (t) {
          return t.element == e;
        });
      }, e.prototype.handleError = function (e, t, n) {
        this.application.handleError(e, t, n);
      }, e.prototype.scopeConnected = function (e) {
        this.scopesByIdentifier.add(e.identifier, e);
        var t = this.modulesByIdentifier.get(e.identifier);
        t && t.connectContextForScope(e);
      }, e.prototype.scopeDisconnected = function (e) {
        this.scopesByIdentifier["delete"](e.identifier, e);
        var t = this.modulesByIdentifier.get(e.identifier);
        t && t.disconnectContextForScope(e);
      }, e.prototype.connectModule = function (e) {
        this.modulesByIdentifier.set(e.identifier, e), this.scopesByIdentifier.getValuesForKey(e.identifier).forEach(function (t) {
          return e.connectContextForScope(t);
        });
      }, e.prototype.disconnectModule = function (e) {
        this.modulesByIdentifier["delete"](e.identifier), this.scopesByIdentifier.getValuesForKey(e.identifier).forEach(function (t) {
          return e.disconnectContextForScope(t);
        });
      }, e;
    }(),
        L = {
      controllerAttribute: "data-controller",
      actionAttribute: "data-action",
      targetAttribute: "data-target"
    },
        P = function P(e, t, n, r) {
      return new (n || (n = Promise))(function (i, o) {
        function a(e) {
          try {
            u(r.next(e));
          } catch (e) {
            o(e);
          }
        }

        function s(e) {
          try {
            u(r["throw"](e));
          } catch (e) {
            o(e);
          }
        }

        function u(e) {
          e.done ? i(e.value) : new n(function (t) {
            t(e.value);
          }).then(a, s);
        }

        u((r = r.apply(e, t || [])).next());
      });
    },
        N = function N(e, t) {
      var n,
          r,
          i,
          o,
          a = {
        label: 0,
        sent: function sent() {
          if (1 & i[0]) throw i[1];
          return i[1];
        },
        trys: [],
        ops: []
      };
      return o = {
        next: s(0),
        "throw": s(1),
        "return": s(2)
      }, "function" == typeof Symbol && (o[Symbol.iterator] = function () {
        return this;
      }), o;

      function s(o) {
        return function (s) {
          return function (o) {
            if (n) throw new TypeError("Generator is already executing.");

            for (; a;) {
              try {
                if (n = 1, r && (i = r[2 & o[0] ? "return" : o[0] ? "throw" : "next"]) && !(i = i.call(r, o[1])).done) return i;

                switch (r = 0, i && (o = [0, i.value]), o[0]) {
                  case 0:
                  case 1:
                    i = o;
                    break;

                  case 4:
                    return a.label++, {
                      value: o[1],
                      done: !1
                    };

                  case 5:
                    a.label++, r = o[1], o = [0];
                    continue;

                  case 7:
                    o = a.ops.pop(), a.trys.pop();
                    continue;

                  default:
                    if (!(i = (i = a.trys).length > 0 && i[i.length - 1]) && (6 === o[0] || 2 === o[0])) {
                      a = 0;
                      continue;
                    }

                    if (3 === o[0] && (!i || o[1] > i[0] && o[1] < i[3])) {
                      a.label = o[1];
                      break;
                    }

                    if (6 === o[0] && a.label < i[1]) {
                      a.label = i[1], i = o;
                      break;
                    }

                    if (i && a.label < i[2]) {
                      a.label = i[2], a.ops.push(o);
                      break;
                    }

                    i[2] && a.ops.pop(), a.trys.pop();
                    continue;
                }

                o = t.call(e, a);
              } catch (e) {
                o = [6, e], r = 0;
              } finally {
                n = i = 0;
              }
            }

            if (5 & o[0]) throw o[1];
            return {
              value: o[0] ? o[1] : void 0,
              done: !0
            };
          }([o, s]);
        };
      }
    },
        I = function () {
      function e(e, t) {
        void 0 === e && (e = document.documentElement), void 0 === t && (t = L), this.element = e, this.schema = t, this.dispatcher = new i(this), this.router = new D(this);
      }

      return e.start = function (t, n) {
        var r = new e(t, n);
        return r.start(), r;
      }, e.prototype.start = function () {
        return P(this, void 0, void 0, function () {
          return N(this, function (e) {
            switch (e.label) {
              case 0:
                return [4, new Promise(function (e) {
                  "loading" == document.readyState ? document.addEventListener("DOMContentLoaded", e) : e();
                })];

              case 1:
                return e.sent(), this.router.start(), this.dispatcher.start(), [2];
            }
          });
        });
      }, e.prototype.stop = function () {
        this.router.stop(), this.dispatcher.stop();
      }, e.prototype.register = function (e, t) {
        this.load({
          identifier: e,
          controllerConstructor: t
        });
      }, e.prototype.load = function (e) {
        for (var t = this, n = [], r = 1; r < arguments.length; r++) {
          n[r - 1] = arguments[r];
        }

        var i = Array.isArray(e) ? e : [e].concat(n);
        i.forEach(function (e) {
          return t.router.loadDefinition(e);
        });
      }, e.prototype.unload = function (e) {
        for (var t = this, n = [], r = 1; r < arguments.length; r++) {
          n[r - 1] = arguments[r];
        }

        var i = Array.isArray(e) ? e : [e].concat(n);
        i.forEach(function (e) {
          return t.router.unloadIdentifier(e);
        });
      }, Object.defineProperty(e.prototype, "controllers", {
        get: function get() {
          return this.router.contexts.map(function (e) {
            return e.controller;
          });
        },
        enumerable: !0,
        configurable: !0
      }), e.prototype.getControllerForElementAndIdentifier = function (e, t) {
        var n = this.router.getContextForElementAndIdentifier(e, t);
        return n ? n.controller : null;
      }, e.prototype.handleError = function (e, t, n) {
        console.error("%s\n\n%o\n\n%o", t, e, n);
      }, e;
    }();

    function M(e) {
      var t = e.prototype;
      (function (e) {
        var t = function (e) {
          var t = [];

          for (; e;) {
            t.push(e), e = Object.getPrototypeOf(e);
          }

          return t;
        }(e);

        return Array.from(t.reduce(function (e, t) {
          return function (e) {
            var t = e.targets;
            return Array.isArray(t) ? t : [];
          }(t).forEach(function (t) {
            return e.add(t);
          }), e;
        }, new Set()));
      })(e).forEach(function (e) {
        var n, r, i;
        return r = t, (n = {})[e + "Target"] = {
          get: function get() {
            var t = this.targets.find(e);
            if (t) return t;
            throw new Error('Missing target element "' + this.identifier + "." + e + '"');
          }
        }, n[e + "Targets"] = {
          get: function get() {
            return this.targets.findAll(e);
          }
        }, n["has" + function (e) {
          return e.charAt(0).toUpperCase() + e.slice(1);
        }(e) + "Target"] = {
          get: function get() {
            return this.targets.has(e);
          }
        }, i = n, void Object.keys(i).forEach(function (e) {
          if (!(e in r)) {
            var t = i[e];
            Object.defineProperty(r, e, t);
          }
        });
      });
    }

    var R = function () {
      function e(e) {
        this.context = e;
      }

      return e.bless = function () {
        M(this);
      }, Object.defineProperty(e.prototype, "application", {
        get: function get() {
          return this.context.application;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "scope", {
        get: function get() {
          return this.context.scope;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "element", {
        get: function get() {
          return this.scope.element;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "identifier", {
        get: function get() {
          return this.scope.identifier;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "targets", {
        get: function get() {
          return this.scope.targets;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "data", {
        get: function get() {
          return this.scope.data;
        },
        enumerable: !0,
        configurable: !0
      }), e.prototype.initialize = function () {}, e.prototype.connect = function () {}, e.prototype.disconnect = function () {}, e.targets = [], e;
    }();
  }, function (e, t, n) {}, function (e, t, n) {}, function (e, t, n) {}, function (e, t, n) {}, function (e, t, n) {}, function (e, t, n) {}, function (e, t, n) {}, function (e, t, n) {}, function (e, t, n) {}, function (e, t, n) {}, function (e, t, n) {}, function (e, t, n) {}, function (e, t, n) {
    "use strict";

    n(1), n(2), n(3), n(4), n(5), n(6), n(7), n(8), n(9), n(10), n(11), n(12);
  }, function (e, t) {
    !function (e, t, n, r) {
      "use strict";

      t = void 0 !== t && t.Math == Math ? t : "undefined" != typeof self && self.Math == Math ? self : Function("return this")(), e.fn.transition = function () {
        var r,
            i = e(this),
            o = i.selector || "",
            a = new Date().getTime(),
            s = [],
            u = arguments,
            c = u[0],
            l = [].slice.call(arguments, 1),
            f = "string" == typeof c;
        t.requestAnimationFrame || t.mozRequestAnimationFrame || t.webkitRequestAnimationFrame || t.msRequestAnimationFrame;
        return i.each(function (t) {
          var d,
              p,
              h,
              v,
              g,
              m,
              y,
              b,
              w,
              _ = e(this),
              x = this;

          (w = {
            initialize: function initialize() {
              d = w.get.settings.apply(x, u), v = d.className, h = d.error, g = d.metadata, b = "." + d.namespace, y = "module-" + d.namespace, p = _.data(y) || w, m = w.get.animationEndEvent(), f && (f = w.invoke(c)), !1 === f && (w.verbose("Converted arguments into settings object", d), d.interval ? w.delay(d.animate) : w.animate(), w.instantiate());
            },
            instantiate: function instantiate() {
              w.verbose("Storing instance of module", w), p = w, _.data(y, p);
            },
            destroy: function destroy() {
              w.verbose("Destroying previous module for", x), _.removeData(y);
            },
            refresh: function refresh() {
              w.verbose("Refreshing display type on next animation"), delete w.displayType;
            },
            forceRepaint: function forceRepaint() {
              w.verbose("Forcing element repaint");

              var e = _.parent(),
                  t = _.next();

              0 === t.length ? _.detach().appendTo(e) : _.detach().insertBefore(t);
            },
            repaint: function repaint() {
              w.verbose("Repainting element");
              x.offsetWidth;
            },
            delay: function delay(e) {
              var n,
                  r = w.get.animationDirection();
              r || (r = w.can.transition() ? w.get.direction() : "static"), e = void 0 !== e ? e : d.interval, n = "auto" == d.reverse && r == v.outward || 1 == d.reverse ? (i.length - t) * d.interval : t * d.interval, w.debug("Delaying animation by", n), setTimeout(w.animate, n);
            },
            animate: function animate(e) {
              if (d = e || d, !w.is.supported()) return w.error(h.support), !1;

              if (w.debug("Preparing animation", d.animation), w.is.animating()) {
                if (d.queue) return !d.allowRepeats && w.has.direction() && w.is.occurring() && !0 !== w.queuing ? w.debug("Animation is currently occurring, preventing queueing same animation", d.animation) : w.queue(d.animation), !1;
                if (!d.allowRepeats && w.is.occurring()) return w.debug("Animation is already occurring, will not execute repeated animation", d.animation), !1;
                w.debug("New animation started, completing previous early", d.animation), p.complete();
              }

              w.can.animate() ? w.set.animating(d.animation) : w.error(h.noAnimation, d.animation, x);
            },
            reset: function reset() {
              w.debug("Resetting animation to beginning conditions"), w.remove.animationCallbacks(), w.restore.conditions(), w.remove.animating();
            },
            queue: function queue(e) {
              w.debug("Queueing animation of", e), w.queuing = !0, _.one(m + ".queue" + b, function () {
                w.queuing = !1, w.repaint(), w.animate.apply(this, d);
              });
            },
            complete: function complete(e) {
              w.debug("Animation complete", d.animation), w.remove.completeCallback(), w.remove.failSafe(), w.is.looping() || (w.is.outward() ? (w.verbose("Animation is outward, hiding element"), w.restore.conditions(), w.hide()) : w.is.inward() ? (w.verbose("Animation is outward, showing element"), w.restore.conditions(), w.show()) : (w.verbose("Static animation completed"), w.restore.conditions(), d.onComplete.call(x)));
            },
            force: {
              visible: function visible() {
                var e = _.attr("style"),
                    t = w.get.userStyle(),
                    n = w.get.displayType(),
                    r = t + "display: " + n + " !important;",
                    i = void 0 === e || "" === e;

                _.css("display") !== n ? (w.verbose("Overriding default display to show element", n), _.attr("style", r)) : i && _.removeAttr("style");
              },
              hidden: function hidden() {
                var e = _.attr("style"),
                    t = void 0 === e || "" === e;

                "none" === _.css("display") || w.is.hidden() ? t && _.removeAttr("style") : (w.verbose("Overriding default display to hide element"), _.css("display", "none"));
              }
            },
            has: {
              direction: function direction(t) {
                var n = !1;
                return "string" == typeof (t = t || d.animation) && (t = t.split(" "), e.each(t, function (e, t) {
                  t !== v.inward && t !== v.outward || (n = !0);
                })), n;
              },
              inlineDisplay: function inlineDisplay() {
                var t = _.attr("style") || "";
                return e.isArray(t.match(/display.*?;/, ""));
              }
            },
            set: {
              animating: function animating(e) {
                var t;
                w.remove.completeCallback(), e = e || d.animation, t = w.get.animationClass(e), w.save.animation(t), w.force.visible(), w.remove.hidden(), w.remove.direction(), w.start.animation(t);
              },
              duration: function duration(e, t) {
                ((t = "number" == typeof (t = t || d.duration) ? t + "ms" : t) || 0 === t) && (w.verbose("Setting animation duration", t), _.css({
                  "animation-duration": t
                }));
              },
              direction: function direction(e) {
                (e = e || w.get.direction()) == v.inward ? w.set.inward() : w.set.outward();
              },
              looping: function looping() {
                w.debug("Transition set to loop"), _.addClass(v.looping);
              },
              hidden: function hidden() {
                _.addClass(v.transition).addClass(v.hidden);
              },
              inward: function inward() {
                w.debug("Setting direction to inward"), _.removeClass(v.outward).addClass(v.inward);
              },
              outward: function outward() {
                w.debug("Setting direction to outward"), _.removeClass(v.inward).addClass(v.outward);
              },
              visible: function visible() {
                _.addClass(v.transition).addClass(v.visible);
              }
            },
            start: {
              animation: function animation(e) {
                e = e || w.get.animationClass(), w.debug("Starting tween", e), _.addClass(e).one(m + ".complete" + b, w.complete), d.useFailSafe && w.add.failSafe(), w.set.duration(d.duration), d.onStart.call(x);
              }
            },
            save: {
              animation: function animation(e) {
                w.cache || (w.cache = {}), w.cache.animation = e;
              },
              displayType: function displayType(e) {
                "none" !== e && _.data(g.displayType, e);
              },
              transitionExists: function transitionExists(t, n) {
                e.fn.transition.exists[t] = n, w.verbose("Saving existence of transition", t, n);
              }
            },
            restore: {
              conditions: function conditions() {
                var e = w.get.currentAnimation();
                e && (_.removeClass(e), w.verbose("Removing animation class", w.cache)), w.remove.duration();
              }
            },
            add: {
              failSafe: function failSafe() {
                var e = w.get.duration();
                w.timer = setTimeout(function () {
                  _.triggerHandler(m);
                }, e + d.failSafeDelay), w.verbose("Adding fail safe timer", w.timer);
              }
            },
            remove: {
              animating: function animating() {
                _.removeClass(v.animating);
              },
              animationCallbacks: function animationCallbacks() {
                w.remove.queueCallback(), w.remove.completeCallback();
              },
              queueCallback: function queueCallback() {
                _.off(".queue" + b);
              },
              completeCallback: function completeCallback() {
                _.off(".complete" + b);
              },
              display: function display() {
                _.css("display", "");
              },
              direction: function direction() {
                _.removeClass(v.inward).removeClass(v.outward);
              },
              duration: function duration() {
                _.css("animation-duration", "");
              },
              failSafe: function failSafe() {
                w.verbose("Removing fail safe timer", w.timer), w.timer && clearTimeout(w.timer);
              },
              hidden: function hidden() {
                _.removeClass(v.hidden);
              },
              visible: function visible() {
                _.removeClass(v.visible);
              },
              looping: function looping() {
                w.debug("Transitions are no longer looping"), w.is.looping() && (w.reset(), _.removeClass(v.looping));
              },
              transition: function transition() {
                _.removeClass(v.visible).removeClass(v.hidden);
              }
            },
            get: {
              settings: function settings(t, n, r) {
                return "object" == _typeof(t) ? e.extend(!0, {}, e.fn.transition.settings, t) : "function" == typeof r ? e.extend({}, e.fn.transition.settings, {
                  animation: t,
                  onComplete: r,
                  duration: n
                }) : "string" == typeof n || "number" == typeof n ? e.extend({}, e.fn.transition.settings, {
                  animation: t,
                  duration: n
                }) : "object" == _typeof(n) ? e.extend({}, e.fn.transition.settings, n, {
                  animation: t
                }) : "function" == typeof n ? e.extend({}, e.fn.transition.settings, {
                  animation: t,
                  onComplete: n
                }) : e.extend({}, e.fn.transition.settings, {
                  animation: t
                });
              },
              animationClass: function animationClass(e) {
                var t = e || d.animation,
                    n = w.can.transition() && !w.has.direction() ? w.get.direction() + " " : "";
                return v.animating + " " + v.transition + " " + n + t;
              },
              currentAnimation: function currentAnimation() {
                return !(!w.cache || void 0 === w.cache.animation) && w.cache.animation;
              },
              currentDirection: function currentDirection() {
                return w.is.inward() ? v.inward : v.outward;
              },
              direction: function direction() {
                return w.is.hidden() || !w.is.visible() ? v.inward : v.outward;
              },
              animationDirection: function animationDirection(t) {
                var n;
                return "string" == typeof (t = t || d.animation) && (t = t.split(" "), e.each(t, function (e, t) {
                  t === v.inward ? n = v.inward : t === v.outward && (n = v.outward);
                })), n || !1;
              },
              duration: function duration(e) {
                return !1 === (e = e || d.duration) && (e = _.css("animation-duration") || 0), "string" == typeof e ? e.indexOf("ms") > -1 ? parseFloat(e) : 1e3 * parseFloat(e) : e;
              },
              displayType: function displayType(e) {
                return e = void 0 === e || e, d.displayType ? d.displayType : (e && void 0 === _.data(g.displayType) && w.can.transition(!0), _.data(g.displayType));
              },
              userStyle: function userStyle(e) {
                return (e = e || _.attr("style") || "").replace(/display.*?;/, "");
              },
              transitionExists: function transitionExists(t) {
                return e.fn.transition.exists[t];
              },
              animationStartEvent: function animationStartEvent() {
                var e,
                    t = n.createElement("div"),
                    r = {
                  animation: "animationstart",
                  OAnimation: "oAnimationStart",
                  MozAnimation: "mozAnimationStart",
                  WebkitAnimation: "webkitAnimationStart"
                };

                for (e in r) {
                  if (void 0 !== t.style[e]) return r[e];
                }

                return !1;
              },
              animationEndEvent: function animationEndEvent() {
                var e,
                    t = n.createElement("div"),
                    r = {
                  animation: "animationend",
                  OAnimation: "oAnimationEnd",
                  MozAnimation: "mozAnimationEnd",
                  WebkitAnimation: "webkitAnimationEnd"
                };

                for (e in r) {
                  if (void 0 !== t.style[e]) return r[e];
                }

                return !1;
              }
            },
            can: {
              transition: function transition(t) {
                var n,
                    r,
                    i,
                    o,
                    a,
                    s,
                    u = d.animation,
                    c = w.get.transitionExists(u),
                    l = w.get.displayType(!1);

                if (void 0 === c || t) {
                  if (w.verbose("Determining whether animation exists"), n = _.attr("class"), r = _.prop("tagName"), o = (i = e("<" + r + " />").addClass(n).insertAfter(_)).addClass(u).removeClass(v.inward).removeClass(v.outward).addClass(v.animating).addClass(v.transition).css("animationName"), a = i.addClass(v.inward).css("animationName"), l || (l = i.attr("class", n).removeAttr("style").removeClass(v.hidden).removeClass(v.visible).show().css("display"), w.verbose("Determining final display state", l), w.save.displayType(l)), i.remove(), o != a) w.debug("Direction exists for animation", u), s = !0;else {
                    if ("none" == o || !o) return void w.debug("No animation defined in css", u);
                    w.debug("Static animation found", u, l), s = !1;
                  }
                  w.save.transitionExists(u, s);
                }

                return void 0 !== c ? c : s;
              },
              animate: function animate() {
                return void 0 !== w.can.transition();
              }
            },
            is: {
              animating: function animating() {
                return _.hasClass(v.animating);
              },
              inward: function inward() {
                return _.hasClass(v.inward);
              },
              outward: function outward() {
                return _.hasClass(v.outward);
              },
              looping: function looping() {
                return _.hasClass(v.looping);
              },
              occurring: function occurring(e) {
                return e = "." + (e = e || d.animation).replace(" ", "."), _.filter(e).length > 0;
              },
              visible: function visible() {
                return _.is(":visible");
              },
              hidden: function hidden() {
                return "hidden" === _.css("visibility");
              },
              supported: function supported() {
                return !1 !== m;
              }
            },
            hide: function hide() {
              w.verbose("Hiding element"), w.is.animating() && w.reset(), x.blur(), w.remove.display(), w.remove.visible(), w.set.hidden(), w.force.hidden(), d.onHide.call(x), d.onComplete.call(x);
            },
            show: function show(e) {
              w.verbose("Showing element", e), w.remove.hidden(), w.set.visible(), w.force.visible(), d.onShow.call(x), d.onComplete.call(x);
            },
            toggle: function toggle() {
              w.is.visible() ? w.hide() : w.show();
            },
            stop: function stop() {
              w.debug("Stopping current animation"), _.triggerHandler(m);
            },
            stopAll: function stopAll() {
              w.debug("Stopping all animation"), w.remove.queueCallback(), _.triggerHandler(m);
            },
            clear: {
              queue: function queue() {
                w.debug("Clearing animation queue"), w.remove.queueCallback();
              }
            },
            enable: function enable() {
              w.verbose("Starting animation"), _.removeClass(v.disabled);
            },
            disable: function disable() {
              w.debug("Stopping animation"), _.addClass(v.disabled);
            },
            setting: function setting(t, n) {
              if (w.debug("Changing setting", t, n), e.isPlainObject(t)) e.extend(!0, d, t);else {
                if (void 0 === n) return d[t];
                e.isPlainObject(d[t]) ? e.extend(!0, d[t], n) : d[t] = n;
              }
            },
            internal: function internal(t, n) {
              if (e.isPlainObject(t)) e.extend(!0, w, t);else {
                if (void 0 === n) return w[t];
                w[t] = n;
              }
            },
            debug: function debug() {
              !d.silent && d.debug && (d.performance ? w.performance.log(arguments) : (w.debug = Function.prototype.bind.call(console.info, console, d.name + ":"), w.debug.apply(console, arguments)));
            },
            verbose: function verbose() {
              !d.silent && d.verbose && d.debug && (d.performance ? w.performance.log(arguments) : (w.verbose = Function.prototype.bind.call(console.info, console, d.name + ":"), w.verbose.apply(console, arguments)));
            },
            error: function error() {
              d.silent || (w.error = Function.prototype.bind.call(console.error, console, d.name + ":"), w.error.apply(console, arguments));
            },
            performance: {
              log: function log(e) {
                var t, n;
                d.performance && (n = (t = new Date().getTime()) - (a || t), a = t, s.push({
                  Name: e[0],
                  Arguments: [].slice.call(e, 1) || "",
                  Element: x,
                  "Execution Time": n
                })), clearTimeout(w.performance.timer), w.performance.timer = setTimeout(w.performance.display, 500);
              },
              display: function display() {
                var t = d.name + ":",
                    n = 0;
                a = !1, clearTimeout(w.performance.timer), e.each(s, function (e, t) {
                  n += t["Execution Time"];
                }), t += " " + n + "ms", o && (t += " '" + o + "'"), i.length > 1 && (t += " (" + i.length + ")"), (void 0 !== console.group || void 0 !== console.table) && s.length > 0 && (console.groupCollapsed(t), console.table ? console.table(s) : e.each(s, function (e, t) {
                  console.log(t.Name + ": " + t["Execution Time"] + "ms");
                }), console.groupEnd()), s = [];
              }
            },
            invoke: function invoke(t, n, i) {
              var o,
                  a,
                  s,
                  u = p;
              return n = n || l, i = x || i, "string" == typeof t && void 0 !== u && (t = t.split(/[\. ]/), o = t.length - 1, e.each(t, function (n, r) {
                var i = n != o ? r + t[n + 1].charAt(0).toUpperCase() + t[n + 1].slice(1) : t;
                if (e.isPlainObject(u[i]) && n != o) u = u[i];else {
                  if (void 0 !== u[i]) return a = u[i], !1;
                  if (!e.isPlainObject(u[r]) || n == o) return void 0 !== u[r] && (a = u[r], !1);
                  u = u[r];
                }
              })), e.isFunction(a) ? s = a.apply(i, n) : void 0 !== a && (s = a), e.isArray(r) ? r.push(s) : void 0 !== r ? r = [r, s] : void 0 !== s && (r = s), void 0 !== a && a;
            }
          }).initialize();
        }), void 0 !== r ? r : this;
      }, e.fn.transition.exists = {}, e.fn.transition.settings = {
        name: "Transition",
        silent: !1,
        debug: !1,
        verbose: !1,
        performance: !0,
        namespace: "transition",
        interval: 0,
        reverse: "auto",
        onStart: function onStart() {},
        onComplete: function onComplete() {},
        onShow: function onShow() {},
        onHide: function onHide() {},
        useFailSafe: !0,
        failSafeDelay: 100,
        allowRepeats: !1,
        displayType: !1,
        animation: "fade",
        duration: !1,
        queue: !0,
        metadata: {
          displayType: "display"
        },
        className: {
          animating: "animating",
          disabled: "disabled",
          hidden: "hidden",
          inward: "in",
          loading: "loading",
          looping: "looping",
          outward: "out",
          transition: "transition",
          visible: "visible"
        },
        error: {
          noAnimation: "Element is no longer attached to DOM. Unable to animate.  Use silent setting to surpress this warning in production.",
          repeated: "That animation is already occurring, cancelling repeated animation",
          method: "The method you called is not defined",
          support: "This browser does not support CSS animations"
        }
      };
    }(jQuery, window, document);
  }, function (e, t) {
    !function (e, t, n, r) {
      "use strict";

      t = void 0 !== t && t.Math == Math ? t : "undefined" != typeof self && self.Math == Math ? self : Function("return this")(), e.fn.dropdown = function (r) {
        var i,
            o = e(this),
            a = e(n),
            s = o.selector || "",
            u = "ontouchstart" in n.documentElement,
            c = new Date().getTime(),
            l = [],
            f = arguments[0],
            d = "string" == typeof f,
            p = [].slice.call(arguments, 1);
        return o.each(function (h) {
          var v,
              g,
              m,
              y,
              b,
              w,
              _,
              x,
              C = e.isPlainObject(r) ? e.extend(!0, {}, e.fn.dropdown.settings, r) : e.extend({}, e.fn.dropdown.settings),
              k = C.className,
              T = C.message,
              S = C.fields,
              A = C.keys,
              E = C.metadata,
              O = C.namespace,
              j = C.regExp,
              D = C.selector,
              L = C.error,
              P = C.templates,
              N = "." + O,
              I = "module-" + O,
              M = e(this),
              R = e(C.context),
              q = M.find(D.text),
              F = M.find(D.search),
              B = M.find(D.sizer),
              z = M.find(D.input),
              H = M.find(D.icon),
              W = M.prev().find(D.text).length > 0 ? M.prev().find(D.text) : M.prev(),
              $ = M.children(D.menu),
              V = $.find(D.item),
              U = !1,
              K = !1,
              X = !1,
              G = this,
              Y = M.data(I);

          x = {
            initialize: function initialize() {
              x.debug("Initializing dropdown", C), x.is.alreadySetup() ? x.setup.reference() : (x.setup.layout(), C.values && x.change.values(C.values), x.refreshData(), x.save.defaults(), x.restore.selected(), x.create.id(), x.bind.events(), x.observeChanges(), x.instantiate());
            },
            instantiate: function instantiate() {
              x.verbose("Storing instance of dropdown", x), Y = x, M.data(I, x);
            },
            destroy: function destroy() {
              x.verbose("Destroying previous dropdown", M), x.remove.tabbable(), M.off(N).removeData(I), $.off(N), a.off(y), x.disconnect.menuObserver(), x.disconnect.selectObserver();
            },
            observeChanges: function observeChanges() {
              "MutationObserver" in t && (w = new MutationObserver(x.event.select.mutation), _ = new MutationObserver(x.event.menu.mutation), x.debug("Setting up mutation observer", w, _), x.observe.select(), x.observe.menu());
            },
            disconnect: {
              menuObserver: function menuObserver() {
                _ && _.disconnect();
              },
              selectObserver: function selectObserver() {
                w && w.disconnect();
              }
            },
            observe: {
              select: function select() {
                x.has.input() && w.observe(M[0], {
                  childList: !0,
                  subtree: !0
                });
              },
              menu: function menu() {
                x.has.menu() && _.observe($[0], {
                  childList: !0,
                  subtree: !0
                });
              }
            },
            create: {
              id: function id() {
                b = (Math.random().toString(16) + "000000000").substr(2, 8), y = "." + b, x.verbose("Creating unique id for element", b);
              },
              userChoice: function userChoice(t) {
                var n, r, i;
                return !!(t = t || x.get.userValues()) && (t = e.isArray(t) ? t : [t], e.each(t, function (t, o) {
                  !1 === x.get.item(o) && (i = C.templates.addition(x.add.variables(T.addResult, o)), r = e("<div />").html(i).attr("data-" + E.value, o).attr("data-" + E.text, o).addClass(k.addition).addClass(k.item), C.hideAdditions && r.addClass(k.hidden), n = void 0 === n ? r : n.add(r), x.verbose("Creating user choices for value", o, r));
                }), n);
              },
              userLabels: function userLabels(t) {
                var n = x.get.userValues();
                n && (x.debug("Adding user labels", n), e.each(n, function (e, t) {
                  x.verbose("Adding custom user value"), x.add.label(t, t);
                }));
              },
              menu: function menu() {
                $ = e("<div />").addClass(k.menu).appendTo(M);
              },
              sizer: function sizer() {
                B = e("<span />").addClass(k.sizer).insertAfter(F);
              }
            },
            search: function search(e) {
              e = void 0 !== e ? e : x.get.query(), x.verbose("Searching for query", e), x.has.minCharacters(e) ? x.filter(e) : x.hide();
            },
            select: {
              firstUnfiltered: function firstUnfiltered() {
                x.verbose("Selecting first non-filtered element"), x.remove.selectedItem(), V.not(D.unselectable).not(D.addition + D.hidden).eq(0).addClass(k.selected);
              },
              nextAvailable: function nextAvailable(e) {
                var t = (e = e.eq(0)).nextAll(D.item).not(D.unselectable).eq(0),
                    n = e.prevAll(D.item).not(D.unselectable).eq(0);
                t.length > 0 ? (x.verbose("Moving selection to", t), t.addClass(k.selected)) : (x.verbose("Moving selection to", n), n.addClass(k.selected));
              }
            },
            setup: {
              api: function api() {
                var e = {
                  debug: C.debug,
                  urlData: {
                    value: x.get.value(),
                    query: x.get.query()
                  },
                  on: !1
                };
                x.verbose("First request, initializing API"), M.api(e);
              },
              layout: function layout() {
                M.is("select") && (x.setup.select(), x.setup.returnedObject()), x.has.menu() || x.create.menu(), x.is.search() && !x.has.search() && (x.verbose("Adding search input"), F = e("<input />").addClass(k.search).prop("autocomplete", "off").insertBefore(q)), x.is.multiple() && x.is.searchSelection() && !x.has.sizer() && x.create.sizer(), C.allowTab && x.set.tabbable();
              },
              select: function select() {
                var t = x.get.selectValues();
                x.debug("Dropdown initialized on a select", t), M.is("select") && (z = M), z.parent(D.dropdown).length > 0 ? (x.debug("UI dropdown already exists. Creating dropdown menu only"), M = z.closest(D.dropdown), x.has.menu() || x.create.menu(), $ = M.children(D.menu), x.setup.menu(t)) : (x.debug("Creating entire dropdown from select"), M = e("<div />").attr("class", z.attr("class")).addClass(k.selection).addClass(k.dropdown).html(P.dropdown(t)).insertBefore(z), z.hasClass(k.multiple) && !1 === z.prop("multiple") && (x.error(L.missingMultiple), z.prop("multiple", !0)), z.is("[multiple]") && x.set.multiple(), z.prop("disabled") && (x.debug("Disabling dropdown"), M.addClass(k.disabled)), z.removeAttr("class").detach().prependTo(M)), x.refresh();
              },
              menu: function menu(e) {
                $.html(P.menu(e, S)), V = $.find(D.item);
              },
              reference: function reference() {
                x.debug("Dropdown behavior was called on select, replacing with closest dropdown"), M = M.parent(D.dropdown), Y = M.data(I), G = M.get(0), x.refresh(), x.setup.returnedObject();
              },
              returnedObject: function returnedObject() {
                var e = o.slice(0, h),
                    t = o.slice(h + 1);
                o = e.add(M).add(t);
              }
            },
            refresh: function refresh() {
              x.refreshSelectors(), x.refreshData();
            },
            refreshItems: function refreshItems() {
              V = $.find(D.item);
            },
            refreshSelectors: function refreshSelectors() {
              x.verbose("Refreshing selector cache"), q = M.find(D.text), F = M.find(D.search), z = M.find(D.input), H = M.find(D.icon), W = M.prev().find(D.text).length > 0 ? M.prev().find(D.text) : M.prev(), $ = M.children(D.menu), V = $.find(D.item);
            },
            refreshData: function refreshData() {
              x.verbose("Refreshing cached metadata"), V.removeData(E.text).removeData(E.value);
            },
            clearData: function clearData() {
              x.verbose("Clearing metadata"), V.removeData(E.text).removeData(E.value), M.removeData(E.defaultText).removeData(E.defaultValue).removeData(E.placeholderText);
            },
            toggle: function toggle() {
              x.verbose("Toggling menu visibility"), x.is.active() ? x.hide() : x.show();
            },
            show: function show(t) {
              if (t = e.isFunction(t) ? t : function () {}, !x.can.show() && x.is.remote() && (x.debug("No API results retrieved, searching before show"), x.queryRemote(x.get.query(), x.show)), x.can.show() && !x.is.active()) {
                if (x.debug("Showing dropdown"), !x.has.message() || x.has.maxSelections() || x.has.allResultsFiltered() || x.remove.message(), x.is.allFiltered()) return !0;
                !1 !== C.onShow.call(G) && x.animate.show(function () {
                  x.can.click() && x.bind.intent(), x.has.menuSearch() && x.focusSearch(), x.set.visible(), t.call(G);
                });
              }
            },
            hide: function hide(t) {
              t = e.isFunction(t) ? t : function () {}, x.is.active() && (x.debug("Hiding dropdown"), !1 !== C.onHide.call(G) && x.animate.hide(function () {
                x.remove.visible(), t.call(G);
              }));
            },
            hideOthers: function hideOthers() {
              x.verbose("Finding other dropdowns to hide"), o.not(M).has(D.menu + "." + k.visible).dropdown("hide");
            },
            hideMenu: function hideMenu() {
              x.verbose("Hiding menu  instantaneously"), x.remove.active(), x.remove.visible(), $.transition("hide");
            },
            hideSubMenus: function hideSubMenus() {
              var e = $.children(D.item).find(D.menu);
              x.verbose("Hiding sub menus", e), e.transition("hide");
            },
            bind: {
              events: function events() {
                u && x.bind.touchEvents(), x.bind.keyboardEvents(), x.bind.inputEvents(), x.bind.mouseEvents();
              },
              touchEvents: function touchEvents() {
                x.debug("Touch device detected binding additional touch events"), x.is.searchSelection() || x.is.single() && M.on("touchstart" + N, x.event.test.toggle), $.on("touchstart" + N, D.item, x.event.item.mouseenter);
              },
              keyboardEvents: function keyboardEvents() {
                x.verbose("Binding keyboard events"), M.on("keydown" + N, x.event.keydown), x.has.search() && M.on(x.get.inputEvent() + N, D.search, x.event.input), x.is.multiple() && a.on("keydown" + y, x.event.document.keydown);
              },
              inputEvents: function inputEvents() {
                x.verbose("Binding input change events"), M.on("change" + N, D.input, x.event.change);
              },
              mouseEvents: function mouseEvents() {
                x.verbose("Binding mouse events"), x.is.multiple() && M.on("click" + N, D.label, x.event.label.click).on("click" + N, D.remove, x.event.remove.click), x.is.searchSelection() ? (M.on("mousedown" + N, x.event.mousedown).on("mouseup" + N, x.event.mouseup).on("mousedown" + N, D.menu, x.event.menu.mousedown).on("mouseup" + N, D.menu, x.event.menu.mouseup).on("click" + N, D.icon, x.event.icon.click).on("focus" + N, D.search, x.event.search.focus).on("click" + N, D.search, x.event.search.focus).on("blur" + N, D.search, x.event.search.blur).on("click" + N, D.text, x.event.text.focus), x.is.multiple() && M.on("click" + N, x.event.click)) : ("click" == C.on ? M.on("click" + N, D.icon, x.event.icon.click).on("click" + N, x.event.test.toggle) : "hover" == C.on ? M.on("mouseenter" + N, x.delay.show).on("mouseleave" + N, x.delay.hide) : M.on(C.on + N, x.toggle), M.on("mousedown" + N, x.event.mousedown).on("mouseup" + N, x.event.mouseup).on("focus" + N, x.event.focus), x.has.menuSearch() ? M.on("blur" + N, D.search, x.event.search.blur) : M.on("blur" + N, x.event.blur)), $.on("mouseenter" + N, D.item, x.event.item.mouseenter).on("mouseleave" + N, D.item, x.event.item.mouseleave).on("click" + N, D.item, x.event.item.click);
              },
              intent: function intent() {
                x.verbose("Binding hide intent event to document"), u && a.on("touchstart" + y, x.event.test.touch).on("touchmove" + y, x.event.test.touch), a.on("click" + y, x.event.test.hide);
              }
            },
            unbind: {
              intent: function intent() {
                x.verbose("Removing hide intent event from document"), u && a.off("touchstart" + y).off("touchmove" + y), a.off("click" + y);
              }
            },
            filter: function filter(e) {
              var t = void 0 !== e ? e : x.get.query(),
                  n = function n() {
                x.is.multiple() && x.filterActive(), (e || !e && 0 == x.get.activeItem().length) && x.select.firstUnfiltered(), x.has.allResultsFiltered() ? C.onNoResults.call(G, t) ? C.allowAdditions ? C.hideAdditions && (x.verbose("User addition with no menu, setting empty style"), x.set.empty(), x.hideMenu()) : (x.verbose("All items filtered, showing message", t), x.add.message(T.noResults)) : (x.verbose("All items filtered, hiding dropdown", t), x.hideMenu()) : (x.remove.empty(), x.remove.message()), C.allowAdditions && x.add.userSuggestion(e), x.is.searchSelection() && x.can.show() && x.is.focusedOnSearch() && x.show();
              };

              C.useLabels && x.has.maxSelections() || (C.apiSettings ? x.can.useAPI() ? x.queryRemote(t, function () {
                C.filterRemoteData && x.filterItems(t), n();
              }) : x.error(L.noAPI) : (x.filterItems(t), n()));
            },
            queryRemote: function queryRemote(t, n) {
              var r = {
                errorDuration: !1,
                cache: "local",
                throttle: C.throttle,
                urlData: {
                  query: t
                },
                onError: function onError() {
                  x.add.message(T.serverError), n();
                },
                onFailure: function onFailure() {
                  x.add.message(T.serverError), n();
                },
                onSuccess: function onSuccess(e) {
                  x.remove.message(), x.setup.menu({
                    values: e[S.remoteValues]
                  }), n();
                }
              };
              M.api("get request") || x.setup.api(), r = e.extend(!0, {}, r, C.apiSettings), M.api("setting", r).api("query");
            },
            filterItems: function filterItems(t) {
              var n = void 0 !== t ? t : x.get.query(),
                  r = null,
                  i = x.escape.string(n),
                  o = new RegExp("^" + i, "igm");
              x.has.query() && (r = [], x.verbose("Searching for matching values", n), V.each(function () {
                var t,
                    i,
                    a = e(this);

                if ("both" == C.match || "text" == C.match) {
                  if (-1 !== (t = String(x.get.choiceText(a, !1))).search(o)) return r.push(this), !0;
                  if ("exact" === C.fullTextSearch && x.exactSearch(n, t)) return r.push(this), !0;
                  if (!0 === C.fullTextSearch && x.fuzzySearch(n, t)) return r.push(this), !0;
                }

                if ("both" == C.match || "value" == C.match) {
                  if (-1 !== (i = String(x.get.choiceValue(a, t))).search(o)) return r.push(this), !0;
                  if ("exact" === C.fullTextSearch && x.exactSearch(n, i)) return r.push(this), !0;
                  if (!0 === C.fullTextSearch && x.fuzzySearch(n, i)) return r.push(this), !0;
                }
              })), x.debug("Showing only matched items", n), x.remove.filteredItem(), r && V.not(r).addClass(k.filtered);
            },
            fuzzySearch: function fuzzySearch(e, t) {
              var n = t.length,
                  r = e.length;
              if (e = e.toLowerCase(), t = t.toLowerCase(), r > n) return !1;
              if (r === n) return e === t;

              e: for (var i = 0, o = 0; i < r; i++) {
                for (var a = e.charCodeAt(i); o < n;) {
                  if (t.charCodeAt(o++) === a) continue e;
                }

                return !1;
              }

              return !0;
            },
            exactSearch: function exactSearch(e, t) {
              return e = e.toLowerCase(), (t = t.toLowerCase()).indexOf(e) > -1;
            },
            filterActive: function filterActive() {
              C.useLabels && V.filter("." + k.active).addClass(k.filtered);
            },
            focusSearch: function focusSearch(e) {
              x.has.search() && !x.is.focusedOnSearch() && (e ? (M.off("focus" + N, D.search), F.focus(), M.on("focus" + N, D.search, x.event.search.focus)) : F.focus());
            },
            forceSelection: function forceSelection() {
              var e = V.not(k.filtered).filter("." + k.selected).eq(0),
                  t = V.not(k.filtered).filter("." + k.active).eq(0),
                  n = e.length > 0 ? e : t;
              if (n.length > 0 && !x.is.multiple()) return x.debug("Forcing partial selection to selected item", n), void x.event.item.click.call(n, {}, !0);
              C.allowAdditions ? (x.set.selected(x.get.query()), x.remove.searchTerm()) : x.remove.searchTerm();
            },
            change: {
              values: function values(t) {
                C.allowAdditions || x.clear(), x.debug("Creating dropdown with specified values", t), x.setup.menu({
                  values: t
                }), e.each(t, function (e, t) {
                  if (1 == t.selected) return x.debug("Setting initial selection to", t.value), x.set.selected(t.value), !0;
                });
              }
            },
            event: {
              change: function change() {
                X || (x.debug("Input changed, updating selection"), x.set.selected());
              },
              focus: function focus() {
                C.showOnFocus && !U && x.is.hidden() && !g && x.show();
              },
              blur: function blur(e) {
                g = n.activeElement === this, U || g || (x.remove.activeLabel(), x.hide());
              },
              mousedown: function mousedown() {
                x.is.searchSelection() ? m = !0 : U = !0;
              },
              mouseup: function mouseup() {
                x.is.searchSelection() ? m = !1 : U = !1;
              },
              click: function click(t) {
                e(t.target).is(M) && (x.is.focusedOnSearch() ? x.show() : x.focusSearch());
              },
              search: {
                focus: function focus() {
                  U = !0, x.is.multiple() && x.remove.activeLabel(), C.showOnFocus && x.search();
                },
                blur: function blur(e) {
                  g = n.activeElement === this, x.is.searchSelection() && !m && (K || g || (C.forceSelection && x.forceSelection(), x.hide())), m = !1;
                }
              },
              icon: {
                click: function click(e) {
                  x.toggle();
                }
              },
              text: {
                focus: function focus(e) {
                  U = !0, x.focusSearch();
                }
              },
              input: function input(e) {
                (x.is.multiple() || x.is.searchSelection()) && x.set.filtered(), clearTimeout(x.timer), x.timer = setTimeout(x.search, C.delay.search);
              },
              label: {
                click: function click(t) {
                  var n = e(this),
                      r = M.find(D.label),
                      i = r.filter("." + k.active),
                      o = n.nextAll("." + k.active),
                      a = n.prevAll("." + k.active),
                      s = o.length > 0 ? n.nextUntil(o).add(i).add(n) : n.prevUntil(a).add(i).add(n);
                  t.shiftKey ? (i.removeClass(k.active), s.addClass(k.active)) : t.ctrlKey ? n.toggleClass(k.active) : (i.removeClass(k.active), n.addClass(k.active)), C.onLabelSelect.apply(this, r.filter("." + k.active));
                }
              },
              remove: {
                click: function click() {
                  var t = e(this).parent();
                  t.hasClass(k.active) ? x.remove.activeLabels() : x.remove.activeLabels(t);
                }
              },
              test: {
                toggle: function toggle(e) {
                  var t = x.is.multiple() ? x.show : x.toggle;
                  x.is.bubbledLabelClick(e) || x.is.bubbledIconClick(e) || x.determine.eventOnElement(e, t) && e.preventDefault();
                },
                touch: function touch(e) {
                  x.determine.eventOnElement(e, function () {
                    "touchstart" == e.type ? x.timer = setTimeout(function () {
                      x.hide();
                    }, C.delay.touch) : "touchmove" == e.type && clearTimeout(x.timer);
                  }), e.stopPropagation();
                },
                hide: function hide(e) {
                  x.determine.eventInModule(e, x.hide);
                }
              },
              select: {
                mutation: function mutation(t) {
                  x.debug("<select> modified, recreating menu");
                  var n = !1;
                  e.each(t, function (t, r) {
                    if (e(r.target).is("select") || e(r.addedNodes).is("select")) return n = !0, !0;
                  }), n && (x.disconnect.selectObserver(), x.refresh(), x.setup.select(), x.set.selected(), x.observe.select());
                }
              },
              menu: {
                mutation: function mutation(t) {
                  var n = t[0],
                      r = n.addedNodes ? e(n.addedNodes[0]) : e(!1),
                      i = n.removedNodes ? e(n.removedNodes[0]) : e(!1),
                      o = r.add(i),
                      a = o.is(D.addition) || o.closest(D.addition).length > 0,
                      s = o.is(D.message) || o.closest(D.message).length > 0;
                  a || s ? (x.debug("Updating item selector cache"), x.refreshItems()) : (x.debug("Menu modified, updating selector cache"), x.refresh());
                },
                mousedown: function mousedown() {
                  K = !0;
                },
                mouseup: function mouseup() {
                  K = !1;
                }
              },
              item: {
                mouseenter: function mouseenter(t) {
                  var n = e(t.target),
                      r = e(this),
                      i = r.children(D.menu),
                      o = r.siblings(D.item).children(D.menu),
                      a = i.length > 0;
                  !(i.find(n).length > 0) && a && (clearTimeout(x.itemTimer), x.itemTimer = setTimeout(function () {
                    x.verbose("Showing sub-menu", i), e.each(o, function () {
                      x.animate.hide(!1, e(this));
                    }), x.animate.show(!1, i);
                  }, C.delay.show), t.preventDefault());
                },
                mouseleave: function mouseleave(t) {
                  var n = e(this).children(D.menu);
                  n.length > 0 && (clearTimeout(x.itemTimer), x.itemTimer = setTimeout(function () {
                    x.verbose("Hiding sub-menu", n), x.animate.hide(!1, n);
                  }, C.delay.hide));
                },
                click: function click(t, r) {
                  var i = e(this),
                      o = e(t ? t.target : ""),
                      a = i.find(D.menu),
                      s = x.get.choiceText(i),
                      u = x.get.choiceValue(i, s),
                      c = a.length > 0,
                      l = a.find(o).length > 0;
                  x.has.menuSearch() && e(n.activeElement).blur(), l || c && !C.allowCategorySelection || (x.is.searchSelection() && (C.allowAdditions && x.remove.userAddition(), x.remove.searchTerm(), x.is.focusedOnSearch() || 1 == r || x.focusSearch(!0)), C.useLabels || (x.remove.filteredItem(), x.set.scrollPosition(i)), x.determine.selectAction.call(this, s, u));
                }
              },
              document: {
                keydown: function keydown(e) {
                  var t = e.which;

                  if (x.is.inObject(t, A)) {
                    var n = M.find(D.label),
                        r = n.filter("." + k.active),
                        i = (r.data(E.value), n.index(r)),
                        o = n.length,
                        a = r.length > 0,
                        s = r.length > 1,
                        u = 0 === i,
                        c = i + 1 == o,
                        l = x.is.searchSelection(),
                        f = x.is.focusedOnSearch(),
                        d = x.is.focused(),
                        p = f && 0 === x.get.caretPosition();
                    if (l && !a && !f) return;
                    t == A.leftArrow ? !d && !p || a ? a && (e.shiftKey ? x.verbose("Adding previous label to selection") : (x.verbose("Selecting previous label"), n.removeClass(k.active)), u && !s ? r.addClass(k.active) : r.prev(D.siblingLabel).addClass(k.active).end(), e.preventDefault()) : (x.verbose("Selecting previous label"), n.last().addClass(k.active)) : t == A.rightArrow ? (d && !a && n.first().addClass(k.active), a && (e.shiftKey ? x.verbose("Adding next label to selection") : (x.verbose("Selecting next label"), n.removeClass(k.active)), c ? l ? f ? n.removeClass(k.active) : x.focusSearch() : s ? r.next(D.siblingLabel).addClass(k.active) : r.addClass(k.active) : r.next(D.siblingLabel).addClass(k.active), e.preventDefault())) : t == A.deleteKey || t == A.backspace ? a ? (x.verbose("Removing active labels"), c && l && !f && x.focusSearch(), r.last().next(D.siblingLabel).addClass(k.active), x.remove.activeLabels(r), e.preventDefault()) : p && !a && t == A.backspace && (x.verbose("Removing last label on input backspace"), r = n.last().addClass(k.active), x.remove.activeLabels(r)) : r.removeClass(k.active);
                  }
                }
              },
              keydown: function keydown(e) {
                var t = e.which;

                if (x.is.inObject(t, A)) {
                  var n,
                      r = V.not(D.unselectable).filter("." + k.selected).eq(0),
                      i = $.children("." + k.active).eq(0),
                      o = r.length > 0 ? r : i,
                      a = o.length > 0 ? o.siblings(":not(." + k.filtered + ")").addBack() : $.children(":not(." + k.filtered + ")"),
                      s = o.children(D.menu),
                      u = o.closest(D.menu),
                      c = u.hasClass(k.visible) || u.hasClass(k.animating) || u.parent(D.menu).length > 0,
                      l = s.length > 0,
                      f = o.length > 0,
                      d = o.not(D.unselectable).length > 0,
                      p = t == A.delimiter && C.allowAdditions && x.is.multiple();

                  if (C.allowAdditions && C.hideAdditions && (t == A.enter || p) && d && (x.verbose("Selecting item from keyboard shortcut", o), x.event.item.click.call(o, e), x.is.searchSelection() && x.remove.searchTerm()), x.is.visible()) {
                    if ((t == A.enter || p) && (t == A.enter && f && l && !C.allowCategorySelection ? (x.verbose("Pressed enter on unselectable category, opening sub menu"), t = A.rightArrow) : d && (x.verbose("Selecting item from keyboard shortcut", o), x.event.item.click.call(o, e), x.is.searchSelection() && x.remove.searchTerm()), e.preventDefault()), f && (t == A.leftArrow && u[0] !== $[0] && (x.verbose("Left key pressed, closing sub-menu"), x.animate.hide(!1, u), o.removeClass(k.selected), u.closest(D.item).addClass(k.selected), e.preventDefault()), t == A.rightArrow && l && (x.verbose("Right key pressed, opening sub-menu"), x.animate.show(!1, s), o.removeClass(k.selected), s.find(D.item).eq(0).addClass(k.selected), e.preventDefault())), t == A.upArrow) {
                      if (n = f && c ? o.prevAll(D.item + ":not(" + D.unselectable + ")").eq(0) : V.eq(0), a.index(n) < 0) return x.verbose("Up key pressed but reached top of current menu"), void e.preventDefault();
                      x.verbose("Up key pressed, changing active item"), o.removeClass(k.selected), n.addClass(k.selected), x.set.scrollPosition(n), C.selectOnKeydown && x.is.single() && x.set.selectedItem(n), e.preventDefault();
                    }

                    if (t == A.downArrow) {
                      if (0 === (n = f && c ? n = o.nextAll(D.item + ":not(" + D.unselectable + ")").eq(0) : V.eq(0)).length) return x.verbose("Down key pressed but reached bottom of current menu"), void e.preventDefault();
                      x.verbose("Down key pressed, changing active item"), V.removeClass(k.selected), n.addClass(k.selected), x.set.scrollPosition(n), C.selectOnKeydown && x.is.single() && x.set.selectedItem(n), e.preventDefault();
                    }

                    t == A.pageUp && (x.scrollPage("up"), e.preventDefault()), t == A.pageDown && (x.scrollPage("down"), e.preventDefault()), t == A.escape && (x.verbose("Escape key pressed, closing dropdown"), x.hide());
                  } else p && e.preventDefault(), t != A.downArrow || x.is.visible() || (x.verbose("Down key pressed, showing dropdown"), x.show(), e.preventDefault());
                } else x.has.search() || x.set.selectedLetter(String.fromCharCode(t));
              }
            },
            trigger: {
              change: function change() {
                var e = n.createEvent("HTMLEvents"),
                    t = z[0];
                t && (x.verbose("Triggering native change event"), e.initEvent("change", !0, !1), t.dispatchEvent(e));
              }
            },
            determine: {
              selectAction: function selectAction(t, n) {
                x.verbose("Determining action", C.action), e.isFunction(x.action[C.action]) ? (x.verbose("Triggering preset action", C.action, t, n), x.action[C.action].call(G, t, n, this)) : e.isFunction(C.action) ? (x.verbose("Triggering user action", C.action, t, n), C.action.call(G, t, n, this)) : x.error(L.action, C.action);
              },
              eventInModule: function eventInModule(t, r) {
                var i = e(t.target),
                    o = i.closest(n.documentElement).length > 0,
                    a = i.closest(M).length > 0;
                return r = e.isFunction(r) ? r : function () {}, o && !a ? (x.verbose("Triggering event", r), r(), !0) : (x.verbose("Event occurred in dropdown, canceling callback"), !1);
              },
              eventOnElement: function eventOnElement(t, r) {
                var i = e(t.target),
                    o = i.closest(D.siblingLabel),
                    a = n.body.contains(t.target),
                    s = 0 === M.find(o).length,
                    u = 0 === i.closest($).length;
                return r = e.isFunction(r) ? r : function () {}, a && s && u ? (x.verbose("Triggering event", r), r(), !0) : (x.verbose("Event occurred in dropdown menu, canceling callback"), !1);
              }
            },
            action: {
              nothing: function nothing() {},
              activate: function activate(t, n, r) {
                if (n = void 0 !== n ? n : t, x.can.activate(e(r))) {
                  if (x.set.selected(n, e(r)), x.is.multiple() && !x.is.allFiltered()) return;
                  x.hideAndClear();
                }
              },
              select: function select(t, n, r) {
                if (n = void 0 !== n ? n : t, x.can.activate(e(r))) {
                  if (x.set.value(n, e(r)), x.is.multiple() && !x.is.allFiltered()) return;
                  x.hideAndClear();
                }
              },
              combo: function combo(t, n, r) {
                n = void 0 !== n ? n : t, x.set.selected(n, e(r)), x.hideAndClear();
              },
              hide: function hide(e, t, n) {
                x.set.value(t, e), x.hideAndClear();
              }
            },
            get: {
              id: function id() {
                return b;
              },
              defaultText: function defaultText() {
                return M.data(E.defaultText);
              },
              defaultValue: function defaultValue() {
                return M.data(E.defaultValue);
              },
              placeholderText: function placeholderText() {
                return "auto" != C.placeholder && "string" == typeof C.placeholder ? C.placeholder : M.data(E.placeholderText) || "";
              },
              text: function text() {
                return q.text();
              },
              query: function query() {
                return e.trim(F.val());
              },
              searchWidth: function searchWidth(e) {
                return e = void 0 !== e ? e : F.val(), B.text(e), Math.ceil(B.width() + 1);
              },
              selectionCount: function selectionCount() {
                var t = x.get.values();
                return x.is.multiple() ? e.isArray(t) ? t.length : 0 : "" !== x.get.value() ? 1 : 0;
              },
              transition: function transition(e) {
                return "auto" == C.transition ? x.is.upward(e) ? "slide up" : "slide down" : C.transition;
              },
              userValues: function userValues() {
                var t = x.get.values();
                return !!t && (t = e.isArray(t) ? t : [t], e.grep(t, function (e) {
                  return !1 === x.get.item(e);
                }));
              },
              uniqueArray: function uniqueArray(t) {
                return e.grep(t, function (n, r) {
                  return e.inArray(n, t) === r;
                });
              },
              caretPosition: function caretPosition() {
                var e,
                    t,
                    r = F.get(0);
                return "selectionStart" in r ? r.selectionStart : n.selection ? (r.focus(), t = (e = n.selection.createRange()).text.length, e.moveStart("character", -r.value.length), e.text.length - t) : void 0;
              },
              value: function value() {
                var t = z.length > 0 ? z.val() : M.data(E.value),
                    n = e.isArray(t) && 1 === t.length && "" === t[0];
                return void 0 === t || n ? "" : t;
              },
              values: function values() {
                var e = x.get.value();
                return "" === e ? "" : !x.has.selectInput() && x.is.multiple() ? "string" == typeof e ? e.split(C.delimiter) : "" : e;
              },
              remoteValues: function remoteValues() {
                var t = x.get.values(),
                    n = !1;
                return t && ("string" == typeof t && (t = [t]), e.each(t, function (e, t) {
                  var r = x.read.remoteData(t);
                  x.verbose("Restoring value from session data", r, t), r && (n || (n = {}), n[t] = r);
                })), n;
              },
              choiceText: function choiceText(t, n) {
                if (n = void 0 !== n ? n : C.preserveHTML, t) return t.find(D.menu).length > 0 && (x.verbose("Retrieving text of element with sub-menu"), (t = t.clone()).find(D.menu).remove(), t.find(D.menuIcon).remove()), void 0 !== t.data(E.text) ? t.data(E.text) : n ? e.trim(t.html()) : e.trim(t.text());
              },
              choiceValue: function choiceValue(t, n) {
                return n = n || x.get.choiceText(t), !!t && (void 0 !== t.data(E.value) ? String(t.data(E.value)) : "string" == typeof n ? e.trim(n.toLowerCase()) : String(n));
              },
              inputEvent: function inputEvent() {
                var e = F[0];
                return !!e && (void 0 !== e.oninput ? "input" : void 0 !== e.onpropertychange ? "propertychange" : "keyup");
              },
              selectValues: function selectValues() {
                var t = {
                  values: []
                };
                return M.find("option").each(function () {
                  var n = e(this),
                      r = n.html(),
                      i = n.attr("disabled"),
                      o = void 0 !== n.attr("value") ? n.attr("value") : r;
                  "auto" === C.placeholder && "" === o ? t.placeholder = r : t.values.push({
                    name: r,
                    value: o,
                    disabled: i
                  });
                }), C.placeholder && "auto" !== C.placeholder && (x.debug("Setting placeholder value to", C.placeholder), t.placeholder = C.placeholder), C.sortSelect ? (t.values.sort(function (e, t) {
                  return e.name > t.name ? 1 : -1;
                }), x.debug("Retrieved and sorted values from select", t)) : x.debug("Retrieved values from select", t), t;
              },
              activeItem: function activeItem() {
                return V.filter("." + k.active);
              },
              selectedItem: function selectedItem() {
                var e = V.not(D.unselectable).filter("." + k.selected);
                return e.length > 0 ? e : V.eq(0);
              },
              itemWithAdditions: function itemWithAdditions(e) {
                var t = x.get.item(e),
                    n = x.create.userChoice(e);
                return n && n.length > 0 && (t = t.length > 0 ? t.add(n) : n), t;
              },
              item: function item(t, n) {
                var r,
                    i,
                    o = !1;
                return t = void 0 !== t ? t : void 0 !== x.get.values() ? x.get.values() : x.get.text(), r = i ? t.length > 0 : null != t, i = x.is.multiple() && e.isArray(t), n = "" === t || 0 === t || n || !1, r && V.each(function () {
                  var r = e(this),
                      a = x.get.choiceText(r),
                      s = x.get.choiceValue(r, a);
                  if (null != s) if (i) -1 === e.inArray(String(s), t) && -1 === e.inArray(a, t) || (o = o ? o.add(r) : r);else if (n) {
                    if (x.verbose("Ambiguous dropdown value using strict type check", r, t), s === t || a === t) return o = r, !0;
                  } else if (String(s) == String(t) || a == t) return x.verbose("Found select item by value", s, t), o = r, !0;
                }), o;
              }
            },
            check: {
              maxSelections: function maxSelections(e) {
                return !C.maxSelections || ((e = void 0 !== e ? e : x.get.selectionCount()) >= C.maxSelections ? (x.debug("Maximum selection count reached"), C.useLabels && (V.addClass(k.filtered), x.add.message(T.maxSelections)), !0) : (x.verbose("No longer at maximum selection count"), x.remove.message(), x.remove.filteredItem(), x.is.searchSelection() && x.filterItems(), !1));
              }
            },
            restore: {
              defaults: function defaults() {
                x.clear(), x.restore.defaultText(), x.restore.defaultValue();
              },
              defaultText: function defaultText() {
                var e = x.get.defaultText();
                e === x.get.placeholderText ? (x.debug("Restoring default placeholder text", e), x.set.placeholderText(e)) : (x.debug("Restoring default text", e), x.set.text(e));
              },
              placeholderText: function placeholderText() {
                x.set.placeholderText();
              },
              defaultValue: function defaultValue() {
                var e = x.get.defaultValue();
                void 0 !== e && (x.debug("Restoring default value", e), "" !== e ? (x.set.value(e), x.set.selected()) : (x.remove.activeItem(), x.remove.selectedItem()));
              },
              labels: function labels() {
                C.allowAdditions && (C.useLabels || (x.error(L.labels), C.useLabels = !0), x.debug("Restoring selected values"), x.create.userLabels()), x.check.maxSelections();
              },
              selected: function selected() {
                x.restore.values(), x.is.multiple() ? (x.debug("Restoring previously selected values and labels"), x.restore.labels()) : x.debug("Restoring previously selected values");
              },
              values: function values() {
                x.set.initialLoad(), C.apiSettings && C.saveRemoteData && x.get.remoteValues() ? x.restore.remoteValues() : x.set.selected(), x.remove.initialLoad();
              },
              remoteValues: function remoteValues() {
                var t = x.get.remoteValues();
                x.debug("Recreating selected from session data", t), t && (x.is.single() ? e.each(t, function (e, t) {
                  x.set.text(t);
                }) : e.each(t, function (e, t) {
                  x.add.label(e, t);
                }));
              }
            },
            read: {
              remoteData: function remoteData(e) {
                var n;
                if (void 0 !== t.Storage) return void 0 !== (n = sessionStorage.getItem(e)) && n;
                x.error(L.noStorage);
              }
            },
            save: {
              defaults: function defaults() {
                x.save.defaultText(), x.save.placeholderText(), x.save.defaultValue();
              },
              defaultValue: function defaultValue() {
                var e = x.get.value();
                x.verbose("Saving default value as", e), M.data(E.defaultValue, e);
              },
              defaultText: function defaultText() {
                var e = x.get.text();
                x.verbose("Saving default text as", e), M.data(E.defaultText, e);
              },
              placeholderText: function placeholderText() {
                var e;
                !1 !== C.placeholder && q.hasClass(k.placeholder) && (e = x.get.text(), x.verbose("Saving placeholder text as", e), M.data(E.placeholderText, e));
              },
              remoteData: function remoteData(e, n) {
                void 0 !== t.Storage ? (x.verbose("Saving remote data to session storage", n, e), sessionStorage.setItem(n, e)) : x.error(L.noStorage);
              }
            },
            clear: function clear() {
              x.is.multiple() && C.useLabels ? x.remove.labels() : (x.remove.activeItem(), x.remove.selectedItem()), x.set.placeholderText(), x.clearValue();
            },
            clearValue: function clearValue() {
              x.set.value("");
            },
            scrollPage: function scrollPage(e, t) {
              var n,
                  r,
                  i = t || x.get.selectedItem(),
                  o = i.closest(D.menu),
                  a = o.outerHeight(),
                  s = o.scrollTop(),
                  u = V.eq(0).outerHeight(),
                  c = Math.floor(a / u),
                  l = (o.prop("scrollHeight"), "up" == e ? s - u * c : s + u * c),
                  f = V.not(D.unselectable);
              r = "up" == e ? f.index(i) - c : f.index(i) + c, (n = ("up" == e ? r >= 0 : r < f.length) ? f.eq(r) : "up" == e ? f.first() : f.last()).length > 0 && (x.debug("Scrolling page", e, n), i.removeClass(k.selected), n.addClass(k.selected), C.selectOnKeydown && x.is.single() && x.set.selectedItem(n), o.scrollTop(l));
            },
            set: {
              filtered: function filtered() {
                var e = x.is.multiple(),
                    t = x.is.searchSelection(),
                    n = e && t,
                    r = t ? x.get.query() : "",
                    i = "string" == typeof r && r.length > 0,
                    o = x.get.searchWidth(),
                    a = "" !== r;
                e && i && (x.verbose("Adjusting input width", o, C.glyphWidth), F.css("width", o)), i || n && a ? (x.verbose("Hiding placeholder text"), q.addClass(k.filtered)) : (!e || n && !a) && (x.verbose("Showing placeholder text"), q.removeClass(k.filtered));
              },
              empty: function empty() {
                M.addClass(k.empty);
              },
              loading: function loading() {
                M.addClass(k.loading);
              },
              placeholderText: function placeholderText(e) {
                e = e || x.get.placeholderText(), x.debug("Setting placeholder text", e), x.set.text(e), q.addClass(k.placeholder);
              },
              tabbable: function tabbable() {
                x.is.searchSelection() ? (x.debug("Added tabindex to searchable dropdown"), F.val("").attr("tabindex", 0), $.attr("tabindex", -1)) : (x.debug("Added tabindex to dropdown"), void 0 === M.attr("tabindex") && (M.attr("tabindex", 0), $.attr("tabindex", -1)));
              },
              initialLoad: function initialLoad() {
                x.verbose("Setting initial load"), v = !0;
              },
              activeItem: function activeItem(e) {
                C.allowAdditions && e.filter(D.addition).length > 0 ? e.addClass(k.filtered) : e.addClass(k.active);
              },
              partialSearch: function partialSearch(e) {
                var t = x.get.query().length;
                F.val(e.substr(0, t));
              },
              scrollPosition: function scrollPosition(e, t) {
                var n, r, i, o, a, s;
                n = (e = e || x.get.selectedItem()).closest(D.menu), r = e && e.length > 0, t = void 0 !== t && t, e && n.length > 0 && r && (e.position().top, n.addClass(k.loading), i = (o = n.scrollTop()) - n.offset().top + e.offset().top, t || (s = o + n.height() < i + 5, a = i - 5 < o), x.debug("Scrolling to active item", i), (t || a || s) && n.scrollTop(i), n.removeClass(k.loading));
              },
              text: function text(e) {
                "select" !== C.action && ("combo" == C.action ? (x.debug("Changing combo button text", e, W), C.preserveHTML ? W.html(e) : W.text(e)) : (e !== x.get.placeholderText() && q.removeClass(k.placeholder), x.debug("Changing text", e, q), q.removeClass(k.filtered), C.preserveHTML ? q.html(e) : q.text(e)));
              },
              selectedItem: function selectedItem(e) {
                var t = x.get.choiceValue(e),
                    n = x.get.choiceText(e, !1),
                    r = x.get.choiceText(e, !0);
                x.debug("Setting user selection to item", e), x.remove.activeItem(), x.set.partialSearch(n), x.set.activeItem(e), x.set.selected(t, e), x.set.text(r);
              },
              selectedLetter: function selectedLetter(t) {
                var n,
                    r = V.filter("." + k.selected),
                    i = r.length > 0 && x.has.firstLetter(r, t),
                    o = !1;
                i && (n = r.nextAll(V).eq(0), x.has.firstLetter(n, t) && (o = n)), o || V.each(function () {
                  if (x.has.firstLetter(e(this), t)) return o = e(this), !1;
                }), o && (x.verbose("Scrolling to next value with letter", t), x.set.scrollPosition(o), r.removeClass(k.selected), o.addClass(k.selected), C.selectOnKeydown && x.is.single() && x.set.selectedItem(o));
              },
              direction: function direction(e) {
                "auto" == C.direction ? (x.remove.upward(), x.can.openDownward(e) ? x.remove.upward(e) : x.set.upward(e), x.is.leftward(e) || x.can.openRightward(e) || x.set.leftward(e)) : "upward" == C.direction && x.set.upward(e);
              },
              upward: function upward(e) {
                (e || M).addClass(k.upward);
              },
              leftward: function leftward(e) {
                (e || $).addClass(k.leftward);
              },
              value: function value(e, t, n) {
                var r = x.escape.value(e),
                    i = z.length > 0,
                    o = (x.has.value(e), x.get.values()),
                    a = void 0 !== e ? String(e) : e;

                if (i) {
                  if (!C.allowReselection && a == o && (x.verbose("Skipping value update already same value", e, o), !x.is.initialLoad())) return;
                  x.is.single() && x.has.selectInput() && x.can.extendSelect() && (x.debug("Adding user option", e), x.add.optionValue(e)), x.debug("Updating input value", r, o), X = !0, z.val(r), !1 === C.fireOnInit && x.is.initialLoad() ? x.debug("Input native change event ignored on initial load") : x.trigger.change(), X = !1;
                } else x.verbose("Storing value in metadata", r, z), r !== o && M.data(E.value, a);

                !1 === C.fireOnInit && x.is.initialLoad() ? x.verbose("No callback on initial load", C.onChange) : C.onChange.call(G, e, t, n);
              },
              active: function active() {
                M.addClass(k.active);
              },
              multiple: function multiple() {
                M.addClass(k.multiple);
              },
              visible: function visible() {
                M.addClass(k.visible);
              },
              exactly: function exactly(e, t) {
                x.debug("Setting selected to exact values"), x.clear(), x.set.selected(e, t);
              },
              selected: function selected(t, n) {
                var r = x.is.multiple();
                (n = C.allowAdditions ? n || x.get.itemWithAdditions(t) : n || x.get.item(t)) && (x.debug("Setting selected menu item to", n), x.is.multiple() && x.remove.searchWidth(), x.is.single() ? (x.remove.activeItem(), x.remove.selectedItem()) : C.useLabels && x.remove.selectedItem(), n.each(function () {
                  var t = e(this),
                      i = x.get.choiceText(t),
                      o = x.get.choiceValue(t, i),
                      a = t.hasClass(k.filtered),
                      s = t.hasClass(k.active),
                      u = t.hasClass(k.addition),
                      c = r && 1 == n.length;
                  r ? !s || u ? (C.apiSettings && C.saveRemoteData && x.save.remoteData(i, o), C.useLabels ? (x.add.value(o, i, t), x.add.label(o, i, c), x.set.activeItem(t), x.filterActive(), x.select.nextAvailable(n)) : (x.add.value(o, i, t), x.set.text(x.add.variables(T.count)), x.set.activeItem(t))) : a || (x.debug("Selected active value, removing label"), x.remove.selected(o)) : (C.apiSettings && C.saveRemoteData && x.save.remoteData(i, o), x.set.text(i), x.set.value(o, i, t), t.addClass(k.active).addClass(k.selected));
                }));
              }
            },
            add: {
              label: function label(t, n, r) {
                var i,
                    o = x.is.searchSelection() ? F : q,
                    a = x.escape.value(t);
                i = e("<a />").addClass(k.label).attr("data-" + E.value, a).html(P.label(a, n)), i = C.onLabelCreate.call(i, a, n), x.has.label(t) ? x.debug("Label already exists, skipping", a) : (C.label.variation && i.addClass(C.label.variation), !0 === r ? (x.debug("Animating in label", i), i.addClass(k.hidden).insertBefore(o).transition(C.label.transition, C.label.duration)) : (x.debug("Adding selection label", i), i.insertBefore(o)));
              },
              message: function message(t) {
                var n = $.children(D.message),
                    r = C.templates.message(x.add.variables(t));
                n.length > 0 ? n.html(r) : n = e("<div/>").html(r).addClass(k.message).appendTo($);
              },
              optionValue: function optionValue(t) {
                var n = x.escape.value(t);
                z.find('option[value="' + x.escape.string(n) + '"]').length > 0 || (x.disconnect.selectObserver(), x.is.single() && (x.verbose("Removing previous user addition"), z.find("option." + k.addition).remove()), e("<option/>").prop("value", n).addClass(k.addition).html(t).appendTo(z), x.verbose("Adding user addition as an <option>", t), x.observe.select());
              },
              userSuggestion: function userSuggestion(e) {
                var t,
                    n = $.children(D.addition),
                    r = x.get.item(e),
                    i = r && r.not(D.addition).length,
                    o = n.length > 0;
                C.useLabels && x.has.maxSelections() || ("" === e || i ? n.remove() : (o ? (n.data(E.value, e).data(E.text, e).attr("data-" + E.value, e).attr("data-" + E.text, e).removeClass(k.filtered), C.hideAdditions || (t = C.templates.addition(x.add.variables(T.addResult, e)), n.html(t)), x.verbose("Replacing user suggestion with new value", n)) : ((n = x.create.userChoice(e)).prependTo($), x.verbose("Adding item choice to menu corresponding with user choice addition", n)), C.hideAdditions && !x.is.allFiltered() || n.addClass(k.selected).siblings().removeClass(k.selected), x.refreshItems()));
              },
              variables: function variables(e, t) {
                var n,
                    r,
                    i = -1 !== e.search("{count}"),
                    o = -1 !== e.search("{maxCount}"),
                    a = -1 !== e.search("{term}");
                return x.verbose("Adding templated variables to message", e), i && (n = x.get.selectionCount(), e = e.replace("{count}", n)), o && (n = x.get.selectionCount(), e = e.replace("{maxCount}", C.maxSelections)), a && (r = t || x.get.query(), e = e.replace("{term}", r)), e;
              },
              value: function value(t, n, r) {
                var i,
                    o = x.get.values();
                "" !== t ? (e.isArray(o) ? (i = o.concat([t]), i = x.get.uniqueArray(i)) : i = [t], x.has.selectInput() ? x.can.extendSelect() && (x.debug("Adding value to select", t, i, z), x.add.optionValue(t)) : (i = i.join(C.delimiter), x.debug("Setting hidden input to delimited value", i, z)), !1 === C.fireOnInit && x.is.initialLoad() ? x.verbose("Skipping onadd callback on initial load", C.onAdd) : C.onAdd.call(G, t, n, r), x.set.value(i, t, n, r), x.check.maxSelections()) : x.debug("Cannot select blank values from multiselect");
              }
            },
            remove: {
              active: function active() {
                M.removeClass(k.active);
              },
              activeLabel: function activeLabel() {
                M.find(D.label).removeClass(k.active);
              },
              empty: function empty() {
                M.removeClass(k.empty);
              },
              loading: function loading() {
                M.removeClass(k.loading);
              },
              initialLoad: function initialLoad() {
                v = !1;
              },
              upward: function upward(e) {
                (e || M).removeClass(k.upward);
              },
              leftward: function leftward(e) {
                (e || $).removeClass(k.leftward);
              },
              visible: function visible() {
                M.removeClass(k.visible);
              },
              activeItem: function activeItem() {
                V.removeClass(k.active);
              },
              filteredItem: function filteredItem() {
                C.useLabels && x.has.maxSelections() || (C.useLabels && x.is.multiple() ? V.not("." + k.active).removeClass(k.filtered) : V.removeClass(k.filtered), x.remove.empty());
              },
              optionValue: function optionValue(e) {
                var t = x.escape.value(e),
                    n = z.find('option[value="' + x.escape.string(t) + '"]');
                n.length > 0 && n.hasClass(k.addition) && (w && (w.disconnect(), x.verbose("Temporarily disconnecting mutation observer")), n.remove(), x.verbose("Removing user addition as an <option>", t), w && w.observe(z[0], {
                  childList: !0,
                  subtree: !0
                }));
              },
              message: function message() {
                $.children(D.message).remove();
              },
              searchWidth: function searchWidth() {
                F.css("width", "");
              },
              searchTerm: function searchTerm() {
                x.verbose("Cleared search term"), F.val(""), x.set.filtered();
              },
              userAddition: function userAddition() {
                V.filter(D.addition).remove();
              },
              selected: function selected(t, n) {
                if (!(n = C.allowAdditions ? n || x.get.itemWithAdditions(t) : n || x.get.item(t))) return !1;
                n.each(function () {
                  var t = e(this),
                      n = x.get.choiceText(t),
                      r = x.get.choiceValue(t, n);
                  x.is.multiple() ? C.useLabels ? (x.remove.value(r, n, t), x.remove.label(r)) : (x.remove.value(r, n, t), 0 === x.get.selectionCount() ? x.set.placeholderText() : x.set.text(x.add.variables(T.count))) : x.remove.value(r, n, t), t.removeClass(k.filtered).removeClass(k.active), C.useLabels && t.removeClass(k.selected);
                });
              },
              selectedItem: function selectedItem() {
                V.removeClass(k.selected);
              },
              value: function value(e, t, n) {
                var r,
                    i = x.get.values();
                x.has.selectInput() ? (x.verbose("Input is <select> removing selected option", e), r = x.remove.arrayValue(e, i), x.remove.optionValue(e)) : (x.verbose("Removing from delimited values", e), r = (r = x.remove.arrayValue(e, i)).join(C.delimiter)), !1 === C.fireOnInit && x.is.initialLoad() ? x.verbose("No callback on initial load", C.onRemove) : C.onRemove.call(G, e, t, n), x.set.value(r, t, n), x.check.maxSelections();
              },
              arrayValue: function arrayValue(t, n) {
                return e.isArray(n) || (n = [n]), n = e.grep(n, function (e) {
                  return t != e;
                }), x.verbose("Removed value from delimited string", t, n), n;
              },
              label: function label(e, t) {
                var n = M.find(D.label).filter("[data-" + E.value + '="' + x.escape.string(e) + '"]');
                x.verbose("Removing label", n), n.remove();
              },
              activeLabels: function activeLabels(e) {
                e = e || M.find(D.label).filter("." + k.active), x.verbose("Removing active label selections", e), x.remove.labels(e);
              },
              labels: function labels(t) {
                t = t || M.find(D.label), x.verbose("Removing labels", t), t.each(function () {
                  var t = e(this),
                      n = t.data(E.value),
                      r = void 0 !== n ? String(n) : n,
                      i = x.is.userValue(r);
                  !1 !== C.onLabelRemove.call(t, n) ? (x.remove.message(), i ? (x.remove.value(r), x.remove.label(r)) : x.remove.selected(r)) : x.debug("Label remove callback cancelled removal");
                });
              },
              tabbable: function tabbable() {
                x.is.searchSelection() ? (x.debug("Searchable dropdown initialized"), F.removeAttr("tabindex"), $.removeAttr("tabindex")) : (x.debug("Simple selection dropdown initialized"), M.removeAttr("tabindex"), $.removeAttr("tabindex"));
              }
            },
            has: {
              menuSearch: function menuSearch() {
                return x.has.search() && F.closest($).length > 0;
              },
              search: function search() {
                return F.length > 0;
              },
              sizer: function sizer() {
                return B.length > 0;
              },
              selectInput: function selectInput() {
                return z.is("select");
              },
              minCharacters: function minCharacters(e) {
                return !C.minCharacters || (e = String(void 0 !== e ? e : x.get.query())).length >= C.minCharacters;
              },
              firstLetter: function firstLetter(e, t) {
                var n;
                return !(!e || 0 === e.length || "string" != typeof t) && (n = x.get.choiceText(e, !1), (t = t.toLowerCase()) == String(n).charAt(0).toLowerCase());
              },
              input: function input() {
                return z.length > 0;
              },
              items: function items() {
                return V.length > 0;
              },
              menu: function menu() {
                return $.length > 0;
              },
              message: function message() {
                return 0 !== $.children(D.message).length;
              },
              label: function label(e) {
                var t = x.escape.value(e);
                return M.find(D.label).filter("[data-" + E.value + '="' + x.escape.string(t) + '"]').length > 0;
              },
              maxSelections: function maxSelections() {
                return C.maxSelections && x.get.selectionCount() >= C.maxSelections;
              },
              allResultsFiltered: function allResultsFiltered() {
                var e = V.not(D.addition);
                return e.filter(D.unselectable).length === e.length;
              },
              userSuggestion: function userSuggestion() {
                return $.children(D.addition).length > 0;
              },
              query: function query() {
                return "" !== x.get.query();
              },
              value: function value(t) {
                var n = x.get.values();
                return !!(e.isArray(n) ? n && -1 !== e.inArray(t, n) : n == t);
              }
            },
            is: {
              active: function active() {
                return M.hasClass(k.active);
              },
              bubbledLabelClick: function bubbledLabelClick(t) {
                return e(t.target).is("select, input") && M.closest("label").length > 0;
              },
              bubbledIconClick: function bubbledIconClick(t) {
                return e(t.target).closest(H).length > 0;
              },
              alreadySetup: function alreadySetup() {
                return M.is("select") && void 0 !== M.parent(D.dropdown).data(I) && 0 === M.prev().length;
              },
              animating: function animating(e) {
                return e ? e.transition && e.transition("is animating") : $.transition && $.transition("is animating");
              },
              leftward: function leftward(e) {
                return (e || $).hasClass(k.leftward);
              },
              disabled: function disabled() {
                return M.hasClass(k.disabled);
              },
              focused: function focused() {
                return n.activeElement === M[0];
              },
              focusedOnSearch: function focusedOnSearch() {
                return n.activeElement === F[0];
              },
              allFiltered: function allFiltered() {
                return (x.is.multiple() || x.has.search()) && !(0 == C.hideAdditions && x.has.userSuggestion()) && !x.has.message() && x.has.allResultsFiltered();
              },
              hidden: function hidden(e) {
                return !x.is.visible(e);
              },
              initialLoad: function initialLoad() {
                return v;
              },
              inObject: function inObject(t, n) {
                var r = !1;
                return e.each(n, function (e, n) {
                  if (n == t) return r = !0, !0;
                }), r;
              },
              multiple: function multiple() {
                return M.hasClass(k.multiple);
              },
              remote: function remote() {
                return C.apiSettings && x.can.useAPI();
              },
              single: function single() {
                return !x.is.multiple();
              },
              selectMutation: function selectMutation(t) {
                var n = !1;
                return e.each(t, function (t, r) {
                  if (r.target && e(r.target).is("select")) return n = !0, !0;
                }), n;
              },
              search: function search() {
                return M.hasClass(k.search);
              },
              searchSelection: function searchSelection() {
                return x.has.search() && 1 === F.parent(D.dropdown).length;
              },
              selection: function selection() {
                return M.hasClass(k.selection);
              },
              userValue: function userValue(t) {
                return -1 !== e.inArray(t, x.get.userValues());
              },
              upward: function upward(e) {
                return (e || M).hasClass(k.upward);
              },
              visible: function visible(e) {
                return e ? e.hasClass(k.visible) : $.hasClass(k.visible);
              },
              verticallyScrollableContext: function verticallyScrollableContext() {
                var e = R.get(0) !== t && R.css("overflow-y");
                return "auto" == e || "scroll" == e;
              },
              horizontallyScrollableContext: function horizontallyScrollableContext() {
                var e = R.get(0) !== t && R.css("overflow-X");
                return "auto" == e || "scroll" == e;
              }
            },
            can: {
              activate: function activate(e) {
                return !!C.useLabels || !x.has.maxSelections() || !(!x.has.maxSelections() || !e.hasClass(k.active));
              },
              openDownward: function openDownward(e) {
                var t,
                    n,
                    r = e || $,
                    i = !0;
                return r.addClass(k.loading), n = {
                  context: {
                    scrollTop: R.scrollTop(),
                    height: R.outerHeight()
                  },
                  menu: {
                    offset: r.offset(),
                    height: r.outerHeight()
                  }
                }, x.is.verticallyScrollableContext() && (n.menu.offset.top += n.context.scrollTop), (t = {
                  above: n.context.scrollTop <= n.menu.offset.top - n.menu.height,
                  below: n.context.scrollTop + n.context.height >= n.menu.offset.top + n.menu.height
                }).below ? (x.verbose("Dropdown can fit in context downward", t), i = !0) : t.below || t.above ? (x.verbose("Dropdown cannot fit below, opening upward", t), i = !1) : (x.verbose("Dropdown cannot fit in either direction, favoring downward", t), i = !0), r.removeClass(k.loading), i;
              },
              openRightward: function openRightward(e) {
                var t,
                    n,
                    r = e || $,
                    i = !0;
                return r.addClass(k.loading), n = {
                  context: {
                    scrollLeft: R.scrollLeft(),
                    width: R.outerWidth()
                  },
                  menu: {
                    offset: r.offset(),
                    width: r.outerWidth()
                  }
                }, x.is.horizontallyScrollableContext() && (n.menu.offset.left += n.context.scrollLeft), (t = n.menu.offset.left + n.menu.width >= n.context.scrollLeft + n.context.width) && (x.verbose("Dropdown cannot fit in context rightward", t), i = !1), r.removeClass(k.loading), i;
              },
              click: function click() {
                return u || "click" == C.on;
              },
              extendSelect: function extendSelect() {
                return C.allowAdditions || C.apiSettings;
              },
              show: function show() {
                return !x.is.disabled() && (x.has.items() || x.has.message());
              },
              useAPI: function useAPI() {
                return void 0 !== e.fn.api;
              }
            },
            animate: {
              show: function show(t, n) {
                var r,
                    i = n || $,
                    o = n ? function () {} : function () {
                  x.hideSubMenus(), x.hideOthers(), x.set.active();
                };
                t = e.isFunction(t) ? t : function () {}, x.verbose("Doing menu show animation", i), x.set.direction(n), r = x.get.transition(n), x.is.selection() && x.set.scrollPosition(x.get.selectedItem(), !0), (x.is.hidden(i) || x.is.animating(i)) && ("none" == r ? (o(), i.transition("show"), t.call(G)) : void 0 !== e.fn.transition && M.transition("is supported") ? i.transition({
                  animation: r + " in",
                  debug: C.debug,
                  verbose: C.verbose,
                  duration: C.duration,
                  queue: !0,
                  onStart: o,
                  onComplete: function onComplete() {
                    t.call(G);
                  }
                }) : x.error(L.noTransition, r));
              },
              hide: function hide(t, n) {
                var r = n || $,
                    i = (n ? C.duration : C.duration, n ? function () {} : function () {
                  x.can.click() && x.unbind.intent(), x.remove.active();
                }),
                    o = x.get.transition(n);
                t = e.isFunction(t) ? t : function () {}, (x.is.visible(r) || x.is.animating(r)) && (x.verbose("Doing menu hide animation", r), "none" == o ? (i(), r.transition("hide"), t.call(G)) : void 0 !== e.fn.transition && M.transition("is supported") ? r.transition({
                  animation: o + " out",
                  duration: C.duration,
                  debug: C.debug,
                  verbose: C.verbose,
                  queue: !0,
                  onStart: i,
                  onComplete: function onComplete() {
                    t.call(G);
                  }
                }) : x.error(L.transition));
              }
            },
            hideAndClear: function hideAndClear() {
              x.remove.searchTerm(), x.has.maxSelections() || (x.has.search() ? x.hide(function () {
                x.remove.filteredItem();
              }) : x.hide());
            },
            delay: {
              show: function show() {
                x.verbose("Delaying show event to ensure user intent"), clearTimeout(x.timer), x.timer = setTimeout(x.show, C.delay.show);
              },
              hide: function hide() {
                x.verbose("Delaying hide event to ensure user intent"), clearTimeout(x.timer), x.timer = setTimeout(x.hide, C.delay.hide);
              }
            },
            escape: {
              value: function value(t) {
                var n = e.isArray(t),
                    r = "string" == typeof t,
                    i = !r && !n,
                    o = r && -1 !== t.search(j.quote),
                    a = [];
                return i || !o ? t : (x.debug("Encoding quote values for use in select", t), n ? (e.each(t, function (e, t) {
                  a.push(t.replace(j.quote, "&quot;"));
                }), a) : t.replace(j.quote, "&quot;"));
              },
              string: function string(e) {
                return (e = String(e)).replace(j.escape, "\\$&");
              }
            },
            setting: function setting(t, n) {
              if (x.debug("Changing setting", t, n), e.isPlainObject(t)) e.extend(!0, C, t);else {
                if (void 0 === n) return C[t];
                e.isPlainObject(C[t]) ? e.extend(!0, C[t], n) : C[t] = n;
              }
            },
            internal: function internal(t, n) {
              if (e.isPlainObject(t)) e.extend(!0, x, t);else {
                if (void 0 === n) return x[t];
                x[t] = n;
              }
            },
            debug: function debug() {
              !C.silent && C.debug && (C.performance ? x.performance.log(arguments) : (x.debug = Function.prototype.bind.call(console.info, console, C.name + ":"), x.debug.apply(console, arguments)));
            },
            verbose: function verbose() {
              !C.silent && C.verbose && C.debug && (C.performance ? x.performance.log(arguments) : (x.verbose = Function.prototype.bind.call(console.info, console, C.name + ":"), x.verbose.apply(console, arguments)));
            },
            error: function error() {
              C.silent || (x.error = Function.prototype.bind.call(console.error, console, C.name + ":"), x.error.apply(console, arguments));
            },
            performance: {
              log: function log(e) {
                var t, n;
                C.performance && (n = (t = new Date().getTime()) - (c || t), c = t, l.push({
                  Name: e[0],
                  Arguments: [].slice.call(e, 1) || "",
                  Element: G,
                  "Execution Time": n
                })), clearTimeout(x.performance.timer), x.performance.timer = setTimeout(x.performance.display, 500);
              },
              display: function display() {
                var t = C.name + ":",
                    n = 0;
                c = !1, clearTimeout(x.performance.timer), e.each(l, function (e, t) {
                  n += t["Execution Time"];
                }), t += " " + n + "ms", s && (t += " '" + s + "'"), (void 0 !== console.group || void 0 !== console.table) && l.length > 0 && (console.groupCollapsed(t), console.table ? console.table(l) : e.each(l, function (e, t) {
                  console.log(t.Name + ": " + t["Execution Time"] + "ms");
                }), console.groupEnd()), l = [];
              }
            },
            invoke: function invoke(t, n, r) {
              var o,
                  a,
                  s,
                  u = Y;
              return n = n || p, r = G || r, "string" == typeof t && void 0 !== u && (t = t.split(/[\. ]/), o = t.length - 1, e.each(t, function (n, r) {
                var i = n != o ? r + t[n + 1].charAt(0).toUpperCase() + t[n + 1].slice(1) : t;
                if (e.isPlainObject(u[i]) && n != o) u = u[i];else {
                  if (void 0 !== u[i]) return a = u[i], !1;
                  if (!e.isPlainObject(u[r]) || n == o) return void 0 !== u[r] ? (a = u[r], !1) : (x.error(L.method, t), !1);
                  u = u[r];
                }
              })), e.isFunction(a) ? s = a.apply(r, n) : void 0 !== a && (s = a), e.isArray(i) ? i.push(s) : void 0 !== i ? i = [i, s] : void 0 !== s && (i = s), a;
            }
          }, d ? (void 0 === Y && x.initialize(), x.invoke(f)) : (void 0 !== Y && Y.invoke("destroy"), x.initialize());
        }), void 0 !== i ? i : o;
      }, e.fn.dropdown.settings = {
        silent: !1,
        debug: !1,
        verbose: !1,
        performance: !0,
        on: "click",
        action: "activate",
        values: !1,
        apiSettings: !1,
        selectOnKeydown: !0,
        minCharacters: 0,
        filterRemoteData: !1,
        saveRemoteData: !0,
        throttle: 200,
        context: t,
        direction: "auto",
        keepOnScreen: !0,
        match: "both",
        fullTextSearch: !1,
        placeholder: "auto",
        preserveHTML: !0,
        sortSelect: !1,
        forceSelection: !0,
        allowAdditions: !1,
        hideAdditions: !0,
        maxSelections: !1,
        useLabels: !0,
        delimiter: ",",
        showOnFocus: !0,
        allowReselection: !1,
        allowTab: !0,
        allowCategorySelection: !1,
        fireOnInit: !1,
        transition: "auto",
        duration: 200,
        glyphWidth: 1.037,
        label: {
          transition: "scale",
          duration: 200,
          variation: !1
        },
        delay: {
          hide: 300,
          show: 200,
          search: 20,
          touch: 50
        },
        onChange: function onChange(e, t, n) {},
        onAdd: function onAdd(e, t, n) {},
        onRemove: function onRemove(e, t, n) {},
        onLabelSelect: function onLabelSelect(e) {},
        onLabelCreate: function onLabelCreate(t, n) {
          return e(this);
        },
        onLabelRemove: function onLabelRemove(e) {
          return !0;
        },
        onNoResults: function onNoResults(e) {
          return !0;
        },
        onShow: function onShow() {},
        onHide: function onHide() {},
        name: "Dropdown",
        namespace: "dropdown",
        message: {
          addResult: "Add <b>{term}</b>",
          count: "{count} selected",
          maxSelections: "Max {maxCount} selections",
          noResults: "No results found.",
          serverError: "There was an error contacting the server"
        },
        error: {
          action: "You called a dropdown action that was not defined",
          alreadySetup: "Once a select has been initialized behaviors must be called on the created ui dropdown",
          labels: "Allowing user additions currently requires the use of labels.",
          missingMultiple: "<select> requires multiple property to be set to correctly preserve multiple values",
          method: "The method you called is not defined.",
          noAPI: "The API module is required to load resources remotely",
          noStorage: "Saving remote data requires session storage",
          noTransition: "This module requires ui transitions <https://github.com/Semantic-Org/UI-Transition>"
        },
        regExp: {
          escape: /[-[\]{}()*+?.,\\^$|#\s]/g,
          quote: /"/g
        },
        metadata: {
          defaultText: "defaultText",
          defaultValue: "defaultValue",
          placeholderText: "placeholder",
          text: "text",
          value: "value"
        },
        fields: {
          remoteValues: "results",
          values: "values",
          disabled: "disabled",
          name: "name",
          value: "value",
          text: "text"
        },
        keys: {
          backspace: 8,
          delimiter: 188,
          deleteKey: 46,
          enter: 13,
          escape: 27,
          pageUp: 33,
          pageDown: 34,
          leftArrow: 37,
          upArrow: 38,
          rightArrow: 39,
          downArrow: 40
        },
        selector: {
          addition: ".addition",
          dropdown: ".apparatus.ui.dropdown",
          hidden: ".hidden",
          icon: "> .dropdown.icon",
          input: '> input[type="hidden"], > select',
          item: ".item",
          label: "> .label",
          remove: "> .label > .delete.icon",
          siblingLabel: ".label",
          menu: ".menu",
          message: ".message",
          menuIcon: ".dropdown.icon",
          search: "input.search, .menu > .search > input, .menu input.search",
          sizer: "> input.sizer",
          text: "> .text:not(.icon)",
          unselectable: ".disabled, .filtered"
        },
        className: {
          active: "active",
          addition: "addition",
          animating: "animating",
          disabled: "disabled",
          empty: "empty",
          dropdown: "ui dropdown",
          filtered: "filtered",
          hidden: "hidden transition",
          item: "item",
          label: "ui label",
          loading: "loading",
          menu: "menu",
          message: "message",
          multiple: "multiple",
          placeholder: "default",
          sizer: "sizer",
          search: "search",
          selected: "selected",
          selection: "selection",
          upward: "upward",
          leftward: "left",
          visible: "visible"
        }
      }, e.fn.dropdown.settings.templates = {
        dropdown: function dropdown(t) {
          var n = t.placeholder || !1,
              r = (t.values, "");
          return r += '<i class="dropdown icon"></i>', t.placeholder ? r += '<div class="default text">' + n + "</div>" : r += '<div class="text"></div>', r += '<div class="menu">', e.each(t.values, function (e, t) {
            r += t.disabled ? '<div class="disabled item" data-value="' + t.value + '">' + t.name + "</div>" : '<div class="item" data-value="' + t.value + '">' + t.name + "</div>";
          }), r += "</div>";
        },
        menu: function menu(t, n) {
          var r = t[n.values] || {},
              i = "";
          return e.each(r, function (e, t) {
            var r = t[n.text] ? 'data-text="' + t[n.text] + '"' : "",
                o = t[n.disabled] ? "disabled " : "";
            i += '<div class="' + o + 'item" data-value="' + t[n.value] + '"' + r + ">", i += t[n.name], i += "</div>";
          }), i;
        },
        label: function label(e, t) {
          return t + '<i class="delete icon"></i>';
        },
        message: function message(e) {
          return e;
        },
        addition: function addition(e) {
          return e;
        }
      };
    }(jQuery, window, document);
  }, function (e, t, n) {
    var r, i;
    window, e.exports = (r = n(34), i = n(37), function (e) {
      var t = {};

      function n(r) {
        if (t[r]) return t[r].exports;
        var i = t[r] = {
          i: r,
          l: !1,
          exports: {}
        };
        return e[r].call(i.exports, i, i.exports, n), i.l = !0, i.exports;
      }

      return n.m = e, n.c = t, n.d = function (e, t, r) {
        n.o(e, t) || Object.defineProperty(e, t, {
          enumerable: !0,
          get: r
        });
      }, n.r = function (e) {
        "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
          value: "Module"
        }), Object.defineProperty(e, "__esModule", {
          value: !0
        });
      }, n.t = function (e, t) {
        if (1 & t && (e = n(e)), 8 & t) return e;
        if (4 & t && "object" == _typeof(e) && e && e.__esModule) return e;
        var r = Object.create(null);
        if (n.r(r), Object.defineProperty(r, "default", {
          enumerable: !0,
          value: e
        }), 2 & t && "string" != typeof e) for (var i in e) {
          n.d(r, i, function (t) {
            return e[t];
          }.bind(null, i));
        }
        return r;
      }, n.n = function (e) {
        var t = e && e.__esModule ? function () {
          return e["default"];
        } : function () {
          return e;
        };
        return n.d(t, "a", t), t;
      }, n.o = function (e, t) {
        return Object.prototype.hasOwnProperty.call(e, t);
      }, n.p = "", n(n.s = 4);
    }([function (e, t) {
      e.exports = r;
    }, function (e, t) {
      e.exports = i;
    }, function (e, t, n) {
      "use strict";

      (function (e) {
        var r = n(0),
            i = n(3),
            o = [].indexOf;

        t.a = function () {
          var t =
          /*#__PURE__*/
          function (_i$a) {
            _inherits(t, _i$a);

            function t() {
              _classCallCheck(this, t);

              return _possibleConstructorReturn(this, _getPrototypeOf(t).apply(this, arguments));
            }

            _createClass(t, [{
              key: "init",
              value: function init() {
                var _this = this;

                return this.scope_element = this.get_scope_element(), this.form_update_handler = function (t) {
                  if (_this.$element.is(":visible") && _this.is_dependent_on_input(e(t.target)) && e(t.target).closest(_this.options.scope_selector).is(_this.scope_element)) return _this.update_dependent_fields();
                }, this.scope_element.on("change.SimpleFormDependentFields", "input,select", this.form_update_handler), this.update_dependent_fields();
              }
            }, {
              key: "destroy",
              value: function destroy() {
                return this.scope_element.off(".SimpleFormDependentFields", "input,select", this.form_update_handler);
              }
            }, {
              key: "depends_on",
              value: function depends_on() {
                return this.$element.data("depends-on");
              }
            }, {
              key: "depends_on_any",
              value: function depends_on_any() {
                return this.depends_on().depends_on_any;
              }
            }, {
              key: "depends_on_all",
              value: function depends_on_all() {
                return this.depends_on().depends_on_all;
              }
            }, {
              key: "depends_on_none",
              value: function depends_on_none() {
                return this.depends_on().depends_on_none;
              }
            }, {
              key: "get_form",
              value: function get_form() {
                return this.$element.closest("form");
              }
            }, {
              key: "get_input",
              value: function get_input(e) {
                return this.get_inputs().filter("[name$='[".concat(e, "]']"));
              }
            }, {
              key: "get_input_names",
              value: function get_input_names() {
                return Object.keys(this.depends_on_any() || {}).concat(Object.keys(this.depends_on_all() || {}).concat(Object.keys(this.depends_on_none() || {})));
              }
            }, {
              key: "get_inputs",
              value: function get_inputs() {
                var _this2 = this;

                return this.scope_element.find("input,select").not(":hidden").filter(function (t, n) {
                  return e(n).closest(_this2.options.scope_selector).is(_this2.scope_element);
                });
              }
            }, {
              key: "get_scope_element",
              value: function get_scope_element() {
                return this.$element.closest(this.options.scope_selector);
              }
            }, {
              key: "is_dependent_on_input",
              value: function is_dependent_on_input(e) {
                return Object(r.filter)(this.get_input_names(), function (t) {
                  return e.is("[name$='[".concat(t, "]']"));
                }).length > 0;
              }
            }, {
              key: "update_dependent_fields",
              value: function update_dependent_fields() {
                return this.is_condition_valid() ? this.show_content() : this.hide_content();
              }
            }, {
              key: "show_content",
              value: function show_content() {
                var t;
                if (!(this.$element.children().length > 0) && (t = this.$element.data("template-html"))) return this.$element.append(e(t));
              }
            }, {
              key: "hide_content",
              value: function hide_content() {
                var e;
                if (e = this.$element.children().remove(), !this.$element.data("template-html")) return this.$element.data("template-html", e);
              }
            }, {
              key: "is_condition_valid",
              value: function is_condition_valid() {
                switch (!1) {
                  case !this.depends_on_any():
                    return this.is_any_valid();

                  case !this.depends_on_all():
                    return this.is_all_valid();

                  case !this.depends_on_none():
                    return this.is_none_valid();
                }
              }
            }, {
              key: "is_any_valid",
              value: function is_any_valid() {
                var e, t, n, i, o, a, s, u, c;

                for (i in s = !1, o = this.depends_on_any()) {
                  for (c = o[i], t = 0, n = (a = Object(r.flatten)([c])).length; t < n; t++) {
                    u = a[t], e = this.is_valid(i, u), s = s || e;
                  }
                }

                return s;
              }
            }, {
              key: "is_all_valid",
              value: function is_all_valid() {
                var e, t, n, i, o, a, s, u, c;

                for (i in s = !0, o = this.depends_on_all()) {
                  for (c = o[i], t = 0, n = (a = Object(r.flatten)([c])).length; t < n; t++) {
                    u = a[t], e = this.is_valid(i, u), s = s && e;
                  }
                }

                return s;
              }
            }, {
              key: "is_none_valid",
              value: function is_none_valid() {
                var e, t, n, i, o, a, s, u, c;

                for (i in s = !0, o = this.depends_on_none()) {
                  for (c = o[i], t = 0, n = (a = Object(r.flatten)([c])).length; t < n; t++) {
                    u = a[t], e = this.is_valid(i, u), s = s && !e;
                  }
                }

                return s;
              }
            }, {
              key: "is_valid",
              value: function is_valid(e, t) {
                var n;

                switch (n = this.get_input(e), t = t.toString()) {
                  case "true":
                    t = "1";
                    break;

                  case "false":
                    t = "0";
                }

                switch (n.prop("type")) {
                  case "radio":
                    return n.filter(":checked").val() === t;

                  case "checkbox":
                    switch (t) {
                      case "1":
                        return n.filter(":checked").length > 0;

                      default:
                        return n.not(":checked").length > 0;
                    }

                    break;

                  case "select-one":
                    return n.val() === t;

                  case "select-multiple":
                    return o.call(n.val(), t) >= 0;

                  default:
                    return n.val() === t;
                }
              }
            }]);

            return t;
          }(i.a);

          return t.defaults = {
            name: "SimpleFormDependentFields",
            debug: !1,
            scope_selector: ".simple_form_dependent_fields__scope, .simple_form_dependent_fields__item, .simple_form_nested_fields__item, form"
          }, t;
        }.call(void 0);
      }).call(this, n(1));
    }, function (e, t, n) {
      "use strict";

      (function (e) {
        t.a =
        /*#__PURE__*/
        function () {
          _createClass(_class, null, [{
            key: "register",
            value: function register() {
              var e, t, n;
              return t = (e = null != (n = this.defaults) ? n : {}).name || (e.name = /function ([^(]*)/.exec(this + "")[1]), Array.prototype.slice.call(arguments).slice(1), null != arguments[0] || this.selector, this.init_plugin(this, t);
            }
          }, {
            key: "init_plugin",
            value: function init_plugin(t, n) {
              if (void 0 === e.fn[n]) return e.fn[n] = function (e) {
                var r, i, o;
                return r = arguments, i = "plugin_".concat(n), void 0 === e || "object" == _typeof(e) ? this.each(function () {
                  var n;
                  if (this.pluginInstances || (this.pluginInstances = {}), !this.pluginInstances[i]) return n = new t(this, e), this.pluginInstances[i] = n;
                }) : "string" == typeof e && "_" !== e[0] && "init" !== e ? (o = void 0, this.each(function () {
                  var n;
                  if (this.pluginInstances || (this.pluginInstances = {}), (n = this.pluginInstances[i]) instanceof t && "function" == typeof n[e] && (o = n[e].apply(n, Array.prototype.slice.call(r, 1))), "destroy" === e) return this.pluginInstances[i] = null;
                }), void 0 !== o ? o : this) : void 0;
              };
            }
          }]);

          function _class(t, n) {
            _classCallCheck(this, _class);

            this.element = t, this.options = e.extend({}, this.constructor.defaults, n), this.$element = e(this.element), this.init();
          }

          return _class;
        }();
      }).call(this, n(1));
    }, function (e, t, n) {
      "use strict";

      n.r(t);
      var r = n(2);
      t["default"] = r.a;
    }]));
  },,,,,,,,,,,,,,, function (e, t, n) {}, function (e, t, n) {
    n(33);
    $(function () {
      var e = ".simple_form_dependent_fields";
      $(e).SimpleFormDependentFields(), new MutationObserver(function (t) {
        t.forEach(function (t) {
          return $(e).SimpleFormDependentFields();
        });
      }).observe(document.documentElement, {
        childList: !0,
        subtree: !0
      });
    });
  }, function (e, t, n) {
    "use strict";

    n.r(t);
    var r = n(16),
        i = n.n(r);

    (function (e, t) {
      e.fn.SimpleFormDependentFields = function (t) {
        this.each(function () {
          if (!e.data(this, "plugin_SimpleFormDependentFields")) {
            var _t2 = new i.a(this);

            e.data(this, "plugin_SimpleFormDependentFields", _t2);
          }
        });
      };
    })(jQuery, window);
  }, function (e, t, n) {
    (function (e, r) {
      var i;
      /**
       * @license
       * Lodash <https://lodash.com/>
       * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
       * Released under MIT license <https://lodash.com/license>
       * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
       * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
       */

      (function () {
        var o = "Expected a function",
            a = "__lodash_placeholder__",
            s = [["ary", 128], ["bind", 1], ["bindKey", 2], ["curry", 8], ["curryRight", 16], ["flip", 512], ["partial", 32], ["partialRight", 64], ["rearg", 256]],
            u = "[object Arguments]",
            c = "[object Array]",
            l = "[object Boolean]",
            f = "[object Date]",
            d = "[object Error]",
            p = "[object Function]",
            h = "[object GeneratorFunction]",
            v = "[object Map]",
            g = "[object Number]",
            m = "[object Object]",
            y = "[object RegExp]",
            b = "[object Set]",
            w = "[object String]",
            _ = "[object Symbol]",
            x = "[object WeakMap]",
            C = "[object ArrayBuffer]",
            k = "[object DataView]",
            T = "[object Float32Array]",
            S = "[object Float64Array]",
            A = "[object Int8Array]",
            E = "[object Int16Array]",
            O = "[object Int32Array]",
            j = "[object Uint8Array]",
            D = "[object Uint16Array]",
            L = "[object Uint32Array]",
            P = /\b__p \+= '';/g,
            N = /\b(__p \+=) '' \+/g,
            I = /(__e\(.*?\)|\b__t\)) \+\n'';/g,
            M = /&(?:amp|lt|gt|quot|#39);/g,
            R = /[&<>"']/g,
            q = RegExp(M.source),
            F = RegExp(R.source),
            B = /<%-([\s\S]+?)%>/g,
            z = /<%([\s\S]+?)%>/g,
            H = /<%=([\s\S]+?)%>/g,
            W = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
            $ = /^\w*$/,
            V = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g,
            U = /[\\^$.*+?()[\]{}|]/g,
            K = RegExp(U.source),
            X = /^\s+|\s+$/g,
            G = /^\s+/,
            Y = /\s+$/,
            Z = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
            Q = /\{\n\/\* \[wrapped with (.+)\] \*/,
            J = /,? & /,
            ee = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g,
            te = /\\(\\)?/g,
            ne = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g,
            re = /\w*$/,
            ie = /^[-+]0x[0-9a-f]+$/i,
            oe = /^0b[01]+$/i,
            ae = /^\[object .+?Constructor\]$/,
            se = /^0o[0-7]+$/i,
            ue = /^(?:0|[1-9]\d*)$/,
            ce = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g,
            le = /($^)/,
            fe = /['\n\r\u2028\u2029\\]/g,
            de = "\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff",
            pe = "\\xac\\xb1\\xd7\\xf7\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf\\u2000-\\u206f \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000",
            he = "[\\ud800-\\udfff]",
            ve = "[" + pe + "]",
            ge = "[" + de + "]",
            me = "\\d+",
            ye = "[\\u2700-\\u27bf]",
            be = "[a-z\\xdf-\\xf6\\xf8-\\xff]",
            we = "[^\\ud800-\\udfff" + pe + me + "\\u2700-\\u27bfa-z\\xdf-\\xf6\\xf8-\\xffA-Z\\xc0-\\xd6\\xd8-\\xde]",
            _e = "\\ud83c[\\udffb-\\udfff]",
            xe = "[^\\ud800-\\udfff]",
            Ce = "(?:\\ud83c[\\udde6-\\uddff]){2}",
            ke = "[\\ud800-\\udbff][\\udc00-\\udfff]",
            Te = "[A-Z\\xc0-\\xd6\\xd8-\\xde]",
            Se = "(?:" + be + "|" + we + ")",
            Ae = "(?:" + Te + "|" + we + ")",
            Ee = "(?:" + ge + "|" + _e + ")" + "?",
            Oe = "[\\ufe0e\\ufe0f]?" + Ee + ("(?:\\u200d(?:" + [xe, Ce, ke].join("|") + ")[\\ufe0e\\ufe0f]?" + Ee + ")*"),
            je = "(?:" + [ye, Ce, ke].join("|") + ")" + Oe,
            De = "(?:" + [xe + ge + "?", ge, Ce, ke, he].join("|") + ")",
            Le = RegExp("['’]", "g"),
            Pe = RegExp(ge, "g"),
            Ne = RegExp(_e + "(?=" + _e + ")|" + De + Oe, "g"),
            Ie = RegExp([Te + "?" + be + "+(?:['’](?:d|ll|m|re|s|t|ve))?(?=" + [ve, Te, "$"].join("|") + ")", Ae + "+(?:['’](?:D|LL|M|RE|S|T|VE))?(?=" + [ve, Te + Se, "$"].join("|") + ")", Te + "?" + Se + "+(?:['’](?:d|ll|m|re|s|t|ve))?", Te + "+(?:['’](?:D|LL|M|RE|S|T|VE))?", "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", me, je].join("|"), "g"),
            Me = RegExp("[\\u200d\\ud800-\\udfff" + de + "\\ufe0e\\ufe0f]"),
            Re = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/,
            qe = ["Array", "Buffer", "DataView", "Date", "Error", "Float32Array", "Float64Array", "Function", "Int8Array", "Int16Array", "Int32Array", "Map", "Math", "Object", "Promise", "RegExp", "Set", "String", "Symbol", "TypeError", "Uint8Array", "Uint8ClampedArray", "Uint16Array", "Uint32Array", "WeakMap", "_", "clearTimeout", "isFinite", "parseInt", "setTimeout"],
            Fe = -1,
            Be = {};
        Be[T] = Be[S] = Be[A] = Be[E] = Be[O] = Be[j] = Be["[object Uint8ClampedArray]"] = Be[D] = Be[L] = !0, Be[u] = Be[c] = Be[C] = Be[l] = Be[k] = Be[f] = Be[d] = Be[p] = Be[v] = Be[g] = Be[m] = Be[y] = Be[b] = Be[w] = Be[x] = !1;
        var ze = {};
        ze[u] = ze[c] = ze[C] = ze[k] = ze[l] = ze[f] = ze[T] = ze[S] = ze[A] = ze[E] = ze[O] = ze[v] = ze[g] = ze[m] = ze[y] = ze[b] = ze[w] = ze[_] = ze[j] = ze["[object Uint8ClampedArray]"] = ze[D] = ze[L] = !0, ze[d] = ze[p] = ze[x] = !1;

        var He = {
          "\\": "\\",
          "'": "'",
          "\n": "n",
          "\r": "r",
          "\u2028": "u2028",
          "\u2029": "u2029"
        },
            We = parseFloat,
            $e = parseInt,
            Ve = "object" == _typeof(e) && e && e.Object === Object && e,
            Ue = "object" == (typeof self === "undefined" ? "undefined" : _typeof(self)) && self && self.Object === Object && self,
            Ke = Ve || Ue || Function("return this")(),
            Xe = t && !t.nodeType && t,
            Ge = Xe && "object" == _typeof(r) && r && !r.nodeType && r,
            Ye = Ge && Ge.exports === Xe,
            Ze = Ye && Ve.process,
            Qe = function () {
          try {
            var e = Ge && Ge.require && Ge.require("util").types;

            return e || Ze && Ze.binding && Ze.binding("util");
          } catch (e) {}
        }(),
            Je = Qe && Qe.isArrayBuffer,
            et = Qe && Qe.isDate,
            tt = Qe && Qe.isMap,
            nt = Qe && Qe.isRegExp,
            rt = Qe && Qe.isSet,
            it = Qe && Qe.isTypedArray;

        function ot(e, t, n) {
          switch (n.length) {
            case 0:
              return e.call(t);

            case 1:
              return e.call(t, n[0]);

            case 2:
              return e.call(t, n[0], n[1]);

            case 3:
              return e.call(t, n[0], n[1], n[2]);
          }

          return e.apply(t, n);
        }

        function at(e, t, n, r) {
          for (var i = -1, o = null == e ? 0 : e.length; ++i < o;) {
            var a = e[i];
            t(r, a, n(a), e);
          }

          return r;
        }

        function st(e, t) {
          for (var n = -1, r = null == e ? 0 : e.length; ++n < r && !1 !== t(e[n], n, e);) {
            ;
          }

          return e;
        }

        function ut(e, t) {
          for (var n = null == e ? 0 : e.length; n-- && !1 !== t(e[n], n, e);) {
            ;
          }

          return e;
        }

        function ct(e, t) {
          for (var n = -1, r = null == e ? 0 : e.length; ++n < r;) {
            if (!t(e[n], n, e)) return !1;
          }

          return !0;
        }

        function lt(e, t) {
          for (var n = -1, r = null == e ? 0 : e.length, i = 0, o = []; ++n < r;) {
            var a = e[n];
            t(a, n, e) && (o[i++] = a);
          }

          return o;
        }

        function ft(e, t) {
          return !!(null == e ? 0 : e.length) && _t(e, t, 0) > -1;
        }

        function dt(e, t, n) {
          for (var r = -1, i = null == e ? 0 : e.length; ++r < i;) {
            if (n(t, e[r])) return !0;
          }

          return !1;
        }

        function pt(e, t) {
          for (var n = -1, r = null == e ? 0 : e.length, i = Array(r); ++n < r;) {
            i[n] = t(e[n], n, e);
          }

          return i;
        }

        function ht(e, t) {
          for (var n = -1, r = t.length, i = e.length; ++n < r;) {
            e[i + n] = t[n];
          }

          return e;
        }

        function vt(e, t, n, r) {
          var i = -1,
              o = null == e ? 0 : e.length;

          for (r && o && (n = e[++i]); ++i < o;) {
            n = t(n, e[i], i, e);
          }

          return n;
        }

        function gt(e, t, n, r) {
          var i = null == e ? 0 : e.length;

          for (r && i && (n = e[--i]); i--;) {
            n = t(n, e[i], i, e);
          }

          return n;
        }

        function mt(e, t) {
          for (var n = -1, r = null == e ? 0 : e.length; ++n < r;) {
            if (t(e[n], n, e)) return !0;
          }

          return !1;
        }

        var yt = Tt("length");

        function bt(e, t, n) {
          var r;
          return n(e, function (e, n, i) {
            if (t(e, n, i)) return r = n, !1;
          }), r;
        }

        function wt(e, t, n, r) {
          for (var i = e.length, o = n + (r ? 1 : -1); r ? o-- : ++o < i;) {
            if (t(e[o], o, e)) return o;
          }

          return -1;
        }

        function _t(e, t, n) {
          return t == t ? function (e, t, n) {
            var r = n - 1,
                i = e.length;

            for (; ++r < i;) {
              if (e[r] === t) return r;
            }

            return -1;
          }(e, t, n) : wt(e, Ct, n);
        }

        function xt(e, t, n, r) {
          for (var i = n - 1, o = e.length; ++i < o;) {
            if (r(e[i], t)) return i;
          }

          return -1;
        }

        function Ct(e) {
          return e != e;
        }

        function kt(e, t) {
          var n = null == e ? 0 : e.length;
          return n ? Et(e, t) / n : NaN;
        }

        function Tt(e) {
          return function (t) {
            return null == t ? void 0 : t[e];
          };
        }

        function St(e) {
          return function (t) {
            return null == e ? void 0 : e[t];
          };
        }

        function At(e, t, n, r, i) {
          return i(e, function (e, i, o) {
            n = r ? (r = !1, e) : t(n, e, i, o);
          }), n;
        }

        function Et(e, t) {
          for (var n, r = -1, i = e.length; ++r < i;) {
            var o = t(e[r]);
            void 0 !== o && (n = void 0 === n ? o : n + o);
          }

          return n;
        }

        function Ot(e, t) {
          for (var n = -1, r = Array(e); ++n < e;) {
            r[n] = t(n);
          }

          return r;
        }

        function jt(e) {
          return function (t) {
            return e(t);
          };
        }

        function Dt(e, t) {
          return pt(t, function (t) {
            return e[t];
          });
        }

        function Lt(e, t) {
          return e.has(t);
        }

        function Pt(e, t) {
          for (var n = -1, r = e.length; ++n < r && _t(t, e[n], 0) > -1;) {
            ;
          }

          return n;
        }

        function Nt(e, t) {
          for (var n = e.length; n-- && _t(t, e[n], 0) > -1;) {
            ;
          }

          return n;
        }

        function It(e, t) {
          for (var n = e.length, r = 0; n--;) {
            e[n] === t && ++r;
          }

          return r;
        }

        var Mt = St({
          "À": "A",
          "Á": "A",
          "Â": "A",
          "Ã": "A",
          "Ä": "A",
          "Å": "A",
          "à": "a",
          "á": "a",
          "â": "a",
          "ã": "a",
          "ä": "a",
          "å": "a",
          "Ç": "C",
          "ç": "c",
          "Ð": "D",
          "ð": "d",
          "È": "E",
          "É": "E",
          "Ê": "E",
          "Ë": "E",
          "è": "e",
          "é": "e",
          "ê": "e",
          "ë": "e",
          "Ì": "I",
          "Í": "I",
          "Î": "I",
          "Ï": "I",
          "ì": "i",
          "í": "i",
          "î": "i",
          "ï": "i",
          "Ñ": "N",
          "ñ": "n",
          "Ò": "O",
          "Ó": "O",
          "Ô": "O",
          "Õ": "O",
          "Ö": "O",
          "Ø": "O",
          "ò": "o",
          "ó": "o",
          "ô": "o",
          "õ": "o",
          "ö": "o",
          "ø": "o",
          "Ù": "U",
          "Ú": "U",
          "Û": "U",
          "Ü": "U",
          "ù": "u",
          "ú": "u",
          "û": "u",
          "ü": "u",
          "Ý": "Y",
          "ý": "y",
          "ÿ": "y",
          "Æ": "Ae",
          "æ": "ae",
          "Þ": "Th",
          "þ": "th",
          "ß": "ss",
          "Ā": "A",
          "Ă": "A",
          "Ą": "A",
          "ā": "a",
          "ă": "a",
          "ą": "a",
          "Ć": "C",
          "Ĉ": "C",
          "Ċ": "C",
          "Č": "C",
          "ć": "c",
          "ĉ": "c",
          "ċ": "c",
          "č": "c",
          "Ď": "D",
          "Đ": "D",
          "ď": "d",
          "đ": "d",
          "Ē": "E",
          "Ĕ": "E",
          "Ė": "E",
          "Ę": "E",
          "Ě": "E",
          "ē": "e",
          "ĕ": "e",
          "ė": "e",
          "ę": "e",
          "ě": "e",
          "Ĝ": "G",
          "Ğ": "G",
          "Ġ": "G",
          "Ģ": "G",
          "ĝ": "g",
          "ğ": "g",
          "ġ": "g",
          "ģ": "g",
          "Ĥ": "H",
          "Ħ": "H",
          "ĥ": "h",
          "ħ": "h",
          "Ĩ": "I",
          "Ī": "I",
          "Ĭ": "I",
          "Į": "I",
          "İ": "I",
          "ĩ": "i",
          "ī": "i",
          "ĭ": "i",
          "į": "i",
          "ı": "i",
          "Ĵ": "J",
          "ĵ": "j",
          "Ķ": "K",
          "ķ": "k",
          "ĸ": "k",
          "Ĺ": "L",
          "Ļ": "L",
          "Ľ": "L",
          "Ŀ": "L",
          "Ł": "L",
          "ĺ": "l",
          "ļ": "l",
          "ľ": "l",
          "ŀ": "l",
          "ł": "l",
          "Ń": "N",
          "Ņ": "N",
          "Ň": "N",
          "Ŋ": "N",
          "ń": "n",
          "ņ": "n",
          "ň": "n",
          "ŋ": "n",
          "Ō": "O",
          "Ŏ": "O",
          "Ő": "O",
          "ō": "o",
          "ŏ": "o",
          "ő": "o",
          "Ŕ": "R",
          "Ŗ": "R",
          "Ř": "R",
          "ŕ": "r",
          "ŗ": "r",
          "ř": "r",
          "Ś": "S",
          "Ŝ": "S",
          "Ş": "S",
          "Š": "S",
          "ś": "s",
          "ŝ": "s",
          "ş": "s",
          "š": "s",
          "Ţ": "T",
          "Ť": "T",
          "Ŧ": "T",
          "ţ": "t",
          "ť": "t",
          "ŧ": "t",
          "Ũ": "U",
          "Ū": "U",
          "Ŭ": "U",
          "Ů": "U",
          "Ű": "U",
          "Ų": "U",
          "ũ": "u",
          "ū": "u",
          "ŭ": "u",
          "ů": "u",
          "ű": "u",
          "ų": "u",
          "Ŵ": "W",
          "ŵ": "w",
          "Ŷ": "Y",
          "ŷ": "y",
          "Ÿ": "Y",
          "Ź": "Z",
          "Ż": "Z",
          "Ž": "Z",
          "ź": "z",
          "ż": "z",
          "ž": "z",
          "Ĳ": "IJ",
          "ĳ": "ij",
          "Œ": "Oe",
          "œ": "oe",
          "ŉ": "'n",
          "ſ": "s"
        }),
            Rt = St({
          "&": "&amp;",
          "<": "&lt;",
          ">": "&gt;",
          '"': "&quot;",
          "'": "&#39;"
        });

        function qt(e) {
          return "\\" + He[e];
        }

        function Ft(e) {
          return Me.test(e);
        }

        function Bt(e) {
          var t = -1,
              n = Array(e.size);
          return e.forEach(function (e, r) {
            n[++t] = [r, e];
          }), n;
        }

        function zt(e, t) {
          return function (n) {
            return e(t(n));
          };
        }

        function Ht(e, t) {
          for (var n = -1, r = e.length, i = 0, o = []; ++n < r;) {
            var s = e[n];
            s !== t && s !== a || (e[n] = a, o[i++] = n);
          }

          return o;
        }

        function Wt(e) {
          var t = -1,
              n = Array(e.size);
          return e.forEach(function (e) {
            n[++t] = e;
          }), n;
        }

        function $t(e) {
          var t = -1,
              n = Array(e.size);
          return e.forEach(function (e) {
            n[++t] = [e, e];
          }), n;
        }

        function Vt(e) {
          return Ft(e) ? function (e) {
            var t = Ne.lastIndex = 0;

            for (; Ne.test(e);) {
              ++t;
            }

            return t;
          }(e) : yt(e);
        }

        function Ut(e) {
          return Ft(e) ? function (e) {
            return e.match(Ne) || [];
          }(e) : function (e) {
            return e.split("");
          }(e);
        }

        var Kt = St({
          "&amp;": "&",
          "&lt;": "<",
          "&gt;": ">",
          "&quot;": '"',
          "&#39;": "'"
        });

        var Xt = function e(t) {
          var n,
              r = (t = null == t ? Ke : Xt.defaults(Ke.Object(), t, Xt.pick(Ke, qe))).Array,
              i = t.Date,
              de = t.Error,
              pe = t.Function,
              he = t.Math,
              ve = t.Object,
              ge = t.RegExp,
              me = t.String,
              ye = t.TypeError,
              be = r.prototype,
              we = pe.prototype,
              _e = ve.prototype,
              xe = t["__core-js_shared__"],
              Ce = we.toString,
              ke = _e.hasOwnProperty,
              Te = 0,
              Se = (n = /[^.]+$/.exec(xe && xe.keys && xe.keys.IE_PROTO || "")) ? "Symbol(src)_1." + n : "",
              Ae = _e.toString,
              Ee = Ce.call(ve),
              Oe = Ke._,
              je = ge("^" + Ce.call(ke).replace(U, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"),
              De = Ye ? t.Buffer : void 0,
              Ne = t.Symbol,
              Me = t.Uint8Array,
              He = De ? De.allocUnsafe : void 0,
              Ve = zt(ve.getPrototypeOf, ve),
              Ue = ve.create,
              Xe = _e.propertyIsEnumerable,
              Ge = be.splice,
              Ze = Ne ? Ne.isConcatSpreadable : void 0,
              Qe = Ne ? Ne.iterator : void 0,
              yt = Ne ? Ne.toStringTag : void 0,
              St = function () {
            try {
              var e = Ji(ve, "defineProperty");
              return e({}, "", {}), e;
            } catch (e) {}
          }(),
              Gt = t.clearTimeout !== Ke.clearTimeout && t.clearTimeout,
              Yt = i && i.now !== Ke.Date.now && i.now,
              Zt = t.setTimeout !== Ke.setTimeout && t.setTimeout,
              Qt = he.ceil,
              Jt = he.floor,
              en = ve.getOwnPropertySymbols,
              tn = De ? De.isBuffer : void 0,
              nn = t.isFinite,
              rn = be.join,
              on = zt(ve.keys, ve),
              an = he.max,
              sn = he.min,
              un = i.now,
              cn = t.parseInt,
              ln = he.random,
              fn = be.reverse,
              dn = Ji(t, "DataView"),
              pn = Ji(t, "Map"),
              hn = Ji(t, "Promise"),
              vn = Ji(t, "Set"),
              gn = Ji(t, "WeakMap"),
              mn = Ji(ve, "create"),
              yn = gn && new gn(),
              bn = {},
              wn = Ao(dn),
              _n = Ao(pn),
              xn = Ao(hn),
              Cn = Ao(vn),
              kn = Ao(gn),
              Tn = Ne ? Ne.prototype : void 0,
              Sn = Tn ? Tn.valueOf : void 0,
              An = Tn ? Tn.toString : void 0;

          function En(e) {
            if ($a(e) && !Pa(e) && !(e instanceof Ln)) {
              if (e instanceof Dn) return e;
              if (ke.call(e, "__wrapped__")) return Eo(e);
            }

            return new Dn(e);
          }

          var On = function () {
            function e() {}

            return function (t) {
              if (!Wa(t)) return {};
              if (Ue) return Ue(t);
              e.prototype = t;
              var n = new e();
              return e.prototype = void 0, n;
            };
          }();

          function jn() {}

          function Dn(e, t) {
            this.__wrapped__ = e, this.__actions__ = [], this.__chain__ = !!t, this.__index__ = 0, this.__values__ = void 0;
          }

          function Ln(e) {
            this.__wrapped__ = e, this.__actions__ = [], this.__dir__ = 1, this.__filtered__ = !1, this.__iteratees__ = [], this.__takeCount__ = 4294967295, this.__views__ = [];
          }

          function Pn(e) {
            var t = -1,
                n = null == e ? 0 : e.length;

            for (this.clear(); ++t < n;) {
              var r = e[t];
              this.set(r[0], r[1]);
            }
          }

          function Nn(e) {
            var t = -1,
                n = null == e ? 0 : e.length;

            for (this.clear(); ++t < n;) {
              var r = e[t];
              this.set(r[0], r[1]);
            }
          }

          function In(e) {
            var t = -1,
                n = null == e ? 0 : e.length;

            for (this.clear(); ++t < n;) {
              var r = e[t];
              this.set(r[0], r[1]);
            }
          }

          function Mn(e) {
            var t = -1,
                n = null == e ? 0 : e.length;

            for (this.__data__ = new In(); ++t < n;) {
              this.add(e[t]);
            }
          }

          function Rn(e) {
            var t = this.__data__ = new Nn(e);
            this.size = t.size;
          }

          function qn(e, t) {
            var n = Pa(e),
                r = !n && La(e),
                i = !n && !r && Ra(e),
                o = !n && !r && !i && Qa(e),
                a = n || r || i || o,
                s = a ? Ot(e.length, me) : [],
                u = s.length;

            for (var c in e) {
              !t && !ke.call(e, c) || a && ("length" == c || i && ("offset" == c || "parent" == c) || o && ("buffer" == c || "byteLength" == c || "byteOffset" == c) || ao(c, u)) || s.push(c);
            }

            return s;
          }

          function Fn(e) {
            var t = e.length;
            return t ? e[Mr(0, t - 1)] : void 0;
          }

          function Bn(e, t) {
            return ko(mi(e), Gn(t, 0, e.length));
          }

          function zn(e) {
            return ko(mi(e));
          }

          function Hn(e, t, n) {
            (void 0 === n || Oa(e[t], n)) && (void 0 !== n || t in e) || Kn(e, t, n);
          }

          function Wn(e, t, n) {
            var r = e[t];
            ke.call(e, t) && Oa(r, n) && (void 0 !== n || t in e) || Kn(e, t, n);
          }

          function $n(e, t) {
            for (var n = e.length; n--;) {
              if (Oa(e[n][0], t)) return n;
            }

            return -1;
          }

          function Vn(e, t, n, r) {
            return er(e, function (e, i, o) {
              t(r, e, n(e), o);
            }), r;
          }

          function Un(e, t) {
            return e && yi(t, ws(t), e);
          }

          function Kn(e, t, n) {
            "__proto__" == t && St ? St(e, t, {
              configurable: !0,
              enumerable: !0,
              value: n,
              writable: !0
            }) : e[t] = n;
          }

          function Xn(e, t) {
            for (var n = -1, i = t.length, o = r(i), a = null == e; ++n < i;) {
              o[n] = a ? void 0 : vs(e, t[n]);
            }

            return o;
          }

          function Gn(e, t, n) {
            return e == e && (void 0 !== n && (e = e <= n ? e : n), void 0 !== t && (e = e >= t ? e : t)), e;
          }

          function Yn(e, t, n, r, i, o) {
            var a,
                s = 1 & t,
                c = 2 & t,
                d = 4 & t;
            if (n && (a = i ? n(e, r, i, o) : n(e)), void 0 !== a) return a;
            if (!Wa(e)) return e;
            var x = Pa(e);

            if (x) {
              if (a = function (e) {
                var t = e.length,
                    n = new e.constructor(t);
                t && "string" == typeof e[0] && ke.call(e, "index") && (n.index = e.index, n.input = e.input);
                return n;
              }(e), !s) return mi(e, a);
            } else {
              var P = no(e),
                  N = P == p || P == h;
              if (Ra(e)) return fi(e, s);

              if (P == m || P == u || N && !i) {
                if (a = c || N ? {} : io(e), !s) return c ? function (e, t) {
                  return yi(e, to(e), t);
                }(e, function (e, t) {
                  return e && yi(t, _s(t), e);
                }(a, e)) : function (e, t) {
                  return yi(e, eo(e), t);
                }(e, Un(a, e));
              } else {
                if (!ze[P]) return i ? e : {};

                a = function (e, t, n) {
                  var r = e.constructor;

                  switch (t) {
                    case C:
                      return di(e);

                    case l:
                    case f:
                      return new r(+e);

                    case k:
                      return function (e, t) {
                        var n = t ? di(e.buffer) : e.buffer;
                        return new e.constructor(n, e.byteOffset, e.byteLength);
                      }(e, n);

                    case T:
                    case S:
                    case A:
                    case E:
                    case O:
                    case j:
                    case "[object Uint8ClampedArray]":
                    case D:
                    case L:
                      return pi(e, n);

                    case v:
                      return new r();

                    case g:
                    case w:
                      return new r(e);

                    case y:
                      return function (e) {
                        var t = new e.constructor(e.source, re.exec(e));
                        return t.lastIndex = e.lastIndex, t;
                      }(e);

                    case b:
                      return new r();

                    case _:
                      return i = e, Sn ? ve(Sn.call(i)) : {};
                  }

                  var i;
                }(e, P, s);
              }
            }

            o || (o = new Rn());
            var I = o.get(e);
            if (I) return I;
            o.set(e, a), Ga(e) ? e.forEach(function (r) {
              a.add(Yn(r, t, n, r, e, o));
            }) : Va(e) && e.forEach(function (r, i) {
              a.set(i, Yn(r, t, n, i, e, o));
            });
            var M = x ? void 0 : (d ? c ? Ui : Vi : c ? _s : ws)(e);
            return st(M || e, function (r, i) {
              M && (r = e[i = r]), Wn(a, i, Yn(r, t, n, i, e, o));
            }), a;
          }

          function Zn(e, t, n) {
            var r = n.length;
            if (null == e) return !r;

            for (e = ve(e); r--;) {
              var i = n[r],
                  o = t[i],
                  a = e[i];
              if (void 0 === a && !(i in e) || !o(a)) return !1;
            }

            return !0;
          }

          function Qn(e, t, n) {
            if ("function" != typeof e) throw new ye(o);
            return wo(function () {
              e.apply(void 0, n);
            }, t);
          }

          function Jn(e, t, n, r) {
            var i = -1,
                o = ft,
                a = !0,
                s = e.length,
                u = [],
                c = t.length;
            if (!s) return u;
            n && (t = pt(t, jt(n))), r ? (o = dt, a = !1) : t.length >= 200 && (o = Lt, a = !1, t = new Mn(t));

            e: for (; ++i < s;) {
              var l = e[i],
                  f = null == n ? l : n(l);

              if (l = r || 0 !== l ? l : 0, a && f == f) {
                for (var d = c; d--;) {
                  if (t[d] === f) continue e;
                }

                u.push(l);
              } else o(t, f, r) || u.push(l);
            }

            return u;
          }

          En.templateSettings = {
            escape: B,
            evaluate: z,
            interpolate: H,
            variable: "",
            imports: {
              _: En
            }
          }, En.prototype = jn.prototype, En.prototype.constructor = En, Dn.prototype = On(jn.prototype), Dn.prototype.constructor = Dn, Ln.prototype = On(jn.prototype), Ln.prototype.constructor = Ln, Pn.prototype.clear = function () {
            this.__data__ = mn ? mn(null) : {}, this.size = 0;
          }, Pn.prototype["delete"] = function (e) {
            var t = this.has(e) && delete this.__data__[e];
            return this.size -= t ? 1 : 0, t;
          }, Pn.prototype.get = function (e) {
            var t = this.__data__;

            if (mn) {
              var n = t[e];
              return "__lodash_hash_undefined__" === n ? void 0 : n;
            }

            return ke.call(t, e) ? t[e] : void 0;
          }, Pn.prototype.has = function (e) {
            var t = this.__data__;
            return mn ? void 0 !== t[e] : ke.call(t, e);
          }, Pn.prototype.set = function (e, t) {
            var n = this.__data__;
            return this.size += this.has(e) ? 0 : 1, n[e] = mn && void 0 === t ? "__lodash_hash_undefined__" : t, this;
          }, Nn.prototype.clear = function () {
            this.__data__ = [], this.size = 0;
          }, Nn.prototype["delete"] = function (e) {
            var t = this.__data__,
                n = $n(t, e);
            return !(n < 0) && (n == t.length - 1 ? t.pop() : Ge.call(t, n, 1), --this.size, !0);
          }, Nn.prototype.get = function (e) {
            var t = this.__data__,
                n = $n(t, e);
            return n < 0 ? void 0 : t[n][1];
          }, Nn.prototype.has = function (e) {
            return $n(this.__data__, e) > -1;
          }, Nn.prototype.set = function (e, t) {
            var n = this.__data__,
                r = $n(n, e);
            return r < 0 ? (++this.size, n.push([e, t])) : n[r][1] = t, this;
          }, In.prototype.clear = function () {
            this.size = 0, this.__data__ = {
              hash: new Pn(),
              map: new (pn || Nn)(),
              string: new Pn()
            };
          }, In.prototype["delete"] = function (e) {
            var t = Zi(this, e)["delete"](e);
            return this.size -= t ? 1 : 0, t;
          }, In.prototype.get = function (e) {
            return Zi(this, e).get(e);
          }, In.prototype.has = function (e) {
            return Zi(this, e).has(e);
          }, In.prototype.set = function (e, t) {
            var n = Zi(this, e),
                r = n.size;
            return n.set(e, t), this.size += n.size == r ? 0 : 1, this;
          }, Mn.prototype.add = Mn.prototype.push = function (e) {
            return this.__data__.set(e, "__lodash_hash_undefined__"), this;
          }, Mn.prototype.has = function (e) {
            return this.__data__.has(e);
          }, Rn.prototype.clear = function () {
            this.__data__ = new Nn(), this.size = 0;
          }, Rn.prototype["delete"] = function (e) {
            var t = this.__data__,
                n = t["delete"](e);
            return this.size = t.size, n;
          }, Rn.prototype.get = function (e) {
            return this.__data__.get(e);
          }, Rn.prototype.has = function (e) {
            return this.__data__.has(e);
          }, Rn.prototype.set = function (e, t) {
            var n = this.__data__;

            if (n instanceof Nn) {
              var r = n.__data__;
              if (!pn || r.length < 199) return r.push([e, t]), this.size = ++n.size, this;
              n = this.__data__ = new In(r);
            }

            return n.set(e, t), this.size = n.size, this;
          };

          var er = _i(ur),
              tr = _i(cr, !0);

          function nr(e, t) {
            var n = !0;
            return er(e, function (e, r, i) {
              return n = !!t(e, r, i);
            }), n;
          }

          function rr(e, t, n) {
            for (var r = -1, i = e.length; ++r < i;) {
              var o = e[r],
                  a = t(o);
              if (null != a && (void 0 === s ? a == a && !Za(a) : n(a, s))) var s = a,
                  u = o;
            }

            return u;
          }

          function ir(e, t) {
            var n = [];
            return er(e, function (e, r, i) {
              t(e, r, i) && n.push(e);
            }), n;
          }

          function or(e, t, n, r, i) {
            var o = -1,
                a = e.length;

            for (n || (n = oo), i || (i = []); ++o < a;) {
              var s = e[o];
              t > 0 && n(s) ? t > 1 ? or(s, t - 1, n, r, i) : ht(i, s) : r || (i[i.length] = s);
            }

            return i;
          }

          var ar = xi(),
              sr = xi(!0);

          function ur(e, t) {
            return e && ar(e, t, ws);
          }

          function cr(e, t) {
            return e && sr(e, t, ws);
          }

          function lr(e, t) {
            return lt(t, function (t) {
              return Ba(e[t]);
            });
          }

          function fr(e, t) {
            for (var n = 0, r = (t = si(t, e)).length; null != e && n < r;) {
              e = e[So(t[n++])];
            }

            return n && n == r ? e : void 0;
          }

          function dr(e, t, n) {
            var r = t(e);
            return Pa(e) ? r : ht(r, n(e));
          }

          function pr(e) {
            return null == e ? void 0 === e ? "[object Undefined]" : "[object Null]" : yt && yt in ve(e) ? function (e) {
              var t = ke.call(e, yt),
                  n = e[yt];

              try {
                e[yt] = void 0;
                var r = !0;
              } catch (e) {}

              var i = Ae.call(e);
              r && (t ? e[yt] = n : delete e[yt]);
              return i;
            }(e) : function (e) {
              return Ae.call(e);
            }(e);
          }

          function hr(e, t) {
            return e > t;
          }

          function vr(e, t) {
            return null != e && ke.call(e, t);
          }

          function gr(e, t) {
            return null != e && t in ve(e);
          }

          function mr(e, t, n) {
            for (var i = n ? dt : ft, o = e[0].length, a = e.length, s = a, u = r(a), c = 1 / 0, l = []; s--;) {
              var f = e[s];
              s && t && (f = pt(f, jt(t))), c = sn(f.length, c), u[s] = !n && (t || o >= 120 && f.length >= 120) ? new Mn(s && f) : void 0;
            }

            f = e[0];
            var d = -1,
                p = u[0];

            e: for (; ++d < o && l.length < c;) {
              var h = f[d],
                  v = t ? t(h) : h;

              if (h = n || 0 !== h ? h : 0, !(p ? Lt(p, v) : i(l, v, n))) {
                for (s = a; --s;) {
                  var g = u[s];
                  if (!(g ? Lt(g, v) : i(e[s], v, n))) continue e;
                }

                p && p.push(v), l.push(h);
              }
            }

            return l;
          }

          function yr(e, t, n) {
            var r = null == (e = go(e, t = si(t, e))) ? e : e[So(Fo(t))];
            return null == r ? void 0 : ot(r, e, n);
          }

          function br(e) {
            return $a(e) && pr(e) == u;
          }

          function wr(e, t, n, r, i) {
            return e === t || (null == e || null == t || !$a(e) && !$a(t) ? e != e && t != t : function (e, t, n, r, i, o) {
              var a = Pa(e),
                  s = Pa(t),
                  p = a ? c : no(e),
                  h = s ? c : no(t),
                  x = (p = p == u ? m : p) == m,
                  T = (h = h == u ? m : h) == m,
                  S = p == h;

              if (S && Ra(e)) {
                if (!Ra(t)) return !1;
                a = !0, x = !1;
              }

              if (S && !x) return o || (o = new Rn()), a || Qa(e) ? Wi(e, t, n, r, i, o) : function (e, t, n, r, i, o, a) {
                switch (n) {
                  case k:
                    if (e.byteLength != t.byteLength || e.byteOffset != t.byteOffset) return !1;
                    e = e.buffer, t = t.buffer;

                  case C:
                    return !(e.byteLength != t.byteLength || !o(new Me(e), new Me(t)));

                  case l:
                  case f:
                  case g:
                    return Oa(+e, +t);

                  case d:
                    return e.name == t.name && e.message == t.message;

                  case y:
                  case w:
                    return e == t + "";

                  case v:
                    var s = Bt;

                  case b:
                    var u = 1 & r;
                    if (s || (s = Wt), e.size != t.size && !u) return !1;
                    var c = a.get(e);
                    if (c) return c == t;
                    r |= 2, a.set(e, t);
                    var p = Wi(s(e), s(t), r, i, o, a);
                    return a["delete"](e), p;

                  case _:
                    if (Sn) return Sn.call(e) == Sn.call(t);
                }

                return !1;
              }(e, t, p, n, r, i, o);

              if (!(1 & n)) {
                var A = x && ke.call(e, "__wrapped__"),
                    E = T && ke.call(t, "__wrapped__");

                if (A || E) {
                  var O = A ? e.value() : e,
                      j = E ? t.value() : t;
                  return o || (o = new Rn()), i(O, j, n, r, o);
                }
              }

              if (!S) return !1;
              return o || (o = new Rn()), function (e, t, n, r, i, o) {
                var a = 1 & n,
                    s = Vi(e),
                    u = s.length,
                    c = Vi(t).length;
                if (u != c && !a) return !1;
                var l = u;

                for (; l--;) {
                  var f = s[l];
                  if (!(a ? f in t : ke.call(t, f))) return !1;
                }

                var d = o.get(e);
                if (d && o.get(t)) return d == t;
                var p = !0;
                o.set(e, t), o.set(t, e);
                var h = a;

                for (; ++l < u;) {
                  f = s[l];
                  var v = e[f],
                      g = t[f];
                  if (r) var m = a ? r(g, v, f, t, e, o) : r(v, g, f, e, t, o);

                  if (!(void 0 === m ? v === g || i(v, g, n, r, o) : m)) {
                    p = !1;
                    break;
                  }

                  h || (h = "constructor" == f);
                }

                if (p && !h) {
                  var y = e.constructor,
                      b = t.constructor;
                  y != b && "constructor" in e && "constructor" in t && !("function" == typeof y && y instanceof y && "function" == typeof b && b instanceof b) && (p = !1);
                }

                return o["delete"](e), o["delete"](t), p;
              }(e, t, n, r, i, o);
            }(e, t, n, r, wr, i));
          }

          function _r(e, t, n, r) {
            var i = n.length,
                o = i,
                a = !r;
            if (null == e) return !o;

            for (e = ve(e); i--;) {
              var s = n[i];
              if (a && s[2] ? s[1] !== e[s[0]] : !(s[0] in e)) return !1;
            }

            for (; ++i < o;) {
              var u = (s = n[i])[0],
                  c = e[u],
                  l = s[1];

              if (a && s[2]) {
                if (void 0 === c && !(u in e)) return !1;
              } else {
                var f = new Rn();
                if (r) var d = r(c, l, u, e, t, f);
                if (!(void 0 === d ? wr(l, c, 3, r, f) : d)) return !1;
              }
            }

            return !0;
          }

          function xr(e) {
            return !(!Wa(e) || (t = e, Se && Se in t)) && (Ba(e) ? je : ae).test(Ao(e));
            var t;
          }

          function Cr(e) {
            return "function" == typeof e ? e : null == e ? Us : "object" == _typeof(e) ? Pa(e) ? Or(e[0], e[1]) : Er(e) : tu(e);
          }

          function kr(e) {
            if (!fo(e)) return on(e);
            var t = [];

            for (var n in ve(e)) {
              ke.call(e, n) && "constructor" != n && t.push(n);
            }

            return t;
          }

          function Tr(e) {
            if (!Wa(e)) return function (e) {
              var t = [];
              if (null != e) for (var n in ve(e)) {
                t.push(n);
              }
              return t;
            }(e);
            var t = fo(e),
                n = [];

            for (var r in e) {
              ("constructor" != r || !t && ke.call(e, r)) && n.push(r);
            }

            return n;
          }

          function Sr(e, t) {
            return e < t;
          }

          function Ar(e, t) {
            var n = -1,
                i = Ia(e) ? r(e.length) : [];
            return er(e, function (e, r, o) {
              i[++n] = t(e, r, o);
            }), i;
          }

          function Er(e) {
            var t = Qi(e);
            return 1 == t.length && t[0][2] ? ho(t[0][0], t[0][1]) : function (n) {
              return n === e || _r(n, e, t);
            };
          }

          function Or(e, t) {
            return uo(e) && po(t) ? ho(So(e), t) : function (n) {
              var r = vs(n, e);
              return void 0 === r && r === t ? gs(n, e) : wr(t, r, 3);
            };
          }

          function jr(e, t, n, r, i) {
            e !== t && ar(t, function (o, a) {
              if (i || (i = new Rn()), Wa(o)) !function (e, t, n, r, i, o, a) {
                var s = yo(e, n),
                    u = yo(t, n),
                    c = a.get(u);
                if (c) return void Hn(e, n, c);
                var l = o ? o(s, u, n + "", e, t, a) : void 0,
                    f = void 0 === l;

                if (f) {
                  var d = Pa(u),
                      p = !d && Ra(u),
                      h = !d && !p && Qa(u);
                  l = u, d || p || h ? Pa(s) ? l = s : Ma(s) ? l = mi(s) : p ? (f = !1, l = fi(u, !0)) : h ? (f = !1, l = pi(u, !0)) : l = [] : Ka(u) || La(u) ? (l = s, La(s) ? l = as(s) : Wa(s) && !Ba(s) || (l = io(u))) : f = !1;
                }

                f && (a.set(u, l), i(l, u, r, o, a), a["delete"](u));
                Hn(e, n, l);
              }(e, t, a, n, jr, r, i);else {
                var s = r ? r(yo(e, a), o, a + "", e, t, i) : void 0;
                void 0 === s && (s = o), Hn(e, a, s);
              }
            }, _s);
          }

          function Dr(e, t) {
            var n = e.length;
            if (n) return ao(t += t < 0 ? n : 0, n) ? e[t] : void 0;
          }

          function Lr(e, t, n) {
            var r = -1;
            return t = pt(t.length ? t : [Us], jt(Yi())), function (e, t) {
              var n = e.length;

              for (e.sort(t); n--;) {
                e[n] = e[n].value;
              }

              return e;
            }(Ar(e, function (e, n, i) {
              return {
                criteria: pt(t, function (t) {
                  return t(e);
                }),
                index: ++r,
                value: e
              };
            }), function (e, t) {
              return function (e, t, n) {
                var r = -1,
                    i = e.criteria,
                    o = t.criteria,
                    a = i.length,
                    s = n.length;

                for (; ++r < a;) {
                  var u = hi(i[r], o[r]);

                  if (u) {
                    if (r >= s) return u;
                    var c = n[r];
                    return u * ("desc" == c ? -1 : 1);
                  }
                }

                return e.index - t.index;
              }(e, t, n);
            });
          }

          function Pr(e, t, n) {
            for (var r = -1, i = t.length, o = {}; ++r < i;) {
              var a = t[r],
                  s = fr(e, a);
              n(s, a) && zr(o, si(a, e), s);
            }

            return o;
          }

          function Nr(e, t, n, r) {
            var i = r ? xt : _t,
                o = -1,
                a = t.length,
                s = e;

            for (e === t && (t = mi(t)), n && (s = pt(e, jt(n))); ++o < a;) {
              for (var u = 0, c = t[o], l = n ? n(c) : c; (u = i(s, l, u, r)) > -1;) {
                s !== e && Ge.call(s, u, 1), Ge.call(e, u, 1);
              }
            }

            return e;
          }

          function Ir(e, t) {
            for (var n = e ? t.length : 0, r = n - 1; n--;) {
              var i = t[n];

              if (n == r || i !== o) {
                var o = i;
                ao(i) ? Ge.call(e, i, 1) : Jr(e, i);
              }
            }

            return e;
          }

          function Mr(e, t) {
            return e + Jt(ln() * (t - e + 1));
          }

          function Rr(e, t) {
            var n = "";
            if (!e || t < 1 || t > 9007199254740991) return n;

            do {
              t % 2 && (n += e), (t = Jt(t / 2)) && (e += e);
            } while (t);

            return n;
          }

          function qr(e, t) {
            return _o(vo(e, t, Us), e + "");
          }

          function Fr(e) {
            return Fn(Os(e));
          }

          function Br(e, t) {
            var n = Os(e);
            return ko(n, Gn(t, 0, n.length));
          }

          function zr(e, t, n, r) {
            if (!Wa(e)) return e;

            for (var i = -1, o = (t = si(t, e)).length, a = o - 1, s = e; null != s && ++i < o;) {
              var u = So(t[i]),
                  c = n;

              if (i != a) {
                var l = s[u];
                void 0 === (c = r ? r(l, u, s) : void 0) && (c = Wa(l) ? l : ao(t[i + 1]) ? [] : {});
              }

              Wn(s, u, c), s = s[u];
            }

            return e;
          }

          var Hr = yn ? function (e, t) {
            return yn.set(e, t), e;
          } : Us,
              Wr = St ? function (e, t) {
            return St(e, "toString", {
              configurable: !0,
              enumerable: !1,
              value: Ws(t),
              writable: !0
            });
          } : Us;

          function $r(e) {
            return ko(Os(e));
          }

          function Vr(e, t, n) {
            var i = -1,
                o = e.length;
            t < 0 && (t = -t > o ? 0 : o + t), (n = n > o ? o : n) < 0 && (n += o), o = t > n ? 0 : n - t >>> 0, t >>>= 0;

            for (var a = r(o); ++i < o;) {
              a[i] = e[i + t];
            }

            return a;
          }

          function Ur(e, t) {
            var n;
            return er(e, function (e, r, i) {
              return !(n = t(e, r, i));
            }), !!n;
          }

          function Kr(e, t, n) {
            var r = 0,
                i = null == e ? r : e.length;

            if ("number" == typeof t && t == t && i <= 2147483647) {
              for (; r < i;) {
                var o = r + i >>> 1,
                    a = e[o];
                null !== a && !Za(a) && (n ? a <= t : a < t) ? r = o + 1 : i = o;
              }

              return i;
            }

            return Xr(e, t, Us, n);
          }

          function Xr(e, t, n, r) {
            t = n(t);

            for (var i = 0, o = null == e ? 0 : e.length, a = t != t, s = null === t, u = Za(t), c = void 0 === t; i < o;) {
              var l = Jt((i + o) / 2),
                  f = n(e[l]),
                  d = void 0 !== f,
                  p = null === f,
                  h = f == f,
                  v = Za(f);
              if (a) var g = r || h;else g = c ? h && (r || d) : s ? h && d && (r || !p) : u ? h && d && !p && (r || !v) : !p && !v && (r ? f <= t : f < t);
              g ? i = l + 1 : o = l;
            }

            return sn(o, 4294967294);
          }

          function Gr(e, t) {
            for (var n = -1, r = e.length, i = 0, o = []; ++n < r;) {
              var a = e[n],
                  s = t ? t(a) : a;

              if (!n || !Oa(s, u)) {
                var u = s;
                o[i++] = 0 === a ? 0 : a;
              }
            }

            return o;
          }

          function Yr(e) {
            return "number" == typeof e ? e : Za(e) ? NaN : +e;
          }

          function Zr(e) {
            if ("string" == typeof e) return e;
            if (Pa(e)) return pt(e, Zr) + "";
            if (Za(e)) return An ? An.call(e) : "";
            var t = e + "";
            return "0" == t && 1 / e == -1 / 0 ? "-0" : t;
          }

          function Qr(e, t, n) {
            var r = -1,
                i = ft,
                o = e.length,
                a = !0,
                s = [],
                u = s;
            if (n) a = !1, i = dt;else if (o >= 200) {
              var c = t ? null : Ri(e);
              if (c) return Wt(c);
              a = !1, i = Lt, u = new Mn();
            } else u = t ? [] : s;

            e: for (; ++r < o;) {
              var l = e[r],
                  f = t ? t(l) : l;

              if (l = n || 0 !== l ? l : 0, a && f == f) {
                for (var d = u.length; d--;) {
                  if (u[d] === f) continue e;
                }

                t && u.push(f), s.push(l);
              } else i(u, f, n) || (u !== s && u.push(f), s.push(l));
            }

            return s;
          }

          function Jr(e, t) {
            return null == (e = go(e, t = si(t, e))) || delete e[So(Fo(t))];
          }

          function ei(e, t, n, r) {
            return zr(e, t, n(fr(e, t)), r);
          }

          function ti(e, t, n, r) {
            for (var i = e.length, o = r ? i : -1; (r ? o-- : ++o < i) && t(e[o], o, e);) {
              ;
            }

            return n ? Vr(e, r ? 0 : o, r ? o + 1 : i) : Vr(e, r ? o + 1 : 0, r ? i : o);
          }

          function ni(e, t) {
            var n = e;
            return n instanceof Ln && (n = n.value()), vt(t, function (e, t) {
              return t.func.apply(t.thisArg, ht([e], t.args));
            }, n);
          }

          function ri(e, t, n) {
            var i = e.length;
            if (i < 2) return i ? Qr(e[0]) : [];

            for (var o = -1, a = r(i); ++o < i;) {
              for (var s = e[o], u = -1; ++u < i;) {
                u != o && (a[o] = Jn(a[o] || s, e[u], t, n));
              }
            }

            return Qr(or(a, 1), t, n);
          }

          function ii(e, t, n) {
            for (var r = -1, i = e.length, o = t.length, a = {}; ++r < i;) {
              var s = r < o ? t[r] : void 0;
              n(a, e[r], s);
            }

            return a;
          }

          function oi(e) {
            return Ma(e) ? e : [];
          }

          function ai(e) {
            return "function" == typeof e ? e : Us;
          }

          function si(e, t) {
            return Pa(e) ? e : uo(e, t) ? [e] : To(ss(e));
          }

          var ui = qr;

          function ci(e, t, n) {
            var r = e.length;
            return n = void 0 === n ? r : n, !t && n >= r ? e : Vr(e, t, n);
          }

          var li = Gt || function (e) {
            return Ke.clearTimeout(e);
          };

          function fi(e, t) {
            if (t) return e.slice();
            var n = e.length,
                r = He ? He(n) : new e.constructor(n);
            return e.copy(r), r;
          }

          function di(e) {
            var t = new e.constructor(e.byteLength);
            return new Me(t).set(new Me(e)), t;
          }

          function pi(e, t) {
            var n = t ? di(e.buffer) : e.buffer;
            return new e.constructor(n, e.byteOffset, e.length);
          }

          function hi(e, t) {
            if (e !== t) {
              var n = void 0 !== e,
                  r = null === e,
                  i = e == e,
                  o = Za(e),
                  a = void 0 !== t,
                  s = null === t,
                  u = t == t,
                  c = Za(t);
              if (!s && !c && !o && e > t || o && a && u && !s && !c || r && a && u || !n && u || !i) return 1;
              if (!r && !o && !c && e < t || c && n && i && !r && !o || s && n && i || !a && i || !u) return -1;
            }

            return 0;
          }

          function vi(e, t, n, i) {
            for (var o = -1, a = e.length, s = n.length, u = -1, c = t.length, l = an(a - s, 0), f = r(c + l), d = !i; ++u < c;) {
              f[u] = t[u];
            }

            for (; ++o < s;) {
              (d || o < a) && (f[n[o]] = e[o]);
            }

            for (; l--;) {
              f[u++] = e[o++];
            }

            return f;
          }

          function gi(e, t, n, i) {
            for (var o = -1, a = e.length, s = -1, u = n.length, c = -1, l = t.length, f = an(a - u, 0), d = r(f + l), p = !i; ++o < f;) {
              d[o] = e[o];
            }

            for (var h = o; ++c < l;) {
              d[h + c] = t[c];
            }

            for (; ++s < u;) {
              (p || o < a) && (d[h + n[s]] = e[o++]);
            }

            return d;
          }

          function mi(e, t) {
            var n = -1,
                i = e.length;

            for (t || (t = r(i)); ++n < i;) {
              t[n] = e[n];
            }

            return t;
          }

          function yi(e, t, n, r) {
            var i = !n;
            n || (n = {});

            for (var o = -1, a = t.length; ++o < a;) {
              var s = t[o],
                  u = r ? r(n[s], e[s], s, n, e) : void 0;
              void 0 === u && (u = e[s]), i ? Kn(n, s, u) : Wn(n, s, u);
            }

            return n;
          }

          function bi(e, t) {
            return function (n, r) {
              var i = Pa(n) ? at : Vn,
                  o = t ? t() : {};
              return i(n, e, Yi(r, 2), o);
            };
          }

          function wi(e) {
            return qr(function (t, n) {
              var r = -1,
                  i = n.length,
                  o = i > 1 ? n[i - 1] : void 0,
                  a = i > 2 ? n[2] : void 0;

              for (o = e.length > 3 && "function" == typeof o ? (i--, o) : void 0, a && so(n[0], n[1], a) && (o = i < 3 ? void 0 : o, i = 1), t = ve(t); ++r < i;) {
                var s = n[r];
                s && e(t, s, r, o);
              }

              return t;
            });
          }

          function _i(e, t) {
            return function (n, r) {
              if (null == n) return n;
              if (!Ia(n)) return e(n, r);

              for (var i = n.length, o = t ? i : -1, a = ve(n); (t ? o-- : ++o < i) && !1 !== r(a[o], o, a);) {
                ;
              }

              return n;
            };
          }

          function xi(e) {
            return function (t, n, r) {
              for (var i = -1, o = ve(t), a = r(t), s = a.length; s--;) {
                var u = a[e ? s : ++i];
                if (!1 === n(o[u], u, o)) break;
              }

              return t;
            };
          }

          function Ci(e) {
            return function (t) {
              var n = Ft(t = ss(t)) ? Ut(t) : void 0,
                  r = n ? n[0] : t.charAt(0),
                  i = n ? ci(n, 1).join("") : t.slice(1);
              return r[e]() + i;
            };
          }

          function ki(e) {
            return function (t) {
              return vt(Bs(Ls(t).replace(Le, "")), e, "");
            };
          }

          function Ti(e) {
            return function () {
              var t = arguments;

              switch (t.length) {
                case 0:
                  return new e();

                case 1:
                  return new e(t[0]);

                case 2:
                  return new e(t[0], t[1]);

                case 3:
                  return new e(t[0], t[1], t[2]);

                case 4:
                  return new e(t[0], t[1], t[2], t[3]);

                case 5:
                  return new e(t[0], t[1], t[2], t[3], t[4]);

                case 6:
                  return new e(t[0], t[1], t[2], t[3], t[4], t[5]);

                case 7:
                  return new e(t[0], t[1], t[2], t[3], t[4], t[5], t[6]);
              }

              var n = On(e.prototype),
                  r = e.apply(n, t);
              return Wa(r) ? r : n;
            };
          }

          function Si(e) {
            return function (t, n, r) {
              var i = ve(t);

              if (!Ia(t)) {
                var o = Yi(n, 3);
                t = ws(t), n = function n(e) {
                  return o(i[e], e, i);
                };
              }

              var a = e(t, n, r);
              return a > -1 ? i[o ? t[a] : a] : void 0;
            };
          }

          function Ai(e) {
            return $i(function (t) {
              var n = t.length,
                  r = n,
                  i = Dn.prototype.thru;

              for (e && t.reverse(); r--;) {
                var a = t[r];
                if ("function" != typeof a) throw new ye(o);
                if (i && !s && "wrapper" == Xi(a)) var s = new Dn([], !0);
              }

              for (r = s ? r : n; ++r < n;) {
                var u = Xi(a = t[r]),
                    c = "wrapper" == u ? Ki(a) : void 0;
                s = c && co(c[0]) && 424 == c[1] && !c[4].length && 1 == c[9] ? s[Xi(c[0])].apply(s, c[3]) : 1 == a.length && co(a) ? s[u]() : s.thru(a);
              }

              return function () {
                var e = arguments,
                    r = e[0];
                if (s && 1 == e.length && Pa(r)) return s.plant(r).value();

                for (var i = 0, o = n ? t[i].apply(this, e) : r; ++i < n;) {
                  o = t[i].call(this, o);
                }

                return o;
              };
            });
          }

          function Ei(e, t, n, i, o, a, s, u, c, l) {
            var f = 128 & t,
                d = 1 & t,
                p = 2 & t,
                h = 24 & t,
                v = 512 & t,
                g = p ? void 0 : Ti(e);
            return function m() {
              for (var y = arguments.length, b = r(y), w = y; w--;) {
                b[w] = arguments[w];
              }

              if (h) var _ = Gi(m),
                  x = It(b, _);

              if (i && (b = vi(b, i, o, h)), a && (b = gi(b, a, s, h)), y -= x, h && y < l) {
                var C = Ht(b, _);
                return Ii(e, t, Ei, m.placeholder, n, b, C, u, c, l - y);
              }

              var k = d ? n : this,
                  T = p ? k[e] : e;
              return y = b.length, u ? b = mo(b, u) : v && y > 1 && b.reverse(), f && c < y && (b.length = c), this && this !== Ke && this instanceof m && (T = g || Ti(T)), T.apply(k, b);
            };
          }

          function Oi(e, t) {
            return function (n, r) {
              return function (e, t, n, r) {
                return ur(e, function (e, i, o) {
                  t(r, n(e), i, o);
                }), r;
              }(n, e, t(r), {});
            };
          }

          function ji(e, t) {
            return function (n, r) {
              var i;
              if (void 0 === n && void 0 === r) return t;

              if (void 0 !== n && (i = n), void 0 !== r) {
                if (void 0 === i) return r;
                "string" == typeof n || "string" == typeof r ? (n = Zr(n), r = Zr(r)) : (n = Yr(n), r = Yr(r)), i = e(n, r);
              }

              return i;
            };
          }

          function Di(e) {
            return $i(function (t) {
              return t = pt(t, jt(Yi())), qr(function (n) {
                var r = this;
                return e(t, function (e) {
                  return ot(e, r, n);
                });
              });
            });
          }

          function Li(e, t) {
            var n = (t = void 0 === t ? " " : Zr(t)).length;
            if (n < 2) return n ? Rr(t, e) : t;
            var r = Rr(t, Qt(e / Vt(t)));
            return Ft(t) ? ci(Ut(r), 0, e).join("") : r.slice(0, e);
          }

          function Pi(e) {
            return function (t, n, i) {
              return i && "number" != typeof i && so(t, n, i) && (n = i = void 0), t = ns(t), void 0 === n ? (n = t, t = 0) : n = ns(n), function (e, t, n, i) {
                for (var o = -1, a = an(Qt((t - e) / (n || 1)), 0), s = r(a); a--;) {
                  s[i ? a : ++o] = e, e += n;
                }

                return s;
              }(t, n, i = void 0 === i ? t < n ? 1 : -1 : ns(i), e);
            };
          }

          function Ni(e) {
            return function (t, n) {
              return "string" == typeof t && "string" == typeof n || (t = os(t), n = os(n)), e(t, n);
            };
          }

          function Ii(e, t, n, r, i, o, a, s, u, c) {
            var l = 8 & t;
            t |= l ? 32 : 64, 4 & (t &= ~(l ? 64 : 32)) || (t &= -4);
            var f = [e, t, i, l ? o : void 0, l ? a : void 0, l ? void 0 : o, l ? void 0 : a, s, u, c],
                d = n.apply(void 0, f);
            return co(e) && bo(d, f), d.placeholder = r, xo(d, e, t);
          }

          function Mi(e) {
            var t = he[e];
            return function (e, n) {
              if (e = os(e), (n = null == n ? 0 : sn(rs(n), 292)) && nn(e)) {
                var r = (ss(e) + "e").split("e");
                return +((r = (ss(t(r[0] + "e" + (+r[1] + n))) + "e").split("e"))[0] + "e" + (+r[1] - n));
              }

              return t(e);
            };
          }

          var Ri = vn && 1 / Wt(new vn([, -0]))[1] == 1 / 0 ? function (e) {
            return new vn(e);
          } : Zs;

          function qi(e) {
            return function (t) {
              var n = no(t);
              return n == v ? Bt(t) : n == b ? $t(t) : function (e, t) {
                return pt(t, function (t) {
                  return [t, e[t]];
                });
              }(t, e(t));
            };
          }

          function Fi(e, t, n, i, s, u, c, l) {
            var f = 2 & t;
            if (!f && "function" != typeof e) throw new ye(o);
            var d = i ? i.length : 0;

            if (d || (t &= -97, i = s = void 0), c = void 0 === c ? c : an(rs(c), 0), l = void 0 === l ? l : rs(l), d -= s ? s.length : 0, 64 & t) {
              var p = i,
                  h = s;
              i = s = void 0;
            }

            var v = f ? void 0 : Ki(e),
                g = [e, t, n, i, s, p, h, u, c, l];
            if (v && function (e, t) {
              var n = e[1],
                  r = t[1],
                  i = n | r,
                  o = i < 131,
                  s = 128 == r && 8 == n || 128 == r && 256 == n && e[7].length <= t[8] || 384 == r && t[7].length <= t[8] && 8 == n;
              if (!o && !s) return e;
              1 & r && (e[2] = t[2], i |= 1 & n ? 0 : 4);
              var u = t[3];

              if (u) {
                var c = e[3];
                e[3] = c ? vi(c, u, t[4]) : u, e[4] = c ? Ht(e[3], a) : t[4];
              }

              (u = t[5]) && (c = e[5], e[5] = c ? gi(c, u, t[6]) : u, e[6] = c ? Ht(e[5], a) : t[6]);
              (u = t[7]) && (e[7] = u);
              128 & r && (e[8] = null == e[8] ? t[8] : sn(e[8], t[8]));
              null == e[9] && (e[9] = t[9]);
              e[0] = t[0], e[1] = i;
            }(g, v), e = g[0], t = g[1], n = g[2], i = g[3], s = g[4], !(l = g[9] = void 0 === g[9] ? f ? 0 : e.length : an(g[9] - d, 0)) && 24 & t && (t &= -25), t && 1 != t) m = 8 == t || 16 == t ? function (e, t, n) {
              var i = Ti(e);
              return function o() {
                for (var a = arguments.length, s = r(a), u = a, c = Gi(o); u--;) {
                  s[u] = arguments[u];
                }

                var l = a < 3 && s[0] !== c && s[a - 1] !== c ? [] : Ht(s, c);
                if ((a -= l.length) < n) return Ii(e, t, Ei, o.placeholder, void 0, s, l, void 0, void 0, n - a);
                var f = this && this !== Ke && this instanceof o ? i : e;
                return ot(f, this, s);
              };
            }(e, t, l) : 32 != t && 33 != t || s.length ? Ei.apply(void 0, g) : function (e, t, n, i) {
              var o = 1 & t,
                  a = Ti(e);
              return function t() {
                for (var s = -1, u = arguments.length, c = -1, l = i.length, f = r(l + u), d = this && this !== Ke && this instanceof t ? a : e; ++c < l;) {
                  f[c] = i[c];
                }

                for (; u--;) {
                  f[c++] = arguments[++s];
                }

                return ot(d, o ? n : this, f);
              };
            }(e, t, n, i);else var m = function (e, t, n) {
              var r = 1 & t,
                  i = Ti(e);
              return function t() {
                var o = this && this !== Ke && this instanceof t ? i : e;
                return o.apply(r ? n : this, arguments);
              };
            }(e, t, n);
            return xo((v ? Hr : bo)(m, g), e, t);
          }

          function Bi(e, t, n, r) {
            return void 0 === e || Oa(e, _e[n]) && !ke.call(r, n) ? t : e;
          }

          function zi(e, t, n, r, i, o) {
            return Wa(e) && Wa(t) && (o.set(t, e), jr(e, t, void 0, zi, o), o["delete"](t)), e;
          }

          function Hi(e) {
            return Ka(e) ? void 0 : e;
          }

          function Wi(e, t, n, r, i, o) {
            var a = 1 & n,
                s = e.length,
                u = t.length;
            if (s != u && !(a && u > s)) return !1;
            var c = o.get(e);
            if (c && o.get(t)) return c == t;
            var l = -1,
                f = !0,
                d = 2 & n ? new Mn() : void 0;

            for (o.set(e, t), o.set(t, e); ++l < s;) {
              var p = e[l],
                  h = t[l];
              if (r) var v = a ? r(h, p, l, t, e, o) : r(p, h, l, e, t, o);

              if (void 0 !== v) {
                if (v) continue;
                f = !1;
                break;
              }

              if (d) {
                if (!mt(t, function (e, t) {
                  if (!Lt(d, t) && (p === e || i(p, e, n, r, o))) return d.push(t);
                })) {
                  f = !1;
                  break;
                }
              } else if (p !== h && !i(p, h, n, r, o)) {
                f = !1;
                break;
              }
            }

            return o["delete"](e), o["delete"](t), f;
          }

          function $i(e) {
            return _o(vo(e, void 0, No), e + "");
          }

          function Vi(e) {
            return dr(e, ws, eo);
          }

          function Ui(e) {
            return dr(e, _s, to);
          }

          var Ki = yn ? function (e) {
            return yn.get(e);
          } : Zs;

          function Xi(e) {
            for (var t = e.name + "", n = bn[t], r = ke.call(bn, t) ? n.length : 0; r--;) {
              var i = n[r],
                  o = i.func;
              if (null == o || o == e) return i.name;
            }

            return t;
          }

          function Gi(e) {
            return (ke.call(En, "placeholder") ? En : e).placeholder;
          }

          function Yi() {
            var e = En.iteratee || Ks;
            return e = e === Ks ? Cr : e, arguments.length ? e(arguments[0], arguments[1]) : e;
          }

          function Zi(e, t) {
            var n,
                r,
                i = e.__data__;
            return ("string" == (r = _typeof(n = t)) || "number" == r || "symbol" == r || "boolean" == r ? "__proto__" !== n : null === n) ? i["string" == typeof t ? "string" : "hash"] : i.map;
          }

          function Qi(e) {
            for (var t = ws(e), n = t.length; n--;) {
              var r = t[n],
                  i = e[r];
              t[n] = [r, i, po(i)];
            }

            return t;
          }

          function Ji(e, t) {
            var n = function (e, t) {
              return null == e ? void 0 : e[t];
            }(e, t);

            return xr(n) ? n : void 0;
          }

          var eo = en ? function (e) {
            return null == e ? [] : (e = ve(e), lt(en(e), function (t) {
              return Xe.call(e, t);
            }));
          } : iu,
              to = en ? function (e) {
            for (var t = []; e;) {
              ht(t, eo(e)), e = Ve(e);
            }

            return t;
          } : iu,
              no = pr;

          function ro(e, t, n) {
            for (var r = -1, i = (t = si(t, e)).length, o = !1; ++r < i;) {
              var a = So(t[r]);
              if (!(o = null != e && n(e, a))) break;
              e = e[a];
            }

            return o || ++r != i ? o : !!(i = null == e ? 0 : e.length) && Ha(i) && ao(a, i) && (Pa(e) || La(e));
          }

          function io(e) {
            return "function" != typeof e.constructor || fo(e) ? {} : On(Ve(e));
          }

          function oo(e) {
            return Pa(e) || La(e) || !!(Ze && e && e[Ze]);
          }

          function ao(e, t) {
            var n = _typeof(e);

            return !!(t = null == t ? 9007199254740991 : t) && ("number" == n || "symbol" != n && ue.test(e)) && e > -1 && e % 1 == 0 && e < t;
          }

          function so(e, t, n) {
            if (!Wa(n)) return !1;

            var r = _typeof(t);

            return !!("number" == r ? Ia(n) && ao(t, n.length) : "string" == r && t in n) && Oa(n[t], e);
          }

          function uo(e, t) {
            if (Pa(e)) return !1;

            var n = _typeof(e);

            return !("number" != n && "symbol" != n && "boolean" != n && null != e && !Za(e)) || $.test(e) || !W.test(e) || null != t && e in ve(t);
          }

          function co(e) {
            var t = Xi(e),
                n = En[t];
            if ("function" != typeof n || !(t in Ln.prototype)) return !1;
            if (e === n) return !0;
            var r = Ki(n);
            return !!r && e === r[0];
          }

          (dn && no(new dn(new ArrayBuffer(1))) != k || pn && no(new pn()) != v || hn && "[object Promise]" != no(hn.resolve()) || vn && no(new vn()) != b || gn && no(new gn()) != x) && (no = function no(e) {
            var t = pr(e),
                n = t == m ? e.constructor : void 0,
                r = n ? Ao(n) : "";
            if (r) switch (r) {
              case wn:
                return k;

              case _n:
                return v;

              case xn:
                return "[object Promise]";

              case Cn:
                return b;

              case kn:
                return x;
            }
            return t;
          });
          var lo = xe ? Ba : ou;

          function fo(e) {
            var t = e && e.constructor;
            return e === ("function" == typeof t && t.prototype || _e);
          }

          function po(e) {
            return e == e && !Wa(e);
          }

          function ho(e, t) {
            return function (n) {
              return null != n && n[e] === t && (void 0 !== t || e in ve(n));
            };
          }

          function vo(e, t, n) {
            return t = an(void 0 === t ? e.length - 1 : t, 0), function () {
              for (var i = arguments, o = -1, a = an(i.length - t, 0), s = r(a); ++o < a;) {
                s[o] = i[t + o];
              }

              o = -1;

              for (var u = r(t + 1); ++o < t;) {
                u[o] = i[o];
              }

              return u[t] = n(s), ot(e, this, u);
            };
          }

          function go(e, t) {
            return t.length < 2 ? e : fr(e, Vr(t, 0, -1));
          }

          function mo(e, t) {
            for (var n = e.length, r = sn(t.length, n), i = mi(e); r--;) {
              var o = t[r];
              e[r] = ao(o, n) ? i[o] : void 0;
            }

            return e;
          }

          function yo(e, t) {
            if (("constructor" !== t || "function" != typeof e[t]) && "__proto__" != t) return e[t];
          }

          var bo = Co(Hr),
              wo = Zt || function (e, t) {
            return Ke.setTimeout(e, t);
          },
              _o = Co(Wr);

          function xo(e, t, n) {
            var r = t + "";
            return _o(e, function (e, t) {
              var n = t.length;
              if (!n) return e;
              var r = n - 1;
              return t[r] = (n > 1 ? "& " : "") + t[r], t = t.join(n > 2 ? ", " : " "), e.replace(Z, "{\n/* [wrapped with " + t + "] */\n");
            }(r, function (e, t) {
              return st(s, function (n) {
                var r = "_." + n[0];
                t & n[1] && !ft(e, r) && e.push(r);
              }), e.sort();
            }(function (e) {
              var t = e.match(Q);
              return t ? t[1].split(J) : [];
            }(r), n)));
          }

          function Co(e) {
            var t = 0,
                n = 0;
            return function () {
              var r = un(),
                  i = 16 - (r - n);

              if (n = r, i > 0) {
                if (++t >= 800) return arguments[0];
              } else t = 0;

              return e.apply(void 0, arguments);
            };
          }

          function ko(e, t) {
            var n = -1,
                r = e.length,
                i = r - 1;

            for (t = void 0 === t ? r : t; ++n < t;) {
              var o = Mr(n, i),
                  a = e[o];
              e[o] = e[n], e[n] = a;
            }

            return e.length = t, e;
          }

          var To = function (e) {
            var t = Ca(e, function (e) {
              return 500 === n.size && n.clear(), e;
            }),
                n = t.cache;
            return t;
          }(function (e) {
            var t = [];
            return 46 === e.charCodeAt(0) && t.push(""), e.replace(V, function (e, n, r, i) {
              t.push(r ? i.replace(te, "$1") : n || e);
            }), t;
          });

          function So(e) {
            if ("string" == typeof e || Za(e)) return e;
            var t = e + "";
            return "0" == t && 1 / e == -1 / 0 ? "-0" : t;
          }

          function Ao(e) {
            if (null != e) {
              try {
                return Ce.call(e);
              } catch (e) {}

              try {
                return e + "";
              } catch (e) {}
            }

            return "";
          }

          function Eo(e) {
            if (e instanceof Ln) return e.clone();
            var t = new Dn(e.__wrapped__, e.__chain__);
            return t.__actions__ = mi(e.__actions__), t.__index__ = e.__index__, t.__values__ = e.__values__, t;
          }

          var Oo = qr(function (e, t) {
            return Ma(e) ? Jn(e, or(t, 1, Ma, !0)) : [];
          }),
              jo = qr(function (e, t) {
            var n = Fo(t);
            return Ma(n) && (n = void 0), Ma(e) ? Jn(e, or(t, 1, Ma, !0), Yi(n, 2)) : [];
          }),
              Do = qr(function (e, t) {
            var n = Fo(t);
            return Ma(n) && (n = void 0), Ma(e) ? Jn(e, or(t, 1, Ma, !0), void 0, n) : [];
          });

          function Lo(e, t, n) {
            var r = null == e ? 0 : e.length;
            if (!r) return -1;
            var i = null == n ? 0 : rs(n);
            return i < 0 && (i = an(r + i, 0)), wt(e, Yi(t, 3), i);
          }

          function Po(e, t, n) {
            var r = null == e ? 0 : e.length;
            if (!r) return -1;
            var i = r - 1;
            return void 0 !== n && (i = rs(n), i = n < 0 ? an(r + i, 0) : sn(i, r - 1)), wt(e, Yi(t, 3), i, !0);
          }

          function No(e) {
            return (null == e ? 0 : e.length) ? or(e, 1) : [];
          }

          function Io(e) {
            return e && e.length ? e[0] : void 0;
          }

          var Mo = qr(function (e) {
            var t = pt(e, oi);
            return t.length && t[0] === e[0] ? mr(t) : [];
          }),
              Ro = qr(function (e) {
            var t = Fo(e),
                n = pt(e, oi);
            return t === Fo(n) ? t = void 0 : n.pop(), n.length && n[0] === e[0] ? mr(n, Yi(t, 2)) : [];
          }),
              qo = qr(function (e) {
            var t = Fo(e),
                n = pt(e, oi);
            return (t = "function" == typeof t ? t : void 0) && n.pop(), n.length && n[0] === e[0] ? mr(n, void 0, t) : [];
          });

          function Fo(e) {
            var t = null == e ? 0 : e.length;
            return t ? e[t - 1] : void 0;
          }

          var Bo = qr(zo);

          function zo(e, t) {
            return e && e.length && t && t.length ? Nr(e, t) : e;
          }

          var Ho = $i(function (e, t) {
            var n = null == e ? 0 : e.length,
                r = Xn(e, t);
            return Ir(e, pt(t, function (e) {
              return ao(e, n) ? +e : e;
            }).sort(hi)), r;
          });

          function Wo(e) {
            return null == e ? e : fn.call(e);
          }

          var $o = qr(function (e) {
            return Qr(or(e, 1, Ma, !0));
          }),
              Vo = qr(function (e) {
            var t = Fo(e);
            return Ma(t) && (t = void 0), Qr(or(e, 1, Ma, !0), Yi(t, 2));
          }),
              Uo = qr(function (e) {
            var t = Fo(e);
            return t = "function" == typeof t ? t : void 0, Qr(or(e, 1, Ma, !0), void 0, t);
          });

          function Ko(e) {
            if (!e || !e.length) return [];
            var t = 0;
            return e = lt(e, function (e) {
              if (Ma(e)) return t = an(e.length, t), !0;
            }), Ot(t, function (t) {
              return pt(e, Tt(t));
            });
          }

          function Xo(e, t) {
            if (!e || !e.length) return [];
            var n = Ko(e);
            return null == t ? n : pt(n, function (e) {
              return ot(t, void 0, e);
            });
          }

          var Go = qr(function (e, t) {
            return Ma(e) ? Jn(e, t) : [];
          }),
              Yo = qr(function (e) {
            return ri(lt(e, Ma));
          }),
              Zo = qr(function (e) {
            var t = Fo(e);
            return Ma(t) && (t = void 0), ri(lt(e, Ma), Yi(t, 2));
          }),
              Qo = qr(function (e) {
            var t = Fo(e);
            return t = "function" == typeof t ? t : void 0, ri(lt(e, Ma), void 0, t);
          }),
              Jo = qr(Ko);
          var ea = qr(function (e) {
            var t = e.length,
                n = t > 1 ? e[t - 1] : void 0;
            return n = "function" == typeof n ? (e.pop(), n) : void 0, Xo(e, n);
          });

          function ta(e) {
            var t = En(e);
            return t.__chain__ = !0, t;
          }

          function na(e, t) {
            return t(e);
          }

          var ra = $i(function (e) {
            var t = e.length,
                n = t ? e[0] : 0,
                r = this.__wrapped__,
                i = function i(t) {
              return Xn(t, e);
            };

            return !(t > 1 || this.__actions__.length) && r instanceof Ln && ao(n) ? ((r = r.slice(n, +n + (t ? 1 : 0))).__actions__.push({
              func: na,
              args: [i],
              thisArg: void 0
            }), new Dn(r, this.__chain__).thru(function (e) {
              return t && !e.length && e.push(void 0), e;
            })) : this.thru(i);
          });
          var ia = bi(function (e, t, n) {
            ke.call(e, n) ? ++e[n] : Kn(e, n, 1);
          });
          var oa = Si(Lo),
              aa = Si(Po);

          function sa(e, t) {
            return (Pa(e) ? st : er)(e, Yi(t, 3));
          }

          function ua(e, t) {
            return (Pa(e) ? ut : tr)(e, Yi(t, 3));
          }

          var ca = bi(function (e, t, n) {
            ke.call(e, n) ? e[n].push(t) : Kn(e, n, [t]);
          });
          var la = qr(function (e, t, n) {
            var i = -1,
                o = "function" == typeof t,
                a = Ia(e) ? r(e.length) : [];
            return er(e, function (e) {
              a[++i] = o ? ot(t, e, n) : yr(e, t, n);
            }), a;
          }),
              fa = bi(function (e, t, n) {
            Kn(e, n, t);
          });

          function da(e, t) {
            return (Pa(e) ? pt : Ar)(e, Yi(t, 3));
          }

          var pa = bi(function (e, t, n) {
            e[n ? 0 : 1].push(t);
          }, function () {
            return [[], []];
          });

          var ha = qr(function (e, t) {
            if (null == e) return [];
            var n = t.length;
            return n > 1 && so(e, t[0], t[1]) ? t = [] : n > 2 && so(t[0], t[1], t[2]) && (t = [t[0]]), Lr(e, or(t, 1), []);
          }),
              va = Yt || function () {
            return Ke.Date.now();
          };

          function ga(e, t, n) {
            return t = n ? void 0 : t, Fi(e, 128, void 0, void 0, void 0, void 0, t = e && null == t ? e.length : t);
          }

          function ma(e, t) {
            var n;
            if ("function" != typeof t) throw new ye(o);
            return e = rs(e), function () {
              return --e > 0 && (n = t.apply(this, arguments)), e <= 1 && (t = void 0), n;
            };
          }

          var ya = qr(function (e, t, n) {
            var r = 1;

            if (n.length) {
              var i = Ht(n, Gi(ya));
              r |= 32;
            }

            return Fi(e, r, t, n, i);
          }),
              ba = qr(function (e, t, n) {
            var r = 3;

            if (n.length) {
              var i = Ht(n, Gi(ba));
              r |= 32;
            }

            return Fi(t, r, e, n, i);
          });

          function wa(e, t, n) {
            var r,
                i,
                a,
                s,
                u,
                c,
                l = 0,
                f = !1,
                d = !1,
                p = !0;
            if ("function" != typeof e) throw new ye(o);

            function h(t) {
              var n = r,
                  o = i;
              return r = i = void 0, l = t, s = e.apply(o, n);
            }

            function v(e) {
              return l = e, u = wo(m, t), f ? h(e) : s;
            }

            function g(e) {
              var n = e - c;
              return void 0 === c || n >= t || n < 0 || d && e - l >= a;
            }

            function m() {
              var e = va();
              if (g(e)) return y(e);
              u = wo(m, function (e) {
                var n = t - (e - c);
                return d ? sn(n, a - (e - l)) : n;
              }(e));
            }

            function y(e) {
              return u = void 0, p && r ? h(e) : (r = i = void 0, s);
            }

            function b() {
              var e = va(),
                  n = g(e);

              if (r = arguments, i = this, c = e, n) {
                if (void 0 === u) return v(c);
                if (d) return li(u), u = wo(m, t), h(c);
              }

              return void 0 === u && (u = wo(m, t)), s;
            }

            return t = os(t) || 0, Wa(n) && (f = !!n.leading, a = (d = "maxWait" in n) ? an(os(n.maxWait) || 0, t) : a, p = "trailing" in n ? !!n.trailing : p), b.cancel = function () {
              void 0 !== u && li(u), l = 0, r = c = i = u = void 0;
            }, b.flush = function () {
              return void 0 === u ? s : y(va());
            }, b;
          }

          var _a = qr(function (e, t) {
            return Qn(e, 1, t);
          }),
              xa = qr(function (e, t, n) {
            return Qn(e, os(t) || 0, n);
          });

          function Ca(e, t) {
            if ("function" != typeof e || null != t && "function" != typeof t) throw new ye(o);

            var n = function n() {
              var r = arguments,
                  i = t ? t.apply(this, r) : r[0],
                  o = n.cache;
              if (o.has(i)) return o.get(i);
              var a = e.apply(this, r);
              return n.cache = o.set(i, a) || o, a;
            };

            return n.cache = new (Ca.Cache || In)(), n;
          }

          function ka(e) {
            if ("function" != typeof e) throw new ye(o);
            return function () {
              var t = arguments;

              switch (t.length) {
                case 0:
                  return !e.call(this);

                case 1:
                  return !e.call(this, t[0]);

                case 2:
                  return !e.call(this, t[0], t[1]);

                case 3:
                  return !e.call(this, t[0], t[1], t[2]);
              }

              return !e.apply(this, t);
            };
          }

          Ca.Cache = In;
          var Ta = ui(function (e, t) {
            var n = (t = 1 == t.length && Pa(t[0]) ? pt(t[0], jt(Yi())) : pt(or(t, 1), jt(Yi()))).length;
            return qr(function (r) {
              for (var i = -1, o = sn(r.length, n); ++i < o;) {
                r[i] = t[i].call(this, r[i]);
              }

              return ot(e, this, r);
            });
          }),
              Sa = qr(function (e, t) {
            return Fi(e, 32, void 0, t, Ht(t, Gi(Sa)));
          }),
              Aa = qr(function (e, t) {
            return Fi(e, 64, void 0, t, Ht(t, Gi(Aa)));
          }),
              Ea = $i(function (e, t) {
            return Fi(e, 256, void 0, void 0, void 0, t);
          });

          function Oa(e, t) {
            return e === t || e != e && t != t;
          }

          var ja = Ni(hr),
              Da = Ni(function (e, t) {
            return e >= t;
          }),
              La = br(function () {
            return arguments;
          }()) ? br : function (e) {
            return $a(e) && ke.call(e, "callee") && !Xe.call(e, "callee");
          },
              Pa = r.isArray,
              Na = Je ? jt(Je) : function (e) {
            return $a(e) && pr(e) == C;
          };

          function Ia(e) {
            return null != e && Ha(e.length) && !Ba(e);
          }

          function Ma(e) {
            return $a(e) && Ia(e);
          }

          var Ra = tn || ou,
              qa = et ? jt(et) : function (e) {
            return $a(e) && pr(e) == f;
          };

          function Fa(e) {
            if (!$a(e)) return !1;
            var t = pr(e);
            return t == d || "[object DOMException]" == t || "string" == typeof e.message && "string" == typeof e.name && !Ka(e);
          }

          function Ba(e) {
            if (!Wa(e)) return !1;
            var t = pr(e);
            return t == p || t == h || "[object AsyncFunction]" == t || "[object Proxy]" == t;
          }

          function za(e) {
            return "number" == typeof e && e == rs(e);
          }

          function Ha(e) {
            return "number" == typeof e && e > -1 && e % 1 == 0 && e <= 9007199254740991;
          }

          function Wa(e) {
            var t = _typeof(e);

            return null != e && ("object" == t || "function" == t);
          }

          function $a(e) {
            return null != e && "object" == _typeof(e);
          }

          var Va = tt ? jt(tt) : function (e) {
            return $a(e) && no(e) == v;
          };

          function Ua(e) {
            return "number" == typeof e || $a(e) && pr(e) == g;
          }

          function Ka(e) {
            if (!$a(e) || pr(e) != m) return !1;
            var t = Ve(e);
            if (null === t) return !0;
            var n = ke.call(t, "constructor") && t.constructor;
            return "function" == typeof n && n instanceof n && Ce.call(n) == Ee;
          }

          var Xa = nt ? jt(nt) : function (e) {
            return $a(e) && pr(e) == y;
          };
          var Ga = rt ? jt(rt) : function (e) {
            return $a(e) && no(e) == b;
          };

          function Ya(e) {
            return "string" == typeof e || !Pa(e) && $a(e) && pr(e) == w;
          }

          function Za(e) {
            return "symbol" == _typeof(e) || $a(e) && pr(e) == _;
          }

          var Qa = it ? jt(it) : function (e) {
            return $a(e) && Ha(e.length) && !!Be[pr(e)];
          };
          var Ja = Ni(Sr),
              es = Ni(function (e, t) {
            return e <= t;
          });

          function ts(e) {
            if (!e) return [];
            if (Ia(e)) return Ya(e) ? Ut(e) : mi(e);
            if (Qe && e[Qe]) return function (e) {
              for (var t, n = []; !(t = e.next()).done;) {
                n.push(t.value);
              }

              return n;
            }(e[Qe]());
            var t = no(e);
            return (t == v ? Bt : t == b ? Wt : Os)(e);
          }

          function ns(e) {
            return e ? (e = os(e)) === 1 / 0 || e === -1 / 0 ? 17976931348623157e292 * (e < 0 ? -1 : 1) : e == e ? e : 0 : 0 === e ? e : 0;
          }

          function rs(e) {
            var t = ns(e),
                n = t % 1;
            return t == t ? n ? t - n : t : 0;
          }

          function is(e) {
            return e ? Gn(rs(e), 0, 4294967295) : 0;
          }

          function os(e) {
            if ("number" == typeof e) return e;
            if (Za(e)) return NaN;

            if (Wa(e)) {
              var t = "function" == typeof e.valueOf ? e.valueOf() : e;
              e = Wa(t) ? t + "" : t;
            }

            if ("string" != typeof e) return 0 === e ? e : +e;
            e = e.replace(X, "");
            var n = oe.test(e);
            return n || se.test(e) ? $e(e.slice(2), n ? 2 : 8) : ie.test(e) ? NaN : +e;
          }

          function as(e) {
            return yi(e, _s(e));
          }

          function ss(e) {
            return null == e ? "" : Zr(e);
          }

          var us = wi(function (e, t) {
            if (fo(t) || Ia(t)) yi(t, ws(t), e);else for (var n in t) {
              ke.call(t, n) && Wn(e, n, t[n]);
            }
          }),
              cs = wi(function (e, t) {
            yi(t, _s(t), e);
          }),
              ls = wi(function (e, t, n, r) {
            yi(t, _s(t), e, r);
          }),
              fs = wi(function (e, t, n, r) {
            yi(t, ws(t), e, r);
          }),
              ds = $i(Xn);
          var ps = qr(function (e, t) {
            e = ve(e);
            var n = -1,
                r = t.length,
                i = r > 2 ? t[2] : void 0;

            for (i && so(t[0], t[1], i) && (r = 1); ++n < r;) {
              for (var o = t[n], a = _s(o), s = -1, u = a.length; ++s < u;) {
                var c = a[s],
                    l = e[c];
                (void 0 === l || Oa(l, _e[c]) && !ke.call(e, c)) && (e[c] = o[c]);
              }
            }

            return e;
          }),
              hs = qr(function (e) {
            return e.push(void 0, zi), ot(Cs, void 0, e);
          });

          function vs(e, t, n) {
            var r = null == e ? void 0 : fr(e, t);
            return void 0 === r ? n : r;
          }

          function gs(e, t) {
            return null != e && ro(e, t, gr);
          }

          var ms = Oi(function (e, t, n) {
            null != t && "function" != typeof t.toString && (t = Ae.call(t)), e[t] = n;
          }, Ws(Us)),
              ys = Oi(function (e, t, n) {
            null != t && "function" != typeof t.toString && (t = Ae.call(t)), ke.call(e, t) ? e[t].push(n) : e[t] = [n];
          }, Yi),
              bs = qr(yr);

          function ws(e) {
            return Ia(e) ? qn(e) : kr(e);
          }

          function _s(e) {
            return Ia(e) ? qn(e, !0) : Tr(e);
          }

          var xs = wi(function (e, t, n) {
            jr(e, t, n);
          }),
              Cs = wi(function (e, t, n, r) {
            jr(e, t, n, r);
          }),
              ks = $i(function (e, t) {
            var n = {};
            if (null == e) return n;
            var r = !1;
            t = pt(t, function (t) {
              return t = si(t, e), r || (r = t.length > 1), t;
            }), yi(e, Ui(e), n), r && (n = Yn(n, 7, Hi));

            for (var i = t.length; i--;) {
              Jr(n, t[i]);
            }

            return n;
          });
          var Ts = $i(function (e, t) {
            return null == e ? {} : function (e, t) {
              return Pr(e, t, function (t, n) {
                return gs(e, n);
              });
            }(e, t);
          });

          function Ss(e, t) {
            if (null == e) return {};
            var n = pt(Ui(e), function (e) {
              return [e];
            });
            return t = Yi(t), Pr(e, n, function (e, n) {
              return t(e, n[0]);
            });
          }

          var As = qi(ws),
              Es = qi(_s);

          function Os(e) {
            return null == e ? [] : Dt(e, ws(e));
          }

          var js = ki(function (e, t, n) {
            return t = t.toLowerCase(), e + (n ? Ds(t) : t);
          });

          function Ds(e) {
            return Fs(ss(e).toLowerCase());
          }

          function Ls(e) {
            return (e = ss(e)) && e.replace(ce, Mt).replace(Pe, "");
          }

          var Ps = ki(function (e, t, n) {
            return e + (n ? "-" : "") + t.toLowerCase();
          }),
              Ns = ki(function (e, t, n) {
            return e + (n ? " " : "") + t.toLowerCase();
          }),
              Is = Ci("toLowerCase");
          var Ms = ki(function (e, t, n) {
            return e + (n ? "_" : "") + t.toLowerCase();
          });
          var Rs = ki(function (e, t, n) {
            return e + (n ? " " : "") + Fs(t);
          });
          var qs = ki(function (e, t, n) {
            return e + (n ? " " : "") + t.toUpperCase();
          }),
              Fs = Ci("toUpperCase");

          function Bs(e, t, n) {
            return e = ss(e), void 0 === (t = n ? void 0 : t) ? function (e) {
              return Re.test(e);
            }(e) ? function (e) {
              return e.match(Ie) || [];
            }(e) : function (e) {
              return e.match(ee) || [];
            }(e) : e.match(t) || [];
          }

          var zs = qr(function (e, t) {
            try {
              return ot(e, void 0, t);
            } catch (e) {
              return Fa(e) ? e : new de(e);
            }
          }),
              Hs = $i(function (e, t) {
            return st(t, function (t) {
              t = So(t), Kn(e, t, ya(e[t], e));
            }), e;
          });

          function Ws(e) {
            return function () {
              return e;
            };
          }

          var $s = Ai(),
              Vs = Ai(!0);

          function Us(e) {
            return e;
          }

          function Ks(e) {
            return Cr("function" == typeof e ? e : Yn(e, 1));
          }

          var Xs = qr(function (e, t) {
            return function (n) {
              return yr(n, e, t);
            };
          }),
              Gs = qr(function (e, t) {
            return function (n) {
              return yr(e, n, t);
            };
          });

          function Ys(e, t, n) {
            var r = ws(t),
                i = lr(t, r);
            null != n || Wa(t) && (i.length || !r.length) || (n = t, t = e, e = this, i = lr(t, ws(t)));
            var o = !(Wa(n) && "chain" in n && !n.chain),
                a = Ba(e);
            return st(i, function (n) {
              var r = t[n];
              e[n] = r, a && (e.prototype[n] = function () {
                var t = this.__chain__;

                if (o || t) {
                  var n = e(this.__wrapped__),
                      i = n.__actions__ = mi(this.__actions__);
                  return i.push({
                    func: r,
                    args: arguments,
                    thisArg: e
                  }), n.__chain__ = t, n;
                }

                return r.apply(e, ht([this.value()], arguments));
              });
            }), e;
          }

          function Zs() {}

          var Qs = Di(pt),
              Js = Di(ct),
              eu = Di(mt);

          function tu(e) {
            return uo(e) ? Tt(So(e)) : function (e) {
              return function (t) {
                return fr(t, e);
              };
            }(e);
          }

          var nu = Pi(),
              ru = Pi(!0);

          function iu() {
            return [];
          }

          function ou() {
            return !1;
          }

          var au = ji(function (e, t) {
            return e + t;
          }, 0),
              su = Mi("ceil"),
              uu = ji(function (e, t) {
            return e / t;
          }, 1),
              cu = Mi("floor");
          var lu,
              fu = ji(function (e, t) {
            return e * t;
          }, 1),
              du = Mi("round"),
              pu = ji(function (e, t) {
            return e - t;
          }, 0);
          return En.after = function (e, t) {
            if ("function" != typeof t) throw new ye(o);
            return e = rs(e), function () {
              if (--e < 1) return t.apply(this, arguments);
            };
          }, En.ary = ga, En.assign = us, En.assignIn = cs, En.assignInWith = ls, En.assignWith = fs, En.at = ds, En.before = ma, En.bind = ya, En.bindAll = Hs, En.bindKey = ba, En.castArray = function () {
            if (!arguments.length) return [];
            var e = arguments[0];
            return Pa(e) ? e : [e];
          }, En.chain = ta, En.chunk = function (e, t, n) {
            t = (n ? so(e, t, n) : void 0 === t) ? 1 : an(rs(t), 0);
            var i = null == e ? 0 : e.length;
            if (!i || t < 1) return [];

            for (var o = 0, a = 0, s = r(Qt(i / t)); o < i;) {
              s[a++] = Vr(e, o, o += t);
            }

            return s;
          }, En.compact = function (e) {
            for (var t = -1, n = null == e ? 0 : e.length, r = 0, i = []; ++t < n;) {
              var o = e[t];
              o && (i[r++] = o);
            }

            return i;
          }, En.concat = function () {
            var e = arguments.length;
            if (!e) return [];

            for (var t = r(e - 1), n = arguments[0], i = e; i--;) {
              t[i - 1] = arguments[i];
            }

            return ht(Pa(n) ? mi(n) : [n], or(t, 1));
          }, En.cond = function (e) {
            var t = null == e ? 0 : e.length,
                n = Yi();
            return e = t ? pt(e, function (e) {
              if ("function" != typeof e[1]) throw new ye(o);
              return [n(e[0]), e[1]];
            }) : [], qr(function (n) {
              for (var r = -1; ++r < t;) {
                var i = e[r];
                if (ot(i[0], this, n)) return ot(i[1], this, n);
              }
            });
          }, En.conforms = function (e) {
            return function (e) {
              var t = ws(e);
              return function (n) {
                return Zn(n, e, t);
              };
            }(Yn(e, 1));
          }, En.constant = Ws, En.countBy = ia, En.create = function (e, t) {
            var n = On(e);
            return null == t ? n : Un(n, t);
          }, En.curry = function e(t, n, r) {
            var i = Fi(t, 8, void 0, void 0, void 0, void 0, void 0, n = r ? void 0 : n);
            return i.placeholder = e.placeholder, i;
          }, En.curryRight = function e(t, n, r) {
            var i = Fi(t, 16, void 0, void 0, void 0, void 0, void 0, n = r ? void 0 : n);
            return i.placeholder = e.placeholder, i;
          }, En.debounce = wa, En.defaults = ps, En.defaultsDeep = hs, En.defer = _a, En.delay = xa, En.difference = Oo, En.differenceBy = jo, En.differenceWith = Do, En.drop = function (e, t, n) {
            var r = null == e ? 0 : e.length;
            return r ? Vr(e, (t = n || void 0 === t ? 1 : rs(t)) < 0 ? 0 : t, r) : [];
          }, En.dropRight = function (e, t, n) {
            var r = null == e ? 0 : e.length;
            return r ? Vr(e, 0, (t = r - (t = n || void 0 === t ? 1 : rs(t))) < 0 ? 0 : t) : [];
          }, En.dropRightWhile = function (e, t) {
            return e && e.length ? ti(e, Yi(t, 3), !0, !0) : [];
          }, En.dropWhile = function (e, t) {
            return e && e.length ? ti(e, Yi(t, 3), !0) : [];
          }, En.fill = function (e, t, n, r) {
            var i = null == e ? 0 : e.length;
            return i ? (n && "number" != typeof n && so(e, t, n) && (n = 0, r = i), function (e, t, n, r) {
              var i = e.length;

              for ((n = rs(n)) < 0 && (n = -n > i ? 0 : i + n), (r = void 0 === r || r > i ? i : rs(r)) < 0 && (r += i), r = n > r ? 0 : is(r); n < r;) {
                e[n++] = t;
              }

              return e;
            }(e, t, n, r)) : [];
          }, En.filter = function (e, t) {
            return (Pa(e) ? lt : ir)(e, Yi(t, 3));
          }, En.flatMap = function (e, t) {
            return or(da(e, t), 1);
          }, En.flatMapDeep = function (e, t) {
            return or(da(e, t), 1 / 0);
          }, En.flatMapDepth = function (e, t, n) {
            return n = void 0 === n ? 1 : rs(n), or(da(e, t), n);
          }, En.flatten = No, En.flattenDeep = function (e) {
            return (null == e ? 0 : e.length) ? or(e, 1 / 0) : [];
          }, En.flattenDepth = function (e, t) {
            return (null == e ? 0 : e.length) ? or(e, t = void 0 === t ? 1 : rs(t)) : [];
          }, En.flip = function (e) {
            return Fi(e, 512);
          }, En.flow = $s, En.flowRight = Vs, En.fromPairs = function (e) {
            for (var t = -1, n = null == e ? 0 : e.length, r = {}; ++t < n;) {
              var i = e[t];
              r[i[0]] = i[1];
            }

            return r;
          }, En.functions = function (e) {
            return null == e ? [] : lr(e, ws(e));
          }, En.functionsIn = function (e) {
            return null == e ? [] : lr(e, _s(e));
          }, En.groupBy = ca, En.initial = function (e) {
            return (null == e ? 0 : e.length) ? Vr(e, 0, -1) : [];
          }, En.intersection = Mo, En.intersectionBy = Ro, En.intersectionWith = qo, En.invert = ms, En.invertBy = ys, En.invokeMap = la, En.iteratee = Ks, En.keyBy = fa, En.keys = ws, En.keysIn = _s, En.map = da, En.mapKeys = function (e, t) {
            var n = {};
            return t = Yi(t, 3), ur(e, function (e, r, i) {
              Kn(n, t(e, r, i), e);
            }), n;
          }, En.mapValues = function (e, t) {
            var n = {};
            return t = Yi(t, 3), ur(e, function (e, r, i) {
              Kn(n, r, t(e, r, i));
            }), n;
          }, En.matches = function (e) {
            return Er(Yn(e, 1));
          }, En.matchesProperty = function (e, t) {
            return Or(e, Yn(t, 1));
          }, En.memoize = Ca, En.merge = xs, En.mergeWith = Cs, En.method = Xs, En.methodOf = Gs, En.mixin = Ys, En.negate = ka, En.nthArg = function (e) {
            return e = rs(e), qr(function (t) {
              return Dr(t, e);
            });
          }, En.omit = ks, En.omitBy = function (e, t) {
            return Ss(e, ka(Yi(t)));
          }, En.once = function (e) {
            return ma(2, e);
          }, En.orderBy = function (e, t, n, r) {
            return null == e ? [] : (Pa(t) || (t = null == t ? [] : [t]), Pa(n = r ? void 0 : n) || (n = null == n ? [] : [n]), Lr(e, t, n));
          }, En.over = Qs, En.overArgs = Ta, En.overEvery = Js, En.overSome = eu, En.partial = Sa, En.partialRight = Aa, En.partition = pa, En.pick = Ts, En.pickBy = Ss, En.property = tu, En.propertyOf = function (e) {
            return function (t) {
              return null == e ? void 0 : fr(e, t);
            };
          }, En.pull = Bo, En.pullAll = zo, En.pullAllBy = function (e, t, n) {
            return e && e.length && t && t.length ? Nr(e, t, Yi(n, 2)) : e;
          }, En.pullAllWith = function (e, t, n) {
            return e && e.length && t && t.length ? Nr(e, t, void 0, n) : e;
          }, En.pullAt = Ho, En.range = nu, En.rangeRight = ru, En.rearg = Ea, En.reject = function (e, t) {
            return (Pa(e) ? lt : ir)(e, ka(Yi(t, 3)));
          }, En.remove = function (e, t) {
            var n = [];
            if (!e || !e.length) return n;
            var r = -1,
                i = [],
                o = e.length;

            for (t = Yi(t, 3); ++r < o;) {
              var a = e[r];
              t(a, r, e) && (n.push(a), i.push(r));
            }

            return Ir(e, i), n;
          }, En.rest = function (e, t) {
            if ("function" != typeof e) throw new ye(o);
            return qr(e, t = void 0 === t ? t : rs(t));
          }, En.reverse = Wo, En.sampleSize = function (e, t, n) {
            return t = (n ? so(e, t, n) : void 0 === t) ? 1 : rs(t), (Pa(e) ? Bn : Br)(e, t);
          }, En.set = function (e, t, n) {
            return null == e ? e : zr(e, t, n);
          }, En.setWith = function (e, t, n, r) {
            return r = "function" == typeof r ? r : void 0, null == e ? e : zr(e, t, n, r);
          }, En.shuffle = function (e) {
            return (Pa(e) ? zn : $r)(e);
          }, En.slice = function (e, t, n) {
            var r = null == e ? 0 : e.length;
            return r ? (n && "number" != typeof n && so(e, t, n) ? (t = 0, n = r) : (t = null == t ? 0 : rs(t), n = void 0 === n ? r : rs(n)), Vr(e, t, n)) : [];
          }, En.sortBy = ha, En.sortedUniq = function (e) {
            return e && e.length ? Gr(e) : [];
          }, En.sortedUniqBy = function (e, t) {
            return e && e.length ? Gr(e, Yi(t, 2)) : [];
          }, En.split = function (e, t, n) {
            return n && "number" != typeof n && so(e, t, n) && (t = n = void 0), (n = void 0 === n ? 4294967295 : n >>> 0) ? (e = ss(e)) && ("string" == typeof t || null != t && !Xa(t)) && !(t = Zr(t)) && Ft(e) ? ci(Ut(e), 0, n) : e.split(t, n) : [];
          }, En.spread = function (e, t) {
            if ("function" != typeof e) throw new ye(o);
            return t = null == t ? 0 : an(rs(t), 0), qr(function (n) {
              var r = n[t],
                  i = ci(n, 0, t);
              return r && ht(i, r), ot(e, this, i);
            });
          }, En.tail = function (e) {
            var t = null == e ? 0 : e.length;
            return t ? Vr(e, 1, t) : [];
          }, En.take = function (e, t, n) {
            return e && e.length ? Vr(e, 0, (t = n || void 0 === t ? 1 : rs(t)) < 0 ? 0 : t) : [];
          }, En.takeRight = function (e, t, n) {
            var r = null == e ? 0 : e.length;
            return r ? Vr(e, (t = r - (t = n || void 0 === t ? 1 : rs(t))) < 0 ? 0 : t, r) : [];
          }, En.takeRightWhile = function (e, t) {
            return e && e.length ? ti(e, Yi(t, 3), !1, !0) : [];
          }, En.takeWhile = function (e, t) {
            return e && e.length ? ti(e, Yi(t, 3)) : [];
          }, En.tap = function (e, t) {
            return t(e), e;
          }, En.throttle = function (e, t, n) {
            var r = !0,
                i = !0;
            if ("function" != typeof e) throw new ye(o);
            return Wa(n) && (r = "leading" in n ? !!n.leading : r, i = "trailing" in n ? !!n.trailing : i), wa(e, t, {
              leading: r,
              maxWait: t,
              trailing: i
            });
          }, En.thru = na, En.toArray = ts, En.toPairs = As, En.toPairsIn = Es, En.toPath = function (e) {
            return Pa(e) ? pt(e, So) : Za(e) ? [e] : mi(To(ss(e)));
          }, En.toPlainObject = as, En.transform = function (e, t, n) {
            var r = Pa(e),
                i = r || Ra(e) || Qa(e);

            if (t = Yi(t, 4), null == n) {
              var o = e && e.constructor;
              n = i ? r ? new o() : [] : Wa(e) && Ba(o) ? On(Ve(e)) : {};
            }

            return (i ? st : ur)(e, function (e, r, i) {
              return t(n, e, r, i);
            }), n;
          }, En.unary = function (e) {
            return ga(e, 1);
          }, En.union = $o, En.unionBy = Vo, En.unionWith = Uo, En.uniq = function (e) {
            return e && e.length ? Qr(e) : [];
          }, En.uniqBy = function (e, t) {
            return e && e.length ? Qr(e, Yi(t, 2)) : [];
          }, En.uniqWith = function (e, t) {
            return t = "function" == typeof t ? t : void 0, e && e.length ? Qr(e, void 0, t) : [];
          }, En.unset = function (e, t) {
            return null == e || Jr(e, t);
          }, En.unzip = Ko, En.unzipWith = Xo, En.update = function (e, t, n) {
            return null == e ? e : ei(e, t, ai(n));
          }, En.updateWith = function (e, t, n, r) {
            return r = "function" == typeof r ? r : void 0, null == e ? e : ei(e, t, ai(n), r);
          }, En.values = Os, En.valuesIn = function (e) {
            return null == e ? [] : Dt(e, _s(e));
          }, En.without = Go, En.words = Bs, En.wrap = function (e, t) {
            return Sa(ai(t), e);
          }, En.xor = Yo, En.xorBy = Zo, En.xorWith = Qo, En.zip = Jo, En.zipObject = function (e, t) {
            return ii(e || [], t || [], Wn);
          }, En.zipObjectDeep = function (e, t) {
            return ii(e || [], t || [], zr);
          }, En.zipWith = ea, En.entries = As, En.entriesIn = Es, En.extend = cs, En.extendWith = ls, Ys(En, En), En.add = au, En.attempt = zs, En.camelCase = js, En.capitalize = Ds, En.ceil = su, En.clamp = function (e, t, n) {
            return void 0 === n && (n = t, t = void 0), void 0 !== n && (n = (n = os(n)) == n ? n : 0), void 0 !== t && (t = (t = os(t)) == t ? t : 0), Gn(os(e), t, n);
          }, En.clone = function (e) {
            return Yn(e, 4);
          }, En.cloneDeep = function (e) {
            return Yn(e, 5);
          }, En.cloneDeepWith = function (e, t) {
            return Yn(e, 5, t = "function" == typeof t ? t : void 0);
          }, En.cloneWith = function (e, t) {
            return Yn(e, 4, t = "function" == typeof t ? t : void 0);
          }, En.conformsTo = function (e, t) {
            return null == t || Zn(e, t, ws(t));
          }, En.deburr = Ls, En.defaultTo = function (e, t) {
            return null == e || e != e ? t : e;
          }, En.divide = uu, En.endsWith = function (e, t, n) {
            e = ss(e), t = Zr(t);
            var r = e.length,
                i = n = void 0 === n ? r : Gn(rs(n), 0, r);
            return (n -= t.length) >= 0 && e.slice(n, i) == t;
          }, En.eq = Oa, En.escape = function (e) {
            return (e = ss(e)) && F.test(e) ? e.replace(R, Rt) : e;
          }, En.escapeRegExp = function (e) {
            return (e = ss(e)) && K.test(e) ? e.replace(U, "\\$&") : e;
          }, En.every = function (e, t, n) {
            var r = Pa(e) ? ct : nr;
            return n && so(e, t, n) && (t = void 0), r(e, Yi(t, 3));
          }, En.find = oa, En.findIndex = Lo, En.findKey = function (e, t) {
            return bt(e, Yi(t, 3), ur);
          }, En.findLast = aa, En.findLastIndex = Po, En.findLastKey = function (e, t) {
            return bt(e, Yi(t, 3), cr);
          }, En.floor = cu, En.forEach = sa, En.forEachRight = ua, En.forIn = function (e, t) {
            return null == e ? e : ar(e, Yi(t, 3), _s);
          }, En.forInRight = function (e, t) {
            return null == e ? e : sr(e, Yi(t, 3), _s);
          }, En.forOwn = function (e, t) {
            return e && ur(e, Yi(t, 3));
          }, En.forOwnRight = function (e, t) {
            return e && cr(e, Yi(t, 3));
          }, En.get = vs, En.gt = ja, En.gte = Da, En.has = function (e, t) {
            return null != e && ro(e, t, vr);
          }, En.hasIn = gs, En.head = Io, En.identity = Us, En.includes = function (e, t, n, r) {
            e = Ia(e) ? e : Os(e), n = n && !r ? rs(n) : 0;
            var i = e.length;
            return n < 0 && (n = an(i + n, 0)), Ya(e) ? n <= i && e.indexOf(t, n) > -1 : !!i && _t(e, t, n) > -1;
          }, En.indexOf = function (e, t, n) {
            var r = null == e ? 0 : e.length;
            if (!r) return -1;
            var i = null == n ? 0 : rs(n);
            return i < 0 && (i = an(r + i, 0)), _t(e, t, i);
          }, En.inRange = function (e, t, n) {
            return t = ns(t), void 0 === n ? (n = t, t = 0) : n = ns(n), function (e, t, n) {
              return e >= sn(t, n) && e < an(t, n);
            }(e = os(e), t, n);
          }, En.invoke = bs, En.isArguments = La, En.isArray = Pa, En.isArrayBuffer = Na, En.isArrayLike = Ia, En.isArrayLikeObject = Ma, En.isBoolean = function (e) {
            return !0 === e || !1 === e || $a(e) && pr(e) == l;
          }, En.isBuffer = Ra, En.isDate = qa, En.isElement = function (e) {
            return $a(e) && 1 === e.nodeType && !Ka(e);
          }, En.isEmpty = function (e) {
            if (null == e) return !0;
            if (Ia(e) && (Pa(e) || "string" == typeof e || "function" == typeof e.splice || Ra(e) || Qa(e) || La(e))) return !e.length;
            var t = no(e);
            if (t == v || t == b) return !e.size;
            if (fo(e)) return !kr(e).length;

            for (var n in e) {
              if (ke.call(e, n)) return !1;
            }

            return !0;
          }, En.isEqual = function (e, t) {
            return wr(e, t);
          }, En.isEqualWith = function (e, t, n) {
            var r = (n = "function" == typeof n ? n : void 0) ? n(e, t) : void 0;
            return void 0 === r ? wr(e, t, void 0, n) : !!r;
          }, En.isError = Fa, En.isFinite = function (e) {
            return "number" == typeof e && nn(e);
          }, En.isFunction = Ba, En.isInteger = za, En.isLength = Ha, En.isMap = Va, En.isMatch = function (e, t) {
            return e === t || _r(e, t, Qi(t));
          }, En.isMatchWith = function (e, t, n) {
            return n = "function" == typeof n ? n : void 0, _r(e, t, Qi(t), n);
          }, En.isNaN = function (e) {
            return Ua(e) && e != +e;
          }, En.isNative = function (e) {
            if (lo(e)) throw new de("Unsupported core-js use. Try https://npms.io/search?q=ponyfill.");
            return xr(e);
          }, En.isNil = function (e) {
            return null == e;
          }, En.isNull = function (e) {
            return null === e;
          }, En.isNumber = Ua, En.isObject = Wa, En.isObjectLike = $a, En.isPlainObject = Ka, En.isRegExp = Xa, En.isSafeInteger = function (e) {
            return za(e) && e >= -9007199254740991 && e <= 9007199254740991;
          }, En.isSet = Ga, En.isString = Ya, En.isSymbol = Za, En.isTypedArray = Qa, En.isUndefined = function (e) {
            return void 0 === e;
          }, En.isWeakMap = function (e) {
            return $a(e) && no(e) == x;
          }, En.isWeakSet = function (e) {
            return $a(e) && "[object WeakSet]" == pr(e);
          }, En.join = function (e, t) {
            return null == e ? "" : rn.call(e, t);
          }, En.kebabCase = Ps, En.last = Fo, En.lastIndexOf = function (e, t, n) {
            var r = null == e ? 0 : e.length;
            if (!r) return -1;
            var i = r;
            return void 0 !== n && (i = (i = rs(n)) < 0 ? an(r + i, 0) : sn(i, r - 1)), t == t ? function (e, t, n) {
              for (var r = n + 1; r--;) {
                if (e[r] === t) return r;
              }

              return r;
            }(e, t, i) : wt(e, Ct, i, !0);
          }, En.lowerCase = Ns, En.lowerFirst = Is, En.lt = Ja, En.lte = es, En.max = function (e) {
            return e && e.length ? rr(e, Us, hr) : void 0;
          }, En.maxBy = function (e, t) {
            return e && e.length ? rr(e, Yi(t, 2), hr) : void 0;
          }, En.mean = function (e) {
            return kt(e, Us);
          }, En.meanBy = function (e, t) {
            return kt(e, Yi(t, 2));
          }, En.min = function (e) {
            return e && e.length ? rr(e, Us, Sr) : void 0;
          }, En.minBy = function (e, t) {
            return e && e.length ? rr(e, Yi(t, 2), Sr) : void 0;
          }, En.stubArray = iu, En.stubFalse = ou, En.stubObject = function () {
            return {};
          }, En.stubString = function () {
            return "";
          }, En.stubTrue = function () {
            return !0;
          }, En.multiply = fu, En.nth = function (e, t) {
            return e && e.length ? Dr(e, rs(t)) : void 0;
          }, En.noConflict = function () {
            return Ke._ === this && (Ke._ = Oe), this;
          }, En.noop = Zs, En.now = va, En.pad = function (e, t, n) {
            e = ss(e);
            var r = (t = rs(t)) ? Vt(e) : 0;
            if (!t || r >= t) return e;
            var i = (t - r) / 2;
            return Li(Jt(i), n) + e + Li(Qt(i), n);
          }, En.padEnd = function (e, t, n) {
            e = ss(e);
            var r = (t = rs(t)) ? Vt(e) : 0;
            return t && r < t ? e + Li(t - r, n) : e;
          }, En.padStart = function (e, t, n) {
            e = ss(e);
            var r = (t = rs(t)) ? Vt(e) : 0;
            return t && r < t ? Li(t - r, n) + e : e;
          }, En.parseInt = function (e, t, n) {
            return n || null == t ? t = 0 : t && (t = +t), cn(ss(e).replace(G, ""), t || 0);
          }, En.random = function (e, t, n) {
            if (n && "boolean" != typeof n && so(e, t, n) && (t = n = void 0), void 0 === n && ("boolean" == typeof t ? (n = t, t = void 0) : "boolean" == typeof e && (n = e, e = void 0)), void 0 === e && void 0 === t ? (e = 0, t = 1) : (e = ns(e), void 0 === t ? (t = e, e = 0) : t = ns(t)), e > t) {
              var r = e;
              e = t, t = r;
            }

            if (n || e % 1 || t % 1) {
              var i = ln();
              return sn(e + i * (t - e + We("1e-" + ((i + "").length - 1))), t);
            }

            return Mr(e, t);
          }, En.reduce = function (e, t, n) {
            var r = Pa(e) ? vt : At,
                i = arguments.length < 3;
            return r(e, Yi(t, 4), n, i, er);
          }, En.reduceRight = function (e, t, n) {
            var r = Pa(e) ? gt : At,
                i = arguments.length < 3;
            return r(e, Yi(t, 4), n, i, tr);
          }, En.repeat = function (e, t, n) {
            return t = (n ? so(e, t, n) : void 0 === t) ? 1 : rs(t), Rr(ss(e), t);
          }, En.replace = function () {
            var e = arguments,
                t = ss(e[0]);
            return e.length < 3 ? t : t.replace(e[1], e[2]);
          }, En.result = function (e, t, n) {
            var r = -1,
                i = (t = si(t, e)).length;

            for (i || (i = 1, e = void 0); ++r < i;) {
              var o = null == e ? void 0 : e[So(t[r])];
              void 0 === o && (r = i, o = n), e = Ba(o) ? o.call(e) : o;
            }

            return e;
          }, En.round = du, En.runInContext = e, En.sample = function (e) {
            return (Pa(e) ? Fn : Fr)(e);
          }, En.size = function (e) {
            if (null == e) return 0;
            if (Ia(e)) return Ya(e) ? Vt(e) : e.length;
            var t = no(e);
            return t == v || t == b ? e.size : kr(e).length;
          }, En.snakeCase = Ms, En.some = function (e, t, n) {
            var r = Pa(e) ? mt : Ur;
            return n && so(e, t, n) && (t = void 0), r(e, Yi(t, 3));
          }, En.sortedIndex = function (e, t) {
            return Kr(e, t);
          }, En.sortedIndexBy = function (e, t, n) {
            return Xr(e, t, Yi(n, 2));
          }, En.sortedIndexOf = function (e, t) {
            var n = null == e ? 0 : e.length;

            if (n) {
              var r = Kr(e, t);
              if (r < n && Oa(e[r], t)) return r;
            }

            return -1;
          }, En.sortedLastIndex = function (e, t) {
            return Kr(e, t, !0);
          }, En.sortedLastIndexBy = function (e, t, n) {
            return Xr(e, t, Yi(n, 2), !0);
          }, En.sortedLastIndexOf = function (e, t) {
            if (null == e ? 0 : e.length) {
              var n = Kr(e, t, !0) - 1;
              if (Oa(e[n], t)) return n;
            }

            return -1;
          }, En.startCase = Rs, En.startsWith = function (e, t, n) {
            return e = ss(e), n = null == n ? 0 : Gn(rs(n), 0, e.length), t = Zr(t), e.slice(n, n + t.length) == t;
          }, En.subtract = pu, En.sum = function (e) {
            return e && e.length ? Et(e, Us) : 0;
          }, En.sumBy = function (e, t) {
            return e && e.length ? Et(e, Yi(t, 2)) : 0;
          }, En.template = function (e, t, n) {
            var r = En.templateSettings;
            n && so(e, t, n) && (t = void 0), e = ss(e), t = ls({}, t, r, Bi);
            var i,
                o,
                a = ls({}, t.imports, r.imports, Bi),
                s = ws(a),
                u = Dt(a, s),
                c = 0,
                l = t.interpolate || le,
                f = "__p += '",
                d = ge((t.escape || le).source + "|" + l.source + "|" + (l === H ? ne : le).source + "|" + (t.evaluate || le).source + "|$", "g"),
                p = "//# sourceURL=" + (ke.call(t, "sourceURL") ? (t.sourceURL + "").replace(/[\r\n]/g, " ") : "lodash.templateSources[" + ++Fe + "]") + "\n";
            e.replace(d, function (t, n, r, a, s, u) {
              return r || (r = a), f += e.slice(c, u).replace(fe, qt), n && (i = !0, f += "' +\n__e(" + n + ") +\n'"), s && (o = !0, f += "';\n" + s + ";\n__p += '"), r && (f += "' +\n((__t = (" + r + ")) == null ? '' : __t) +\n'"), c = u + t.length, t;
            }), f += "';\n";
            var h = ke.call(t, "variable") && t.variable;
            h || (f = "with (obj) {\n" + f + "\n}\n"), f = (o ? f.replace(P, "") : f).replace(N, "$1").replace(I, "$1;"), f = "function(" + (h || "obj") + ") {\n" + (h ? "" : "obj || (obj = {});\n") + "var __t, __p = ''" + (i ? ", __e = _.escape" : "") + (o ? ", __j = Array.prototype.join;\nfunction print() { __p += __j.call(arguments, '') }\n" : ";\n") + f + "return __p\n}";
            var v = zs(function () {
              return pe(s, p + "return " + f).apply(void 0, u);
            });
            if (v.source = f, Fa(v)) throw v;
            return v;
          }, En.times = function (e, t) {
            if ((e = rs(e)) < 1 || e > 9007199254740991) return [];
            var n = 4294967295,
                r = sn(e, 4294967295);
            e -= 4294967295;

            for (var i = Ot(r, t = Yi(t)); ++n < e;) {
              t(n);
            }

            return i;
          }, En.toFinite = ns, En.toInteger = rs, En.toLength = is, En.toLower = function (e) {
            return ss(e).toLowerCase();
          }, En.toNumber = os, En.toSafeInteger = function (e) {
            return e ? Gn(rs(e), -9007199254740991, 9007199254740991) : 0 === e ? e : 0;
          }, En.toString = ss, En.toUpper = function (e) {
            return ss(e).toUpperCase();
          }, En.trim = function (e, t, n) {
            if ((e = ss(e)) && (n || void 0 === t)) return e.replace(X, "");
            if (!e || !(t = Zr(t))) return e;
            var r = Ut(e),
                i = Ut(t);
            return ci(r, Pt(r, i), Nt(r, i) + 1).join("");
          }, En.trimEnd = function (e, t, n) {
            if ((e = ss(e)) && (n || void 0 === t)) return e.replace(Y, "");
            if (!e || !(t = Zr(t))) return e;
            var r = Ut(e);
            return ci(r, 0, Nt(r, Ut(t)) + 1).join("");
          }, En.trimStart = function (e, t, n) {
            if ((e = ss(e)) && (n || void 0 === t)) return e.replace(G, "");
            if (!e || !(t = Zr(t))) return e;
            var r = Ut(e);
            return ci(r, Pt(r, Ut(t))).join("");
          }, En.truncate = function (e, t) {
            var n = 30,
                r = "...";

            if (Wa(t)) {
              var i = "separator" in t ? t.separator : i;
              n = "length" in t ? rs(t.length) : n, r = "omission" in t ? Zr(t.omission) : r;
            }

            var o = (e = ss(e)).length;

            if (Ft(e)) {
              var a = Ut(e);
              o = a.length;
            }

            if (n >= o) return e;
            var s = n - Vt(r);
            if (s < 1) return r;
            var u = a ? ci(a, 0, s).join("") : e.slice(0, s);
            if (void 0 === i) return u + r;

            if (a && (s += u.length - s), Xa(i)) {
              if (e.slice(s).search(i)) {
                var c,
                    l = u;

                for (i.global || (i = ge(i.source, ss(re.exec(i)) + "g")), i.lastIndex = 0; c = i.exec(l);) {
                  var f = c.index;
                }

                u = u.slice(0, void 0 === f ? s : f);
              }
            } else if (e.indexOf(Zr(i), s) != s) {
              var d = u.lastIndexOf(i);
              d > -1 && (u = u.slice(0, d));
            }

            return u + r;
          }, En.unescape = function (e) {
            return (e = ss(e)) && q.test(e) ? e.replace(M, Kt) : e;
          }, En.uniqueId = function (e) {
            var t = ++Te;
            return ss(e) + t;
          }, En.upperCase = qs, En.upperFirst = Fs, En.each = sa, En.eachRight = ua, En.first = Io, Ys(En, (lu = {}, ur(En, function (e, t) {
            ke.call(En.prototype, t) || (lu[t] = e);
          }), lu), {
            chain: !1
          }), En.VERSION = "4.17.15", st(["bind", "bindKey", "curry", "curryRight", "partial", "partialRight"], function (e) {
            En[e].placeholder = En;
          }), st(["drop", "take"], function (e, t) {
            Ln.prototype[e] = function (n) {
              n = void 0 === n ? 1 : an(rs(n), 0);
              var r = this.__filtered__ && !t ? new Ln(this) : this.clone();
              return r.__filtered__ ? r.__takeCount__ = sn(n, r.__takeCount__) : r.__views__.push({
                size: sn(n, 4294967295),
                type: e + (r.__dir__ < 0 ? "Right" : "")
              }), r;
            }, Ln.prototype[e + "Right"] = function (t) {
              return this.reverse()[e](t).reverse();
            };
          }), st(["filter", "map", "takeWhile"], function (e, t) {
            var n = t + 1,
                r = 1 == n || 3 == n;

            Ln.prototype[e] = function (e) {
              var t = this.clone();
              return t.__iteratees__.push({
                iteratee: Yi(e, 3),
                type: n
              }), t.__filtered__ = t.__filtered__ || r, t;
            };
          }), st(["head", "last"], function (e, t) {
            var n = "take" + (t ? "Right" : "");

            Ln.prototype[e] = function () {
              return this[n](1).value()[0];
            };
          }), st(["initial", "tail"], function (e, t) {
            var n = "drop" + (t ? "" : "Right");

            Ln.prototype[e] = function () {
              return this.__filtered__ ? new Ln(this) : this[n](1);
            };
          }), Ln.prototype.compact = function () {
            return this.filter(Us);
          }, Ln.prototype.find = function (e) {
            return this.filter(e).head();
          }, Ln.prototype.findLast = function (e) {
            return this.reverse().find(e);
          }, Ln.prototype.invokeMap = qr(function (e, t) {
            return "function" == typeof e ? new Ln(this) : this.map(function (n) {
              return yr(n, e, t);
            });
          }), Ln.prototype.reject = function (e) {
            return this.filter(ka(Yi(e)));
          }, Ln.prototype.slice = function (e, t) {
            e = rs(e);
            var n = this;
            return n.__filtered__ && (e > 0 || t < 0) ? new Ln(n) : (e < 0 ? n = n.takeRight(-e) : e && (n = n.drop(e)), void 0 !== t && (n = (t = rs(t)) < 0 ? n.dropRight(-t) : n.take(t - e)), n);
          }, Ln.prototype.takeRightWhile = function (e) {
            return this.reverse().takeWhile(e).reverse();
          }, Ln.prototype.toArray = function () {
            return this.take(4294967295);
          }, ur(Ln.prototype, function (e, t) {
            var n = /^(?:filter|find|map|reject)|While$/.test(t),
                r = /^(?:head|last)$/.test(t),
                i = En[r ? "take" + ("last" == t ? "Right" : "") : t],
                o = r || /^find/.test(t);
            i && (En.prototype[t] = function () {
              var t = this.__wrapped__,
                  a = r ? [1] : arguments,
                  s = t instanceof Ln,
                  u = a[0],
                  c = s || Pa(t),
                  l = function l(e) {
                var t = i.apply(En, ht([e], a));
                return r && f ? t[0] : t;
              };

              c && n && "function" == typeof u && 1 != u.length && (s = c = !1);
              var f = this.__chain__,
                  d = !!this.__actions__.length,
                  p = o && !f,
                  h = s && !d;

              if (!o && c) {
                t = h ? t : new Ln(this);
                var v = e.apply(t, a);
                return v.__actions__.push({
                  func: na,
                  args: [l],
                  thisArg: void 0
                }), new Dn(v, f);
              }

              return p && h ? e.apply(this, a) : (v = this.thru(l), p ? r ? v.value()[0] : v.value() : v);
            });
          }), st(["pop", "push", "shift", "sort", "splice", "unshift"], function (e) {
            var t = be[e],
                n = /^(?:push|sort|unshift)$/.test(e) ? "tap" : "thru",
                r = /^(?:pop|shift)$/.test(e);

            En.prototype[e] = function () {
              var e = arguments;

              if (r && !this.__chain__) {
                var i = this.value();
                return t.apply(Pa(i) ? i : [], e);
              }

              return this[n](function (n) {
                return t.apply(Pa(n) ? n : [], e);
              });
            };
          }), ur(Ln.prototype, function (e, t) {
            var n = En[t];

            if (n) {
              var r = n.name + "";
              ke.call(bn, r) || (bn[r] = []), bn[r].push({
                name: t,
                func: n
              });
            }
          }), bn[Ei(void 0, 2).name] = [{
            name: "wrapper",
            func: void 0
          }], Ln.prototype.clone = function () {
            var e = new Ln(this.__wrapped__);
            return e.__actions__ = mi(this.__actions__), e.__dir__ = this.__dir__, e.__filtered__ = this.__filtered__, e.__iteratees__ = mi(this.__iteratees__), e.__takeCount__ = this.__takeCount__, e.__views__ = mi(this.__views__), e;
          }, Ln.prototype.reverse = function () {
            if (this.__filtered__) {
              var e = new Ln(this);
              e.__dir__ = -1, e.__filtered__ = !0;
            } else (e = this.clone()).__dir__ *= -1;

            return e;
          }, Ln.prototype.value = function () {
            var e = this.__wrapped__.value(),
                t = this.__dir__,
                n = Pa(e),
                r = t < 0,
                i = n ? e.length : 0,
                o = function (e, t, n) {
              var r = -1,
                  i = n.length;

              for (; ++r < i;) {
                var o = n[r],
                    a = o.size;

                switch (o.type) {
                  case "drop":
                    e += a;
                    break;

                  case "dropRight":
                    t -= a;
                    break;

                  case "take":
                    t = sn(t, e + a);
                    break;

                  case "takeRight":
                    e = an(e, t - a);
                }
              }

              return {
                start: e,
                end: t
              };
            }(0, i, this.__views__),
                a = o.start,
                s = o.end,
                u = s - a,
                c = r ? s : a - 1,
                l = this.__iteratees__,
                f = l.length,
                d = 0,
                p = sn(u, this.__takeCount__);

            if (!n || !r && i == u && p == u) return ni(e, this.__actions__);
            var h = [];

            e: for (; u-- && d < p;) {
              for (var v = -1, g = e[c += t]; ++v < f;) {
                var m = l[v],
                    y = m.iteratee,
                    b = m.type,
                    w = y(g);
                if (2 == b) g = w;else if (!w) {
                  if (1 == b) continue e;
                  break e;
                }
              }

              h[d++] = g;
            }

            return h;
          }, En.prototype.at = ra, En.prototype.chain = function () {
            return ta(this);
          }, En.prototype.commit = function () {
            return new Dn(this.value(), this.__chain__);
          }, En.prototype.next = function () {
            void 0 === this.__values__ && (this.__values__ = ts(this.value()));
            var e = this.__index__ >= this.__values__.length;
            return {
              done: e,
              value: e ? void 0 : this.__values__[this.__index__++]
            };
          }, En.prototype.plant = function (e) {
            for (var t, n = this; n instanceof jn;) {
              var r = Eo(n);
              r.__index__ = 0, r.__values__ = void 0, t ? i.__wrapped__ = r : t = r;
              var i = r;
              n = n.__wrapped__;
            }

            return i.__wrapped__ = e, t;
          }, En.prototype.reverse = function () {
            var e = this.__wrapped__;

            if (e instanceof Ln) {
              var t = e;
              return this.__actions__.length && (t = new Ln(this)), (t = t.reverse()).__actions__.push({
                func: na,
                args: [Wo],
                thisArg: void 0
              }), new Dn(t, this.__chain__);
            }

            return this.thru(Wo);
          }, En.prototype.toJSON = En.prototype.valueOf = En.prototype.value = function () {
            return ni(this.__wrapped__, this.__actions__);
          }, En.prototype.first = En.prototype.head, Qe && (En.prototype[Qe] = function () {
            return this;
          }), En;
        }();

        Ke._ = Xt, void 0 === (i = function () {
          return Xt;
        }.call(t, n, t, r)) || (r.exports = i);
      }).call(this);
    }).call(this, n(35), n(36)(e));
  }, function (e, t) {
    var n;

    n = function () {
      return this;
    }();

    try {
      n = n || new Function("return this")();
    } catch (e) {
      "object" == (typeof window === "undefined" ? "undefined" : _typeof(window)) && (n = window);
    }

    e.exports = n;
  }, function (e, t) {
    e.exports = function (e) {
      return e.webpackPolyfill || (e.deprecate = function () {}, e.paths = [], e.children || (e.children = []), Object.defineProperty(e, "loaded", {
        enumerable: !0,
        get: function get() {
          return e.l;
        }
      }), Object.defineProperty(e, "id", {
        enumerable: !0,
        get: function get() {
          return e.i;
        }
      }), e.webpackPolyfill = 1), e;
    };
  }, function (e, t, n) {
    var r;
    /*!
     * jQuery JavaScript Library v3.4.1
     * https://jquery.com/
     *
     * Includes Sizzle.js
     * https://sizzlejs.com/
     *
     * Copyright JS Foundation and other contributors
     * Released under the MIT license
     * https://jquery.org/license
     *
     * Date: 2019-05-01T21:04Z
     */

    !function (t, n) {
      "use strict";

      "object" == _typeof(e.exports) ? e.exports = t.document ? n(t, !0) : function (e) {
        if (!e.document) throw new Error("jQuery requires a window with a document");
        return n(e);
      } : n(t);
    }("undefined" != typeof window ? window : this, function (n, i) {
      "use strict";

      var o = [],
          a = n.document,
          s = Object.getPrototypeOf,
          u = o.slice,
          c = o.concat,
          l = o.push,
          f = o.indexOf,
          d = {},
          p = d.toString,
          h = d.hasOwnProperty,
          v = h.toString,
          g = v.call(Object),
          m = {},
          y = function y(e) {
        return "function" == typeof e && "number" != typeof e.nodeType;
      },
          b = function b(e) {
        return null != e && e === e.window;
      },
          w = {
        type: !0,
        src: !0,
        nonce: !0,
        noModule: !0
      };

      function _(e, t, n) {
        var r,
            i,
            o = (n = n || a).createElement("script");
        if (o.text = e, t) for (r in w) {
          (i = t[r] || t.getAttribute && t.getAttribute(r)) && o.setAttribute(r, i);
        }
        n.head.appendChild(o).parentNode.removeChild(o);
      }

      function x(e) {
        return null == e ? e + "" : "object" == _typeof(e) || "function" == typeof e ? d[p.call(e)] || "object" : _typeof(e);
      }

      var C = function C(e, t) {
        return new C.fn.init(e, t);
      },
          k = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;

      function T(e) {
        var t = !!e && "length" in e && e.length,
            n = x(e);
        return !y(e) && !b(e) && ("array" === n || 0 === t || "number" == typeof t && t > 0 && t - 1 in e);
      }

      C.fn = C.prototype = {
        jquery: "3.4.1",
        constructor: C,
        length: 0,
        toArray: function toArray() {
          return u.call(this);
        },
        get: function get(e) {
          return null == e ? u.call(this) : e < 0 ? this[e + this.length] : this[e];
        },
        pushStack: function pushStack(e) {
          var t = C.merge(this.constructor(), e);
          return t.prevObject = this, t;
        },
        each: function each(e) {
          return C.each(this, e);
        },
        map: function map(e) {
          return this.pushStack(C.map(this, function (t, n) {
            return e.call(t, n, t);
          }));
        },
        slice: function slice() {
          return this.pushStack(u.apply(this, arguments));
        },
        first: function first() {
          return this.eq(0);
        },
        last: function last() {
          return this.eq(-1);
        },
        eq: function eq(e) {
          var t = this.length,
              n = +e + (e < 0 ? t : 0);
          return this.pushStack(n >= 0 && n < t ? [this[n]] : []);
        },
        end: function end() {
          return this.prevObject || this.constructor();
        },
        push: l,
        sort: o.sort,
        splice: o.splice
      }, C.extend = C.fn.extend = function () {
        var e,
            t,
            n,
            r,
            i,
            o,
            a = arguments[0] || {},
            s = 1,
            u = arguments.length,
            c = !1;

        for ("boolean" == typeof a && (c = a, a = arguments[s] || {}, s++), "object" == _typeof(a) || y(a) || (a = {}), s === u && (a = this, s--); s < u; s++) {
          if (null != (e = arguments[s])) for (t in e) {
            r = e[t], "__proto__" !== t && a !== r && (c && r && (C.isPlainObject(r) || (i = Array.isArray(r))) ? (n = a[t], o = i && !Array.isArray(n) ? [] : i || C.isPlainObject(n) ? n : {}, i = !1, a[t] = C.extend(c, o, r)) : void 0 !== r && (a[t] = r));
          }
        }

        return a;
      }, C.extend({
        expando: "jQuery" + ("3.4.1" + Math.random()).replace(/\D/g, ""),
        isReady: !0,
        error: function error(e) {
          throw new Error(e);
        },
        noop: function noop() {},
        isPlainObject: function isPlainObject(e) {
          var t, n;
          return !(!e || "[object Object]" !== p.call(e)) && (!(t = s(e)) || "function" == typeof (n = h.call(t, "constructor") && t.constructor) && v.call(n) === g);
        },
        isEmptyObject: function isEmptyObject(e) {
          var t;

          for (t in e) {
            return !1;
          }

          return !0;
        },
        globalEval: function globalEval(e, t) {
          _(e, {
            nonce: t && t.nonce
          });
        },
        each: function each(e, t) {
          var n,
              r = 0;
          if (T(e)) for (n = e.length; r < n && !1 !== t.call(e[r], r, e[r]); r++) {
            ;
          } else for (r in e) {
            if (!1 === t.call(e[r], r, e[r])) break;
          }
          return e;
        },
        trim: function trim(e) {
          return null == e ? "" : (e + "").replace(k, "");
        },
        makeArray: function makeArray(e, t) {
          var n = t || [];
          return null != e && (T(Object(e)) ? C.merge(n, "string" == typeof e ? [e] : e) : l.call(n, e)), n;
        },
        inArray: function inArray(e, t, n) {
          return null == t ? -1 : f.call(t, e, n);
        },
        merge: function merge(e, t) {
          for (var n = +t.length, r = 0, i = e.length; r < n; r++) {
            e[i++] = t[r];
          }

          return e.length = i, e;
        },
        grep: function grep(e, t, n) {
          for (var r = [], i = 0, o = e.length, a = !n; i < o; i++) {
            !t(e[i], i) !== a && r.push(e[i]);
          }

          return r;
        },
        map: function map(e, t, n) {
          var r,
              i,
              o = 0,
              a = [];
          if (T(e)) for (r = e.length; o < r; o++) {
            null != (i = t(e[o], o, n)) && a.push(i);
          } else for (o in e) {
            null != (i = t(e[o], o, n)) && a.push(i);
          }
          return c.apply([], a);
        },
        guid: 1,
        support: m
      }), "function" == typeof Symbol && (C.fn[Symbol.iterator] = o[Symbol.iterator]), C.each("Boolean Number String Function Array Date RegExp Object Error Symbol".split(" "), function (e, t) {
        d["[object " + t + "]"] = t.toLowerCase();
      });

      var S =
      /*!
       * Sizzle CSS Selector Engine v2.3.4
       * https://sizzlejs.com/
       *
       * Copyright JS Foundation and other contributors
       * Released under the MIT license
       * https://js.foundation/
       *
       * Date: 2019-04-08
       */
      function (e) {
        var t,
            n,
            r,
            i,
            o,
            a,
            s,
            u,
            c,
            l,
            f,
            d,
            p,
            h,
            v,
            g,
            m,
            y,
            b,
            w = "sizzle" + 1 * new Date(),
            _ = e.document,
            x = 0,
            C = 0,
            k = ue(),
            T = ue(),
            S = ue(),
            A = ue(),
            E = function E(e, t) {
          return e === t && (f = !0), 0;
        },
            O = {}.hasOwnProperty,
            j = [],
            D = j.pop,
            L = j.push,
            P = j.push,
            N = j.slice,
            I = function I(e, t) {
          for (var n = 0, r = e.length; n < r; n++) {
            if (e[n] === t) return n;
          }

          return -1;
        },
            M = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",
            R = "[\\x20\\t\\r\\n\\f]",
            q = "(?:\\\\.|[\\w-]|[^\0-\\xa0])+",
            F = "\\[" + R + "*(" + q + ")(?:" + R + "*([*^$|!~]?=)" + R + "*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + q + "))|)" + R + "*\\]",
            B = ":(" + q + ")(?:\\((('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|((?:\\\\.|[^\\\\()[\\]]|" + F + ")*)|.*)\\)|)",
            z = new RegExp(R + "+", "g"),
            H = new RegExp("^" + R + "+|((?:^|[^\\\\])(?:\\\\.)*)" + R + "+$", "g"),
            W = new RegExp("^" + R + "*," + R + "*"),
            $ = new RegExp("^" + R + "*([>+~]|" + R + ")" + R + "*"),
            V = new RegExp(R + "|>"),
            U = new RegExp(B),
            K = new RegExp("^" + q + "$"),
            X = {
          ID: new RegExp("^#(" + q + ")"),
          CLASS: new RegExp("^\\.(" + q + ")"),
          TAG: new RegExp("^(" + q + "|[*])"),
          ATTR: new RegExp("^" + F),
          PSEUDO: new RegExp("^" + B),
          CHILD: new RegExp("^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + R + "*(even|odd|(([+-]|)(\\d*)n|)" + R + "*(?:([+-]|)" + R + "*(\\d+)|))" + R + "*\\)|)", "i"),
          bool: new RegExp("^(?:" + M + ")$", "i"),
          needsContext: new RegExp("^" + R + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + R + "*((?:-\\d)?\\d*)" + R + "*\\)|)(?=[^-]|$)", "i")
        },
            G = /HTML$/i,
            Y = /^(?:input|select|textarea|button)$/i,
            Z = /^h\d$/i,
            Q = /^[^{]+\{\s*\[native \w/,
            J = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,
            ee = /[+~]/,
            te = new RegExp("\\\\([\\da-f]{1,6}" + R + "?|(" + R + ")|.)", "ig"),
            ne = function ne(e, t, n) {
          var r = "0x" + t - 65536;
          return r != r || n ? t : r < 0 ? String.fromCharCode(r + 65536) : String.fromCharCode(r >> 10 | 55296, 1023 & r | 56320);
        },
            re = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g,
            ie = function ie(e, t) {
          return t ? "\0" === e ? "�" : e.slice(0, -1) + "\\" + e.charCodeAt(e.length - 1).toString(16) + " " : "\\" + e;
        },
            oe = function oe() {
          d();
        },
            ae = we(function (e) {
          return !0 === e.disabled && "fieldset" === e.nodeName.toLowerCase();
        }, {
          dir: "parentNode",
          next: "legend"
        });

        try {
          P.apply(j = N.call(_.childNodes), _.childNodes), j[_.childNodes.length].nodeType;
        } catch (e) {
          P = {
            apply: j.length ? function (e, t) {
              L.apply(e, N.call(t));
            } : function (e, t) {
              for (var n = e.length, r = 0; e[n++] = t[r++];) {
                ;
              }

              e.length = n - 1;
            }
          };
        }

        function se(e, t, r, i) {
          var o,
              s,
              c,
              l,
              f,
              h,
              m,
              y = t && t.ownerDocument,
              x = t ? t.nodeType : 9;
          if (r = r || [], "string" != typeof e || !e || 1 !== x && 9 !== x && 11 !== x) return r;

          if (!i && ((t ? t.ownerDocument || t : _) !== p && d(t), t = t || p, v)) {
            if (11 !== x && (f = J.exec(e))) if (o = f[1]) {
              if (9 === x) {
                if (!(c = t.getElementById(o))) return r;
                if (c.id === o) return r.push(c), r;
              } else if (y && (c = y.getElementById(o)) && b(t, c) && c.id === o) return r.push(c), r;
            } else {
              if (f[2]) return P.apply(r, t.getElementsByTagName(e)), r;
              if ((o = f[3]) && n.getElementsByClassName && t.getElementsByClassName) return P.apply(r, t.getElementsByClassName(o)), r;
            }

            if (n.qsa && !A[e + " "] && (!g || !g.test(e)) && (1 !== x || "object" !== t.nodeName.toLowerCase())) {
              if (m = e, y = t, 1 === x && V.test(e)) {
                for ((l = t.getAttribute("id")) ? l = l.replace(re, ie) : t.setAttribute("id", l = w), s = (h = a(e)).length; s--;) {
                  h[s] = "#" + l + " " + be(h[s]);
                }

                m = h.join(","), y = ee.test(e) && me(t.parentNode) || t;
              }

              try {
                return P.apply(r, y.querySelectorAll(m)), r;
              } catch (t) {
                A(e, !0);
              } finally {
                l === w && t.removeAttribute("id");
              }
            }
          }

          return u(e.replace(H, "$1"), t, r, i);
        }

        function ue() {
          var e = [];
          return function t(n, i) {
            return e.push(n + " ") > r.cacheLength && delete t[e.shift()], t[n + " "] = i;
          };
        }

        function ce(e) {
          return e[w] = !0, e;
        }

        function le(e) {
          var t = p.createElement("fieldset");

          try {
            return !!e(t);
          } catch (e) {
            return !1;
          } finally {
            t.parentNode && t.parentNode.removeChild(t), t = null;
          }
        }

        function fe(e, t) {
          for (var n = e.split("|"), i = n.length; i--;) {
            r.attrHandle[n[i]] = t;
          }
        }

        function de(e, t) {
          var n = t && e,
              r = n && 1 === e.nodeType && 1 === t.nodeType && e.sourceIndex - t.sourceIndex;
          if (r) return r;
          if (n) for (; n = n.nextSibling;) {
            if (n === t) return -1;
          }
          return e ? 1 : -1;
        }

        function pe(e) {
          return function (t) {
            return "input" === t.nodeName.toLowerCase() && t.type === e;
          };
        }

        function he(e) {
          return function (t) {
            var n = t.nodeName.toLowerCase();
            return ("input" === n || "button" === n) && t.type === e;
          };
        }

        function ve(e) {
          return function (t) {
            return "form" in t ? t.parentNode && !1 === t.disabled ? "label" in t ? "label" in t.parentNode ? t.parentNode.disabled === e : t.disabled === e : t.isDisabled === e || t.isDisabled !== !e && ae(t) === e : t.disabled === e : "label" in t && t.disabled === e;
          };
        }

        function ge(e) {
          return ce(function (t) {
            return t = +t, ce(function (n, r) {
              for (var i, o = e([], n.length, t), a = o.length; a--;) {
                n[i = o[a]] && (n[i] = !(r[i] = n[i]));
              }
            });
          });
        }

        function me(e) {
          return e && void 0 !== e.getElementsByTagName && e;
        }

        for (t in n = se.support = {}, o = se.isXML = function (e) {
          var t = e.namespaceURI,
              n = (e.ownerDocument || e).documentElement;
          return !G.test(t || n && n.nodeName || "HTML");
        }, d = se.setDocument = function (e) {
          var t,
              i,
              a = e ? e.ownerDocument || e : _;
          return a !== p && 9 === a.nodeType && a.documentElement ? (h = (p = a).documentElement, v = !o(p), _ !== p && (i = p.defaultView) && i.top !== i && (i.addEventListener ? i.addEventListener("unload", oe, !1) : i.attachEvent && i.attachEvent("onunload", oe)), n.attributes = le(function (e) {
            return e.className = "i", !e.getAttribute("className");
          }), n.getElementsByTagName = le(function (e) {
            return e.appendChild(p.createComment("")), !e.getElementsByTagName("*").length;
          }), n.getElementsByClassName = Q.test(p.getElementsByClassName), n.getById = le(function (e) {
            return h.appendChild(e).id = w, !p.getElementsByName || !p.getElementsByName(w).length;
          }), n.getById ? (r.filter.ID = function (e) {
            var t = e.replace(te, ne);
            return function (e) {
              return e.getAttribute("id") === t;
            };
          }, r.find.ID = function (e, t) {
            if (void 0 !== t.getElementById && v) {
              var n = t.getElementById(e);
              return n ? [n] : [];
            }
          }) : (r.filter.ID = function (e) {
            var t = e.replace(te, ne);
            return function (e) {
              var n = void 0 !== e.getAttributeNode && e.getAttributeNode("id");
              return n && n.value === t;
            };
          }, r.find.ID = function (e, t) {
            if (void 0 !== t.getElementById && v) {
              var n,
                  r,
                  i,
                  o = t.getElementById(e);

              if (o) {
                if ((n = o.getAttributeNode("id")) && n.value === e) return [o];

                for (i = t.getElementsByName(e), r = 0; o = i[r++];) {
                  if ((n = o.getAttributeNode("id")) && n.value === e) return [o];
                }
              }

              return [];
            }
          }), r.find.TAG = n.getElementsByTagName ? function (e, t) {
            return void 0 !== t.getElementsByTagName ? t.getElementsByTagName(e) : n.qsa ? t.querySelectorAll(e) : void 0;
          } : function (e, t) {
            var n,
                r = [],
                i = 0,
                o = t.getElementsByTagName(e);

            if ("*" === e) {
              for (; n = o[i++];) {
                1 === n.nodeType && r.push(n);
              }

              return r;
            }

            return o;
          }, r.find.CLASS = n.getElementsByClassName && function (e, t) {
            if (void 0 !== t.getElementsByClassName && v) return t.getElementsByClassName(e);
          }, m = [], g = [], (n.qsa = Q.test(p.querySelectorAll)) && (le(function (e) {
            h.appendChild(e).innerHTML = "<a id='" + w + "'></a><select id='" + w + "-\r\\' msallowcapture=''><option selected=''></option></select>", e.querySelectorAll("[msallowcapture^='']").length && g.push("[*^$]=" + R + "*(?:''|\"\")"), e.querySelectorAll("[selected]").length || g.push("\\[" + R + "*(?:value|" + M + ")"), e.querySelectorAll("[id~=" + w + "-]").length || g.push("~="), e.querySelectorAll(":checked").length || g.push(":checked"), e.querySelectorAll("a#" + w + "+*").length || g.push(".#.+[+~]");
          }), le(function (e) {
            e.innerHTML = "<a href='' disabled='disabled'></a><select disabled='disabled'><option/></select>";
            var t = p.createElement("input");
            t.setAttribute("type", "hidden"), e.appendChild(t).setAttribute("name", "D"), e.querySelectorAll("[name=d]").length && g.push("name" + R + "*[*^$|!~]?="), 2 !== e.querySelectorAll(":enabled").length && g.push(":enabled", ":disabled"), h.appendChild(e).disabled = !0, 2 !== e.querySelectorAll(":disabled").length && g.push(":enabled", ":disabled"), e.querySelectorAll("*,:x"), g.push(",.*:");
          })), (n.matchesSelector = Q.test(y = h.matches || h.webkitMatchesSelector || h.mozMatchesSelector || h.oMatchesSelector || h.msMatchesSelector)) && le(function (e) {
            n.disconnectedMatch = y.call(e, "*"), y.call(e, "[s!='']:x"), m.push("!=", B);
          }), g = g.length && new RegExp(g.join("|")), m = m.length && new RegExp(m.join("|")), t = Q.test(h.compareDocumentPosition), b = t || Q.test(h.contains) ? function (e, t) {
            var n = 9 === e.nodeType ? e.documentElement : e,
                r = t && t.parentNode;
            return e === r || !(!r || 1 !== r.nodeType || !(n.contains ? n.contains(r) : e.compareDocumentPosition && 16 & e.compareDocumentPosition(r)));
          } : function (e, t) {
            if (t) for (; t = t.parentNode;) {
              if (t === e) return !0;
            }
            return !1;
          }, E = t ? function (e, t) {
            if (e === t) return f = !0, 0;
            var r = !e.compareDocumentPosition - !t.compareDocumentPosition;
            return r || (1 & (r = (e.ownerDocument || e) === (t.ownerDocument || t) ? e.compareDocumentPosition(t) : 1) || !n.sortDetached && t.compareDocumentPosition(e) === r ? e === p || e.ownerDocument === _ && b(_, e) ? -1 : t === p || t.ownerDocument === _ && b(_, t) ? 1 : l ? I(l, e) - I(l, t) : 0 : 4 & r ? -1 : 1);
          } : function (e, t) {
            if (e === t) return f = !0, 0;
            var n,
                r = 0,
                i = e.parentNode,
                o = t.parentNode,
                a = [e],
                s = [t];
            if (!i || !o) return e === p ? -1 : t === p ? 1 : i ? -1 : o ? 1 : l ? I(l, e) - I(l, t) : 0;
            if (i === o) return de(e, t);

            for (n = e; n = n.parentNode;) {
              a.unshift(n);
            }

            for (n = t; n = n.parentNode;) {
              s.unshift(n);
            }

            for (; a[r] === s[r];) {
              r++;
            }

            return r ? de(a[r], s[r]) : a[r] === _ ? -1 : s[r] === _ ? 1 : 0;
          }, p) : p;
        }, se.matches = function (e, t) {
          return se(e, null, null, t);
        }, se.matchesSelector = function (e, t) {
          if ((e.ownerDocument || e) !== p && d(e), n.matchesSelector && v && !A[t + " "] && (!m || !m.test(t)) && (!g || !g.test(t))) try {
            var r = y.call(e, t);
            if (r || n.disconnectedMatch || e.document && 11 !== e.document.nodeType) return r;
          } catch (e) {
            A(t, !0);
          }
          return se(t, p, null, [e]).length > 0;
        }, se.contains = function (e, t) {
          return (e.ownerDocument || e) !== p && d(e), b(e, t);
        }, se.attr = function (e, t) {
          (e.ownerDocument || e) !== p && d(e);
          var i = r.attrHandle[t.toLowerCase()],
              o = i && O.call(r.attrHandle, t.toLowerCase()) ? i(e, t, !v) : void 0;
          return void 0 !== o ? o : n.attributes || !v ? e.getAttribute(t) : (o = e.getAttributeNode(t)) && o.specified ? o.value : null;
        }, se.escape = function (e) {
          return (e + "").replace(re, ie);
        }, se.error = function (e) {
          throw new Error("Syntax error, unrecognized expression: " + e);
        }, se.uniqueSort = function (e) {
          var t,
              r = [],
              i = 0,
              o = 0;

          if (f = !n.detectDuplicates, l = !n.sortStable && e.slice(0), e.sort(E), f) {
            for (; t = e[o++];) {
              t === e[o] && (i = r.push(o));
            }

            for (; i--;) {
              e.splice(r[i], 1);
            }
          }

          return l = null, e;
        }, i = se.getText = function (e) {
          var t,
              n = "",
              r = 0,
              o = e.nodeType;

          if (o) {
            if (1 === o || 9 === o || 11 === o) {
              if ("string" == typeof e.textContent) return e.textContent;

              for (e = e.firstChild; e; e = e.nextSibling) {
                n += i(e);
              }
            } else if (3 === o || 4 === o) return e.nodeValue;
          } else for (; t = e[r++];) {
            n += i(t);
          }

          return n;
        }, (r = se.selectors = {
          cacheLength: 50,
          createPseudo: ce,
          match: X,
          attrHandle: {},
          find: {},
          relative: {
            ">": {
              dir: "parentNode",
              first: !0
            },
            " ": {
              dir: "parentNode"
            },
            "+": {
              dir: "previousSibling",
              first: !0
            },
            "~": {
              dir: "previousSibling"
            }
          },
          preFilter: {
            ATTR: function ATTR(e) {
              return e[1] = e[1].replace(te, ne), e[3] = (e[3] || e[4] || e[5] || "").replace(te, ne), "~=" === e[2] && (e[3] = " " + e[3] + " "), e.slice(0, 4);
            },
            CHILD: function CHILD(e) {
              return e[1] = e[1].toLowerCase(), "nth" === e[1].slice(0, 3) ? (e[3] || se.error(e[0]), e[4] = +(e[4] ? e[5] + (e[6] || 1) : 2 * ("even" === e[3] || "odd" === e[3])), e[5] = +(e[7] + e[8] || "odd" === e[3])) : e[3] && se.error(e[0]), e;
            },
            PSEUDO: function PSEUDO(e) {
              var t,
                  n = !e[6] && e[2];
              return X.CHILD.test(e[0]) ? null : (e[3] ? e[2] = e[4] || e[5] || "" : n && U.test(n) && (t = a(n, !0)) && (t = n.indexOf(")", n.length - t) - n.length) && (e[0] = e[0].slice(0, t), e[2] = n.slice(0, t)), e.slice(0, 3));
            }
          },
          filter: {
            TAG: function TAG(e) {
              var t = e.replace(te, ne).toLowerCase();
              return "*" === e ? function () {
                return !0;
              } : function (e) {
                return e.nodeName && e.nodeName.toLowerCase() === t;
              };
            },
            CLASS: function CLASS(e) {
              var t = k[e + " "];
              return t || (t = new RegExp("(^|" + R + ")" + e + "(" + R + "|$)")) && k(e, function (e) {
                return t.test("string" == typeof e.className && e.className || void 0 !== e.getAttribute && e.getAttribute("class") || "");
              });
            },
            ATTR: function ATTR(e, t, n) {
              return function (r) {
                var i = se.attr(r, e);
                return null == i ? "!=" === t : !t || (i += "", "=" === t ? i === n : "!=" === t ? i !== n : "^=" === t ? n && 0 === i.indexOf(n) : "*=" === t ? n && i.indexOf(n) > -1 : "$=" === t ? n && i.slice(-n.length) === n : "~=" === t ? (" " + i.replace(z, " ") + " ").indexOf(n) > -1 : "|=" === t && (i === n || i.slice(0, n.length + 1) === n + "-"));
              };
            },
            CHILD: function CHILD(e, t, n, r, i) {
              var o = "nth" !== e.slice(0, 3),
                  a = "last" !== e.slice(-4),
                  s = "of-type" === t;
              return 1 === r && 0 === i ? function (e) {
                return !!e.parentNode;
              } : function (t, n, u) {
                var c,
                    l,
                    f,
                    d,
                    p,
                    h,
                    v = o !== a ? "nextSibling" : "previousSibling",
                    g = t.parentNode,
                    m = s && t.nodeName.toLowerCase(),
                    y = !u && !s,
                    b = !1;

                if (g) {
                  if (o) {
                    for (; v;) {
                      for (d = t; d = d[v];) {
                        if (s ? d.nodeName.toLowerCase() === m : 1 === d.nodeType) return !1;
                      }

                      h = v = "only" === e && !h && "nextSibling";
                    }

                    return !0;
                  }

                  if (h = [a ? g.firstChild : g.lastChild], a && y) {
                    for (b = (p = (c = (l = (f = (d = g)[w] || (d[w] = {}))[d.uniqueID] || (f[d.uniqueID] = {}))[e] || [])[0] === x && c[1]) && c[2], d = p && g.childNodes[p]; d = ++p && d && d[v] || (b = p = 0) || h.pop();) {
                      if (1 === d.nodeType && ++b && d === t) {
                        l[e] = [x, p, b];
                        break;
                      }
                    }
                  } else if (y && (b = p = (c = (l = (f = (d = t)[w] || (d[w] = {}))[d.uniqueID] || (f[d.uniqueID] = {}))[e] || [])[0] === x && c[1]), !1 === b) for (; (d = ++p && d && d[v] || (b = p = 0) || h.pop()) && ((s ? d.nodeName.toLowerCase() !== m : 1 !== d.nodeType) || !++b || (y && ((l = (f = d[w] || (d[w] = {}))[d.uniqueID] || (f[d.uniqueID] = {}))[e] = [x, b]), d !== t));) {
                    ;
                  }

                  return (b -= i) === r || b % r == 0 && b / r >= 0;
                }
              };
            },
            PSEUDO: function PSEUDO(e, t) {
              var n,
                  i = r.pseudos[e] || r.setFilters[e.toLowerCase()] || se.error("unsupported pseudo: " + e);
              return i[w] ? i(t) : i.length > 1 ? (n = [e, e, "", t], r.setFilters.hasOwnProperty(e.toLowerCase()) ? ce(function (e, n) {
                for (var r, o = i(e, t), a = o.length; a--;) {
                  e[r = I(e, o[a])] = !(n[r] = o[a]);
                }
              }) : function (e) {
                return i(e, 0, n);
              }) : i;
            }
          },
          pseudos: {
            not: ce(function (e) {
              var t = [],
                  n = [],
                  r = s(e.replace(H, "$1"));
              return r[w] ? ce(function (e, t, n, i) {
                for (var o, a = r(e, null, i, []), s = e.length; s--;) {
                  (o = a[s]) && (e[s] = !(t[s] = o));
                }
              }) : function (e, i, o) {
                return t[0] = e, r(t, null, o, n), t[0] = null, !n.pop();
              };
            }),
            has: ce(function (e) {
              return function (t) {
                return se(e, t).length > 0;
              };
            }),
            contains: ce(function (e) {
              return e = e.replace(te, ne), function (t) {
                return (t.textContent || i(t)).indexOf(e) > -1;
              };
            }),
            lang: ce(function (e) {
              return K.test(e || "") || se.error("unsupported lang: " + e), e = e.replace(te, ne).toLowerCase(), function (t) {
                var n;

                do {
                  if (n = v ? t.lang : t.getAttribute("xml:lang") || t.getAttribute("lang")) return (n = n.toLowerCase()) === e || 0 === n.indexOf(e + "-");
                } while ((t = t.parentNode) && 1 === t.nodeType);

                return !1;
              };
            }),
            target: function target(t) {
              var n = e.location && e.location.hash;
              return n && n.slice(1) === t.id;
            },
            root: function root(e) {
              return e === h;
            },
            focus: function focus(e) {
              return e === p.activeElement && (!p.hasFocus || p.hasFocus()) && !!(e.type || e.href || ~e.tabIndex);
            },
            enabled: ve(!1),
            disabled: ve(!0),
            checked: function checked(e) {
              var t = e.nodeName.toLowerCase();
              return "input" === t && !!e.checked || "option" === t && !!e.selected;
            },
            selected: function selected(e) {
              return e.parentNode && e.parentNode.selectedIndex, !0 === e.selected;
            },
            empty: function empty(e) {
              for (e = e.firstChild; e; e = e.nextSibling) {
                if (e.nodeType < 6) return !1;
              }

              return !0;
            },
            parent: function parent(e) {
              return !r.pseudos.empty(e);
            },
            header: function header(e) {
              return Z.test(e.nodeName);
            },
            input: function input(e) {
              return Y.test(e.nodeName);
            },
            button: function button(e) {
              var t = e.nodeName.toLowerCase();
              return "input" === t && "button" === e.type || "button" === t;
            },
            text: function text(e) {
              var t;
              return "input" === e.nodeName.toLowerCase() && "text" === e.type && (null == (t = e.getAttribute("type")) || "text" === t.toLowerCase());
            },
            first: ge(function () {
              return [0];
            }),
            last: ge(function (e, t) {
              return [t - 1];
            }),
            eq: ge(function (e, t, n) {
              return [n < 0 ? n + t : n];
            }),
            even: ge(function (e, t) {
              for (var n = 0; n < t; n += 2) {
                e.push(n);
              }

              return e;
            }),
            odd: ge(function (e, t) {
              for (var n = 1; n < t; n += 2) {
                e.push(n);
              }

              return e;
            }),
            lt: ge(function (e, t, n) {
              for (var r = n < 0 ? n + t : n > t ? t : n; --r >= 0;) {
                e.push(r);
              }

              return e;
            }),
            gt: ge(function (e, t, n) {
              for (var r = n < 0 ? n + t : n; ++r < t;) {
                e.push(r);
              }

              return e;
            })
          }
        }).pseudos.nth = r.pseudos.eq, {
          radio: !0,
          checkbox: !0,
          file: !0,
          password: !0,
          image: !0
        }) {
          r.pseudos[t] = pe(t);
        }

        for (t in {
          submit: !0,
          reset: !0
        }) {
          r.pseudos[t] = he(t);
        }

        function ye() {}

        function be(e) {
          for (var t = 0, n = e.length, r = ""; t < n; t++) {
            r += e[t].value;
          }

          return r;
        }

        function we(e, t, n) {
          var r = t.dir,
              i = t.next,
              o = i || r,
              a = n && "parentNode" === o,
              s = C++;
          return t.first ? function (t, n, i) {
            for (; t = t[r];) {
              if (1 === t.nodeType || a) return e(t, n, i);
            }

            return !1;
          } : function (t, n, u) {
            var c,
                l,
                f,
                d = [x, s];

            if (u) {
              for (; t = t[r];) {
                if ((1 === t.nodeType || a) && e(t, n, u)) return !0;
              }
            } else for (; t = t[r];) {
              if (1 === t.nodeType || a) if (l = (f = t[w] || (t[w] = {}))[t.uniqueID] || (f[t.uniqueID] = {}), i && i === t.nodeName.toLowerCase()) t = t[r] || t;else {
                if ((c = l[o]) && c[0] === x && c[1] === s) return d[2] = c[2];
                if (l[o] = d, d[2] = e(t, n, u)) return !0;
              }
            }

            return !1;
          };
        }

        function _e(e) {
          return e.length > 1 ? function (t, n, r) {
            for (var i = e.length; i--;) {
              if (!e[i](t, n, r)) return !1;
            }

            return !0;
          } : e[0];
        }

        function xe(e, t, n, r, i) {
          for (var o, a = [], s = 0, u = e.length, c = null != t; s < u; s++) {
            (o = e[s]) && (n && !n(o, r, i) || (a.push(o), c && t.push(s)));
          }

          return a;
        }

        function Ce(e, t, n, r, i, o) {
          return r && !r[w] && (r = Ce(r)), i && !i[w] && (i = Ce(i, o)), ce(function (o, a, s, u) {
            var c,
                l,
                f,
                d = [],
                p = [],
                h = a.length,
                v = o || function (e, t, n) {
              for (var r = 0, i = t.length; r < i; r++) {
                se(e, t[r], n);
              }

              return n;
            }(t || "*", s.nodeType ? [s] : s, []),
                g = !e || !o && t ? v : xe(v, d, e, s, u),
                m = n ? i || (o ? e : h || r) ? [] : a : g;

            if (n && n(g, m, s, u), r) for (c = xe(m, p), r(c, [], s, u), l = c.length; l--;) {
              (f = c[l]) && (m[p[l]] = !(g[p[l]] = f));
            }

            if (o) {
              if (i || e) {
                if (i) {
                  for (c = [], l = m.length; l--;) {
                    (f = m[l]) && c.push(g[l] = f);
                  }

                  i(null, m = [], c, u);
                }

                for (l = m.length; l--;) {
                  (f = m[l]) && (c = i ? I(o, f) : d[l]) > -1 && (o[c] = !(a[c] = f));
                }
              }
            } else m = xe(m === a ? m.splice(h, m.length) : m), i ? i(null, a, m, u) : P.apply(a, m);
          });
        }

        function ke(e) {
          for (var t, n, i, o = e.length, a = r.relative[e[0].type], s = a || r.relative[" "], u = a ? 1 : 0, l = we(function (e) {
            return e === t;
          }, s, !0), f = we(function (e) {
            return I(t, e) > -1;
          }, s, !0), d = [function (e, n, r) {
            var i = !a && (r || n !== c) || ((t = n).nodeType ? l(e, n, r) : f(e, n, r));
            return t = null, i;
          }]; u < o; u++) {
            if (n = r.relative[e[u].type]) d = [we(_e(d), n)];else {
              if ((n = r.filter[e[u].type].apply(null, e[u].matches))[w]) {
                for (i = ++u; i < o && !r.relative[e[i].type]; i++) {
                  ;
                }

                return Ce(u > 1 && _e(d), u > 1 && be(e.slice(0, u - 1).concat({
                  value: " " === e[u - 2].type ? "*" : ""
                })).replace(H, "$1"), n, u < i && ke(e.slice(u, i)), i < o && ke(e = e.slice(i)), i < o && be(e));
              }

              d.push(n);
            }
          }

          return _e(d);
        }

        return ye.prototype = r.filters = r.pseudos, r.setFilters = new ye(), a = se.tokenize = function (e, t) {
          var n,
              i,
              o,
              a,
              s,
              u,
              c,
              l = T[e + " "];
          if (l) return t ? 0 : l.slice(0);

          for (s = e, u = [], c = r.preFilter; s;) {
            for (a in n && !(i = W.exec(s)) || (i && (s = s.slice(i[0].length) || s), u.push(o = [])), n = !1, (i = $.exec(s)) && (n = i.shift(), o.push({
              value: n,
              type: i[0].replace(H, " ")
            }), s = s.slice(n.length)), r.filter) {
              !(i = X[a].exec(s)) || c[a] && !(i = c[a](i)) || (n = i.shift(), o.push({
                value: n,
                type: a,
                matches: i
              }), s = s.slice(n.length));
            }

            if (!n) break;
          }

          return t ? s.length : s ? se.error(e) : T(e, u).slice(0);
        }, s = se.compile = function (e, t) {
          var n,
              i = [],
              o = [],
              s = S[e + " "];

          if (!s) {
            for (t || (t = a(e)), n = t.length; n--;) {
              (s = ke(t[n]))[w] ? i.push(s) : o.push(s);
            }

            (s = S(e, function (e, t) {
              var n = t.length > 0,
                  i = e.length > 0,
                  o = function o(_o2, a, s, u, l) {
                var f,
                    h,
                    g,
                    m = 0,
                    y = "0",
                    b = _o2 && [],
                    w = [],
                    _ = c,
                    C = _o2 || i && r.find.TAG("*", l),
                    k = x += null == _ ? 1 : Math.random() || .1,
                    T = C.length;

                for (l && (c = a === p || a || l); y !== T && null != (f = C[y]); y++) {
                  if (i && f) {
                    for (h = 0, a || f.ownerDocument === p || (d(f), s = !v); g = e[h++];) {
                      if (g(f, a || p, s)) {
                        u.push(f);
                        break;
                      }
                    }

                    l && (x = k);
                  }

                  n && ((f = !g && f) && m--, _o2 && b.push(f));
                }

                if (m += y, n && y !== m) {
                  for (h = 0; g = t[h++];) {
                    g(b, w, a, s);
                  }

                  if (_o2) {
                    if (m > 0) for (; y--;) {
                      b[y] || w[y] || (w[y] = D.call(u));
                    }
                    w = xe(w);
                  }

                  P.apply(u, w), l && !_o2 && w.length > 0 && m + t.length > 1 && se.uniqueSort(u);
                }

                return l && (x = k, c = _), b;
              };

              return n ? ce(o) : o;
            }(o, i))).selector = e;
          }

          return s;
        }, u = se.select = function (e, t, n, i) {
          var o,
              u,
              c,
              l,
              f,
              d = "function" == typeof e && e,
              p = !i && a(e = d.selector || e);

          if (n = n || [], 1 === p.length) {
            if ((u = p[0] = p[0].slice(0)).length > 2 && "ID" === (c = u[0]).type && 9 === t.nodeType && v && r.relative[u[1].type]) {
              if (!(t = (r.find.ID(c.matches[0].replace(te, ne), t) || [])[0])) return n;
              d && (t = t.parentNode), e = e.slice(u.shift().value.length);
            }

            for (o = X.needsContext.test(e) ? 0 : u.length; o-- && (c = u[o], !r.relative[l = c.type]);) {
              if ((f = r.find[l]) && (i = f(c.matches[0].replace(te, ne), ee.test(u[0].type) && me(t.parentNode) || t))) {
                if (u.splice(o, 1), !(e = i.length && be(u))) return P.apply(n, i), n;
                break;
              }
            }
          }

          return (d || s(e, p))(i, t, !v, n, !t || ee.test(e) && me(t.parentNode) || t), n;
        }, n.sortStable = w.split("").sort(E).join("") === w, n.detectDuplicates = !!f, d(), n.sortDetached = le(function (e) {
          return 1 & e.compareDocumentPosition(p.createElement("fieldset"));
        }), le(function (e) {
          return e.innerHTML = "<a href='#'></a>", "#" === e.firstChild.getAttribute("href");
        }) || fe("type|href|height|width", function (e, t, n) {
          if (!n) return e.getAttribute(t, "type" === t.toLowerCase() ? 1 : 2);
        }), n.attributes && le(function (e) {
          return e.innerHTML = "<input/>", e.firstChild.setAttribute("value", ""), "" === e.firstChild.getAttribute("value");
        }) || fe("value", function (e, t, n) {
          if (!n && "input" === e.nodeName.toLowerCase()) return e.defaultValue;
        }), le(function (e) {
          return null == e.getAttribute("disabled");
        }) || fe(M, function (e, t, n) {
          var r;
          if (!n) return !0 === e[t] ? t.toLowerCase() : (r = e.getAttributeNode(t)) && r.specified ? r.value : null;
        }), se;
      }(n);

      C.find = S, C.expr = S.selectors, C.expr[":"] = C.expr.pseudos, C.uniqueSort = C.unique = S.uniqueSort, C.text = S.getText, C.isXMLDoc = S.isXML, C.contains = S.contains, C.escapeSelector = S.escape;

      var A = function A(e, t, n) {
        for (var r = [], i = void 0 !== n; (e = e[t]) && 9 !== e.nodeType;) {
          if (1 === e.nodeType) {
            if (i && C(e).is(n)) break;
            r.push(e);
          }
        }

        return r;
      },
          E = function E(e, t) {
        for (var n = []; e; e = e.nextSibling) {
          1 === e.nodeType && e !== t && n.push(e);
        }

        return n;
      },
          O = C.expr.match.needsContext;

      function j(e, t) {
        return e.nodeName && e.nodeName.toLowerCase() === t.toLowerCase();
      }

      var D = /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i;

      function L(e, t, n) {
        return y(t) ? C.grep(e, function (e, r) {
          return !!t.call(e, r, e) !== n;
        }) : t.nodeType ? C.grep(e, function (e) {
          return e === t !== n;
        }) : "string" != typeof t ? C.grep(e, function (e) {
          return f.call(t, e) > -1 !== n;
        }) : C.filter(t, e, n);
      }

      C.filter = function (e, t, n) {
        var r = t[0];
        return n && (e = ":not(" + e + ")"), 1 === t.length && 1 === r.nodeType ? C.find.matchesSelector(r, e) ? [r] : [] : C.find.matches(e, C.grep(t, function (e) {
          return 1 === e.nodeType;
        }));
      }, C.fn.extend({
        find: function find(e) {
          var t,
              n,
              r = this.length,
              i = this;
          if ("string" != typeof e) return this.pushStack(C(e).filter(function () {
            for (t = 0; t < r; t++) {
              if (C.contains(i[t], this)) return !0;
            }
          }));

          for (n = this.pushStack([]), t = 0; t < r; t++) {
            C.find(e, i[t], n);
          }

          return r > 1 ? C.uniqueSort(n) : n;
        },
        filter: function filter(e) {
          return this.pushStack(L(this, e || [], !1));
        },
        not: function not(e) {
          return this.pushStack(L(this, e || [], !0));
        },
        is: function is(e) {
          return !!L(this, "string" == typeof e && O.test(e) ? C(e) : e || [], !1).length;
        }
      });
      var P,
          N = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/;
      (C.fn.init = function (e, t, n) {
        var r, i;
        if (!e) return this;

        if (n = n || P, "string" == typeof e) {
          if (!(r = "<" === e[0] && ">" === e[e.length - 1] && e.length >= 3 ? [null, e, null] : N.exec(e)) || !r[1] && t) return !t || t.jquery ? (t || n).find(e) : this.constructor(t).find(e);

          if (r[1]) {
            if (t = t instanceof C ? t[0] : t, C.merge(this, C.parseHTML(r[1], t && t.nodeType ? t.ownerDocument || t : a, !0)), D.test(r[1]) && C.isPlainObject(t)) for (r in t) {
              y(this[r]) ? this[r](t[r]) : this.attr(r, t[r]);
            }
            return this;
          }

          return (i = a.getElementById(r[2])) && (this[0] = i, this.length = 1), this;
        }

        return e.nodeType ? (this[0] = e, this.length = 1, this) : y(e) ? void 0 !== n.ready ? n.ready(e) : e(C) : C.makeArray(e, this);
      }).prototype = C.fn, P = C(a);
      var I = /^(?:parents|prev(?:Until|All))/,
          M = {
        children: !0,
        contents: !0,
        next: !0,
        prev: !0
      };

      function R(e, t) {
        for (; (e = e[t]) && 1 !== e.nodeType;) {
          ;
        }

        return e;
      }

      C.fn.extend({
        has: function has(e) {
          var t = C(e, this),
              n = t.length;
          return this.filter(function () {
            for (var e = 0; e < n; e++) {
              if (C.contains(this, t[e])) return !0;
            }
          });
        },
        closest: function closest(e, t) {
          var n,
              r = 0,
              i = this.length,
              o = [],
              a = "string" != typeof e && C(e);
          if (!O.test(e)) for (; r < i; r++) {
            for (n = this[r]; n && n !== t; n = n.parentNode) {
              if (n.nodeType < 11 && (a ? a.index(n) > -1 : 1 === n.nodeType && C.find.matchesSelector(n, e))) {
                o.push(n);
                break;
              }
            }
          }
          return this.pushStack(o.length > 1 ? C.uniqueSort(o) : o);
        },
        index: function index(e) {
          return e ? "string" == typeof e ? f.call(C(e), this[0]) : f.call(this, e.jquery ? e[0] : e) : this[0] && this[0].parentNode ? this.first().prevAll().length : -1;
        },
        add: function add(e, t) {
          return this.pushStack(C.uniqueSort(C.merge(this.get(), C(e, t))));
        },
        addBack: function addBack(e) {
          return this.add(null == e ? this.prevObject : this.prevObject.filter(e));
        }
      }), C.each({
        parent: function parent(e) {
          var t = e.parentNode;
          return t && 11 !== t.nodeType ? t : null;
        },
        parents: function parents(e) {
          return A(e, "parentNode");
        },
        parentsUntil: function parentsUntil(e, t, n) {
          return A(e, "parentNode", n);
        },
        next: function next(e) {
          return R(e, "nextSibling");
        },
        prev: function prev(e) {
          return R(e, "previousSibling");
        },
        nextAll: function nextAll(e) {
          return A(e, "nextSibling");
        },
        prevAll: function prevAll(e) {
          return A(e, "previousSibling");
        },
        nextUntil: function nextUntil(e, t, n) {
          return A(e, "nextSibling", n);
        },
        prevUntil: function prevUntil(e, t, n) {
          return A(e, "previousSibling", n);
        },
        siblings: function siblings(e) {
          return E((e.parentNode || {}).firstChild, e);
        },
        children: function children(e) {
          return E(e.firstChild);
        },
        contents: function contents(e) {
          return void 0 !== e.contentDocument ? e.contentDocument : (j(e, "template") && (e = e.content || e), C.merge([], e.childNodes));
        }
      }, function (e, t) {
        C.fn[e] = function (n, r) {
          var i = C.map(this, t, n);
          return "Until" !== e.slice(-5) && (r = n), r && "string" == typeof r && (i = C.filter(r, i)), this.length > 1 && (M[e] || C.uniqueSort(i), I.test(e) && i.reverse()), this.pushStack(i);
        };
      });
      var q = /[^\x20\t\r\n\f]+/g;

      function F(e) {
        return e;
      }

      function B(e) {
        throw e;
      }

      function z(e, t, n, r) {
        var i;

        try {
          e && y(i = e.promise) ? i.call(e).done(t).fail(n) : e && y(i = e.then) ? i.call(e, t, n) : t.apply(void 0, [e].slice(r));
        } catch (e) {
          n.apply(void 0, [e]);
        }
      }

      C.Callbacks = function (e) {
        e = "string" == typeof e ? function (e) {
          var t = {};
          return C.each(e.match(q) || [], function (e, n) {
            t[n] = !0;
          }), t;
        }(e) : C.extend({}, e);

        var t,
            n,
            r,
            i,
            o = [],
            a = [],
            s = -1,
            u = function u() {
          for (i = i || e.once, r = t = !0; a.length; s = -1) {
            for (n = a.shift(); ++s < o.length;) {
              !1 === o[s].apply(n[0], n[1]) && e.stopOnFalse && (s = o.length, n = !1);
            }
          }

          e.memory || (n = !1), t = !1, i && (o = n ? [] : "");
        },
            c = {
          add: function add() {
            return o && (n && !t && (s = o.length - 1, a.push(n)), function t(n) {
              C.each(n, function (n, r) {
                y(r) ? e.unique && c.has(r) || o.push(r) : r && r.length && "string" !== x(r) && t(r);
              });
            }(arguments), n && !t && u()), this;
          },
          remove: function remove() {
            return C.each(arguments, function (e, t) {
              for (var n; (n = C.inArray(t, o, n)) > -1;) {
                o.splice(n, 1), n <= s && s--;
              }
            }), this;
          },
          has: function has(e) {
            return e ? C.inArray(e, o) > -1 : o.length > 0;
          },
          empty: function empty() {
            return o && (o = []), this;
          },
          disable: function disable() {
            return i = a = [], o = n = "", this;
          },
          disabled: function disabled() {
            return !o;
          },
          lock: function lock() {
            return i = a = [], n || t || (o = n = ""), this;
          },
          locked: function locked() {
            return !!i;
          },
          fireWith: function fireWith(e, n) {
            return i || (n = [e, (n = n || []).slice ? n.slice() : n], a.push(n), t || u()), this;
          },
          fire: function fire() {
            return c.fireWith(this, arguments), this;
          },
          fired: function fired() {
            return !!r;
          }
        };

        return c;
      }, C.extend({
        Deferred: function Deferred(e) {
          var t = [["notify", "progress", C.Callbacks("memory"), C.Callbacks("memory"), 2], ["resolve", "done", C.Callbacks("once memory"), C.Callbacks("once memory"), 0, "resolved"], ["reject", "fail", C.Callbacks("once memory"), C.Callbacks("once memory"), 1, "rejected"]],
              r = "pending",
              i = {
            state: function state() {
              return r;
            },
            always: function always() {
              return o.done(arguments).fail(arguments), this;
            },
            "catch": function _catch(e) {
              return i.then(null, e);
            },
            pipe: function pipe() {
              var e = arguments;
              return C.Deferred(function (n) {
                C.each(t, function (t, r) {
                  var i = y(e[r[4]]) && e[r[4]];
                  o[r[1]](function () {
                    var e = i && i.apply(this, arguments);
                    e && y(e.promise) ? e.promise().progress(n.notify).done(n.resolve).fail(n.reject) : n[r[0] + "With"](this, i ? [e] : arguments);
                  });
                }), e = null;
              }).promise();
            },
            then: function then(e, r, i) {
              var o = 0;

              function a(e, t, r, i) {
                return function () {
                  var s = this,
                      u = arguments,
                      c = function c() {
                    var n, c;

                    if (!(e < o)) {
                      if ((n = r.apply(s, u)) === t.promise()) throw new TypeError("Thenable self-resolution");
                      c = n && ("object" == _typeof(n) || "function" == typeof n) && n.then, y(c) ? i ? c.call(n, a(o, t, F, i), a(o, t, B, i)) : (o++, c.call(n, a(o, t, F, i), a(o, t, B, i), a(o, t, F, t.notifyWith))) : (r !== F && (s = void 0, u = [n]), (i || t.resolveWith)(s, u));
                    }
                  },
                      l = i ? c : function () {
                    try {
                      c();
                    } catch (n) {
                      C.Deferred.exceptionHook && C.Deferred.exceptionHook(n, l.stackTrace), e + 1 >= o && (r !== B && (s = void 0, u = [n]), t.rejectWith(s, u));
                    }
                  };

                  e ? l() : (C.Deferred.getStackHook && (l.stackTrace = C.Deferred.getStackHook()), n.setTimeout(l));
                };
              }

              return C.Deferred(function (n) {
                t[0][3].add(a(0, n, y(i) ? i : F, n.notifyWith)), t[1][3].add(a(0, n, y(e) ? e : F)), t[2][3].add(a(0, n, y(r) ? r : B));
              }).promise();
            },
            promise: function promise(e) {
              return null != e ? C.extend(e, i) : i;
            }
          },
              o = {};
          return C.each(t, function (e, n) {
            var a = n[2],
                s = n[5];
            i[n[1]] = a.add, s && a.add(function () {
              r = s;
            }, t[3 - e][2].disable, t[3 - e][3].disable, t[0][2].lock, t[0][3].lock), a.add(n[3].fire), o[n[0]] = function () {
              return o[n[0] + "With"](this === o ? void 0 : this, arguments), this;
            }, o[n[0] + "With"] = a.fireWith;
          }), i.promise(o), e && e.call(o, o), o;
        },
        when: function when(e) {
          var t = arguments.length,
              n = t,
              r = Array(n),
              i = u.call(arguments),
              o = C.Deferred(),
              a = function a(e) {
            return function (n) {
              r[e] = this, i[e] = arguments.length > 1 ? u.call(arguments) : n, --t || o.resolveWith(r, i);
            };
          };

          if (t <= 1 && (z(e, o.done(a(n)).resolve, o.reject, !t), "pending" === o.state() || y(i[n] && i[n].then))) return o.then();

          for (; n--;) {
            z(i[n], a(n), o.reject);
          }

          return o.promise();
        }
      });
      var H = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;
      C.Deferred.exceptionHook = function (e, t) {
        n.console && n.console.warn && e && H.test(e.name) && n.console.warn("jQuery.Deferred exception: " + e.message, e.stack, t);
      }, C.readyException = function (e) {
        n.setTimeout(function () {
          throw e;
        });
      };
      var W = C.Deferred();

      function $() {
        a.removeEventListener("DOMContentLoaded", $), n.removeEventListener("load", $), C.ready();
      }

      C.fn.ready = function (e) {
        return W.then(e)["catch"](function (e) {
          C.readyException(e);
        }), this;
      }, C.extend({
        isReady: !1,
        readyWait: 1,
        ready: function ready(e) {
          (!0 === e ? --C.readyWait : C.isReady) || (C.isReady = !0, !0 !== e && --C.readyWait > 0 || W.resolveWith(a, [C]));
        }
      }), C.ready.then = W.then, "complete" === a.readyState || "loading" !== a.readyState && !a.documentElement.doScroll ? n.setTimeout(C.ready) : (a.addEventListener("DOMContentLoaded", $), n.addEventListener("load", $));

      var V = function V(e, t, n, r, i, o, a) {
        var s = 0,
            u = e.length,
            c = null == n;
        if ("object" === x(n)) for (s in i = !0, n) {
          V(e, t, s, n[s], !0, o, a);
        } else if (void 0 !== r && (i = !0, y(r) || (a = !0), c && (a ? (t.call(e, r), t = null) : (c = t, t = function t(e, _t3, n) {
          return c.call(C(e), n);
        })), t)) for (; s < u; s++) {
          t(e[s], n, a ? r : r.call(e[s], s, t(e[s], n)));
        }
        return i ? e : c ? t.call(e) : u ? t(e[0], n) : o;
      },
          U = /^-ms-/,
          K = /-([a-z])/g;

      function X(e, t) {
        return t.toUpperCase();
      }

      function G(e) {
        return e.replace(U, "ms-").replace(K, X);
      }

      var Y = function Y(e) {
        return 1 === e.nodeType || 9 === e.nodeType || !+e.nodeType;
      };

      function Z() {
        this.expando = C.expando + Z.uid++;
      }

      Z.uid = 1, Z.prototype = {
        cache: function cache(e) {
          var t = e[this.expando];
          return t || (t = {}, Y(e) && (e.nodeType ? e[this.expando] = t : Object.defineProperty(e, this.expando, {
            value: t,
            configurable: !0
          }))), t;
        },
        set: function set(e, t, n) {
          var r,
              i = this.cache(e);
          if ("string" == typeof t) i[G(t)] = n;else for (r in t) {
            i[G(r)] = t[r];
          }
          return i;
        },
        get: function get(e, t) {
          return void 0 === t ? this.cache(e) : e[this.expando] && e[this.expando][G(t)];
        },
        access: function access(e, t, n) {
          return void 0 === t || t && "string" == typeof t && void 0 === n ? this.get(e, t) : (this.set(e, t, n), void 0 !== n ? n : t);
        },
        remove: function remove(e, t) {
          var n,
              r = e[this.expando];

          if (void 0 !== r) {
            if (void 0 !== t) {
              n = (t = Array.isArray(t) ? t.map(G) : (t = G(t)) in r ? [t] : t.match(q) || []).length;

              for (; n--;) {
                delete r[t[n]];
              }
            }

            (void 0 === t || C.isEmptyObject(r)) && (e.nodeType ? e[this.expando] = void 0 : delete e[this.expando]);
          }
        },
        hasData: function hasData(e) {
          var t = e[this.expando];
          return void 0 !== t && !C.isEmptyObject(t);
        }
      };
      var Q = new Z(),
          J = new Z(),
          ee = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
          te = /[A-Z]/g;

      function ne(e, t, n) {
        var r;
        if (void 0 === n && 1 === e.nodeType) if (r = "data-" + t.replace(te, "-$&").toLowerCase(), "string" == typeof (n = e.getAttribute(r))) {
          try {
            n = function (e) {
              return "true" === e || "false" !== e && ("null" === e ? null : e === +e + "" ? +e : ee.test(e) ? JSON.parse(e) : e);
            }(n);
          } catch (e) {}

          J.set(e, t, n);
        } else n = void 0;
        return n;
      }

      C.extend({
        hasData: function hasData(e) {
          return J.hasData(e) || Q.hasData(e);
        },
        data: function data(e, t, n) {
          return J.access(e, t, n);
        },
        removeData: function removeData(e, t) {
          J.remove(e, t);
        },
        _data: function _data(e, t, n) {
          return Q.access(e, t, n);
        },
        _removeData: function _removeData(e, t) {
          Q.remove(e, t);
        }
      }), C.fn.extend({
        data: function data(e, t) {
          var n,
              r,
              i,
              o = this[0],
              a = o && o.attributes;

          if (void 0 === e) {
            if (this.length && (i = J.get(o), 1 === o.nodeType && !Q.get(o, "hasDataAttrs"))) {
              for (n = a.length; n--;) {
                a[n] && 0 === (r = a[n].name).indexOf("data-") && (r = G(r.slice(5)), ne(o, r, i[r]));
              }

              Q.set(o, "hasDataAttrs", !0);
            }

            return i;
          }

          return "object" == _typeof(e) ? this.each(function () {
            J.set(this, e);
          }) : V(this, function (t) {
            var n;
            if (o && void 0 === t) return void 0 !== (n = J.get(o, e)) || void 0 !== (n = ne(o, e)) ? n : void 0;
            this.each(function () {
              J.set(this, e, t);
            });
          }, null, t, arguments.length > 1, null, !0);
        },
        removeData: function removeData(e) {
          return this.each(function () {
            J.remove(this, e);
          });
        }
      }), C.extend({
        queue: function queue(e, t, n) {
          var r;
          if (e) return t = (t || "fx") + "queue", r = Q.get(e, t), n && (!r || Array.isArray(n) ? r = Q.access(e, t, C.makeArray(n)) : r.push(n)), r || [];
        },
        dequeue: function dequeue(e, t) {
          t = t || "fx";

          var n = C.queue(e, t),
              r = n.length,
              i = n.shift(),
              o = C._queueHooks(e, t);

          "inprogress" === i && (i = n.shift(), r--), i && ("fx" === t && n.unshift("inprogress"), delete o.stop, i.call(e, function () {
            C.dequeue(e, t);
          }, o)), !r && o && o.empty.fire();
        },
        _queueHooks: function _queueHooks(e, t) {
          var n = t + "queueHooks";
          return Q.get(e, n) || Q.access(e, n, {
            empty: C.Callbacks("once memory").add(function () {
              Q.remove(e, [t + "queue", n]);
            })
          });
        }
      }), C.fn.extend({
        queue: function queue(e, t) {
          var n = 2;
          return "string" != typeof e && (t = e, e = "fx", n--), arguments.length < n ? C.queue(this[0], e) : void 0 === t ? this : this.each(function () {
            var n = C.queue(this, e, t);
            C._queueHooks(this, e), "fx" === e && "inprogress" !== n[0] && C.dequeue(this, e);
          });
        },
        dequeue: function dequeue(e) {
          return this.each(function () {
            C.dequeue(this, e);
          });
        },
        clearQueue: function clearQueue(e) {
          return this.queue(e || "fx", []);
        },
        promise: function promise(e, t) {
          var n,
              r = 1,
              i = C.Deferred(),
              o = this,
              a = this.length,
              s = function s() {
            --r || i.resolveWith(o, [o]);
          };

          for ("string" != typeof e && (t = e, e = void 0), e = e || "fx"; a--;) {
            (n = Q.get(o[a], e + "queueHooks")) && n.empty && (r++, n.empty.add(s));
          }

          return s(), i.promise(t);
        }
      });

      var re = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source,
          ie = new RegExp("^(?:([+-])=|)(" + re + ")([a-z%]*)$", "i"),
          oe = ["Top", "Right", "Bottom", "Left"],
          ae = a.documentElement,
          se = function se(e) {
        return C.contains(e.ownerDocument, e);
      },
          ue = {
        composed: !0
      };

      ae.getRootNode && (se = function se(e) {
        return C.contains(e.ownerDocument, e) || e.getRootNode(ue) === e.ownerDocument;
      });

      var ce = function ce(e, t) {
        return "none" === (e = t || e).style.display || "" === e.style.display && se(e) && "none" === C.css(e, "display");
      },
          le = function le(e, t, n, r) {
        var i,
            o,
            a = {};

        for (o in t) {
          a[o] = e.style[o], e.style[o] = t[o];
        }

        for (o in i = n.apply(e, r || []), t) {
          e.style[o] = a[o];
        }

        return i;
      };

      function fe(e, t, n, r) {
        var i,
            o,
            a = 20,
            s = r ? function () {
          return r.cur();
        } : function () {
          return C.css(e, t, "");
        },
            u = s(),
            c = n && n[3] || (C.cssNumber[t] ? "" : "px"),
            l = e.nodeType && (C.cssNumber[t] || "px" !== c && +u) && ie.exec(C.css(e, t));

        if (l && l[3] !== c) {
          for (u /= 2, c = c || l[3], l = +u || 1; a--;) {
            C.style(e, t, l + c), (1 - o) * (1 - (o = s() / u || .5)) <= 0 && (a = 0), l /= o;
          }

          l *= 2, C.style(e, t, l + c), n = n || [];
        }

        return n && (l = +l || +u || 0, i = n[1] ? l + (n[1] + 1) * n[2] : +n[2], r && (r.unit = c, r.start = l, r.end = i)), i;
      }

      var de = {};

      function pe(e) {
        var t,
            n = e.ownerDocument,
            r = e.nodeName,
            i = de[r];
        return i || (t = n.body.appendChild(n.createElement(r)), i = C.css(t, "display"), t.parentNode.removeChild(t), "none" === i && (i = "block"), de[r] = i, i);
      }

      function he(e, t) {
        for (var n, r, i = [], o = 0, a = e.length; o < a; o++) {
          (r = e[o]).style && (n = r.style.display, t ? ("none" === n && (i[o] = Q.get(r, "display") || null, i[o] || (r.style.display = "")), "" === r.style.display && ce(r) && (i[o] = pe(r))) : "none" !== n && (i[o] = "none", Q.set(r, "display", n)));
        }

        for (o = 0; o < a; o++) {
          null != i[o] && (e[o].style.display = i[o]);
        }

        return e;
      }

      C.fn.extend({
        show: function show() {
          return he(this, !0);
        },
        hide: function hide() {
          return he(this);
        },
        toggle: function toggle(e) {
          return "boolean" == typeof e ? e ? this.show() : this.hide() : this.each(function () {
            ce(this) ? C(this).show() : C(this).hide();
          });
        }
      });
      var ve = /^(?:checkbox|radio)$/i,
          ge = /<([a-z][^\/\0>\x20\t\r\n\f]*)/i,
          me = /^$|^module$|\/(?:java|ecma)script/i,
          ye = {
        option: [1, "<select multiple='multiple'>", "</select>"],
        thead: [1, "<table>", "</table>"],
        col: [2, "<table><colgroup>", "</colgroup></table>"],
        tr: [2, "<table><tbody>", "</tbody></table>"],
        td: [3, "<table><tbody><tr>", "</tr></tbody></table>"],
        _default: [0, "", ""]
      };

      function be(e, t) {
        var n;
        return n = void 0 !== e.getElementsByTagName ? e.getElementsByTagName(t || "*") : void 0 !== e.querySelectorAll ? e.querySelectorAll(t || "*") : [], void 0 === t || t && j(e, t) ? C.merge([e], n) : n;
      }

      function we(e, t) {
        for (var n = 0, r = e.length; n < r; n++) {
          Q.set(e[n], "globalEval", !t || Q.get(t[n], "globalEval"));
        }
      }

      ye.optgroup = ye.option, ye.tbody = ye.tfoot = ye.colgroup = ye.caption = ye.thead, ye.th = ye.td;

      var _e,
          xe,
          Ce = /<|&#?\w+;/;

      function ke(e, t, n, r, i) {
        for (var o, a, s, u, c, l, f = t.createDocumentFragment(), d = [], p = 0, h = e.length; p < h; p++) {
          if ((o = e[p]) || 0 === o) if ("object" === x(o)) C.merge(d, o.nodeType ? [o] : o);else if (Ce.test(o)) {
            for (a = a || f.appendChild(t.createElement("div")), s = (ge.exec(o) || ["", ""])[1].toLowerCase(), u = ye[s] || ye._default, a.innerHTML = u[1] + C.htmlPrefilter(o) + u[2], l = u[0]; l--;) {
              a = a.lastChild;
            }

            C.merge(d, a.childNodes), (a = f.firstChild).textContent = "";
          } else d.push(t.createTextNode(o));
        }

        for (f.textContent = "", p = 0; o = d[p++];) {
          if (r && C.inArray(o, r) > -1) i && i.push(o);else if (c = se(o), a = be(f.appendChild(o), "script"), c && we(a), n) for (l = 0; o = a[l++];) {
            me.test(o.type || "") && n.push(o);
          }
        }

        return f;
      }

      _e = a.createDocumentFragment().appendChild(a.createElement("div")), (xe = a.createElement("input")).setAttribute("type", "radio"), xe.setAttribute("checked", "checked"), xe.setAttribute("name", "t"), _e.appendChild(xe), m.checkClone = _e.cloneNode(!0).cloneNode(!0).lastChild.checked, _e.innerHTML = "<textarea>x</textarea>", m.noCloneChecked = !!_e.cloneNode(!0).lastChild.defaultValue;
      var Te = /^key/,
          Se = /^(?:mouse|pointer|contextmenu|drag|drop)|click/,
          Ae = /^([^.]*)(?:\.(.+)|)/;

      function Ee() {
        return !0;
      }

      function Oe() {
        return !1;
      }

      function je(e, t) {
        return e === function () {
          try {
            return a.activeElement;
          } catch (e) {}
        }() == ("focus" === t);
      }

      function De(e, t, n, r, i, o) {
        var a, s;

        if ("object" == _typeof(t)) {
          for (s in "string" != typeof n && (r = r || n, n = void 0), t) {
            De(e, s, n, r, t[s], o);
          }

          return e;
        }

        if (null == r && null == i ? (i = n, r = n = void 0) : null == i && ("string" == typeof n ? (i = r, r = void 0) : (i = r, r = n, n = void 0)), !1 === i) i = Oe;else if (!i) return e;
        return 1 === o && (a = i, (i = function i(e) {
          return C().off(e), a.apply(this, arguments);
        }).guid = a.guid || (a.guid = C.guid++)), e.each(function () {
          C.event.add(this, t, i, r, n);
        });
      }

      function Le(e, t, n) {
        n ? (Q.set(e, t, !1), C.event.add(e, t, {
          namespace: !1,
          handler: function handler(e) {
            var r,
                i,
                o = Q.get(this, t);

            if (1 & e.isTrigger && this[t]) {
              if (o.length) (C.event.special[t] || {}).delegateType && e.stopPropagation();else if (o = u.call(arguments), Q.set(this, t, o), r = n(this, t), this[t](), o !== (i = Q.get(this, t)) || r ? Q.set(this, t, !1) : i = {}, o !== i) return e.stopImmediatePropagation(), e.preventDefault(), i.value;
            } else o.length && (Q.set(this, t, {
              value: C.event.trigger(C.extend(o[0], C.Event.prototype), o.slice(1), this)
            }), e.stopImmediatePropagation());
          }
        })) : void 0 === Q.get(e, t) && C.event.add(e, t, Ee);
      }

      C.event = {
        global: {},
        add: function add(e, t, n, r, i) {
          var o,
              a,
              s,
              u,
              c,
              l,
              f,
              d,
              p,
              h,
              v,
              g = Q.get(e);
          if (g) for (n.handler && (n = (o = n).handler, i = o.selector), i && C.find.matchesSelector(ae, i), n.guid || (n.guid = C.guid++), (u = g.events) || (u = g.events = {}), (a = g.handle) || (a = g.handle = function (t) {
            return void 0 !== C && C.event.triggered !== t.type ? C.event.dispatch.apply(e, arguments) : void 0;
          }), c = (t = (t || "").match(q) || [""]).length; c--;) {
            p = v = (s = Ae.exec(t[c]) || [])[1], h = (s[2] || "").split(".").sort(), p && (f = C.event.special[p] || {}, p = (i ? f.delegateType : f.bindType) || p, f = C.event.special[p] || {}, l = C.extend({
              type: p,
              origType: v,
              data: r,
              handler: n,
              guid: n.guid,
              selector: i,
              needsContext: i && C.expr.match.needsContext.test(i),
              namespace: h.join(".")
            }, o), (d = u[p]) || ((d = u[p] = []).delegateCount = 0, f.setup && !1 !== f.setup.call(e, r, h, a) || e.addEventListener && e.addEventListener(p, a)), f.add && (f.add.call(e, l), l.handler.guid || (l.handler.guid = n.guid)), i ? d.splice(d.delegateCount++, 0, l) : d.push(l), C.event.global[p] = !0);
          }
        },
        remove: function remove(e, t, n, r, i) {
          var o,
              a,
              s,
              u,
              c,
              l,
              f,
              d,
              p,
              h,
              v,
              g = Q.hasData(e) && Q.get(e);

          if (g && (u = g.events)) {
            for (c = (t = (t || "").match(q) || [""]).length; c--;) {
              if (p = v = (s = Ae.exec(t[c]) || [])[1], h = (s[2] || "").split(".").sort(), p) {
                for (f = C.event.special[p] || {}, d = u[p = (r ? f.delegateType : f.bindType) || p] || [], s = s[2] && new RegExp("(^|\\.)" + h.join("\\.(?:.*\\.|)") + "(\\.|$)"), a = o = d.length; o--;) {
                  l = d[o], !i && v !== l.origType || n && n.guid !== l.guid || s && !s.test(l.namespace) || r && r !== l.selector && ("**" !== r || !l.selector) || (d.splice(o, 1), l.selector && d.delegateCount--, f.remove && f.remove.call(e, l));
                }

                a && !d.length && (f.teardown && !1 !== f.teardown.call(e, h, g.handle) || C.removeEvent(e, p, g.handle), delete u[p]);
              } else for (p in u) {
                C.event.remove(e, p + t[c], n, r, !0);
              }
            }

            C.isEmptyObject(u) && Q.remove(e, "handle events");
          }
        },
        dispatch: function dispatch(e) {
          var t,
              n,
              r,
              i,
              o,
              a,
              s = C.event.fix(e),
              u = new Array(arguments.length),
              c = (Q.get(this, "events") || {})[s.type] || [],
              l = C.event.special[s.type] || {};

          for (u[0] = s, t = 1; t < arguments.length; t++) {
            u[t] = arguments[t];
          }

          if (s.delegateTarget = this, !l.preDispatch || !1 !== l.preDispatch.call(this, s)) {
            for (a = C.event.handlers.call(this, s, c), t = 0; (i = a[t++]) && !s.isPropagationStopped();) {
              for (s.currentTarget = i.elem, n = 0; (o = i.handlers[n++]) && !s.isImmediatePropagationStopped();) {
                s.rnamespace && !1 !== o.namespace && !s.rnamespace.test(o.namespace) || (s.handleObj = o, s.data = o.data, void 0 !== (r = ((C.event.special[o.origType] || {}).handle || o.handler).apply(i.elem, u)) && !1 === (s.result = r) && (s.preventDefault(), s.stopPropagation()));
              }
            }

            return l.postDispatch && l.postDispatch.call(this, s), s.result;
          }
        },
        handlers: function handlers(e, t) {
          var n,
              r,
              i,
              o,
              a,
              s = [],
              u = t.delegateCount,
              c = e.target;
          if (u && c.nodeType && !("click" === e.type && e.button >= 1)) for (; c !== this; c = c.parentNode || this) {
            if (1 === c.nodeType && ("click" !== e.type || !0 !== c.disabled)) {
              for (o = [], a = {}, n = 0; n < u; n++) {
                void 0 === a[i = (r = t[n]).selector + " "] && (a[i] = r.needsContext ? C(i, this).index(c) > -1 : C.find(i, this, null, [c]).length), a[i] && o.push(r);
              }

              o.length && s.push({
                elem: c,
                handlers: o
              });
            }
          }
          return c = this, u < t.length && s.push({
            elem: c,
            handlers: t.slice(u)
          }), s;
        },
        addProp: function addProp(e, t) {
          Object.defineProperty(C.Event.prototype, e, {
            enumerable: !0,
            configurable: !0,
            get: y(t) ? function () {
              if (this.originalEvent) return t(this.originalEvent);
            } : function () {
              if (this.originalEvent) return this.originalEvent[e];
            },
            set: function set(t) {
              Object.defineProperty(this, e, {
                enumerable: !0,
                configurable: !0,
                writable: !0,
                value: t
              });
            }
          });
        },
        fix: function fix(e) {
          return e[C.expando] ? e : new C.Event(e);
        },
        special: {
          load: {
            noBubble: !0
          },
          click: {
            setup: function setup(e) {
              var t = this || e;
              return ve.test(t.type) && t.click && j(t, "input") && Le(t, "click", Ee), !1;
            },
            trigger: function trigger(e) {
              var t = this || e;
              return ve.test(t.type) && t.click && j(t, "input") && Le(t, "click"), !0;
            },
            _default: function _default(e) {
              var t = e.target;
              return ve.test(t.type) && t.click && j(t, "input") && Q.get(t, "click") || j(t, "a");
            }
          },
          beforeunload: {
            postDispatch: function postDispatch(e) {
              void 0 !== e.result && e.originalEvent && (e.originalEvent.returnValue = e.result);
            }
          }
        }
      }, C.removeEvent = function (e, t, n) {
        e.removeEventListener && e.removeEventListener(t, n);
      }, C.Event = function (e, t) {
        if (!(this instanceof C.Event)) return new C.Event(e, t);
        e && e.type ? (this.originalEvent = e, this.type = e.type, this.isDefaultPrevented = e.defaultPrevented || void 0 === e.defaultPrevented && !1 === e.returnValue ? Ee : Oe, this.target = e.target && 3 === e.target.nodeType ? e.target.parentNode : e.target, this.currentTarget = e.currentTarget, this.relatedTarget = e.relatedTarget) : this.type = e, t && C.extend(this, t), this.timeStamp = e && e.timeStamp || Date.now(), this[C.expando] = !0;
      }, C.Event.prototype = {
        constructor: C.Event,
        isDefaultPrevented: Oe,
        isPropagationStopped: Oe,
        isImmediatePropagationStopped: Oe,
        isSimulated: !1,
        preventDefault: function preventDefault() {
          var e = this.originalEvent;
          this.isDefaultPrevented = Ee, e && !this.isSimulated && e.preventDefault();
        },
        stopPropagation: function stopPropagation() {
          var e = this.originalEvent;
          this.isPropagationStopped = Ee, e && !this.isSimulated && e.stopPropagation();
        },
        stopImmediatePropagation: function stopImmediatePropagation() {
          var e = this.originalEvent;
          this.isImmediatePropagationStopped = Ee, e && !this.isSimulated && e.stopImmediatePropagation(), this.stopPropagation();
        }
      }, C.each({
        altKey: !0,
        bubbles: !0,
        cancelable: !0,
        changedTouches: !0,
        ctrlKey: !0,
        detail: !0,
        eventPhase: !0,
        metaKey: !0,
        pageX: !0,
        pageY: !0,
        shiftKey: !0,
        view: !0,
        "char": !0,
        code: !0,
        charCode: !0,
        key: !0,
        keyCode: !0,
        button: !0,
        buttons: !0,
        clientX: !0,
        clientY: !0,
        offsetX: !0,
        offsetY: !0,
        pointerId: !0,
        pointerType: !0,
        screenX: !0,
        screenY: !0,
        targetTouches: !0,
        toElement: !0,
        touches: !0,
        which: function which(e) {
          var t = e.button;
          return null == e.which && Te.test(e.type) ? null != e.charCode ? e.charCode : e.keyCode : !e.which && void 0 !== t && Se.test(e.type) ? 1 & t ? 1 : 2 & t ? 3 : 4 & t ? 2 : 0 : e.which;
        }
      }, C.event.addProp), C.each({
        focus: "focusin",
        blur: "focusout"
      }, function (e, t) {
        C.event.special[e] = {
          setup: function setup() {
            return Le(this, e, je), !1;
          },
          trigger: function trigger() {
            return Le(this, e), !0;
          },
          delegateType: t
        };
      }), C.each({
        mouseenter: "mouseover",
        mouseleave: "mouseout",
        pointerenter: "pointerover",
        pointerleave: "pointerout"
      }, function (e, t) {
        C.event.special[e] = {
          delegateType: t,
          bindType: t,
          handle: function handle(e) {
            var n,
                r = this,
                i = e.relatedTarget,
                o = e.handleObj;
            return i && (i === r || C.contains(r, i)) || (e.type = o.origType, n = o.handler.apply(this, arguments), e.type = t), n;
          }
        };
      }), C.fn.extend({
        on: function on(e, t, n, r) {
          return De(this, e, t, n, r);
        },
        one: function one(e, t, n, r) {
          return De(this, e, t, n, r, 1);
        },
        off: function off(e, t, n) {
          var r, i;
          if (e && e.preventDefault && e.handleObj) return r = e.handleObj, C(e.delegateTarget).off(r.namespace ? r.origType + "." + r.namespace : r.origType, r.selector, r.handler), this;

          if ("object" == _typeof(e)) {
            for (i in e) {
              this.off(i, t, e[i]);
            }

            return this;
          }

          return !1 !== t && "function" != typeof t || (n = t, t = void 0), !1 === n && (n = Oe), this.each(function () {
            C.event.remove(this, e, n, t);
          });
        }
      });
      var Pe = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([a-z][^\/\0>\x20\t\r\n\f]*)[^>]*)\/>/gi,
          Ne = /<script|<style|<link/i,
          Ie = /checked\s*(?:[^=]|=\s*.checked.)/i,
          Me = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;

      function Re(e, t) {
        return j(e, "table") && j(11 !== t.nodeType ? t : t.firstChild, "tr") && C(e).children("tbody")[0] || e;
      }

      function qe(e) {
        return e.type = (null !== e.getAttribute("type")) + "/" + e.type, e;
      }

      function Fe(e) {
        return "true/" === (e.type || "").slice(0, 5) ? e.type = e.type.slice(5) : e.removeAttribute("type"), e;
      }

      function Be(e, t) {
        var n, r, i, o, a, s, u, c;

        if (1 === t.nodeType) {
          if (Q.hasData(e) && (o = Q.access(e), a = Q.set(t, o), c = o.events)) for (i in delete a.handle, a.events = {}, c) {
            for (n = 0, r = c[i].length; n < r; n++) {
              C.event.add(t, i, c[i][n]);
            }
          }
          J.hasData(e) && (s = J.access(e), u = C.extend({}, s), J.set(t, u));
        }
      }

      function ze(e, t) {
        var n = t.nodeName.toLowerCase();
        "input" === n && ve.test(e.type) ? t.checked = e.checked : "input" !== n && "textarea" !== n || (t.defaultValue = e.defaultValue);
      }

      function He(e, t, n, r) {
        t = c.apply([], t);
        var i,
            o,
            a,
            s,
            u,
            l,
            f = 0,
            d = e.length,
            p = d - 1,
            h = t[0],
            v = y(h);
        if (v || d > 1 && "string" == typeof h && !m.checkClone && Ie.test(h)) return e.each(function (i) {
          var o = e.eq(i);
          v && (t[0] = h.call(this, i, o.html())), He(o, t, n, r);
        });

        if (d && (o = (i = ke(t, e[0].ownerDocument, !1, e, r)).firstChild, 1 === i.childNodes.length && (i = o), o || r)) {
          for (s = (a = C.map(be(i, "script"), qe)).length; f < d; f++) {
            u = i, f !== p && (u = C.clone(u, !0, !0), s && C.merge(a, be(u, "script"))), n.call(e[f], u, f);
          }

          if (s) for (l = a[a.length - 1].ownerDocument, C.map(a, Fe), f = 0; f < s; f++) {
            u = a[f], me.test(u.type || "") && !Q.access(u, "globalEval") && C.contains(l, u) && (u.src && "module" !== (u.type || "").toLowerCase() ? C._evalUrl && !u.noModule && C._evalUrl(u.src, {
              nonce: u.nonce || u.getAttribute("nonce")
            }) : _(u.textContent.replace(Me, ""), u, l));
          }
        }

        return e;
      }

      function We(e, t, n) {
        for (var r, i = t ? C.filter(t, e) : e, o = 0; null != (r = i[o]); o++) {
          n || 1 !== r.nodeType || C.cleanData(be(r)), r.parentNode && (n && se(r) && we(be(r, "script")), r.parentNode.removeChild(r));
        }

        return e;
      }

      C.extend({
        htmlPrefilter: function htmlPrefilter(e) {
          return e.replace(Pe, "<$1></$2>");
        },
        clone: function clone(e, t, n) {
          var r,
              i,
              o,
              a,
              s = e.cloneNode(!0),
              u = se(e);
          if (!(m.noCloneChecked || 1 !== e.nodeType && 11 !== e.nodeType || C.isXMLDoc(e))) for (a = be(s), r = 0, i = (o = be(e)).length; r < i; r++) {
            ze(o[r], a[r]);
          }
          if (t) if (n) for (o = o || be(e), a = a || be(s), r = 0, i = o.length; r < i; r++) {
            Be(o[r], a[r]);
          } else Be(e, s);
          return (a = be(s, "script")).length > 0 && we(a, !u && be(e, "script")), s;
        },
        cleanData: function cleanData(e) {
          for (var t, n, r, i = C.event.special, o = 0; void 0 !== (n = e[o]); o++) {
            if (Y(n)) {
              if (t = n[Q.expando]) {
                if (t.events) for (r in t.events) {
                  i[r] ? C.event.remove(n, r) : C.removeEvent(n, r, t.handle);
                }
                n[Q.expando] = void 0;
              }

              n[J.expando] && (n[J.expando] = void 0);
            }
          }
        }
      }), C.fn.extend({
        detach: function detach(e) {
          return We(this, e, !0);
        },
        remove: function remove(e) {
          return We(this, e);
        },
        text: function text(e) {
          return V(this, function (e) {
            return void 0 === e ? C.text(this) : this.empty().each(function () {
              1 !== this.nodeType && 11 !== this.nodeType && 9 !== this.nodeType || (this.textContent = e);
            });
          }, null, e, arguments.length);
        },
        append: function append() {
          return He(this, arguments, function (e) {
            1 !== this.nodeType && 11 !== this.nodeType && 9 !== this.nodeType || Re(this, e).appendChild(e);
          });
        },
        prepend: function prepend() {
          return He(this, arguments, function (e) {
            if (1 === this.nodeType || 11 === this.nodeType || 9 === this.nodeType) {
              var t = Re(this, e);
              t.insertBefore(e, t.firstChild);
            }
          });
        },
        before: function before() {
          return He(this, arguments, function (e) {
            this.parentNode && this.parentNode.insertBefore(e, this);
          });
        },
        after: function after() {
          return He(this, arguments, function (e) {
            this.parentNode && this.parentNode.insertBefore(e, this.nextSibling);
          });
        },
        empty: function empty() {
          for (var e, t = 0; null != (e = this[t]); t++) {
            1 === e.nodeType && (C.cleanData(be(e, !1)), e.textContent = "");
          }

          return this;
        },
        clone: function clone(e, t) {
          return e = null != e && e, t = null == t ? e : t, this.map(function () {
            return C.clone(this, e, t);
          });
        },
        html: function html(e) {
          return V(this, function (e) {
            var t = this[0] || {},
                n = 0,
                r = this.length;
            if (void 0 === e && 1 === t.nodeType) return t.innerHTML;

            if ("string" == typeof e && !Ne.test(e) && !ye[(ge.exec(e) || ["", ""])[1].toLowerCase()]) {
              e = C.htmlPrefilter(e);

              try {
                for (; n < r; n++) {
                  1 === (t = this[n] || {}).nodeType && (C.cleanData(be(t, !1)), t.innerHTML = e);
                }

                t = 0;
              } catch (e) {}
            }

            t && this.empty().append(e);
          }, null, e, arguments.length);
        },
        replaceWith: function replaceWith() {
          var e = [];
          return He(this, arguments, function (t) {
            var n = this.parentNode;
            C.inArray(this, e) < 0 && (C.cleanData(be(this)), n && n.replaceChild(t, this));
          }, e);
        }
      }), C.each({
        appendTo: "append",
        prependTo: "prepend",
        insertBefore: "before",
        insertAfter: "after",
        replaceAll: "replaceWith"
      }, function (e, t) {
        C.fn[e] = function (e) {
          for (var n, r = [], i = C(e), o = i.length - 1, a = 0; a <= o; a++) {
            n = a === o ? this : this.clone(!0), C(i[a])[t](n), l.apply(r, n.get());
          }

          return this.pushStack(r);
        };
      });

      var $e = new RegExp("^(" + re + ")(?!px)[a-z%]+$", "i"),
          Ve = function Ve(e) {
        var t = e.ownerDocument.defaultView;
        return t && t.opener || (t = n), t.getComputedStyle(e);
      },
          Ue = new RegExp(oe.join("|"), "i");

      function Ke(e, t, n) {
        var r,
            i,
            o,
            a,
            s = e.style;
        return (n = n || Ve(e)) && ("" !== (a = n.getPropertyValue(t) || n[t]) || se(e) || (a = C.style(e, t)), !m.pixelBoxStyles() && $e.test(a) && Ue.test(t) && (r = s.width, i = s.minWidth, o = s.maxWidth, s.minWidth = s.maxWidth = s.width = a, a = n.width, s.width = r, s.minWidth = i, s.maxWidth = o)), void 0 !== a ? a + "" : a;
      }

      function Xe(e, t) {
        return {
          get: function get() {
            if (!e()) return (this.get = t).apply(this, arguments);
            delete this.get;
          }
        };
      }

      !function () {
        function e() {
          if (l) {
            c.style.cssText = "position:absolute;left:-11111px;width:60px;margin-top:1px;padding:0;border:0", l.style.cssText = "position:relative;display:block;box-sizing:border-box;overflow:scroll;margin:auto;border:1px;padding:1px;width:60%;top:1%", ae.appendChild(c).appendChild(l);
            var e = n.getComputedStyle(l);
            r = "1%" !== e.top, u = 12 === t(e.marginLeft), l.style.right = "60%", s = 36 === t(e.right), i = 36 === t(e.width), l.style.position = "absolute", o = 12 === t(l.offsetWidth / 3), ae.removeChild(c), l = null;
          }
        }

        function t(e) {
          return Math.round(parseFloat(e));
        }

        var r,
            i,
            o,
            s,
            u,
            c = a.createElement("div"),
            l = a.createElement("div");
        l.style && (l.style.backgroundClip = "content-box", l.cloneNode(!0).style.backgroundClip = "", m.clearCloneStyle = "content-box" === l.style.backgroundClip, C.extend(m, {
          boxSizingReliable: function boxSizingReliable() {
            return e(), i;
          },
          pixelBoxStyles: function pixelBoxStyles() {
            return e(), s;
          },
          pixelPosition: function pixelPosition() {
            return e(), r;
          },
          reliableMarginLeft: function reliableMarginLeft() {
            return e(), u;
          },
          scrollboxSize: function scrollboxSize() {
            return e(), o;
          }
        }));
      }();
      var Ge = ["Webkit", "Moz", "ms"],
          Ye = a.createElement("div").style,
          Ze = {};

      function Qe(e) {
        var t = C.cssProps[e] || Ze[e];
        return t || (e in Ye ? e : Ze[e] = function (e) {
          for (var t = e[0].toUpperCase() + e.slice(1), n = Ge.length; n--;) {
            if ((e = Ge[n] + t) in Ye) return e;
          }
        }(e) || e);
      }

      var Je = /^(none|table(?!-c[ea]).+)/,
          et = /^--/,
          tt = {
        position: "absolute",
        visibility: "hidden",
        display: "block"
      },
          nt = {
        letterSpacing: "0",
        fontWeight: "400"
      };

      function rt(e, t, n) {
        var r = ie.exec(t);
        return r ? Math.max(0, r[2] - (n || 0)) + (r[3] || "px") : t;
      }

      function it(e, t, n, r, i, o) {
        var a = "width" === t ? 1 : 0,
            s = 0,
            u = 0;
        if (n === (r ? "border" : "content")) return 0;

        for (; a < 4; a += 2) {
          "margin" === n && (u += C.css(e, n + oe[a], !0, i)), r ? ("content" === n && (u -= C.css(e, "padding" + oe[a], !0, i)), "margin" !== n && (u -= C.css(e, "border" + oe[a] + "Width", !0, i))) : (u += C.css(e, "padding" + oe[a], !0, i), "padding" !== n ? u += C.css(e, "border" + oe[a] + "Width", !0, i) : s += C.css(e, "border" + oe[a] + "Width", !0, i));
        }

        return !r && o >= 0 && (u += Math.max(0, Math.ceil(e["offset" + t[0].toUpperCase() + t.slice(1)] - o - u - s - .5)) || 0), u;
      }

      function ot(e, t, n) {
        var r = Ve(e),
            i = (!m.boxSizingReliable() || n) && "border-box" === C.css(e, "boxSizing", !1, r),
            o = i,
            a = Ke(e, t, r),
            s = "offset" + t[0].toUpperCase() + t.slice(1);

        if ($e.test(a)) {
          if (!n) return a;
          a = "auto";
        }

        return (!m.boxSizingReliable() && i || "auto" === a || !parseFloat(a) && "inline" === C.css(e, "display", !1, r)) && e.getClientRects().length && (i = "border-box" === C.css(e, "boxSizing", !1, r), (o = s in e) && (a = e[s])), (a = parseFloat(a) || 0) + it(e, t, n || (i ? "border" : "content"), o, r, a) + "px";
      }

      function at(e, t, n, r, i) {
        return new at.prototype.init(e, t, n, r, i);
      }

      C.extend({
        cssHooks: {
          opacity: {
            get: function get(e, t) {
              if (t) {
                var n = Ke(e, "opacity");
                return "" === n ? "1" : n;
              }
            }
          }
        },
        cssNumber: {
          animationIterationCount: !0,
          columnCount: !0,
          fillOpacity: !0,
          flexGrow: !0,
          flexShrink: !0,
          fontWeight: !0,
          gridArea: !0,
          gridColumn: !0,
          gridColumnEnd: !0,
          gridColumnStart: !0,
          gridRow: !0,
          gridRowEnd: !0,
          gridRowStart: !0,
          lineHeight: !0,
          opacity: !0,
          order: !0,
          orphans: !0,
          widows: !0,
          zIndex: !0,
          zoom: !0
        },
        cssProps: {},
        style: function style(e, t, n, r) {
          if (e && 3 !== e.nodeType && 8 !== e.nodeType && e.style) {
            var i,
                o,
                a,
                s = G(t),
                u = et.test(t),
                c = e.style;
            if (u || (t = Qe(s)), a = C.cssHooks[t] || C.cssHooks[s], void 0 === n) return a && "get" in a && void 0 !== (i = a.get(e, !1, r)) ? i : c[t];
            "string" === (o = _typeof(n)) && (i = ie.exec(n)) && i[1] && (n = fe(e, t, i), o = "number"), null != n && n == n && ("number" !== o || u || (n += i && i[3] || (C.cssNumber[s] ? "" : "px")), m.clearCloneStyle || "" !== n || 0 !== t.indexOf("background") || (c[t] = "inherit"), a && "set" in a && void 0 === (n = a.set(e, n, r)) || (u ? c.setProperty(t, n) : c[t] = n));
          }
        },
        css: function css(e, t, n, r) {
          var i,
              o,
              a,
              s = G(t);
          return et.test(t) || (t = Qe(s)), (a = C.cssHooks[t] || C.cssHooks[s]) && "get" in a && (i = a.get(e, !0, n)), void 0 === i && (i = Ke(e, t, r)), "normal" === i && t in nt && (i = nt[t]), "" === n || n ? (o = parseFloat(i), !0 === n || isFinite(o) ? o || 0 : i) : i;
        }
      }), C.each(["height", "width"], function (e, t) {
        C.cssHooks[t] = {
          get: function get(e, n, r) {
            if (n) return !Je.test(C.css(e, "display")) || e.getClientRects().length && e.getBoundingClientRect().width ? ot(e, t, r) : le(e, tt, function () {
              return ot(e, t, r);
            });
          },
          set: function set(e, n, r) {
            var i,
                o = Ve(e),
                a = !m.scrollboxSize() && "absolute" === o.position,
                s = (a || r) && "border-box" === C.css(e, "boxSizing", !1, o),
                u = r ? it(e, t, r, s, o) : 0;
            return s && a && (u -= Math.ceil(e["offset" + t[0].toUpperCase() + t.slice(1)] - parseFloat(o[t]) - it(e, t, "border", !1, o) - .5)), u && (i = ie.exec(n)) && "px" !== (i[3] || "px") && (e.style[t] = n, n = C.css(e, t)), rt(0, n, u);
          }
        };
      }), C.cssHooks.marginLeft = Xe(m.reliableMarginLeft, function (e, t) {
        if (t) return (parseFloat(Ke(e, "marginLeft")) || e.getBoundingClientRect().left - le(e, {
          marginLeft: 0
        }, function () {
          return e.getBoundingClientRect().left;
        })) + "px";
      }), C.each({
        margin: "",
        padding: "",
        border: "Width"
      }, function (e, t) {
        C.cssHooks[e + t] = {
          expand: function expand(n) {
            for (var r = 0, i = {}, o = "string" == typeof n ? n.split(" ") : [n]; r < 4; r++) {
              i[e + oe[r] + t] = o[r] || o[r - 2] || o[0];
            }

            return i;
          }
        }, "margin" !== e && (C.cssHooks[e + t].set = rt);
      }), C.fn.extend({
        css: function css(e, t) {
          return V(this, function (e, t, n) {
            var r,
                i,
                o = {},
                a = 0;

            if (Array.isArray(t)) {
              for (r = Ve(e), i = t.length; a < i; a++) {
                o[t[a]] = C.css(e, t[a], !1, r);
              }

              return o;
            }

            return void 0 !== n ? C.style(e, t, n) : C.css(e, t);
          }, e, t, arguments.length > 1);
        }
      }), C.Tween = at, at.prototype = {
        constructor: at,
        init: function init(e, t, n, r, i, o) {
          this.elem = e, this.prop = n, this.easing = i || C.easing._default, this.options = t, this.start = this.now = this.cur(), this.end = r, this.unit = o || (C.cssNumber[n] ? "" : "px");
        },
        cur: function cur() {
          var e = at.propHooks[this.prop];
          return e && e.get ? e.get(this) : at.propHooks._default.get(this);
        },
        run: function run(e) {
          var t,
              n = at.propHooks[this.prop];
          return this.options.duration ? this.pos = t = C.easing[this.easing](e, this.options.duration * e, 0, 1, this.options.duration) : this.pos = t = e, this.now = (this.end - this.start) * t + this.start, this.options.step && this.options.step.call(this.elem, this.now, this), n && n.set ? n.set(this) : at.propHooks._default.set(this), this;
        }
      }, at.prototype.init.prototype = at.prototype, at.propHooks = {
        _default: {
          get: function get(e) {
            var t;
            return 1 !== e.elem.nodeType || null != e.elem[e.prop] && null == e.elem.style[e.prop] ? e.elem[e.prop] : (t = C.css(e.elem, e.prop, "")) && "auto" !== t ? t : 0;
          },
          set: function set(e) {
            C.fx.step[e.prop] ? C.fx.step[e.prop](e) : 1 !== e.elem.nodeType || !C.cssHooks[e.prop] && null == e.elem.style[Qe(e.prop)] ? e.elem[e.prop] = e.now : C.style(e.elem, e.prop, e.now + e.unit);
          }
        }
      }, at.propHooks.scrollTop = at.propHooks.scrollLeft = {
        set: function set(e) {
          e.elem.nodeType && e.elem.parentNode && (e.elem[e.prop] = e.now);
        }
      }, C.easing = {
        linear: function linear(e) {
          return e;
        },
        swing: function swing(e) {
          return .5 - Math.cos(e * Math.PI) / 2;
        },
        _default: "swing"
      }, C.fx = at.prototype.init, C.fx.step = {};
      var st,
          ut,
          ct = /^(?:toggle|show|hide)$/,
          lt = /queueHooks$/;

      function ft() {
        ut && (!1 === a.hidden && n.requestAnimationFrame ? n.requestAnimationFrame(ft) : n.setTimeout(ft, C.fx.interval), C.fx.tick());
      }

      function dt() {
        return n.setTimeout(function () {
          st = void 0;
        }), st = Date.now();
      }

      function pt(e, t) {
        var n,
            r = 0,
            i = {
          height: e
        };

        for (t = t ? 1 : 0; r < 4; r += 2 - t) {
          i["margin" + (n = oe[r])] = i["padding" + n] = e;
        }

        return t && (i.opacity = i.width = e), i;
      }

      function ht(e, t, n) {
        for (var r, i = (vt.tweeners[t] || []).concat(vt.tweeners["*"]), o = 0, a = i.length; o < a; o++) {
          if (r = i[o].call(n, t, e)) return r;
        }
      }

      function vt(e, t, n) {
        var r,
            i,
            o = 0,
            a = vt.prefilters.length,
            s = C.Deferred().always(function () {
          delete u.elem;
        }),
            u = function u() {
          if (i) return !1;

          for (var t = st || dt(), n = Math.max(0, c.startTime + c.duration - t), r = 1 - (n / c.duration || 0), o = 0, a = c.tweens.length; o < a; o++) {
            c.tweens[o].run(r);
          }

          return s.notifyWith(e, [c, r, n]), r < 1 && a ? n : (a || s.notifyWith(e, [c, 1, 0]), s.resolveWith(e, [c]), !1);
        },
            c = s.promise({
          elem: e,
          props: C.extend({}, t),
          opts: C.extend(!0, {
            specialEasing: {},
            easing: C.easing._default
          }, n),
          originalProperties: t,
          originalOptions: n,
          startTime: st || dt(),
          duration: n.duration,
          tweens: [],
          createTween: function createTween(t, n) {
            var r = C.Tween(e, c.opts, t, n, c.opts.specialEasing[t] || c.opts.easing);
            return c.tweens.push(r), r;
          },
          stop: function stop(t) {
            var n = 0,
                r = t ? c.tweens.length : 0;
            if (i) return this;

            for (i = !0; n < r; n++) {
              c.tweens[n].run(1);
            }

            return t ? (s.notifyWith(e, [c, 1, 0]), s.resolveWith(e, [c, t])) : s.rejectWith(e, [c, t]), this;
          }
        }),
            l = c.props;

        for (!function (e, t) {
          var n, r, i, o, a;

          for (n in e) {
            if (i = t[r = G(n)], o = e[n], Array.isArray(o) && (i = o[1], o = e[n] = o[0]), n !== r && (e[r] = o, delete e[n]), (a = C.cssHooks[r]) && ("expand" in a)) for (n in o = a.expand(o), delete e[r], o) {
              (n in e) || (e[n] = o[n], t[n] = i);
            } else t[r] = i;
          }
        }(l, c.opts.specialEasing); o < a; o++) {
          if (r = vt.prefilters[o].call(c, e, l, c.opts)) return y(r.stop) && (C._queueHooks(c.elem, c.opts.queue).stop = r.stop.bind(r)), r;
        }

        return C.map(l, ht, c), y(c.opts.start) && c.opts.start.call(e, c), c.progress(c.opts.progress).done(c.opts.done, c.opts.complete).fail(c.opts.fail).always(c.opts.always), C.fx.timer(C.extend(u, {
          elem: e,
          anim: c,
          queue: c.opts.queue
        })), c;
      }

      C.Animation = C.extend(vt, {
        tweeners: {
          "*": [function (e, t) {
            var n = this.createTween(e, t);
            return fe(n.elem, e, ie.exec(t), n), n;
          }]
        },
        tweener: function tweener(e, t) {
          y(e) ? (t = e, e = ["*"]) : e = e.match(q);

          for (var n, r = 0, i = e.length; r < i; r++) {
            n = e[r], vt.tweeners[n] = vt.tweeners[n] || [], vt.tweeners[n].unshift(t);
          }
        },
        prefilters: [function (e, t, n) {
          var r,
              i,
              o,
              a,
              s,
              u,
              c,
              l,
              f = "width" in t || "height" in t,
              d = this,
              p = {},
              h = e.style,
              v = e.nodeType && ce(e),
              g = Q.get(e, "fxshow");

          for (r in n.queue || (null == (a = C._queueHooks(e, "fx")).unqueued && (a.unqueued = 0, s = a.empty.fire, a.empty.fire = function () {
            a.unqueued || s();
          }), a.unqueued++, d.always(function () {
            d.always(function () {
              a.unqueued--, C.queue(e, "fx").length || a.empty.fire();
            });
          })), t) {
            if (i = t[r], ct.test(i)) {
              if (delete t[r], o = o || "toggle" === i, i === (v ? "hide" : "show")) {
                if ("show" !== i || !g || void 0 === g[r]) continue;
                v = !0;
              }

              p[r] = g && g[r] || C.style(e, r);
            }
          }

          if ((u = !C.isEmptyObject(t)) || !C.isEmptyObject(p)) for (r in f && 1 === e.nodeType && (n.overflow = [h.overflow, h.overflowX, h.overflowY], null == (c = g && g.display) && (c = Q.get(e, "display")), "none" === (l = C.css(e, "display")) && (c ? l = c : (he([e], !0), c = e.style.display || c, l = C.css(e, "display"), he([e]))), ("inline" === l || "inline-block" === l && null != c) && "none" === C.css(e, "float") && (u || (d.done(function () {
            h.display = c;
          }), null == c && (l = h.display, c = "none" === l ? "" : l)), h.display = "inline-block")), n.overflow && (h.overflow = "hidden", d.always(function () {
            h.overflow = n.overflow[0], h.overflowX = n.overflow[1], h.overflowY = n.overflow[2];
          })), u = !1, p) {
            u || (g ? "hidden" in g && (v = g.hidden) : g = Q.access(e, "fxshow", {
              display: c
            }), o && (g.hidden = !v), v && he([e], !0), d.done(function () {
              for (r in v || he([e]), Q.remove(e, "fxshow"), p) {
                C.style(e, r, p[r]);
              }
            })), u = ht(v ? g[r] : 0, r, d), r in g || (g[r] = u.start, v && (u.end = u.start, u.start = 0));
          }
        }],
        prefilter: function prefilter(e, t) {
          t ? vt.prefilters.unshift(e) : vt.prefilters.push(e);
        }
      }), C.speed = function (e, t, n) {
        var r = e && "object" == _typeof(e) ? C.extend({}, e) : {
          complete: n || !n && t || y(e) && e,
          duration: e,
          easing: n && t || t && !y(t) && t
        };
        return C.fx.off ? r.duration = 0 : "number" != typeof r.duration && (r.duration in C.fx.speeds ? r.duration = C.fx.speeds[r.duration] : r.duration = C.fx.speeds._default), null != r.queue && !0 !== r.queue || (r.queue = "fx"), r.old = r.complete, r.complete = function () {
          y(r.old) && r.old.call(this), r.queue && C.dequeue(this, r.queue);
        }, r;
      }, C.fn.extend({
        fadeTo: function fadeTo(e, t, n, r) {
          return this.filter(ce).css("opacity", 0).show().end().animate({
            opacity: t
          }, e, n, r);
        },
        animate: function animate(e, t, n, r) {
          var i = C.isEmptyObject(e),
              o = C.speed(t, n, r),
              a = function a() {
            var t = vt(this, C.extend({}, e), o);
            (i || Q.get(this, "finish")) && t.stop(!0);
          };

          return a.finish = a, i || !1 === o.queue ? this.each(a) : this.queue(o.queue, a);
        },
        stop: function stop(e, t, n) {
          var r = function r(e) {
            var t = e.stop;
            delete e.stop, t(n);
          };

          return "string" != typeof e && (n = t, t = e, e = void 0), t && !1 !== e && this.queue(e || "fx", []), this.each(function () {
            var t = !0,
                i = null != e && e + "queueHooks",
                o = C.timers,
                a = Q.get(this);
            if (i) a[i] && a[i].stop && r(a[i]);else for (i in a) {
              a[i] && a[i].stop && lt.test(i) && r(a[i]);
            }

            for (i = o.length; i--;) {
              o[i].elem !== this || null != e && o[i].queue !== e || (o[i].anim.stop(n), t = !1, o.splice(i, 1));
            }

            !t && n || C.dequeue(this, e);
          });
        },
        finish: function finish(e) {
          return !1 !== e && (e = e || "fx"), this.each(function () {
            var t,
                n = Q.get(this),
                r = n[e + "queue"],
                i = n[e + "queueHooks"],
                o = C.timers,
                a = r ? r.length : 0;

            for (n.finish = !0, C.queue(this, e, []), i && i.stop && i.stop.call(this, !0), t = o.length; t--;) {
              o[t].elem === this && o[t].queue === e && (o[t].anim.stop(!0), o.splice(t, 1));
            }

            for (t = 0; t < a; t++) {
              r[t] && r[t].finish && r[t].finish.call(this);
            }

            delete n.finish;
          });
        }
      }), C.each(["toggle", "show", "hide"], function (e, t) {
        var n = C.fn[t];

        C.fn[t] = function (e, r, i) {
          return null == e || "boolean" == typeof e ? n.apply(this, arguments) : this.animate(pt(t, !0), e, r, i);
        };
      }), C.each({
        slideDown: pt("show"),
        slideUp: pt("hide"),
        slideToggle: pt("toggle"),
        fadeIn: {
          opacity: "show"
        },
        fadeOut: {
          opacity: "hide"
        },
        fadeToggle: {
          opacity: "toggle"
        }
      }, function (e, t) {
        C.fn[e] = function (e, n, r) {
          return this.animate(t, e, n, r);
        };
      }), C.timers = [], C.fx.tick = function () {
        var e,
            t = 0,
            n = C.timers;

        for (st = Date.now(); t < n.length; t++) {
          (e = n[t])() || n[t] !== e || n.splice(t--, 1);
        }

        n.length || C.fx.stop(), st = void 0;
      }, C.fx.timer = function (e) {
        C.timers.push(e), C.fx.start();
      }, C.fx.interval = 13, C.fx.start = function () {
        ut || (ut = !0, ft());
      }, C.fx.stop = function () {
        ut = null;
      }, C.fx.speeds = {
        slow: 600,
        fast: 200,
        _default: 400
      }, C.fn.delay = function (e, t) {
        return e = C.fx && C.fx.speeds[e] || e, t = t || "fx", this.queue(t, function (t, r) {
          var i = n.setTimeout(t, e);

          r.stop = function () {
            n.clearTimeout(i);
          };
        });
      }, function () {
        var e = a.createElement("input"),
            t = a.createElement("select").appendChild(a.createElement("option"));
        e.type = "checkbox", m.checkOn = "" !== e.value, m.optSelected = t.selected, (e = a.createElement("input")).value = "t", e.type = "radio", m.radioValue = "t" === e.value;
      }();
      var gt,
          mt = C.expr.attrHandle;
      C.fn.extend({
        attr: function attr(e, t) {
          return V(this, C.attr, e, t, arguments.length > 1);
        },
        removeAttr: function removeAttr(e) {
          return this.each(function () {
            C.removeAttr(this, e);
          });
        }
      }), C.extend({
        attr: function attr(e, t, n) {
          var r,
              i,
              o = e.nodeType;
          if (3 !== o && 8 !== o && 2 !== o) return void 0 === e.getAttribute ? C.prop(e, t, n) : (1 === o && C.isXMLDoc(e) || (i = C.attrHooks[t.toLowerCase()] || (C.expr.match.bool.test(t) ? gt : void 0)), void 0 !== n ? null === n ? void C.removeAttr(e, t) : i && "set" in i && void 0 !== (r = i.set(e, n, t)) ? r : (e.setAttribute(t, n + ""), n) : i && "get" in i && null !== (r = i.get(e, t)) ? r : null == (r = C.find.attr(e, t)) ? void 0 : r);
        },
        attrHooks: {
          type: {
            set: function set(e, t) {
              if (!m.radioValue && "radio" === t && j(e, "input")) {
                var n = e.value;
                return e.setAttribute("type", t), n && (e.value = n), t;
              }
            }
          }
        },
        removeAttr: function removeAttr(e, t) {
          var n,
              r = 0,
              i = t && t.match(q);
          if (i && 1 === e.nodeType) for (; n = i[r++];) {
            e.removeAttribute(n);
          }
        }
      }), gt = {
        set: function set(e, t, n) {
          return !1 === t ? C.removeAttr(e, n) : e.setAttribute(n, n), n;
        }
      }, C.each(C.expr.match.bool.source.match(/\w+/g), function (e, t) {
        var n = mt[t] || C.find.attr;

        mt[t] = function (e, t, r) {
          var i,
              o,
              a = t.toLowerCase();
          return r || (o = mt[a], mt[a] = i, i = null != n(e, t, r) ? a : null, mt[a] = o), i;
        };
      });
      var yt = /^(?:input|select|textarea|button)$/i,
          bt = /^(?:a|area)$/i;

      function wt(e) {
        return (e.match(q) || []).join(" ");
      }

      function _t(e) {
        return e.getAttribute && e.getAttribute("class") || "";
      }

      function xt(e) {
        return Array.isArray(e) ? e : "string" == typeof e && e.match(q) || [];
      }

      C.fn.extend({
        prop: function prop(e, t) {
          return V(this, C.prop, e, t, arguments.length > 1);
        },
        removeProp: function removeProp(e) {
          return this.each(function () {
            delete this[C.propFix[e] || e];
          });
        }
      }), C.extend({
        prop: function prop(e, t, n) {
          var r,
              i,
              o = e.nodeType;
          if (3 !== o && 8 !== o && 2 !== o) return 1 === o && C.isXMLDoc(e) || (t = C.propFix[t] || t, i = C.propHooks[t]), void 0 !== n ? i && "set" in i && void 0 !== (r = i.set(e, n, t)) ? r : e[t] = n : i && "get" in i && null !== (r = i.get(e, t)) ? r : e[t];
        },
        propHooks: {
          tabIndex: {
            get: function get(e) {
              var t = C.find.attr(e, "tabindex");
              return t ? parseInt(t, 10) : yt.test(e.nodeName) || bt.test(e.nodeName) && e.href ? 0 : -1;
            }
          }
        },
        propFix: {
          "for": "htmlFor",
          "class": "className"
        }
      }), m.optSelected || (C.propHooks.selected = {
        get: function get(e) {
          var t = e.parentNode;
          return t && t.parentNode && t.parentNode.selectedIndex, null;
        },
        set: function set(e) {
          var t = e.parentNode;
          t && (t.selectedIndex, t.parentNode && t.parentNode.selectedIndex);
        }
      }), C.each(["tabIndex", "readOnly", "maxLength", "cellSpacing", "cellPadding", "rowSpan", "colSpan", "useMap", "frameBorder", "contentEditable"], function () {
        C.propFix[this.toLowerCase()] = this;
      }), C.fn.extend({
        addClass: function addClass(e) {
          var t,
              n,
              r,
              i,
              o,
              a,
              s,
              u = 0;
          if (y(e)) return this.each(function (t) {
            C(this).addClass(e.call(this, t, _t(this)));
          });
          if ((t = xt(e)).length) for (; n = this[u++];) {
            if (i = _t(n), r = 1 === n.nodeType && " " + wt(i) + " ") {
              for (a = 0; o = t[a++];) {
                r.indexOf(" " + o + " ") < 0 && (r += o + " ");
              }

              i !== (s = wt(r)) && n.setAttribute("class", s);
            }
          }
          return this;
        },
        removeClass: function removeClass(e) {
          var t,
              n,
              r,
              i,
              o,
              a,
              s,
              u = 0;
          if (y(e)) return this.each(function (t) {
            C(this).removeClass(e.call(this, t, _t(this)));
          });
          if (!arguments.length) return this.attr("class", "");
          if ((t = xt(e)).length) for (; n = this[u++];) {
            if (i = _t(n), r = 1 === n.nodeType && " " + wt(i) + " ") {
              for (a = 0; o = t[a++];) {
                for (; r.indexOf(" " + o + " ") > -1;) {
                  r = r.replace(" " + o + " ", " ");
                }
              }

              i !== (s = wt(r)) && n.setAttribute("class", s);
            }
          }
          return this;
        },
        toggleClass: function toggleClass(e, t) {
          var n = _typeof(e),
              r = "string" === n || Array.isArray(e);

          return "boolean" == typeof t && r ? t ? this.addClass(e) : this.removeClass(e) : y(e) ? this.each(function (n) {
            C(this).toggleClass(e.call(this, n, _t(this), t), t);
          }) : this.each(function () {
            var t, i, o, a;
            if (r) for (i = 0, o = C(this), a = xt(e); t = a[i++];) {
              o.hasClass(t) ? o.removeClass(t) : o.addClass(t);
            } else void 0 !== e && "boolean" !== n || ((t = _t(this)) && Q.set(this, "__className__", t), this.setAttribute && this.setAttribute("class", t || !1 === e ? "" : Q.get(this, "__className__") || ""));
          });
        },
        hasClass: function hasClass(e) {
          var t,
              n,
              r = 0;

          for (t = " " + e + " "; n = this[r++];) {
            if (1 === n.nodeType && (" " + wt(_t(n)) + " ").indexOf(t) > -1) return !0;
          }

          return !1;
        }
      });
      var Ct = /\r/g;
      C.fn.extend({
        val: function val(e) {
          var t,
              n,
              r,
              i = this[0];
          return arguments.length ? (r = y(e), this.each(function (n) {
            var i;
            1 === this.nodeType && (null == (i = r ? e.call(this, n, C(this).val()) : e) ? i = "" : "number" == typeof i ? i += "" : Array.isArray(i) && (i = C.map(i, function (e) {
              return null == e ? "" : e + "";
            })), (t = C.valHooks[this.type] || C.valHooks[this.nodeName.toLowerCase()]) && "set" in t && void 0 !== t.set(this, i, "value") || (this.value = i));
          })) : i ? (t = C.valHooks[i.type] || C.valHooks[i.nodeName.toLowerCase()]) && "get" in t && void 0 !== (n = t.get(i, "value")) ? n : "string" == typeof (n = i.value) ? n.replace(Ct, "") : null == n ? "" : n : void 0;
        }
      }), C.extend({
        valHooks: {
          option: {
            get: function get(e) {
              var t = C.find.attr(e, "value");
              return null != t ? t : wt(C.text(e));
            }
          },
          select: {
            get: function get(e) {
              var t,
                  n,
                  r,
                  i = e.options,
                  o = e.selectedIndex,
                  a = "select-one" === e.type,
                  s = a ? null : [],
                  u = a ? o + 1 : i.length;

              for (r = o < 0 ? u : a ? o : 0; r < u; r++) {
                if (((n = i[r]).selected || r === o) && !n.disabled && (!n.parentNode.disabled || !j(n.parentNode, "optgroup"))) {
                  if (t = C(n).val(), a) return t;
                  s.push(t);
                }
              }

              return s;
            },
            set: function set(e, t) {
              for (var n, r, i = e.options, o = C.makeArray(t), a = i.length; a--;) {
                ((r = i[a]).selected = C.inArray(C.valHooks.option.get(r), o) > -1) && (n = !0);
              }

              return n || (e.selectedIndex = -1), o;
            }
          }
        }
      }), C.each(["radio", "checkbox"], function () {
        C.valHooks[this] = {
          set: function set(e, t) {
            if (Array.isArray(t)) return e.checked = C.inArray(C(e).val(), t) > -1;
          }
        }, m.checkOn || (C.valHooks[this].get = function (e) {
          return null === e.getAttribute("value") ? "on" : e.value;
        });
      }), m.focusin = "onfocusin" in n;

      var kt = /^(?:focusinfocus|focusoutblur)$/,
          Tt = function Tt(e) {
        e.stopPropagation();
      };

      C.extend(C.event, {
        trigger: function trigger(e, t, r, i) {
          var o,
              s,
              u,
              c,
              l,
              f,
              d,
              p,
              v = [r || a],
              g = h.call(e, "type") ? e.type : e,
              m = h.call(e, "namespace") ? e.namespace.split(".") : [];

          if (s = p = u = r = r || a, 3 !== r.nodeType && 8 !== r.nodeType && !kt.test(g + C.event.triggered) && (g.indexOf(".") > -1 && (m = g.split("."), g = m.shift(), m.sort()), l = g.indexOf(":") < 0 && "on" + g, (e = e[C.expando] ? e : new C.Event(g, "object" == _typeof(e) && e)).isTrigger = i ? 2 : 3, e.namespace = m.join("."), e.rnamespace = e.namespace ? new RegExp("(^|\\.)" + m.join("\\.(?:.*\\.|)") + "(\\.|$)") : null, e.result = void 0, e.target || (e.target = r), t = null == t ? [e] : C.makeArray(t, [e]), d = C.event.special[g] || {}, i || !d.trigger || !1 !== d.trigger.apply(r, t))) {
            if (!i && !d.noBubble && !b(r)) {
              for (c = d.delegateType || g, kt.test(c + g) || (s = s.parentNode); s; s = s.parentNode) {
                v.push(s), u = s;
              }

              u === (r.ownerDocument || a) && v.push(u.defaultView || u.parentWindow || n);
            }

            for (o = 0; (s = v[o++]) && !e.isPropagationStopped();) {
              p = s, e.type = o > 1 ? c : d.bindType || g, (f = (Q.get(s, "events") || {})[e.type] && Q.get(s, "handle")) && f.apply(s, t), (f = l && s[l]) && f.apply && Y(s) && (e.result = f.apply(s, t), !1 === e.result && e.preventDefault());
            }

            return e.type = g, i || e.isDefaultPrevented() || d._default && !1 !== d._default.apply(v.pop(), t) || !Y(r) || l && y(r[g]) && !b(r) && ((u = r[l]) && (r[l] = null), C.event.triggered = g, e.isPropagationStopped() && p.addEventListener(g, Tt), r[g](), e.isPropagationStopped() && p.removeEventListener(g, Tt), C.event.triggered = void 0, u && (r[l] = u)), e.result;
          }
        },
        simulate: function simulate(e, t, n) {
          var r = C.extend(new C.Event(), n, {
            type: e,
            isSimulated: !0
          });
          C.event.trigger(r, null, t);
        }
      }), C.fn.extend({
        trigger: function trigger(e, t) {
          return this.each(function () {
            C.event.trigger(e, t, this);
          });
        },
        triggerHandler: function triggerHandler(e, t) {
          var n = this[0];
          if (n) return C.event.trigger(e, t, n, !0);
        }
      }), m.focusin || C.each({
        focus: "focusin",
        blur: "focusout"
      }, function (e, t) {
        var n = function n(e) {
          C.event.simulate(t, e.target, C.event.fix(e));
        };

        C.event.special[t] = {
          setup: function setup() {
            var r = this.ownerDocument || this,
                i = Q.access(r, t);
            i || r.addEventListener(e, n, !0), Q.access(r, t, (i || 0) + 1);
          },
          teardown: function teardown() {
            var r = this.ownerDocument || this,
                i = Q.access(r, t) - 1;
            i ? Q.access(r, t, i) : (r.removeEventListener(e, n, !0), Q.remove(r, t));
          }
        };
      });
      var St = n.location,
          At = Date.now(),
          Et = /\?/;

      C.parseXML = function (e) {
        var t;
        if (!e || "string" != typeof e) return null;

        try {
          t = new n.DOMParser().parseFromString(e, "text/xml");
        } catch (e) {
          t = void 0;
        }

        return t && !t.getElementsByTagName("parsererror").length || C.error("Invalid XML: " + e), t;
      };

      var Ot = /\[\]$/,
          jt = /\r?\n/g,
          Dt = /^(?:submit|button|image|reset|file)$/i,
          Lt = /^(?:input|select|textarea|keygen)/i;

      function Pt(e, t, n, r) {
        var i;
        if (Array.isArray(t)) C.each(t, function (t, i) {
          n || Ot.test(e) ? r(e, i) : Pt(e + "[" + ("object" == _typeof(i) && null != i ? t : "") + "]", i, n, r);
        });else if (n || "object" !== x(t)) r(e, t);else for (i in t) {
          Pt(e + "[" + i + "]", t[i], n, r);
        }
      }

      C.param = function (e, t) {
        var n,
            r = [],
            i = function i(e, t) {
          var n = y(t) ? t() : t;
          r[r.length] = encodeURIComponent(e) + "=" + encodeURIComponent(null == n ? "" : n);
        };

        if (null == e) return "";
        if (Array.isArray(e) || e.jquery && !C.isPlainObject(e)) C.each(e, function () {
          i(this.name, this.value);
        });else for (n in e) {
          Pt(n, e[n], t, i);
        }
        return r.join("&");
      }, C.fn.extend({
        serialize: function serialize() {
          return C.param(this.serializeArray());
        },
        serializeArray: function serializeArray() {
          return this.map(function () {
            var e = C.prop(this, "elements");
            return e ? C.makeArray(e) : this;
          }).filter(function () {
            var e = this.type;
            return this.name && !C(this).is(":disabled") && Lt.test(this.nodeName) && !Dt.test(e) && (this.checked || !ve.test(e));
          }).map(function (e, t) {
            var n = C(this).val();
            return null == n ? null : Array.isArray(n) ? C.map(n, function (e) {
              return {
                name: t.name,
                value: e.replace(jt, "\r\n")
              };
            }) : {
              name: t.name,
              value: n.replace(jt, "\r\n")
            };
          }).get();
        }
      });
      var Nt = /%20/g,
          It = /#.*$/,
          Mt = /([?&])_=[^&]*/,
          Rt = /^(.*?):[ \t]*([^\r\n]*)$/gm,
          qt = /^(?:GET|HEAD)$/,
          Ft = /^\/\//,
          Bt = {},
          zt = {},
          Ht = "*/".concat("*"),
          Wt = a.createElement("a");

      function $t(e) {
        return function (t, n) {
          "string" != typeof t && (n = t, t = "*");
          var r,
              i = 0,
              o = t.toLowerCase().match(q) || [];
          if (y(n)) for (; r = o[i++];) {
            "+" === r[0] ? (r = r.slice(1) || "*", (e[r] = e[r] || []).unshift(n)) : (e[r] = e[r] || []).push(n);
          }
        };
      }

      function Vt(e, t, n, r) {
        var i = {},
            o = e === zt;

        function a(s) {
          var u;
          return i[s] = !0, C.each(e[s] || [], function (e, s) {
            var c = s(t, n, r);
            return "string" != typeof c || o || i[c] ? o ? !(u = c) : void 0 : (t.dataTypes.unshift(c), a(c), !1);
          }), u;
        }

        return a(t.dataTypes[0]) || !i["*"] && a("*");
      }

      function Ut(e, t) {
        var n,
            r,
            i = C.ajaxSettings.flatOptions || {};

        for (n in t) {
          void 0 !== t[n] && ((i[n] ? e : r || (r = {}))[n] = t[n]);
        }

        return r && C.extend(!0, e, r), e;
      }

      Wt.href = St.href, C.extend({
        active: 0,
        lastModified: {},
        etag: {},
        ajaxSettings: {
          url: St.href,
          type: "GET",
          isLocal: /^(?:about|app|app-storage|.+-extension|file|res|widget):$/.test(St.protocol),
          global: !0,
          processData: !0,
          async: !0,
          contentType: "application/x-www-form-urlencoded; charset=UTF-8",
          accepts: {
            "*": Ht,
            text: "text/plain",
            html: "text/html",
            xml: "application/xml, text/xml",
            json: "application/json, text/javascript"
          },
          contents: {
            xml: /\bxml\b/,
            html: /\bhtml/,
            json: /\bjson\b/
          },
          responseFields: {
            xml: "responseXML",
            text: "responseText",
            json: "responseJSON"
          },
          converters: {
            "* text": String,
            "text html": !0,
            "text json": JSON.parse,
            "text xml": C.parseXML
          },
          flatOptions: {
            url: !0,
            context: !0
          }
        },
        ajaxSetup: function ajaxSetup(e, t) {
          return t ? Ut(Ut(e, C.ajaxSettings), t) : Ut(C.ajaxSettings, e);
        },
        ajaxPrefilter: $t(Bt),
        ajaxTransport: $t(zt),
        ajax: function ajax(e, t) {
          "object" == _typeof(e) && (t = e, e = void 0), t = t || {};
          var r,
              i,
              o,
              s,
              u,
              c,
              l,
              f,
              d,
              p,
              h = C.ajaxSetup({}, t),
              v = h.context || h,
              g = h.context && (v.nodeType || v.jquery) ? C(v) : C.event,
              m = C.Deferred(),
              y = C.Callbacks("once memory"),
              b = h.statusCode || {},
              w = {},
              _ = {},
              x = "canceled",
              k = {
            readyState: 0,
            getResponseHeader: function getResponseHeader(e) {
              var t;

              if (l) {
                if (!s) for (s = {}; t = Rt.exec(o);) {
                  s[t[1].toLowerCase() + " "] = (s[t[1].toLowerCase() + " "] || []).concat(t[2]);
                }
                t = s[e.toLowerCase() + " "];
              }

              return null == t ? null : t.join(", ");
            },
            getAllResponseHeaders: function getAllResponseHeaders() {
              return l ? o : null;
            },
            setRequestHeader: function setRequestHeader(e, t) {
              return null == l && (e = _[e.toLowerCase()] = _[e.toLowerCase()] || e, w[e] = t), this;
            },
            overrideMimeType: function overrideMimeType(e) {
              return null == l && (h.mimeType = e), this;
            },
            statusCode: function statusCode(e) {
              var t;
              if (e) if (l) k.always(e[k.status]);else for (t in e) {
                b[t] = [b[t], e[t]];
              }
              return this;
            },
            abort: function abort(e) {
              var t = e || x;
              return r && r.abort(t), T(0, t), this;
            }
          };

          if (m.promise(k), h.url = ((e || h.url || St.href) + "").replace(Ft, St.protocol + "//"), h.type = t.method || t.type || h.method || h.type, h.dataTypes = (h.dataType || "*").toLowerCase().match(q) || [""], null == h.crossDomain) {
            c = a.createElement("a");

            try {
              c.href = h.url, c.href = c.href, h.crossDomain = Wt.protocol + "//" + Wt.host != c.protocol + "//" + c.host;
            } catch (e) {
              h.crossDomain = !0;
            }
          }

          if (h.data && h.processData && "string" != typeof h.data && (h.data = C.param(h.data, h.traditional)), Vt(Bt, h, t, k), l) return k;

          for (d in (f = C.event && h.global) && 0 == C.active++ && C.event.trigger("ajaxStart"), h.type = h.type.toUpperCase(), h.hasContent = !qt.test(h.type), i = h.url.replace(It, ""), h.hasContent ? h.data && h.processData && 0 === (h.contentType || "").indexOf("application/x-www-form-urlencoded") && (h.data = h.data.replace(Nt, "+")) : (p = h.url.slice(i.length), h.data && (h.processData || "string" == typeof h.data) && (i += (Et.test(i) ? "&" : "?") + h.data, delete h.data), !1 === h.cache && (i = i.replace(Mt, "$1"), p = (Et.test(i) ? "&" : "?") + "_=" + At++ + p), h.url = i + p), h.ifModified && (C.lastModified[i] && k.setRequestHeader("If-Modified-Since", C.lastModified[i]), C.etag[i] && k.setRequestHeader("If-None-Match", C.etag[i])), (h.data && h.hasContent && !1 !== h.contentType || t.contentType) && k.setRequestHeader("Content-Type", h.contentType), k.setRequestHeader("Accept", h.dataTypes[0] && h.accepts[h.dataTypes[0]] ? h.accepts[h.dataTypes[0]] + ("*" !== h.dataTypes[0] ? ", " + Ht + "; q=0.01" : "") : h.accepts["*"]), h.headers) {
            k.setRequestHeader(d, h.headers[d]);
          }

          if (h.beforeSend && (!1 === h.beforeSend.call(v, k, h) || l)) return k.abort();

          if (x = "abort", y.add(h.complete), k.done(h.success), k.fail(h.error), r = Vt(zt, h, t, k)) {
            if (k.readyState = 1, f && g.trigger("ajaxSend", [k, h]), l) return k;
            h.async && h.timeout > 0 && (u = n.setTimeout(function () {
              k.abort("timeout");
            }, h.timeout));

            try {
              l = !1, r.send(w, T);
            } catch (e) {
              if (l) throw e;
              T(-1, e);
            }
          } else T(-1, "No Transport");

          function T(e, t, a, s) {
            var c,
                d,
                p,
                w,
                _,
                x = t;

            l || (l = !0, u && n.clearTimeout(u), r = void 0, o = s || "", k.readyState = e > 0 ? 4 : 0, c = e >= 200 && e < 300 || 304 === e, a && (w = function (e, t, n) {
              for (var r, i, o, a, s = e.contents, u = e.dataTypes; "*" === u[0];) {
                u.shift(), void 0 === r && (r = e.mimeType || t.getResponseHeader("Content-Type"));
              }

              if (r) for (i in s) {
                if (s[i] && s[i].test(r)) {
                  u.unshift(i);
                  break;
                }
              }
              if (u[0] in n) o = u[0];else {
                for (i in n) {
                  if (!u[0] || e.converters[i + " " + u[0]]) {
                    o = i;
                    break;
                  }

                  a || (a = i);
                }

                o = o || a;
              }
              if (o) return o !== u[0] && u.unshift(o), n[o];
            }(h, k, a)), w = function (e, t, n, r) {
              var i,
                  o,
                  a,
                  s,
                  u,
                  c = {},
                  l = e.dataTypes.slice();
              if (l[1]) for (a in e.converters) {
                c[a.toLowerCase()] = e.converters[a];
              }

              for (o = l.shift(); o;) {
                if (e.responseFields[o] && (n[e.responseFields[o]] = t), !u && r && e.dataFilter && (t = e.dataFilter(t, e.dataType)), u = o, o = l.shift()) if ("*" === o) o = u;else if ("*" !== u && u !== o) {
                  if (!(a = c[u + " " + o] || c["* " + o])) for (i in c) {
                    if ((s = i.split(" "))[1] === o && (a = c[u + " " + s[0]] || c["* " + s[0]])) {
                      !0 === a ? a = c[i] : !0 !== c[i] && (o = s[0], l.unshift(s[1]));
                      break;
                    }
                  }
                  if (!0 !== a) if (a && e["throws"]) t = a(t);else try {
                    t = a(t);
                  } catch (e) {
                    return {
                      state: "parsererror",
                      error: a ? e : "No conversion from " + u + " to " + o
                    };
                  }
                }
              }

              return {
                state: "success",
                data: t
              };
            }(h, w, k, c), c ? (h.ifModified && ((_ = k.getResponseHeader("Last-Modified")) && (C.lastModified[i] = _), (_ = k.getResponseHeader("etag")) && (C.etag[i] = _)), 204 === e || "HEAD" === h.type ? x = "nocontent" : 304 === e ? x = "notmodified" : (x = w.state, d = w.data, c = !(p = w.error))) : (p = x, !e && x || (x = "error", e < 0 && (e = 0))), k.status = e, k.statusText = (t || x) + "", c ? m.resolveWith(v, [d, x, k]) : m.rejectWith(v, [k, x, p]), k.statusCode(b), b = void 0, f && g.trigger(c ? "ajaxSuccess" : "ajaxError", [k, h, c ? d : p]), y.fireWith(v, [k, x]), f && (g.trigger("ajaxComplete", [k, h]), --C.active || C.event.trigger("ajaxStop")));
          }

          return k;
        },
        getJSON: function getJSON(e, t, n) {
          return C.get(e, t, n, "json");
        },
        getScript: function getScript(e, t) {
          return C.get(e, void 0, t, "script");
        }
      }), C.each(["get", "post"], function (e, t) {
        C[t] = function (e, n, r, i) {
          return y(n) && (i = i || r, r = n, n = void 0), C.ajax(C.extend({
            url: e,
            type: t,
            dataType: i,
            data: n,
            success: r
          }, C.isPlainObject(e) && e));
        };
      }), C._evalUrl = function (e, t) {
        return C.ajax({
          url: e,
          type: "GET",
          dataType: "script",
          cache: !0,
          async: !1,
          global: !1,
          converters: {
            "text script": function textScript() {}
          },
          dataFilter: function dataFilter(e) {
            C.globalEval(e, t);
          }
        });
      }, C.fn.extend({
        wrapAll: function wrapAll(e) {
          var t;
          return this[0] && (y(e) && (e = e.call(this[0])), t = C(e, this[0].ownerDocument).eq(0).clone(!0), this[0].parentNode && t.insertBefore(this[0]), t.map(function () {
            for (var e = this; e.firstElementChild;) {
              e = e.firstElementChild;
            }

            return e;
          }).append(this)), this;
        },
        wrapInner: function wrapInner(e) {
          return y(e) ? this.each(function (t) {
            C(this).wrapInner(e.call(this, t));
          }) : this.each(function () {
            var t = C(this),
                n = t.contents();
            n.length ? n.wrapAll(e) : t.append(e);
          });
        },
        wrap: function wrap(e) {
          var t = y(e);
          return this.each(function (n) {
            C(this).wrapAll(t ? e.call(this, n) : e);
          });
        },
        unwrap: function unwrap(e) {
          return this.parent(e).not("body").each(function () {
            C(this).replaceWith(this.childNodes);
          }), this;
        }
      }), C.expr.pseudos.hidden = function (e) {
        return !C.expr.pseudos.visible(e);
      }, C.expr.pseudos.visible = function (e) {
        return !!(e.offsetWidth || e.offsetHeight || e.getClientRects().length);
      }, C.ajaxSettings.xhr = function () {
        try {
          return new n.XMLHttpRequest();
        } catch (e) {}
      };
      var Kt = {
        0: 200,
        1223: 204
      },
          Xt = C.ajaxSettings.xhr();
      m.cors = !!Xt && "withCredentials" in Xt, m.ajax = Xt = !!Xt, C.ajaxTransport(function (e) {
        var _t4, r;

        if (m.cors || Xt && !e.crossDomain) return {
          send: function send(i, o) {
            var a,
                s = e.xhr();
            if (s.open(e.type, e.url, e.async, e.username, e.password), e.xhrFields) for (a in e.xhrFields) {
              s[a] = e.xhrFields[a];
            }

            for (a in e.mimeType && s.overrideMimeType && s.overrideMimeType(e.mimeType), e.crossDomain || i["X-Requested-With"] || (i["X-Requested-With"] = "XMLHttpRequest"), i) {
              s.setRequestHeader(a, i[a]);
            }

            _t4 = function t(e) {
              return function () {
                _t4 && (_t4 = r = s.onload = s.onerror = s.onabort = s.ontimeout = s.onreadystatechange = null, "abort" === e ? s.abort() : "error" === e ? "number" != typeof s.status ? o(0, "error") : o(s.status, s.statusText) : o(Kt[s.status] || s.status, s.statusText, "text" !== (s.responseType || "text") || "string" != typeof s.responseText ? {
                  binary: s.response
                } : {
                  text: s.responseText
                }, s.getAllResponseHeaders()));
              };
            }, s.onload = _t4(), r = s.onerror = s.ontimeout = _t4("error"), void 0 !== s.onabort ? s.onabort = r : s.onreadystatechange = function () {
              4 === s.readyState && n.setTimeout(function () {
                _t4 && r();
              });
            }, _t4 = _t4("abort");

            try {
              s.send(e.hasContent && e.data || null);
            } catch (e) {
              if (_t4) throw e;
            }
          },
          abort: function abort() {
            _t4 && _t4();
          }
        };
      }), C.ajaxPrefilter(function (e) {
        e.crossDomain && (e.contents.script = !1);
      }), C.ajaxSetup({
        accepts: {
          script: "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript"
        },
        contents: {
          script: /\b(?:java|ecma)script\b/
        },
        converters: {
          "text script": function textScript(e) {
            return C.globalEval(e), e;
          }
        }
      }), C.ajaxPrefilter("script", function (e) {
        void 0 === e.cache && (e.cache = !1), e.crossDomain && (e.type = "GET");
      }), C.ajaxTransport("script", function (e) {
        var t, _n2;

        if (e.crossDomain || e.scriptAttrs) return {
          send: function send(r, i) {
            t = C("<script>").attr(e.scriptAttrs || {}).prop({
              charset: e.scriptCharset,
              src: e.url
            }).on("load error", _n2 = function n(e) {
              t.remove(), _n2 = null, e && i("error" === e.type ? 404 : 200, e.type);
            }), a.head.appendChild(t[0]);
          },
          abort: function abort() {
            _n2 && _n2();
          }
        };
      });
      var Gt,
          Yt = [],
          Zt = /(=)\?(?=&|$)|\?\?/;
      C.ajaxSetup({
        jsonp: "callback",
        jsonpCallback: function jsonpCallback() {
          var e = Yt.pop() || C.expando + "_" + At++;
          return this[e] = !0, e;
        }
      }), C.ajaxPrefilter("json jsonp", function (e, t, r) {
        var i,
            o,
            a,
            s = !1 !== e.jsonp && (Zt.test(e.url) ? "url" : "string" == typeof e.data && 0 === (e.contentType || "").indexOf("application/x-www-form-urlencoded") && Zt.test(e.data) && "data");
        if (s || "jsonp" === e.dataTypes[0]) return i = e.jsonpCallback = y(e.jsonpCallback) ? e.jsonpCallback() : e.jsonpCallback, s ? e[s] = e[s].replace(Zt, "$1" + i) : !1 !== e.jsonp && (e.url += (Et.test(e.url) ? "&" : "?") + e.jsonp + "=" + i), e.converters["script json"] = function () {
          return a || C.error(i + " was not called"), a[0];
        }, e.dataTypes[0] = "json", o = n[i], n[i] = function () {
          a = arguments;
        }, r.always(function () {
          void 0 === o ? C(n).removeProp(i) : n[i] = o, e[i] && (e.jsonpCallback = t.jsonpCallback, Yt.push(i)), a && y(o) && o(a[0]), a = o = void 0;
        }), "script";
      }), m.createHTMLDocument = ((Gt = a.implementation.createHTMLDocument("").body).innerHTML = "<form></form><form></form>", 2 === Gt.childNodes.length), C.parseHTML = function (e, t, n) {
        return "string" != typeof e ? [] : ("boolean" == typeof t && (n = t, t = !1), t || (m.createHTMLDocument ? ((r = (t = a.implementation.createHTMLDocument("")).createElement("base")).href = a.location.href, t.head.appendChild(r)) : t = a), o = !n && [], (i = D.exec(e)) ? [t.createElement(i[1])] : (i = ke([e], t, o), o && o.length && C(o).remove(), C.merge([], i.childNodes)));
        var r, i, o;
      }, C.fn.load = function (e, t, n) {
        var r,
            i,
            o,
            a = this,
            s = e.indexOf(" ");
        return s > -1 && (r = wt(e.slice(s)), e = e.slice(0, s)), y(t) ? (n = t, t = void 0) : t && "object" == _typeof(t) && (i = "POST"), a.length > 0 && C.ajax({
          url: e,
          type: i || "GET",
          dataType: "html",
          data: t
        }).done(function (e) {
          o = arguments, a.html(r ? C("<div>").append(C.parseHTML(e)).find(r) : e);
        }).always(n && function (e, t) {
          a.each(function () {
            n.apply(this, o || [e.responseText, t, e]);
          });
        }), this;
      }, C.each(["ajaxStart", "ajaxStop", "ajaxComplete", "ajaxError", "ajaxSuccess", "ajaxSend"], function (e, t) {
        C.fn[t] = function (e) {
          return this.on(t, e);
        };
      }), C.expr.pseudos.animated = function (e) {
        return C.grep(C.timers, function (t) {
          return e === t.elem;
        }).length;
      }, C.offset = {
        setOffset: function setOffset(e, t, n) {
          var r,
              i,
              o,
              a,
              s,
              u,
              c = C.css(e, "position"),
              l = C(e),
              f = {};
          "static" === c && (e.style.position = "relative"), s = l.offset(), o = C.css(e, "top"), u = C.css(e, "left"), ("absolute" === c || "fixed" === c) && (o + u).indexOf("auto") > -1 ? (a = (r = l.position()).top, i = r.left) : (a = parseFloat(o) || 0, i = parseFloat(u) || 0), y(t) && (t = t.call(e, n, C.extend({}, s))), null != t.top && (f.top = t.top - s.top + a), null != t.left && (f.left = t.left - s.left + i), "using" in t ? t.using.call(e, f) : l.css(f);
        }
      }, C.fn.extend({
        offset: function offset(e) {
          if (arguments.length) return void 0 === e ? this : this.each(function (t) {
            C.offset.setOffset(this, e, t);
          });
          var t,
              n,
              r = this[0];
          return r ? r.getClientRects().length ? (t = r.getBoundingClientRect(), n = r.ownerDocument.defaultView, {
            top: t.top + n.pageYOffset,
            left: t.left + n.pageXOffset
          }) : {
            top: 0,
            left: 0
          } : void 0;
        },
        position: function position() {
          if (this[0]) {
            var e,
                t,
                n,
                r = this[0],
                i = {
              top: 0,
              left: 0
            };
            if ("fixed" === C.css(r, "position")) t = r.getBoundingClientRect();else {
              for (t = this.offset(), n = r.ownerDocument, e = r.offsetParent || n.documentElement; e && (e === n.body || e === n.documentElement) && "static" === C.css(e, "position");) {
                e = e.parentNode;
              }

              e && e !== r && 1 === e.nodeType && ((i = C(e).offset()).top += C.css(e, "borderTopWidth", !0), i.left += C.css(e, "borderLeftWidth", !0));
            }
            return {
              top: t.top - i.top - C.css(r, "marginTop", !0),
              left: t.left - i.left - C.css(r, "marginLeft", !0)
            };
          }
        },
        offsetParent: function offsetParent() {
          return this.map(function () {
            for (var e = this.offsetParent; e && "static" === C.css(e, "position");) {
              e = e.offsetParent;
            }

            return e || ae;
          });
        }
      }), C.each({
        scrollLeft: "pageXOffset",
        scrollTop: "pageYOffset"
      }, function (e, t) {
        var n = "pageYOffset" === t;

        C.fn[e] = function (r) {
          return V(this, function (e, r, i) {
            var o;
            if (b(e) ? o = e : 9 === e.nodeType && (o = e.defaultView), void 0 === i) return o ? o[t] : e[r];
            o ? o.scrollTo(n ? o.pageXOffset : i, n ? i : o.pageYOffset) : e[r] = i;
          }, e, r, arguments.length);
        };
      }), C.each(["top", "left"], function (e, t) {
        C.cssHooks[t] = Xe(m.pixelPosition, function (e, n) {
          if (n) return n = Ke(e, t), $e.test(n) ? C(e).position()[t] + "px" : n;
        });
      }), C.each({
        Height: "height",
        Width: "width"
      }, function (e, t) {
        C.each({
          padding: "inner" + e,
          content: t,
          "": "outer" + e
        }, function (n, r) {
          C.fn[r] = function (i, o) {
            var a = arguments.length && (n || "boolean" != typeof i),
                s = n || (!0 === i || !0 === o ? "margin" : "border");
            return V(this, function (t, n, i) {
              var o;
              return b(t) ? 0 === r.indexOf("outer") ? t["inner" + e] : t.document.documentElement["client" + e] : 9 === t.nodeType ? (o = t.documentElement, Math.max(t.body["scroll" + e], o["scroll" + e], t.body["offset" + e], o["offset" + e], o["client" + e])) : void 0 === i ? C.css(t, n, s) : C.style(t, n, i, s);
            }, t, a ? i : void 0, a);
          };
        });
      }), C.each("blur focus focusin focusout resize scroll click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup contextmenu".split(" "), function (e, t) {
        C.fn[t] = function (e, n) {
          return arguments.length > 0 ? this.on(t, null, e, n) : this.trigger(t);
        };
      }), C.fn.extend({
        hover: function hover(e, t) {
          return this.mouseenter(e).mouseleave(t || e);
        }
      }), C.fn.extend({
        bind: function bind(e, t, n) {
          return this.on(e, null, t, n);
        },
        unbind: function unbind(e, t) {
          return this.off(e, null, t);
        },
        delegate: function delegate(e, t, n, r) {
          return this.on(t, e, n, r);
        },
        undelegate: function undelegate(e, t, n) {
          return 1 === arguments.length ? this.off(e, "**") : this.off(t, e || "**", n);
        }
      }), C.proxy = function (e, t) {
        var n, r, i;
        if ("string" == typeof t && (n = e[t], t = e, e = n), y(e)) return r = u.call(arguments, 2), (i = function i() {
          return e.apply(t || this, r.concat(u.call(arguments)));
        }).guid = e.guid = e.guid || C.guid++, i;
      }, C.holdReady = function (e) {
        e ? C.readyWait++ : C.ready(!0);
      }, C.isArray = Array.isArray, C.parseJSON = JSON.parse, C.nodeName = j, C.isFunction = y, C.isWindow = b, C.camelCase = G, C.type = x, C.now = Date.now, C.isNumeric = function (e) {
        var t = C.type(e);
        return ("number" === t || "string" === t) && !isNaN(e - parseFloat(e));
      }, void 0 === (r = function () {
        return C;
      }.apply(t, [])) || (e.exports = r);
      var Qt = n.jQuery,
          Jt = n.$;
      return C.noConflict = function (e) {
        return n.$ === C && (n.$ = Jt), e && n.jQuery === C && (n.jQuery = Qt), C;
      }, i || (n.jQuery = n.$ = C), C;
    });
  }, function (e, t, n) {
    !function (t, n) {
      var r = function (e, t, n) {
        "use strict";

        var r, i;
        if (function () {
          var t,
              n = {
            lazyClass: "lazyload",
            loadedClass: "lazyloaded",
            loadingClass: "lazyloading",
            preloadClass: "lazypreload",
            errorClass: "lazyerror",
            autosizesClass: "lazyautosizes",
            srcAttr: "data-src",
            srcsetAttr: "data-srcset",
            sizesAttr: "data-sizes",
            minSize: 40,
            customMedia: {},
            init: !0,
            expFactor: 1.5,
            hFac: .8,
            loadMode: 2,
            loadHidden: !0,
            ricTimeout: 0,
            throttleDelay: 125
          };

          for (t in i = e.lazySizesConfig || e.lazysizesConfig || {}, n) {
            t in i || (i[t] = n[t]);
          }
        }(), !t || !t.getElementsByClassName) return {
          init: function init() {},
          cfg: i,
          noSupport: !0
        };

        var o = t.documentElement,
            a = e.HTMLPictureElement,
            s = e.addEventListener.bind(e),
            u = e.setTimeout,
            c = e.requestAnimationFrame || u,
            l = e.requestIdleCallback,
            f = /^picture$/i,
            d = ["load", "error", "lazyincluded", "_lazyloaded"],
            p = {},
            h = Array.prototype.forEach,
            v = function v(e, t) {
          return p[t] || (p[t] = new RegExp("(\\s|^)" + t + "(\\s|$)")), p[t].test(e.getAttribute("class") || "") && p[t];
        },
            g = function g(e, t) {
          v(e, t) || e.setAttribute("class", (e.getAttribute("class") || "").trim() + " " + t);
        },
            m = function m(e, t) {
          var n;
          (n = v(e, t)) && e.setAttribute("class", (e.getAttribute("class") || "").replace(n, " "));
        },
            y = function y(e, t, n) {
          var r = n ? "addEventListener" : "removeEventListener";
          n && y(e, t), d.forEach(function (n) {
            e[r](n, t);
          });
        },
            b = function b(e, n, i, o, a) {
          var s = t.createEvent("Event");
          return i || (i = {}), i.instance = r, s.initEvent(n, !o, !a), s.detail = i, e.dispatchEvent(s), s;
        },
            w = function w(t, n) {
          var r;
          !a && (r = e.picturefill || i.pf) ? (n && n.src && !t.getAttribute("srcset") && t.setAttribute("srcset", n.src), r({
            reevaluate: !0,
            elements: [t]
          })) : n && n.src && (t.src = n.src);
        },
            _ = function _(e, t) {
          return (getComputedStyle(e, null) || {})[t];
        },
            x = function x(e, t, n) {
          for (n = n || e.offsetWidth; n < i.minSize && t && !e._lazysizesWidth;) {
            n = t.offsetWidth, t = t.parentNode;
          }

          return n;
        },
            C = (pe = [], he = [], ve = pe, ge = function ge() {
          var e = ve;

          for (ve = pe.length ? he : pe, fe = !0, de = !1; e.length;) {
            e.shift()();
          }

          fe = !1;
        }, me = function me(e, n) {
          fe && !n ? e.apply(this, arguments) : (ve.push(e), de || (de = !0, (t.hidden ? u : c)(ge)));
        }, me._lsFlush = ge, me),
            k = function k(e, t) {
          return t ? function () {
            C(e);
          } : function () {
            var t = this,
                n = arguments;
            C(function () {
              e.apply(t, n);
            });
          };
        },
            T = function T(e) {
          var t,
              r,
              i = function i() {
            t = null, e();
          },
              o = function o() {
            var e = n.now() - r;
            e < 99 ? u(o, 99 - e) : (l || i)(i);
          };

          return function () {
            r = n.now(), t || (t = u(o, 99));
          };
        },
            S = (V = /^img$/i, U = /^iframe$/i, K = "onscroll" in e && !/(gle|ing)bot/.test(navigator.userAgent), X = 0, G = 0, Y = -1, Z = function Z(e) {
          G--, (!e || G < 0 || !e.target) && (G = 0);
        }, Q = function Q(e) {
          return null == $ && ($ = "hidden" == _(t.body, "visibility")), $ || !("hidden" == _(e.parentNode, "visibility") && "hidden" == _(e, "visibility"));
        }, J = function J(e, n) {
          var r,
              i = e,
              a = Q(e);

          for (B -= n, W += n, z -= n, H += n; a && (i = i.offsetParent) && i != t.body && i != o;) {
            (a = (_(i, "opacity") || 1) > 0) && "visible" != _(i, "overflow") && (r = i.getBoundingClientRect(), a = H > r.left && z < r.right && W > r.top - 1 && B < r.bottom + 1);
          }

          return a;
        }, ee = function ee() {
          var e,
              n,
              a,
              s,
              u,
              c,
              l,
              f,
              d,
              p,
              h,
              v,
              g = r.elements;

          if ((M = i.loadMode) && G < 8 && (e = g.length)) {
            for (n = 0, Y++; n < e; n++) {
              if (g[n] && !g[n]._lazyRace) if (!K || r.prematureUnveil && r.prematureUnveil(g[n])) se(g[n]);else if ((f = g[n].getAttribute("data-expand")) && (c = 1 * f) || (c = X), p || (p = !i.expand || i.expand < 1 ? o.clientHeight > 500 && o.clientWidth > 500 ? 500 : 370 : i.expand, r._defEx = p, h = p * i.expFactor, v = i.hFac, $ = null, X < h && G < 1 && Y > 2 && M > 2 && !t.hidden ? (X = h, Y = 0) : X = M > 1 && Y > 1 && G < 6 ? p : 0), d !== c && (q = innerWidth + c * v, F = innerHeight + c, l = -1 * c, d = c), a = g[n].getBoundingClientRect(), (W = a.bottom) >= l && (B = a.top) <= F && (H = a.right) >= l * v && (z = a.left) <= q && (W || H || z || B) && (i.loadHidden || Q(g[n])) && (N && G < 3 && !f && (M < 3 || Y < 4) || J(g[n], c))) {
                if (se(g[n]), u = !0, G > 9) break;
              } else !u && N && !s && G < 4 && Y < 4 && M > 2 && (P[0] || i.preloadAfterLoad) && (P[0] || !f && (W || H || z || B || "auto" != g[n].getAttribute(i.sizesAttr))) && (s = P[0] || g[n]);
            }

            s && !u && se(s);
          }
        }, te = function (e) {
          var t,
              r = 0,
              o = i.throttleDelay,
              a = i.ricTimeout,
              s = function s() {
            t = !1, r = n.now(), e();
          },
              c = l && a > 49 ? function () {
            l(s, {
              timeout: a
            }), a !== i.ricTimeout && (a = i.ricTimeout);
          } : k(function () {
            u(s);
          }, !0);

          return function (e) {
            var i;
            (e = !0 === e) && (a = 33), t || (t = !0, (i = o - (n.now() - r)) < 0 && (i = 0), e || i < 9 ? c() : u(c, i));
          };
        }(ee), ne = function ne(e) {
          var t = e.target;
          t._lazyCache ? delete t._lazyCache : (Z(e), g(t, i.loadedClass), m(t, i.loadingClass), y(t, ie), b(t, "lazyloaded"));
        }, re = k(ne), ie = function ie(e) {
          re({
            target: e.target
          });
        }, oe = function oe(e) {
          var t,
              n = e.getAttribute(i.srcsetAttr);
          (t = i.customMedia[e.getAttribute("data-media") || e.getAttribute("media")]) && e.setAttribute("media", t), n && e.setAttribute("srcset", n);
        }, ae = k(function (e, t, n, r, o) {
          var a, s, c, l, d, p;
          (d = b(e, "lazybeforeunveil", t)).defaultPrevented || (r && (n ? g(e, i.autosizesClass) : e.setAttribute("sizes", r)), s = e.getAttribute(i.srcsetAttr), a = e.getAttribute(i.srcAttr), o && (l = (c = e.parentNode) && f.test(c.nodeName || "")), p = t.firesLoad || "src" in e && (s || a || l), d = {
            target: e
          }, g(e, i.loadingClass), p && (clearTimeout(I), I = u(Z, 2500), y(e, ie, !0)), l && h.call(c.getElementsByTagName("source"), oe), s ? e.setAttribute("srcset", s) : a && !l && (U.test(e.nodeName) ? function (e, t) {
            try {
              e.contentWindow.location.replace(t);
            } catch (n) {
              e.src = t;
            }
          }(e, a) : e.src = a), o && (s || l) && w(e, {
            src: a
          })), e._lazyRace && delete e._lazyRace, m(e, i.lazyClass), C(function () {
            var t = e.complete && e.naturalWidth > 1;
            p && !t || (t && g(e, "ls-is-cached"), ne(d), e._lazyCache = !0, u(function () {
              "_lazyCache" in e && delete e._lazyCache;
            }, 9)), "lazy" == e.loading && G--;
          }, !0);
        }), se = function se(e) {
          if (!e._lazyRace) {
            var t,
                n = V.test(e.nodeName),
                r = n && (e.getAttribute(i.sizesAttr) || e.getAttribute("sizes")),
                o = "auto" == r;
            (!o && N || !n || !e.getAttribute("src") && !e.srcset || e.complete || v(e, i.errorClass) || !v(e, i.lazyClass)) && (t = b(e, "lazyunveilread").detail, o && A.updateElem(e, !0, e.offsetWidth), e._lazyRace = !0, G++, ae(e, t, o, r, n));
          }
        }, ue = T(function () {
          i.loadMode = 3, te();
        }), ce = function ce() {
          3 == i.loadMode && (i.loadMode = 2), ue();
        }, _le = function le() {
          N || (n.now() - R < 999 ? u(_le, 999) : (N = !0, i.loadMode = 3, te(), s("scroll", ce, !0)));
        }, {
          _: function _() {
            R = n.now(), r.elements = t.getElementsByClassName(i.lazyClass), P = t.getElementsByClassName(i.lazyClass + " " + i.preloadClass), s("scroll", te, !0), s("resize", te, !0), s("pageshow", function (e) {
              if (e.persisted) {
                var n = t.querySelectorAll("." + i.loadingClass);
                n.length && n.forEach && c(function () {
                  n.forEach(function (e) {
                    e.complete && se(e);
                  });
                });
              }
            }), e.MutationObserver ? new MutationObserver(te).observe(o, {
              childList: !0,
              subtree: !0,
              attributes: !0
            }) : (o.addEventListener("DOMNodeInserted", te, !0), o.addEventListener("DOMAttrModified", te, !0), setInterval(te, 999)), s("hashchange", te, !0), ["focus", "mouseover", "click", "load", "transitionend", "animationend"].forEach(function (e) {
              t.addEventListener(e, te, !0);
            }), /d$|^c/.test(t.readyState) ? _le() : (s("load", _le), t.addEventListener("DOMContentLoaded", te), u(_le, 2e4)), r.elements.length ? (ee(), C._lsFlush()) : te();
          },
          checkElems: te,
          unveil: se,
          _aLSL: ce
        }),
            A = (j = k(function (e, t, n, r) {
          var i, o, a;
          if (e._lazysizesWidth = r, r += "px", e.setAttribute("sizes", r), f.test(t.nodeName || "")) for (o = 0, a = (i = t.getElementsByTagName("source")).length; o < a; o++) {
            i[o].setAttribute("sizes", r);
          }
          n.detail.dataAttr || w(e, n.detail);
        }), D = function D(e, t, n) {
          var r,
              i = e.parentNode;
          i && (n = x(e, i, n), (r = b(e, "lazybeforesizes", {
            width: n,
            dataAttr: !!t
          })).defaultPrevented || (n = r.detail.width) && n !== e._lazysizesWidth && j(e, i, r, n));
        }, L = T(function () {
          var e,
              t = O.length;
          if (t) for (e = 0; e < t; e++) {
            D(O[e]);
          }
        }), {
          _: function _() {
            O = t.getElementsByClassName(i.autosizesClass), s("resize", L);
          },
          checkElems: L,
          updateElem: D
        }),
            E = function E() {
          !E.i && t.getElementsByClassName && (E.i = !0, A._(), S._());
        };

        var O, j, D, L;

        var P, N, I, M, R, q, F, B, z, H, W, $, V, U, K, X, G, Y, Z, Q, J, ee, te, ne, re, ie, oe, ae, se, ue, ce, _le;

        var fe, de, pe, he, ve, ge, me;
        return u(function () {
          i.init && E();
        }), r = {
          cfg: i,
          autoSizer: A,
          loader: S,
          init: E,
          uP: w,
          aC: g,
          rC: m,
          hC: v,
          fire: b,
          gW: x,
          rAF: C
        };
      }(t, t.document, Date);

      t.lazySizes = r, e.exports && (e.exports = r);
    }("undefined" != typeof window ? window : {});
  }, function (e, t, n) {
    var r = {
      "./apparatus/draft/add_block_component_controller.js": 40,
      "./apparatus/ui/dialog_component_controller.js": 58,
      "./block/destroy_button_controller.js": 41,
      "./block/edit_button_controller.js": 42,
      "./block/form_controller.js": 43,
      "./block_controller.js": 44,
      "./draft_controller.js": 47,
      "./drafts/master_page_dropdown_component_controller.js": 48,
      "./page/visibility_toggle_controller.js": 49,
      "./resource_block/crud_component_controller.js": 50,
      "./toolbar_block/draft_status_dropdown_component_controller.js": 51,
      "./toolbar_block/page_path_component/locale_component_controller.js": 52,
      "./toolbar_block/page_path_component/permalink_component_controller.js": 53,
      "./toolbar_block_component_controller.js": 54
    };

    function i(e) {
      var t = o(e);
      return n(t);
    }

    function o(e) {
      if (!n.o(r, e)) {
        var t = new Error("Cannot find module '" + e + "'");
        throw t.code = "MODULE_NOT_FOUND", t;
      }

      return r[e];
    }

    i.keys = function () {
      return Object.keys(r);
    }, i.resolve = o, e.exports = i, i.id = 39;
  }, function (e, t, n) {
    "use strict";

    function r(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }

    function i(e, t) {
      for (var n = 0; n < t.length; n++) {
        var r = t[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
      }
    }

    function o(e, t) {
      return !t || "object" != _typeof(t) && "function" != typeof t ? function (e) {
        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e;
      }(e) : t;
    }

    function a(e) {
      return (a = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function s(e, t) {
      return (s = Object.setPrototypeOf || function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    n.r(t), n.d(t, "default", function () {
      return u;
    });

    var u = function (e) {
      function t() {
        return r(this, t), o(this, a(t).apply(this, arguments));
      }

      var n, u, c;
      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), t && s(e, t);
      }(t, e), n = t, (u = [{
        key: "toggle",
        value: function value() {
          this.element.classList.toggle(this.visibleClass), this.toggled && this.selectTarget.focus();
        }
      }, {
        key: "onSuccess",
        value: function value(e) {
          var _e$detail = _slicedToArray(e.detail, 3),
              t = _e$detail[0],
              n = _e$detail[1],
              r = _e$detail[2];

          this.toggle(!1), this.selectTarget.selectedIndex = 0, this.draftController.addBlockAtPosition(r.response, this.position);
        }
      }, {
        key: "toggled",
        get: function get() {
          return this.element.classList.contains(this.visibleClass);
        }
      }, {
        key: "draftController",
        get: function get() {
          if (this.draft) return this.application.getControllerForElementAndIdentifier(this.draft, "draft");
        }
      }, {
        key: "draft",
        get: function get() {
          return this.element.closest(".draft");
        }
      }, {
        key: "position",
        get: function get() {
          return _toConsumableArray(this.siblings).indexOf(this.element);
        }
      }, {
        key: "siblings",
        get: function get() {
          return this.element.parentNode.querySelectorAll(".draft__add_block");
        }
      }, {
        key: "visibleClass",
        get: function get() {
          return this.data.get("visibleClass");
        }
      }]) && i(n.prototype, u), c && i(n, c), t;
    }(n(0).b);

    var c, l, f;
    f = ["select"], (l = "targets") in (c = u) ? Object.defineProperty(c, l, {
      value: f,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : c[l] = f;
  }, function (e, t, n) {
    "use strict";

    function r(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }

    function i(e, t) {
      for (var n = 0; n < t.length; n++) {
        var r = t[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
      }
    }

    function o(e, t) {
      return !t || "object" != _typeof(t) && "function" != typeof t ? function (e) {
        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e;
      }(e) : t;
    }

    function a(e) {
      return (a = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function s(e, t) {
      return (s = Object.setPrototypeOf || function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    n.r(t), n.d(t, "default", function () {
      return u;
    });

    var u = function (e) {
      function t() {
        return r(this, t), o(this, a(t).apply(this, arguments));
      }

      var n, u, c;
      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), t && s(e, t);
      }(t, e), n = t, (u = [{
        key: "connect",
        value: function value() {}
      }, {
        key: "disconnect",
        value: function value() {}
      }, {
        key: "onSuccess",
        value: function value(e) {
          this.blockController.destroy();
        }
      }, {
        key: "onError",
        value: function value(e) {
          console.log(e);
        }
      }, {
        key: "blockController",
        get: function get() {
          var e = this.element.closest(".block");
          return this.application.getControllerForElementAndIdentifier(e, "block");
        }
      }]) && i(n.prototype, u), c && i(n, c), t;
    }(n(0).b);
  }, function (e, t, n) {
    "use strict";

    function r(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }

    function i(e, t) {
      for (var n = 0; n < t.length; n++) {
        var r = t[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
      }
    }

    function o(e, t) {
      return !t || "object" != _typeof(t) && "function" != typeof t ? function (e) {
        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e;
      }(e) : t;
    }

    function a(e) {
      return (a = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function s(e, t) {
      return (s = Object.setPrototypeOf || function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    n.r(t), n.d(t, "default", function () {
      return u;
    });

    var u = function (e) {
      function t() {
        return r(this, t), o(this, a(t).apply(this, arguments));
      }

      var n, u, c;
      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), t && s(e, t);
      }(t, e), n = t, (u = [{
        key: "connect",
        value: function value() {}
      }, {
        key: "disconnect",
        value: function value() {}
      }, {
        key: "onSuccess",
        value: function value(e) {
          var _e$detail2 = _slicedToArray(e.detail, 3),
              t = _e$detail2[0],
              n = _e$detail2[1],
              r = _e$detail2[2];

          this.blockController.update(r.response);
        }
      }, {
        key: "onError",
        value: function value(e) {
          console.log(e);
        }
      }, {
        key: "blockController",
        get: function get() {
          var e = this.element.closest(".block");
          return this.application.getControllerForElementAndIdentifier(e, "block");
        }
      }]) && i(n.prototype, u), c && i(n, c), t;
    }(n(0).b);
  }, function (e, t, n) {
    "use strict";

    function r(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }

    function i(e, t) {
      for (var n = 0; n < t.length; n++) {
        var r = t[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
      }
    }

    function o(e, t) {
      return !t || "object" != _typeof(t) && "function" != typeof t ? function (e) {
        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e;
      }(e) : t;
    }

    function a(e) {
      return (a = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function s(e, t) {
      return (s = Object.setPrototypeOf || function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    n.r(t), n.d(t, "default", function () {
      return u;
    });

    var u = function (e) {
      function t() {
        return r(this, t), o(this, a(t).apply(this, arguments));
      }

      var n, u, c;
      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), t && s(e, t);
      }(t, e), n = t, (u = [{
        key: "connect",
        value: function value() {}
      }, {
        key: "disconnect",
        value: function value() {}
      }, {
        key: "onSuccess",
        value: function value(e) {
          console.log(e);

          var _e$detail3 = _slicedToArray(e.detail, 3),
              t = _e$detail3[0],
              n = _e$detail3[1],
              r = _e$detail3[2];

          this.blockController.update(r.response);
        }
      }, {
        key: "onError",
        value: function value(e) {
          var _e$detail4 = _slicedToArray(e.detail, 3),
              t = _e$detail4[0],
              n = _e$detail4[1],
              r = _e$detail4[2];

          this.blockController.update(r.response);
        }
      }, {
        key: "blockController",
        get: function get() {
          var e = this.element.closest(".block");
          return this.application.getControllerForElementAndIdentifier(e, "block");
        }
      }]) && i(n.prototype, u), c && i(n, c), t;
    }(n(0).b);
  }, function (e, t, n) {
    "use strict";

    n.r(t), n.d(t, "default", function () {
      return c;
    });
    var r = n(0);

    function i(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }

    function o(e, t) {
      for (var n = 0; n < t.length; n++) {
        var r = t[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
      }
    }

    function a(e, t) {
      return !t || "object" != _typeof(t) && "function" != typeof t ? function (e) {
        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e;
      }(e) : t;
    }

    function s(e) {
      return (s = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function u(e, t) {
      return (u = Object.setPrototypeOf || function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    n(45);

    var c = function (e) {
      function t() {
        return i(this, t), a(this, s(t).apply(this, arguments));
      }

      var n, r, c;
      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), t && u(e, t);
      }(t, e), n = t, (r = [{
        key: "connect",
        value: function value() {}
      }, {
        key: "disconnect",
        value: function value() {}
      }, {
        key: "update",
        value: function value(e) {
          var t = this.draftController;
          $(this.element).replaceWith($(e).filter("div.apparatus.block")), t.updateBlockPositions();
        }
      }, {
        key: "destroy",
        value: function value() {
          var e = this.draftController,
              t = $(this.element.previousSibling),
              n = $(this.element),
              r = t.slideUp("fast").promise(),
              i = n.slideUp("fast").promise();
          $.when(r, i).then(function () {
            t.remove(), n.remove(), e.updateBlockPositions();
          });
        }
      }, {
        key: "cancelCreate",
        value: function value() {
          this.destroy();
        }
      }, {
        key: "moveUp",
        value: function value() {
          var _this3 = this;

          this.previousBlock && $(this.element).swap(this.previousBlock).then(function () {
            _this3.draftController.updateBlockPositions();
          });
        }
      }, {
        key: "moveDown",
        value: function value() {
          var _this4 = this;

          this.nextBlock && $(this.element).swap(this.nextBlock).then(function () {
            _this4.draftController.updateBlockPositions();
          });
        }
      }, {
        key: "previousBlock",
        get: function get() {
          return $(this.element).prevAll(".apparatus.block").first();
        }
      }, {
        key: "nextBlock",
        get: function get() {
          return $(this.element).nextAll(".apparatus.block").first();
        }
      }, {
        key: "draftController",
        get: function get() {
          if (this.draft) return this.application.getControllerForElementAndIdentifier(this.draft, "draft");
        }
      }, {
        key: "draft",
        get: function get() {
          return this.element.closest(".draft");
        }
      }]) && o(n.prototype, r), c && o(n, c), t;
    }(r.b);

    var l, f, d;
    d = ["directionButton"], (f = "targets") in (l = c) ? Object.defineProperty(l, f, {
      value: d,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : l[f] = d;
  }, function (e, t, n) {
    "use strict";

    n.r(t);
    n(46);
  }, function (e, t) {
    (function (e) {
      var t = function t(_t5, n) {
        var r = e(_t5),
            i = e(n);
        r.addClass("swapped"), i.addClass("swapped");
        var o = e.Deferred(),
            a = r.offset(),
            s = i.offset(),
            u = r.clone(),
            c = i.clone(),
            l = a.top > s.top ? "up" : "down",
            f = s.top + i.height() - a.top;
        var d = 0,
            p = 0;
        r.css("opacity", 0), i.css("opacity", 0), u.insertAfter(r).css({
          position: "absolute",
          width: r.outerWidth(),
          height: r.outerHeight()
        }).offset(a).css("z-index", "999"), c.insertAfter(i).css({
          position: "absolute",
          width: i.outerWidth(),
          height: i.outerHeight()
        }).offset(s).css("z-index", "999"), "down" === l ? (p = f - i.height(), d = f - r.height()) : (p = f - r.height(), d = f - i.height());
        var h = u.animate({
          top: "+=".concat(d, "px")
        }, 300).promise(),
            v = c.animate({
          top: "-=".concat(p, "px")
        }, 300).promise();
        return e.when(h, v).then(function () {
          i.insertBefore(u).css("opacity", 1), u.remove(), r.insertBefore(c).css("opacity", 1), c.remove(), o.resolve();
        }), r.removeClass("swapped"), i.removeClass("swapped"), o.promise();
      };

      e.fn.swap = function (n, r) {
        var i = this;
        return 1 === i.length && 1 === n.length && void 0 === r ? t(i, n) : i.length > 1 && "number" == typeof n && "number" == typeof r ? (t(i[n], i[r]), i) : void e.error("Argument Error!");
      };
    })(jQuery), function (e) {
      e.fn.extend({
        myPluginLoad: function myPluginLoad(t) {
          var n = e.Deferred();
          return e.when(swapFrom, swapTo).then(function () {
            n.resolve();
          }), n.promise();
        }
      });
    }(jQuery);
  }, function (e, t, n) {
    "use strict";

    function r(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }

    function i(e, t) {
      for (var n = 0; n < t.length; n++) {
        var r = t[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
      }
    }

    function o(e, t) {
      return !t || "object" != _typeof(t) && "function" != typeof t ? function (e) {
        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e;
      }(e) : t;
    }

    function a(e) {
      return (a = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function s(e, t) {
      return (s = Object.setPrototypeOf || function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    n.r(t), n.d(t, "default", function () {
      return u;
    });

    var u = function (e) {
      function t() {
        return r(this, t), o(this, a(t).apply(this, arguments));
      }

      var n, u, c;
      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), t && s(e, t);
      }(t, e), n = t, (u = [{
        key: "addBlockAtPosition",
        value: function value(e, t) {
          this.addBlockTargets[t].insertAdjacentHTML("afterend", e);
        }
      }, {
        key: "updateBlockPositions",
        value: function value() {
          console.log("updating block positions"), fetch(this.data.get("update-block-positions-path"), {
            method: "post",
            body: JSON.stringify({
              blocks: this.blockIds
            }),
            headers: {
              "Content-Type": "application/json",
              "X-CSRF-Token": Rails.csrfToken()
            },
            credentials: "same-origin"
          });
        }
      }, {
        key: "blocks",
        get: function get() {
          return this.element.querySelectorAll(".apparatus.block");
        }
      }, {
        key: "blockIds",
        get: function get() {
          if (this.blocks) return Array.from(this.blocks).map(function (e) {
            return e.dataset.id;
          });
        }
      }]) && i(n.prototype, u), c && i(n, c), t;
    }(n(0).b);

    var c, l, f;
    f = ["addBlock"], (l = "targets") in (c = u) ? Object.defineProperty(c, l, {
      value: f,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : c[l] = f;
  }, function (e, t, n) {
    "use strict";

    n.r(t), n.d(t, "default", function () {
      return c;
    });
    var r = n(0);

    function i(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }

    function o(e, t) {
      for (var n = 0; n < t.length; n++) {
        var r = t[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
      }
    }

    function a(e, t) {
      return !t || "object" != _typeof(t) && "function" != typeof t ? function (e) {
        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e;
      }(e) : t;
    }

    function s(e) {
      return (s = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function u(e, t) {
      return (u = Object.setPrototypeOf || function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    n(14), n(15);

    var c = function (e) {
      function t() {
        return i(this, t), a(this, s(t).apply(this, arguments));
      }

      var n, r, c;
      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), t && u(e, t);
      }(t, e), n = t, (r = [{
        key: "connect",
        value: function value() {
          var _this5 = this;

          $(this.dropdownTarget).dropdown({
            duration: 0,
            transition: "drop",
            selectOnKeydown: !1,
            action: function action(e, t, n) {
              confirm(_this5.data.get("confirmation")) && (n.querySelector("input").checked = !0, _this5.submitForm());
            }
          });
        }
      }, {
        key: "submitForm",
        value: function value() {
          this.formTarget.submit();
        }
      }, {
        key: "close",
        value: function value() {
          $(this.dropdownTarget).dropdown("hide");
        }
      }]) && o(n.prototype, r), c && o(n, c), t;
    }(r.b);

    var l, f, d;
    d = ["dropdown", "form"], (f = "targets") in (l = c) ? Object.defineProperty(l, f, {
      value: d,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : l[f] = d;
  }, function (e, t, n) {
    "use strict";

    function r(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }

    function i(e, t) {
      for (var n = 0; n < t.length; n++) {
        var r = t[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
      }
    }

    function o(e, t) {
      return !t || "object" != _typeof(t) && "function" != typeof t ? function (e) {
        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e;
      }(e) : t;
    }

    function a(e) {
      return (a = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function s(e, t) {
      return (s = Object.setPrototypeOf || function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    n.r(t), n.d(t, "default", function () {
      return u;
    });

    var u = function (e) {
      function t() {
        return r(this, t), o(this, a(t).apply(this, arguments));
      }

      var n, u, c;
      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), t && s(e, t);
      }(t, e), n = t, (u = [{
        key: "connect",
        value: function value() {
          this.element.classList.contains(this.data.get("disabled-class"));
        }
      }, {
        key: "onBefore",
        value: function value(e) {
          this.setLoadingState(!0), this.toggleState();
        }
      }, {
        key: "onSuccess",
        value: function value(e) {
          this.setLoadingState(!1);
        }
      }, {
        key: "onError",
        value: function value(e) {
          this.toggleState();
        }
      }, {
        key: "setLoadingState",
        value: function value(e) {
          this.element.classList.toggle(this.data.get("loading-class"), e);
        }
      }, {
        key: "toggleState",
        value: function value() {
          this.isOn ? (this.element.classList.remove(this.data.get("on-class")), this.element.classList.add(this.data.get("off-class"))) : (this.element.classList.remove(this.data.get("off-class")), this.element.classList.add(this.data.get("on-class")));
        }
      }, {
        key: "isOn",
        get: function get() {
          return this.element.classList.contains(this.data.get("on-class"));
        }
      }]) && i(n.prototype, u), c && i(n, c), t;
    }(n(0).b);
  }, function (e, t, n) {
    "use strict";

    function r(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }

    function i(e, t) {
      for (var n = 0; n < t.length; n++) {
        var r = t[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
      }
    }

    function o(e, t) {
      return !t || "object" != _typeof(t) && "function" != typeof t ? function (e) {
        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e;
      }(e) : t;
    }

    function a(e) {
      return (a = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function s(e, t) {
      return (s = Object.setPrototypeOf || function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    n.r(t), n.d(t, "default", function () {
      return u;
    });

    var u = function (e) {
      function t() {
        return r(this, t), o(this, a(t).apply(this, arguments));
      }

      var n, u, c;
      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), t && s(e, t);
      }(t, e), n = t, (u = [{
        key: "connect",
        value: function value() {
          this.indexPath && this._fetchIndex();
        }
      }, {
        key: "update",
        value: function value(e) {
          e.detail[0], e.detail[1];
          var t = e.detail[2];
          this.element.innerHTML = t.responseText;
        }
      }, {
        key: "_fetchIndex",
        value: function value() {
          var _this6 = this;

          Rails.ajax({
            type: "GET",
            dataType: "html",
            url: this.indexPath,
            success: function success(e) {
              _this6.element.innerHTML = e.body.innerHTML;
            }
          });
        }
      }, {
        key: "isEditable",
        get: function get() {
          return this.element.classList.contains("editable");
        }
      }, {
        key: "indexPath",
        get: function get() {
          return this.data.get("indexPath");
        }
      }]) && i(n.prototype, u), c && i(n, c), t;
    }(n(0).b);
  }, function (e, t, n) {
    "use strict";

    n.r(t), n.d(t, "default", function () {
      return c;
    });
    var r = n(0);

    function i(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }

    function o(e, t) {
      for (var n = 0; n < t.length; n++) {
        var r = t[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
      }
    }

    function a(e, t) {
      return !t || "object" != _typeof(t) && "function" != typeof t ? function (e) {
        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e;
      }(e) : t;
    }

    function s(e) {
      return (s = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function u(e, t) {
      return (u = Object.setPrototypeOf || function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    n(14), n(15);

    var c = function (e) {
      function t() {
        return i(this, t), a(this, s(t).apply(this, arguments));
      }

      var n, r, c;
      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), t && u(e, t);
      }(t, e), n = t, (r = [{
        key: "connect",
        value: function value() {
          $(this.element).dropdown({
            duration: 0,
            transition: "drop"
          });
        }
      }, {
        key: "close",
        value: function value() {
          $(this.element).dropdown("hide");
        }
      }]) && o(n.prototype, r), c && o(n, c), t;
    }(r.b);
  }, function (e, t, n) {
    "use strict";

    function r(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }

    function i(e, t) {
      for (var n = 0; n < t.length; n++) {
        var r = t[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
      }
    }

    function o(e, t) {
      return !t || "object" != _typeof(t) && "function" != typeof t ? function (e) {
        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e;
      }(e) : t;
    }

    function a(e) {
      return (a = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function s(e, t) {
      return (s = Object.setPrototypeOf || function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    n.r(t), n.d(t, "default", function () {
      return u;
    });

    var u = function (e) {
      function t() {
        return r(this, t), o(this, a(t).apply(this, arguments));
      }

      var n, u, c;
      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), t && s(e, t);
      }(t, e), n = t, (u = [{
        key: "setLocale",
        value: function value(e) {
          var t = window.location.toString().replace("".concat(this.data.get("locale")), e.target.value);
          Turbolinks.visit(t);
        }
      }]) && i(n.prototype, u), c && i(n, c), t;
    }(n(0).b);
  }, function (e, t, n) {
    "use strict";

    function r(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }

    function i(e, t) {
      for (var n = 0; n < t.length; n++) {
        var r = t[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
      }
    }

    function o(e, t) {
      return !t || "object" != _typeof(t) && "function" != typeof t ? function (e) {
        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e;
      }(e) : t;
    }

    function a(e) {
      return (a = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function s(e, t) {
      return (s = Object.setPrototypeOf || function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    n.r(t), n.d(t, "default", function () {
      return u;
    });

    var u = function (e) {
      function t() {
        return r(this, t), o(this, a(t).apply(this, arguments));
      }

      var n, u, c;
      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), t && s(e, t);
      }(t, e), n = t, (u = [{
        key: "initialize",
        value: function value() {
          var _this7 = this;

          window.addEventListener("load", function () {
            _this7.resizeInput(), _this7.updateOriginalValue();
          }), this.inputTarget.addEventListener("input", function () {
            _this7.resizeInput();
          });
        }
      }, {
        key: "connect",
        value: function value() {}
      }, {
        key: "onSuccess",
        value: function value() {
          this.updateOriginalValue(), this.updateChangedState();
        }
      }, {
        key: "cancel",
        value: function value() {
          this.inputTarget.value = this.data.get("originalValue"), this.updateChangedState(), this.resizeInput();
        }
      }, {
        key: "updateOriginalValue",
        value: function value() {
          this.data.set("originalValue", this.inputTarget.value);
        }
      }, {
        key: "updateChangedState",
        value: function value() {
          this.element.classList.toggle("changed", this.hasChanged);
        }
      }, {
        key: "resizeInput",
        value: function value() {
          this.dummyContent = this.inputTarget.value, this.inputTarget.style.width = "".concat(this.dummyWidth, "px");
        }
      }, {
        key: "dummyWidth",
        get: function get() {
          return Math.ceil(this.dummyTarget.offsetWidth);
        }
      }, {
        key: "hasChanged",
        get: function get() {
          return this.inputTarget.value != this.data.get("originalValue");
        }
      }, {
        key: "dummyContent",
        set: function set(e) {
          this.dummyTarget.textContent = e;
        }
      }]) && i(n.prototype, u), c && i(n, c), t;
    }(n(0).b);

    var c, l, f;
    f = ["form", "input", "dummy", "cancelButton"], (l = "targets") in (c = u) ? Object.defineProperty(c, l, {
      value: f,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : c[l] = f;
  }, function (e, t, n) {
    "use strict";

    function r(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }

    function i(e, t) {
      for (var n = 0; n < t.length; n++) {
        var r = t[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
      }
    }

    function o(e, t) {
      return !t || "object" != _typeof(t) && "function" != typeof t ? function (e) {
        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e;
      }(e) : t;
    }

    function a(e) {
      return (a = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function s(e, t) {
      return (s = Object.setPrototypeOf || function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    n.r(t), n.d(t, "default", function () {
      return u;
    });

    var u = function (e) {
      function t() {
        return r(this, t), o(this, a(t).apply(this, arguments));
      }

      var n, u, c;
      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), t && s(e, t);
      }(t, e), n = t, (u = [{
        key: "hide",
        value: function value() {
          this.element.classList.toggle(this.data.get("hiddenClass"));
        }
      }]) && i(n.prototype, u), c && i(n, c), t;
    }(n(0).b);
  },,, function (e, t, n) {
    "use strict";

    n.r(t);
    n(31), n(13), n(32), n(38);
    var r = n(0).a.start(),
        i = n(39);
    r.load(function (e) {
      return e.keys().map(function (t) {
        return function (e, t) {
          var n = function (e) {
            var t = (e.match(/^(?:\.\/)?(.+)(?:[_-]controller\..+?)$/) || [])[1];
            if (t) return t.replace(/_/g, "-").replace(/\//g, "--");
          }(t);

          if (n) return function (e, t) {
            var n = e["default"];
            if ("function" == typeof n) return {
              identifier: t,
              controllerConstructor: n
            };
          }(e(t), n);
        }(e, t);
      }).filter(function (e) {
        return e;
      });
    }(i));
  }, function (e, t, n) {
    "use strict";

    n.r(t), n.d(t, "default", function () {
      return x;
    });
    var r = n(0),
        i = window.CustomEvent;

    function o(e) {
      for (; e;) {
        if ("dialog" === e.localName) return e;
        e = e.parentElement;
      }

      return null;
    }

    function a(e) {
      e && e.blur && e !== document.body && e.blur();
    }

    function s(e, t) {
      for (var n = 0; n < e.length; ++n) {
        if (e[n] === t) return !0;
      }

      return !1;
    }

    function u(e) {
      return !(!e || !e.hasAttribute("method")) && "dialog" === e.getAttribute("method").toLowerCase();
    }

    function c(e) {
      if (this.dialog_ = e, this.replacedStyleTop_ = !1, this.openAsModal_ = !1, e.hasAttribute("role") || e.setAttribute("role", "dialog"), e.show = this.show.bind(this), e.showModal = this.showModal.bind(this), e.close = this.close.bind(this), "returnValue" in e || (e.returnValue = ""), "MutationObserver" in window) {
        new MutationObserver(this.maybeHideModal.bind(this)).observe(e, {
          attributes: !0,
          attributeFilter: ["open"]
        });
      } else {
        var t,
            n = !1,
            r = function () {
          n ? this.downgradeModal() : this.maybeHideModal(), n = !1;
        }.bind(this),
            i = function i(_i2) {
          if (_i2.target === e) {
            var o = "DOMNodeRemoved";
            n |= _i2.type.substr(0, o.length) === o, window.clearTimeout(t), t = window.setTimeout(r, 0);
          }
        };

        ["DOMAttrModified", "DOMNodeRemoved", "DOMNodeRemovedFromDocument"].forEach(function (t) {
          e.addEventListener(t, i);
        });
      }

      Object.defineProperty(e, "open", {
        set: this.setOpen.bind(this),
        get: e.hasAttribute.bind(e, "open")
      }), this.backdrop_ = document.createElement("div"), this.backdrop_.className = "backdrop", this.backdrop_.addEventListener("click", this.backdropClick_.bind(this));
    }

    i && "object" != _typeof(i) || ((i = function i(e, t) {
      t = t || {};
      var n = document.createEvent("CustomEvent");
      return n.initCustomEvent(e, !!t.bubbles, !!t.cancelable, t.detail || null), n;
    }).prototype = window.Event.prototype), c.prototype = {
      get dialog() {
        return this.dialog_;
      },

      maybeHideModal: function maybeHideModal() {
        this.dialog_.hasAttribute("open") && document.body.contains(this.dialog_) || this.downgradeModal();
      },
      downgradeModal: function downgradeModal() {
        this.openAsModal_ && (this.openAsModal_ = !1, this.dialog_.style.zIndex = "", this.replacedStyleTop_ && (this.dialog_.style.top = "", this.replacedStyleTop_ = !1), this.backdrop_.parentNode && this.backdrop_.parentNode.removeChild(this.backdrop_), l.dm.removeDialog(this));
      },
      setOpen: function setOpen(e) {
        e ? this.dialog_.hasAttribute("open") || this.dialog_.setAttribute("open", "") : (this.dialog_.removeAttribute("open"), this.maybeHideModal());
      },
      backdropClick_: function backdropClick_(e) {
        if (this.dialog_.hasAttribute("tabindex")) this.dialog_.focus();else {
          var t = document.createElement("div");
          this.dialog_.insertBefore(t, this.dialog_.firstChild), t.tabIndex = -1, t.focus(), this.dialog_.removeChild(t);
        }
        var n = document.createEvent("MouseEvents");
        n.initMouseEvent(e.type, e.bubbles, e.cancelable, window, e.detail, e.screenX, e.screenY, e.clientX, e.clientY, e.ctrlKey, e.altKey, e.shiftKey, e.metaKey, e.button, e.relatedTarget), this.dialog_.dispatchEvent(n), e.stopPropagation();
      },
      focus_: function focus_() {
        var e = this.dialog_.querySelector("[autofocus]:not([disabled])");

        if (!e && this.dialog_.tabIndex >= 0 && (e = this.dialog_), !e) {
          var t = ["button", "input", "keygen", "select", "textarea"].map(function (e) {
            return e + ":not([disabled])";
          });
          t.push('[tabindex]:not([disabled]):not([tabindex=""])'), e = this.dialog_.querySelector(t.join(", "));
        }

        a(document.activeElement), e && e.focus();
      },
      updateZIndex: function updateZIndex(e, t) {
        if (e < t) throw new Error("dialogZ should never be < backdropZ");
        this.dialog_.style.zIndex = e, this.backdrop_.style.zIndex = t;
      },
      show: function show() {
        this.dialog_.open || (this.setOpen(!0), this.focus_());
      },
      showModal: function showModal() {
        if (this.dialog_.hasAttribute("open")) throw new Error("Failed to execute 'showModal' on dialog: The element is already open, and therefore cannot be opened modally.");
        if (!document.body.contains(this.dialog_)) throw new Error("Failed to execute 'showModal' on dialog: The element is not in a Document.");
        if (!l.dm.pushDialog(this)) throw new Error("Failed to execute 'showModal' on dialog: There are too many open modal dialogs.");
        (function (e) {
          for (; e && e !== document.body;) {
            var t = window.getComputedStyle(e),
                n = function n(e, _n3) {
              return !(void 0 === t[e] || t[e] === _n3);
            };

            if (t.opacity < 1 || n("zIndex", "auto") || n("transform", "none") || n("mixBlendMode", "normal") || n("filter", "none") || n("perspective", "none") || "isolate" === t.isolation || "fixed" === t.position || "touch" === t.webkitOverflowScrolling) return !0;
            e = e.parentElement;
          }

          return !1;
        })(this.dialog_.parentElement) && console.warn("A dialog is being shown inside a stacking context. This may cause it to be unusable. For more information, see this link: https://github.com/GoogleChrome/dialog-polyfill/#stacking-context"), this.setOpen(!0), this.openAsModal_ = !0, l.needsCentering(this.dialog_) ? (l.reposition(this.dialog_), this.replacedStyleTop_ = !0) : this.replacedStyleTop_ = !1, this.dialog_.parentNode.insertBefore(this.backdrop_, this.dialog_.nextSibling), this.focus_();
      },
      close: function close(e) {
        if (!this.dialog_.hasAttribute("open")) throw new Error("Failed to execute 'close' on dialog: The element does not have an 'open' attribute, and therefore cannot be closed.");
        this.setOpen(!1), void 0 !== e && (this.dialog_.returnValue = e);
        var t = new i("close", {
          bubbles: !1,
          cancelable: !1
        });
        this.dialog_.dispatchEvent(t);
      }
    };
    var l = {
      reposition: function reposition(e) {
        var t = document.body.scrollTop || document.documentElement.scrollTop,
            n = t + (window.innerHeight - e.offsetHeight) / 2;
        e.style.top = Math.max(t, n) + "px";
      },
      isInlinePositionSetByStylesheet: function isInlinePositionSetByStylesheet(e) {
        for (var t = 0; t < document.styleSheets.length; ++t) {
          var n = document.styleSheets[t],
              r = null;

          try {
            r = n.cssRules;
          } catch (e) {}

          if (r) for (var i = 0; i < r.length; ++i) {
            var o = r[i],
                a = null;

            try {
              a = document.querySelectorAll(o.selectorText);
            } catch (e) {}

            if (a && s(a, e)) {
              var u = o.style.getPropertyValue("top"),
                  c = o.style.getPropertyValue("bottom");
              if (u && "auto" !== u || c && "auto" !== c) return !0;
            }
          }
        }

        return !1;
      },
      needsCentering: function needsCentering(e) {
        return "absolute" === window.getComputedStyle(e).position && !("auto" !== e.style.top && "" !== e.style.top || "auto" !== e.style.bottom && "" !== e.style.bottom) && !l.isInlinePositionSetByStylesheet(e);
      },
      forceRegisterDialog: function forceRegisterDialog(e) {
        if ((window.HTMLDialogElement || e.showModal) && console.warn("This browser already supports <dialog>, the polyfill may not work correctly", e), "dialog" !== e.localName) throw new Error("Failed to register dialog: The element is not a dialog.");
        new c(e);
      },
      registerDialog: function registerDialog(e) {
        e.showModal || l.forceRegisterDialog(e);
      },
      DialogManager: function DialogManager() {
        this.pendingDialogStack = [];
        var e = this.checkDOM_.bind(this);
        this.overlay = document.createElement("div"), this.overlay.className = "_dialog_overlay", this.overlay.addEventListener("click", function (t) {
          this.forwardTab_ = void 0, t.stopPropagation(), e([]);
        }.bind(this)), this.handleKey_ = this.handleKey_.bind(this), this.handleFocus_ = this.handleFocus_.bind(this), this.zIndexLow_ = 1e5, this.zIndexHigh_ = 100150, this.forwardTab_ = void 0, "MutationObserver" in window && (this.mo_ = new MutationObserver(function (t) {
          var n = [];
          t.forEach(function (e) {
            for (var t, r = 0; t = e.removedNodes[r]; ++r) {
              t instanceof Element && ("dialog" === t.localName && n.push(t), n = n.concat(t.querySelectorAll("dialog")));
            }
          }), n.length && e(n);
        }));
      }
    };

    if (l.DialogManager.prototype.blockDocument = function () {
      document.documentElement.addEventListener("focus", this.handleFocus_, !0), document.addEventListener("keydown", this.handleKey_), this.mo_ && this.mo_.observe(document, {
        childList: !0,
        subtree: !0
      });
    }, l.DialogManager.prototype.unblockDocument = function () {
      document.documentElement.removeEventListener("focus", this.handleFocus_, !0), document.removeEventListener("keydown", this.handleKey_), this.mo_ && this.mo_.disconnect();
    }, l.DialogManager.prototype.updateStacking = function () {
      for (var e, t = this.zIndexHigh_, n = 0; e = this.pendingDialogStack[n]; ++n) {
        e.updateZIndex(--t, --t), 0 === n && (this.overlay.style.zIndex = --t);
      }

      var r = this.pendingDialogStack[0];
      r ? (r.dialog.parentNode || document.body).appendChild(this.overlay) : this.overlay.parentNode && this.overlay.parentNode.removeChild(this.overlay);
    }, l.DialogManager.prototype.containedByTopDialog_ = function (e) {
      for (; e = o(e);) {
        for (var t, n = 0; t = this.pendingDialogStack[n]; ++n) {
          if (t.dialog === e) return 0 === n;
        }

        e = e.parentElement;
      }

      return !1;
    }, l.DialogManager.prototype.handleFocus_ = function (e) {
      if (!this.containedByTopDialog_(e.target) && document.activeElement !== document.documentElement && (e.preventDefault(), e.stopPropagation(), a(e.target), void 0 !== this.forwardTab_)) {
        var t = this.pendingDialogStack[0];
        return t.dialog.compareDocumentPosition(e.target) & Node.DOCUMENT_POSITION_PRECEDING && (this.forwardTab_ ? t.focus_() : e.target !== document.documentElement && document.documentElement.focus()), !1;
      }
    }, l.DialogManager.prototype.handleKey_ = function (e) {
      if (this.forwardTab_ = void 0, 27 === e.keyCode) {
        e.preventDefault(), e.stopPropagation();
        var t = new i("cancel", {
          bubbles: !1,
          cancelable: !0
        }),
            n = this.pendingDialogStack[0];
        n && n.dialog.dispatchEvent(t) && n.dialog.close();
      } else 9 === e.keyCode && (this.forwardTab_ = !e.shiftKey);
    }, l.DialogManager.prototype.checkDOM_ = function (e) {
      this.pendingDialogStack.slice().forEach(function (t) {
        -1 !== e.indexOf(t.dialog) ? t.downgradeModal() : t.maybeHideModal();
      });
    }, l.DialogManager.prototype.pushDialog = function (e) {
      var t = (this.zIndexHigh_ - this.zIndexLow_) / 2 - 1;
      return !(this.pendingDialogStack.length >= t) && (1 === this.pendingDialogStack.unshift(e) && this.blockDocument(), this.updateStacking(), !0);
    }, l.DialogManager.prototype.removeDialog = function (e) {
      var t = this.pendingDialogStack.indexOf(e);
      -1 !== t && (this.pendingDialogStack.splice(t, 1), 0 === this.pendingDialogStack.length && this.unblockDocument(), this.updateStacking());
    }, l.dm = new l.DialogManager(), l.formSubmitter = null, l.useValue = null, void 0 === window.HTMLDialogElement) {
      var f = document.createElement("form");

      if (f.setAttribute("method", "dialog"), "dialog" !== f.method) {
        var d = Object.getOwnPropertyDescriptor(HTMLFormElement.prototype, "method");

        if (d) {
          var p = d.get;

          d.get = function () {
            return u(this) ? "dialog" : p.call(this);
          };

          var h = d.set;
          d.set = function (e) {
            return "string" == typeof e && "dialog" === e.toLowerCase() ? this.setAttribute("method", e) : h.call(this, e);
          }, Object.defineProperty(HTMLFormElement.prototype, "method", d);
        }
      }

      document.addEventListener("click", function (e) {
        if (l.formSubmitter = null, l.useValue = null, !e.defaultPrevented) {
          var t = e.target;

          if (t && u(t.form)) {
            if (!("submit" === t.type && ["button", "input"].indexOf(t.localName) > -1)) {
              if ("input" !== t.localName || "image" !== t.type) return;
              l.useValue = e.offsetX + "," + e.offsetY;
            }

            o(t) && (l.formSubmitter = t);
          }
        }
      }, !1);
      var v = HTMLFormElement.prototype.submit;
      HTMLFormElement.prototype.submit = function () {
        if (!u(this)) return v.call(this);
        var e = o(this);
        e && e.close();
      }, document.addEventListener("submit", function (e) {
        var t = e.target;

        if (u(t)) {
          e.preventDefault();
          var n = o(t);

          if (n) {
            var r = l.formSubmitter;
            r && r.form === t ? n.close(l.useValue || r.value) : n.close(), l.formSubmitter = null;
          }
        }
      }, !0);
    }

    var g = l;

    function m(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }

    function y(e, t) {
      for (var n = 0; n < t.length; n++) {
        var r = t[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
      }
    }

    function b(e, t) {
      return !t || "object" != _typeof(t) && "function" != typeof t ? function (e) {
        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e;
      }(e) : t;
    }

    function w(e) {
      return (w = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function _(e, t) {
      return (_ = Object.setPrototypeOf || function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    var x = function (e) {
      function t() {
        return m(this, t), b(this, w(t).apply(this, arguments));
      }

      var n, r, i;
      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), t && _(e, t);
      }(t, e), n = t, (r = [{
        key: "initialize",
        value: function value() {
          g.registerDialog(this.element);
        }
      }, {
        key: "connect",
        value: function value() {
          this.isOpen && this.open();
        }
      }, {
        key: "disconnect",
        value: function value() {}
      }, {
        key: "open",
        value: function value() {
          this.element.showModal();
        }
      }, {
        key: "close",
        value: function value() {
          this.element.close();
        }
      }, {
        key: "isOpen",
        get: function get() {
          return JSON.parse(this.data.get("open"));
        }
      }]) && y(n.prototype, r), i && y(n, i), t;
    }(r.b);
  }]);
});